webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularCookies = __webpack_require__(3);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _angularResource = __webpack_require__(5);
	
	var _angularResource2 = _interopRequireDefault(_angularResource);
	
	var _angularSanitize = __webpack_require__(7);
	
	var _angularSanitize2 = _interopRequireDefault(_angularSanitize);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _angularUiBootstrap = __webpack_require__(10);
	
	var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);
	
	__webpack_require__(12);
	
	var _app = __webpack_require__(14);
	
	var _auth = __webpack_require__(15);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _account = __webpack_require__(26);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _admin = __webpack_require__(37);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _tutors = __webpack_require__(41);
	
	var _tutors2 = _interopRequireDefault(_tutors);
	
	var _students = __webpack_require__(45);
	
	var _students2 = _interopRequireDefault(_students);
	
	var _reports = __webpack_require__(48);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _timesheets = __webpack_require__(65);
	
	var _timesheets2 = _interopRequireDefault(_timesheets);
	
	var _navbar = __webpack_require__(69);
	
	var _navbar2 = _interopRequireDefault(_navbar);
	
	var _main = __webpack_require__(71);
	
	var _main2 = _interopRequireDefault(_main);
	
	var _app2 = __webpack_require__(16);
	
	var _app3 = _interopRequireDefault(_app2);
	
	var _util = __webpack_require__(18);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _uiSelect = __webpack_require__(74);
	
	var _uiSelect2 = _interopRequireDefault(_uiSelect);
	
	var _process = __webpack_require__(76);
	
	var _process2 = _interopRequireDefault(_process);
	
	var _services = __webpack_require__(79);
	
	var _services2 = _interopRequireDefault(_services);
	
	var _editPresets = __webpack_require__(82);
	
	var _editPresets2 = _interopRequireDefault(_editPresets);
	
	var _editTutor = __webpack_require__(85);
	
	var _editTutor2 = _interopRequireDefault(_editTutor);
	
	var _editStudent = __webpack_require__(88);
	
	var _editStudent2 = _interopRequireDefault(_editStudent);
	
	var _createStudent = __webpack_require__(91);
	
	var _createStudent2 = _interopRequireDefault(_createStudent);
	
	var _createTutor = __webpack_require__(94);
	
	var _createTutor2 = _interopRequireDefault(_createTutor);
	
	var _deputyImport = __webpack_require__(97);
	
	var _deputyImport2 = _interopRequireDefault(_deputyImport);
	
	__webpack_require__(101);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_angular2.default.module('accessApp', [_angularCookies2.default, _angularResource2.default, _angularSanitize2.default, _angularUiRouter2.default, _angularUiBootstrap2.default, _auth2.default, _account2.default, _admin2.default, 'validation.match', _navbar2.default, _main2.default, _app3.default, _util2.default, _tutors2.default, _timesheets2.default, _uiSelect2.default, _editPresets2.default, _createStudent2.default, _createTutor2.default, _reports2.default, _process2.default, _services2.default, _editTutor2.default, _students2.default, _editStudent2.default, _deputyImport2.default]).config(_app.routeConfig).directive('customOnChange', function () {
	  return {
	    restrict: 'A',
	    link: function link(scope, element, attrs) {
	      var onChangeHandler = scope.$eval(attrs.customOnChange);
	      element.on('change', onChangeHandler);
	      element.on('$destroy', function () {
	        element.off();
	      });
	    }
	  };
	}).run(['$rootScope', '$location', 'Auth', '$http', function ($rootScope, $location, Auth, $http) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (current.name === 'timesheets') {
	      if ($rootScope.changesToBeSaved) {
	        if (!confirm('Your timesheet has unsaved changes. Click cancel to stay to stay on this page.')) {
	          event.preventDefault();
	        } else {
	          $rootScope.changesToBeSaved = false;
	        }
	      }
	    }
	
	    Auth.isLoggedIn(function (loggedIn) {
	      if (next.authenticate && !loggedIn) {
	        $location.path('/login');
	      }
	    });
	  });
	}]);
	
	_angular2.default.element(document).ready(function () {
	  _angular2.default.bootstrap(document, ['accessApp'], {
	    strictDi: true
	  });
	});

/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(13);
	module.exports = 'validation.match';


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	/*!
	 * angular-validation-match
	 * Checks if one input matches another
	 * @version v1.9.0
	 * @link https://github.com/TheSharpieOne/angular-validation-match
	 * @license MIT License, http://www.opensource.org/licenses/MIT
	 */
	(function(window, angular, undefined){'use strict';
	
	match.$inject = ["$parse"];
	angular.module('validation.match', []);
	
	angular.module('validation.match').directive('match', match);
	
	function match ($parse) {
	    return {
	        require: '?ngModel',
	        restrict: 'A',
	        link: function(scope, elem, attrs, ctrl) {
	            if(!ctrl || !attrs.match) {
	                return;
	            }
	
	            var matchGetter = $parse(attrs.match);
	            var caselessGetter = $parse(attrs.matchCaseless);
	            var noMatchGetter = $parse(attrs.notMatch);
	            var matchIgnoreEmptyGetter = $parse(attrs.matchIgnoreEmpty);
	
	            scope.$watch(getMatchValue, function(){
	                ctrl.$$parseAndValidate();
	            });
	
	            ctrl.$validators.match = function(modelValue, viewValue){
	              var matcher = modelValue || viewValue;
	              var match = getMatchValue();
	              var notMatch = noMatchGetter(scope);
	              var value;
	
	              if (matchIgnoreEmptyGetter(scope) && !viewValue) {
	                return true;
	              }
	
	              if(caselessGetter(scope)){
	                value = angular.lowercase(matcher) === angular.lowercase(match);
	              }else{
	                value = matcher === match;
	              }
	              /*jslint bitwise: true */
	              value ^= notMatch;
	              /*jslint bitwise: false */
	              return !!value;
	            };
	
	            function getMatchValue(){
	                var match = matchGetter(scope);
	                if(angular.isObject(match) && match.hasOwnProperty('$viewValue')){
	                    match = match.$viewValue;
	                }
	                return match;
	            }
	        }
	    };
	}
	})(window, window.angular);


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	'use strict';
	
	routeConfig.$inject = ['$urlRouterProvider', '$locationProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routeConfig = routeConfig;
	function routeConfig($urlRouterProvider, $locationProvider) {
	  'ngInject';
	
	  $urlRouterProvider.otherwise('/');
	
	  $locationProvider.html5Mode(true);
	}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	addInterceptor.$inject = ['$httpProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _app = __webpack_require__(16);
	
	var _app2 = _interopRequireDefault(_app);
	
	var _util = __webpack_require__(18);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _angularCookies = __webpack_require__(3);
	
	var _angularCookies2 = _interopRequireDefault(_angularCookies);
	
	var _interceptor = __webpack_require__(20);
	
	var _router = __webpack_require__(21);
	
	var _auth = __webpack_require__(22);
	
	var _user = __webpack_require__(25);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addInterceptor($httpProvider) {
	  'ngInject';
	
	  $httpProvider.interceptors.push('authInterceptor');
	}
	
	exports.default = _angular2.default.module('accessApp.auth', [_app2.default, _util2.default, _angularCookies2.default, _angularUiRouter2.default]).factory('authInterceptor', _interceptor.authInterceptor).run(_router.routerDecorator).factory('Auth', _auth.AuthService).factory('User', _user.UserResource).config(['$httpProvider', addInterceptor]).name;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('accessApp.constants', []).constant('appConfig', __webpack_require__(17)).name;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	'use strict';
	
	exports = module.exports = {
	  // List of user roles
	  userRoles: ['guest', 'user', 'admin'],
	};


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _util = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('accessApp.util', []).factory('Util', _util.UtilService).name;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	UtilService.$inject = ['$window'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UtilService = UtilService;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function UtilService($window) {
	  'ngInject';
	
	  var Util = {
	    safeCb: function safeCb(cb) {
	      return _angular2.default.isFunction(cb) ? cb : _angular2.default.noop;
	    },
	    urlParse: function urlParse(url) {
	      var a = document.createElement('a');
	      a.href = url;
	
	      if (a.host === '') {
	        a.href = a.href;
	      }
	
	      return a;
	    },
	    isSameOrigin: function isSameOrigin(url, origins) {
	      url = Util.urlParse(url);
	      origins = origins && [].concat(origins) || [];
	      origins = origins.map(Util.urlParse);
	      origins.push($window.location);
	      origins = origins.filter(function (o) {
	        var hostnameCheck = url.hostname === o.hostname;
	        var protocolCheck = url.protocol === o.protocol;
	
	        var portCheck = url.port === o.port || o.port === '' && (url.port === '80' || url.port === '443');
	        return hostnameCheck && protocolCheck && portCheck;
	      });
	      return origins.length >= 1;
	    }
	  };
	
	  return Util;
	}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

	'use strict';
	
	authInterceptor.$inject = ['$rootScope', '$q', '$cookies', '$injector', 'Util'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authInterceptor = authInterceptor;
	function authInterceptor($rootScope, $q, $cookies, $injector, Util) {
	  'ngInject';
	
	  var state;
	  return {
	    request: function request(config) {
	      config.headers = config.headers || {};
	      if ($cookies.get('token_sheets') && Util.isSameOrigin(config.url)) {
	        config.headers.Authorization = 'Bearer ' + $cookies.get('token_sheets');
	      }
	      return config;
	    },
	    responseError: function responseError(response) {
	      if (response.status === 401) {
	        (state || (state = $injector.get('$state'))).go('login');
	
	        $cookies.remove('token_sheets');
	      }
	      return $q.reject(response);
	    }
	  };
	}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	'use strict';
	
	routerDecorator.$inject = ['$rootScope', '$state', 'Auth'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerDecorator = routerDecorator;
	function routerDecorator($rootScope, $state, Auth) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next) {
	    if (!next.authenticate) {
	      return;
	    }
	
	    if (typeof next.authenticate === 'string') {
	      Auth.hasRole(next.authenticate).then(function (has) {
	        if (has) {
	          return;
	        }
	
	        event.preventDefault();
	        return Auth.isLoggedIn().then(function (is) {
	          $state.go(is ? 'main' : 'login');
	        });
	      });
	    } else {
	      Auth.isLoggedIn().then(function (is) {
	        if (is) {
	          return;
	        }
	
	        event.preventDefault();
	
	        $state.go('login');
	      });
	    }
	  });
	}

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	AuthService.$inject = ['$location', '$http', '$cookies', '$q', 'appConfig', 'Util', 'User'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.AuthService = AuthService;
	
	var _lodash = __webpack_require__(23);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _User = function _User() {
	  _classCallCheck(this, _User);
	
	  this._id = '';
	  this.name = '';
	  this.email = '';
	  this.role = '';
	  this.$promise = undefined;
	};
	
	function AuthService($location, $http, $cookies, $q, appConfig, Util, User) {
	  'ngInject';
	
	  var safeCb = Util.safeCb;
	  var currentUser = new _User();
	  var userRoles = appConfig.userRoles || [];
	
	  var _hasRole = function _hasRole(userRole, role) {
	    return userRoles.indexOf(userRole) >= userRoles.indexOf(role);
	  };
	
	  if ($cookies.get('token_sheets') && $location.path() !== '/logout') {
	    currentUser = User.get();
	  }
	
	  var Auth = {
	    login: function login(_ref, callback) {
	      var email = _ref.email,
	          password = _ref.password;
	
	      return $http.post('/auth/local', {
	        email: email,
	        password: password
	      }).then(function (res) {
	        $cookies.put('token_sheets', res.data.token);
	        currentUser = User.get();
	        return currentUser.$promise;
	      }).then(function (user) {
	        safeCb(callback)(null, user);
	        return user;
	      }).catch(function (err) {
	        Auth.logout();
	        safeCb(callback)(err.data);
	        return $q.reject(err.data);
	      });
	    },
	    logout: function logout() {
	      $cookies.remove('token_sheets');
	      currentUser = new _User();
	    },
	    createUser: function createUser(user, callback) {
	      return User.save(user, function (data) {
	        $cookies.put('token_sheets', data.token);
	        currentUser = User.get();
	        return safeCb(callback)(null, user);
	      }, function (err) {
	        Auth.logout();
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    changePassword: function changePassword(oldPassword, newPassword, callback) {
	      return User.changePassword({
	        id: currentUser._id
	      }, {
	        oldPassword: oldPassword,
	        newPassword: newPassword
	      }, function () {
	        return safeCb(callback)(null);
	      }, function (err) {
	        return safeCb(callback)(err);
	      }).$promise;
	    },
	    getCurrentUser: function getCurrentUser(callback) {
	      var value = _.get(currentUser, '$promise') ? currentUser.$promise : currentUser;
	
	      return $q.when(value).then(function (user) {
	        safeCb(callback)(user);
	        return user;
	      }, function () {
	        safeCb(callback)({});
	        return {};
	      });
	    },
	    getCurrentUserSync: function getCurrentUserSync() {
	      return currentUser;
	    },
	    isLoggedIn: function isLoggedIn(callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var is = _.get(user, 'role');
	
	        safeCb(callback)(is);
	        return is;
	      });
	    },
	    isLoggedInSync: function isLoggedInSync() {
	      return !!_.get(currentUser, 'role');
	    },
	    hasRole: function hasRole(role, callback) {
	      return Auth.getCurrentUser(undefined).then(function (user) {
	        var has = _hasRole(_.get(user, 'role'), role);
	
	        safeCb(callback)(has);
	        return has;
	      });
	    },
	    hasRoleSync: function hasRoleSync(role) {
	      return _hasRole(_.get(currentUser, 'role'), role);
	    },
	    isAdmin: function isAdmin() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return Auth.hasRole(Reflect.apply([].concat, ['admin'], args));
	    },
	    isAdminSync: function isAdminSync() {
	      return Auth.hasRoleSync('admin');
	    },
	    getToken: function getToken() {
	      return $cookies.get('token_sheets');
	    }
	  };
	
	  return Auth;
	}

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

	'use strict';
	
	UserResource.$inject = ['$resource'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UserResource = UserResource;
	function UserResource($resource) {
	  'ngInject';
	
	  return $resource('/api/users/:id/:controller', {
	    id: '@_id'
	  }, {
	    changePassword: {
	      method: 'PUT',
	      params: {
	        controller: 'password'
	      }
	    },
	    get: {
	      method: 'GET',
	      params: {
	        id: 'me'
	      }
	    }
	  });
	}

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _account = __webpack_require__(27);
	
	var _account2 = _interopRequireDefault(_account);
	
	var _login = __webpack_require__(31);
	
	var _login2 = _interopRequireDefault(_login);
	
	var _settings = __webpack_require__(33);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _signup = __webpack_require__(35);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('accessApp.account', [_angularUiRouter2.default, _login2.default, _settings2.default, _signup2.default]).config(_account2.default).run(['$rootScope', function ($rootScope) {
	  'ngInject';
	
	  $rootScope.$on('$stateChangeStart', function (event, next, nextParams, current) {
	    if (next.name === 'logout' && current && current.name && !current.authenticate) {
	      next.referrer = current.name;
	    }
	  });
	}]).name;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('login', {
	    url: '/login',
	    template: __webpack_require__(28),
	    controller: 'LoginController',
	    controllerAs: 'vm'
	  }).state('logout', {
	    url: '/logout?referrer',
	    referrer: 'main',
	    template: '',
	    controller: ['$state', 'Auth', function controller($state, Auth) {
	      'ngInject';
	
	      var referrer = $state.params.referrer || $state.current.referrer || 'main';
	      Auth.logout();
	      $state.go(referrer);
	    }]
	  }).state('signup', {
	    url: '/signup',
	    template: __webpack_require__(29),
	    controller: 'SignupController',
	    controllerAs: 'vm'
	  }).state('settings', {
	    url: '/settings',
	    template: __webpack_require__(30),
	    controller: 'SettingsController',
	    controllerAs: 'vm',
	    authenticate: true
	  });
	}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"flex v-center h-center\" style=\"height: 80vh\">\n  <div style=\"    padding: 30px;\n    background-color: #ececec;\n    border-radius: 4px;\n    border: 1px solid #ccc;\">\n    <h1 class=\"w600\" style=\"margin-bottom: 20px\">Login to GSPT Sheets</h1>\n    <form class=\"form\" name=\"form\" ng-submit=\"vm.login(form)\" novalidate style=\"min-width: 600px\">\n\n      <div class=\"form-group\">\n        <input type=\"email\" name=\"email\" placeholder=\"Email Address\" class=\"form-control input-lg\" ng-model=\"vm.user.email\" required>\n      </div>\n\n      <div class=\"form-group\">\n        <input type=\"password\" placeholder=\"Password\" name=\"password\" class=\"form-control input-lg\" ng-model=\"vm.user.password\" required>\n      </div>\n\n      <div class=\"form-group has-error\">\n        <p class=\"help-block\" ng-show=\"form.email.$error.required && form.password.$error.required && vm.submitted\">\n           Please enter your email and password.\n        </p>\n        <p class=\"help-block\" ng-show=\"form.email.$error.email && vm.submitted\">\n           Please enter a valid email.\n        </p>\n\n        <p class=\"help-block\">{{ vm.errors.login }}</p>\n      </div>\n\n      <div>\n        <button class=\"btn btn-primary btn-lg btn-block\" type=\"submit\">\n          Login\n        </button>\n        <a class=\"btn btn-default btn-lg btn-register\" ui-sref=\"signup\">\n          Register\n        </a>\n      </div>\n\n    </form>\n  </div>\n</div>\n"

/***/ }),
/* 29 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <h1>Sign up</h1>\n    </div>\n    <div class=\"col-sm-12\">\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.register(form)\" novalidate>\n\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.name.$valid && vm.submitted,\n                                            'has-error': form.name.$invalid && vm.submitted }\">\n          <label>Name</label>\n\n          <input type=\"text\" name=\"name\" class=\"form-control\" ng-model=\"vm.user.name\"\n                 required/>\n          <p class=\"help-block\" ng-show=\"form.name.$error.required && vm.submitted\">\n            A name is required\n          </p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.email.$valid && vm.submitted,\n                                            'has-error': form.email.$invalid && vm.submitted }\">\n          <label>Email</label>\n\n          <input type=\"email\" name=\"email\" class=\"form-control\" ng-model=\"vm.user.email\"\n                 required\n                 mongoose-error/>\n          <p class=\"help-block\" ng-show=\"form.email.$error.email && vm.submitted\">\n            Doesn't look like a valid email.\n          </p>\n          <p class=\"help-block\" ng-show=\"form.email.$error.required && vm.submitted\">\n            What's your email address?\n          </p>\n          <p class=\"help-block\" ng-show=\"form.email.$error.mongoose\">\n            {{ vm.errors.email }}\n          </p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.password.$valid && vm.submitted,\n                                            'has-error': form.password.$invalid && vm.submitted }\">\n          <label>Password</label>\n\n          <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.password\"\n                 ng-minlength=\"3\"\n                 required\n                 mongoose-error/>\n          <p class=\"help-block\"\n             ng-show=\"(form.password.$error.minlength || form.password.$error.required) && vm.submitted\">\n            Password must be at least 3 characters.\n          </p>\n          <p class=\"help-block\" ng-show=\"form.password.$error.mongoose\">\n            {{ vm.errors.password }}\n          </p>\n        </div>\n\n        <div class=\"form-group\" ng-class=\"{ 'has-success': form.confirmPassword.$valid && vm.submitted,\n                                            'has-error': form.confirmPassword.$invalid && vm.submitted }\">\n          <label>Confirm Password</label>\n          <input type=\"password\" name=\"confirmPassword\" class=\"form-control\" ng-model=\"vm.user.confirmPassword\"\n                 match=\"vm.user.password\"\n                 ng-minlength=\"3\" required/>\n          <p class=\"help-block\"\n             ng-show=\"form.confirmPassword.$error.match && vm.submitted\">\n            Passwords must match.\n          </p>\n        </div>\n\n        <div>\n          <button class=\"btn btn-inverse btn-lg btn-register\" type=\"submit\">\n            Sign up\n          </button>\n          <a class=\"btn btn-default btn-lg btn-login\" ui-sref=\"login\">\n            Login\n          </a>\n        </div>\n\n      </form>\n    </div>\n  </div>\n  <hr>\n</div>\n"

/***/ }),
/* 30 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <h1>Change Password</h1>\n    </div>\n    <div class=\"col-sm-12\">\n      <form class=\"form\" name=\"form\" ng-submit=\"vm.changePassword(form)\" novalidate>\n\n        <div class=\"form-group\">\n          <label>Current Password</label>\n\n          <input type=\"password\" name=\"password\" class=\"form-control\" ng-model=\"vm.user.oldPassword\"\n                 mongoose-error/>\n          <p class=\"help-block\" ng-show=\"form.password.$error.mongoose\">\n              {{ vm.errors.other }}\n          </p>\n        </div>\n\n        <div class=\"form-group\">\n          <label>New Password</label>\n\n          <input type=\"password\" name=\"newPassword\" class=\"form-control\" ng-model=\"vm.user.newPassword\"\n                 ng-minlength=\"3\"\n                 required/>\n          <p class=\"help-block\"\n             ng-show=\"(form.newPassword.$error.minlength || form.newPassword.$error.required) && (form.newPassword.$dirty || vm.submitted)\">\n            Password must be at least 3 characters.\n          </p>\n        </div>\n\n        <div class=\"form-group\">\n          <label>Confirm New Password</label>\n\n          <input type=\"password\" name=\"confirmPassword\" class=\"form-control\" ng-model=\"vm.user.confirmPassword\"\n                 match=\"vm.user.newPassword\"\n                 ng-minlength=\"3\"\n                 required=\"\"/>\n          <p class=\"help-block\"\n             ng-show=\"form.confirmPassword.$error.match && vm.submitted\">\n            Passwords must match.\n          </p>\n\n        </div>\n\n        <p class=\"help-block\"> {{ vm.message }} </p>\n\n        <button class=\"btn btn-lg btn-primary\" type=\"submit\">Save changes</button>\n      </form>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _login = __webpack_require__(32);
	
	var _login2 = _interopRequireDefault(_login);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('accessApp.login', []).controller('LoginController', _login2.default).name;

/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var LoginController = function () {
	
	  /*@ngInject*/
	  LoginController.$inject = ['Auth', '$state'];
	  function LoginController(Auth, $state) {
	    _classCallCheck(this, LoginController);
	
	    this.user = {
	      name: '',
	      email: '',
	      password: ''
	    };
	    this.errors = {
	      login: undefined
	    };
	    this.submitted = false;
	
	    this.Auth = Auth;
	    this.$state = $state;
	  }
	
	  _createClass(LoginController, [{
	    key: 'login',
	    value: function login(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        this.Auth.login({
	          email: this.user.email,
	          password: this.user.password
	        }).then(function () {
	          _this.$state.go('timesheets');
	        }).catch(function (err) {
	          _this.errors.login = err.message;
	        });
	      }
	    }
	  }]);
	
	  return LoginController;
	}();
	
	exports.default = LoginController;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _settings = __webpack_require__(34);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('accessApp.settings', []).controller('SettingsController', _settings2.default).name;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SettingsController = function () {
	
	  /*@ngInject*/
	  SettingsController.$inject = ['Auth'];
	  function SettingsController(Auth) {
	    _classCallCheck(this, SettingsController);
	
	    this.user = {
	      oldPassword: '',
	      newPassword: '',
	      confirmPassword: ''
	    };
	    this.errors = {
	      other: undefined
	    };
	    this.message = '';
	    this.submitted = false;
	
	    this.Auth = Auth;
	  }
	
	  _createClass(SettingsController, [{
	    key: 'changePassword',
	    value: function changePassword(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        this.Auth.changePassword(this.user.oldPassword, this.user.newPassword).then(function () {
	          _this.message = 'Password successfully changed.';
	        }).catch(function () {
	          form.password.$setValidity('mongoose', false);
	          _this.errors.other = 'Incorrect password';
	          _this.message = '';
	        });
	      }
	    }
	  }]);
	
	  return SettingsController;
	}();
	
	exports.default = SettingsController;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _signup = __webpack_require__(36);
	
	var _signup2 = _interopRequireDefault(_signup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('accessApp.signup', []).controller('SignupController', _signup2.default).name;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SignupController = function () {
	
	  /*@ngInject*/
	  SignupController.$inject = ['Auth', '$state'];
	  function SignupController(Auth, $state) {
	    _classCallCheck(this, SignupController);
	
	    this.user = {
	      name: '',
	      email: '',
	      password: ''
	    };
	    this.errors = {};
	    this.submitted = false;
	
	    this.Auth = Auth;
	    this.$state = $state;
	  }
	
	  _createClass(SignupController, [{
	    key: 'register',
	    value: function register(form) {
	      var _this = this;
	
	      this.submitted = true;
	
	      if (form.$valid) {
	        return this.Auth.createUser({
	          name: this.user.name,
	          email: this.user.email,
	          password: this.user.password
	        }).then(function () {
	          _this.$state.go('main');
	        }).catch(function (err) {
	          err = err.data;
	          _this.errors = {};
	
	          _angular2.default.forEach(err.errors, function (error, field) {
	            form[field].$setValidity('mongoose', false);
	            _this.errors[field] = error.message;
	          });
	        });
	      }
	    }
	  }]);
	
	  return SignupController;
	}();
	
	exports.default = SignupController;

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _admin = __webpack_require__(38);
	
	var _admin2 = _interopRequireDefault(_admin);
	
	var _admin3 = __webpack_require__(40);
	
	var _admin4 = _interopRequireDefault(_admin3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('accessApp.admin', ['accessApp.auth', 'ui.router']).config(_admin2.default).controller('AdminController', _admin4.default).name;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('admin', {
	    url: '/admin',
	    template: __webpack_require__(39),
	    controller: 'AdminController',
	    controllerAs: 'admin',
	    authenticate: 'admin'
	  });
	}

/***/ }),
/* 39 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n  <p>The delete user and user index api routes are restricted to users with the 'admin' role.</p>\n  <ul class=\"list-group user-list\">\n    <li class=\"list-group-item\" ng-repeat=\"user in admin.users\">\n\t    <div class=\"user-info\">\n\t        <strong>{{user.name}}</strong><br>\n\t        <span class=\"text-muted\">{{user.email}}</span>\n\t    </div>\n        <a ng-click=\"admin.delete(user)\" class=\"trash\"><span class=\"fa fa-trash fa-2x\"></span></a>\n    </li>\n  </ul>\n</div>\n"

/***/ }),
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AdminController = function () {
	  /*@ngInject*/
	  AdminController.$inject = ['User'];
	  function AdminController(User) {
	    _classCallCheck(this, AdminController);
	
	    this.users = User.query();
	  }
	
	  _createClass(AdminController, [{
	    key: 'delete',
	    value: function _delete(user) {
	      user.$remove();
	      this.users.splice(this.users.indexOf(user), 1);
	    }
	  }]);
	
	  return AdminController;
	}();
	
	exports.default = AdminController;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _tutors = __webpack_require__(42);
	
	var _tutors2 = _interopRequireDefault(_tutors);
	
	var _tutors3 = __webpack_require__(44);
	
	var _tutors4 = _interopRequireDefault(_tutors3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('accessApp.tutors', ['accessApp.auth', 'ui.router']).config(_tutors2.default).controller('TutorsController', _tutors4.default).name;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('tutors', {
	    url: '/tutors',
	    template: __webpack_require__(43),
	    controller: 'TutorsController',
	    controllerAs: 'vm'
	  });
	}

/***/ }),
/* 43 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n\t<div class=\"row\">\n\t\t<div class=\"col-sm-6\">\n\t\t\t<h1>Tutors</h1>\n\t\t</div>\n\t\t<div class=\"col-sm-6 text-right\">\n\t\t\t<button class=\"btn btn-primary btn-lg\" ng-disabled=\"vm.finding\" style=\"margin-top: 20px\" ng-click=\"vm.findInactives()\">\n\t\t\t\t<span>Find Inactives</span>\n\t\t\t</button>\n\t\t\t<button class=\"btn btn-primary btn-lg\" style=\"margin-top: 20px\" ng-click=\"vm.showErrors = !vm.showErrors\">\n\t\t\t\t<span>{{vm.showErrors ? 'Show All' : 'Show WWC Errors'}}</span>\n\t\t\t</button>\n\t\t\t<button class=\"btn btn-primary btn-lg\" style=\"margin-top: 20px\" ng-click=\"vm.addTutor()\">\n\t\t\t\t<span>Add Tutor</span>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\t<hr>\n\t<input type=\"text\" placeholder=\"Filter here...\" class=\"form-control\" ng-model=\"vm.search\">\n\t<br>\n\t<table class=\"table table-striped\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Name</th>\n\t\t\t\t<th>CRM ID</th>\n\t\t\t\t<th>Invoice ID</th>\n\t\t\t\t<th>State</th>\n\t\t\t\t<th>WWC ID</th>\n\t\t\t\t<th>WWC Expiry</th>\n\t\t\t\t<th>WWC State</th>\n\t\t\t\t<th>Has Notes</th>\n\t\t\t\t<th>Actions</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr ng-repeat=\"tutor in vm.tutors | filter: {fullName: vm.search} track by tutor._id\" ng-hide=\"vm.checkShow(tutor)\">\n\t\t\t\t<td>{{tutor.nameFirst}} {{tutor.nameLast}}</td>\n\t\t\t\t<td>{{tutor.crmID}}</td>\n\t\t\t\t<td>{{tutor.invoiceCode}}</td>\n\t\t\t\t<td>{{tutor.state}}</td>\n\t\t\t\t<td>{{tutor.wwcID}}</td>\n\t\t\t\t<td>{{tutor.wwcExpires}}</td>\n\t\t\t\t<td>{{tutor.wwcState}}</td>\n\t\t\t\t<td>\n\t\t\t\t\t<span uib-tooltip=\"{{tutor.notes}}\" tooltip-enable=\"{{!!tutor.notes}}\">{{!!tutor.notes}}</span>\n\t\t\t\t</td>\n\t\t\t\t<td style=\"width: 138px;\">\n\t\t\t\t\t<div style=\"margin: -3px 0px;\">\n\t\t\t\t\t\t<button class=\"btn btn-primary btn-sm\" ng-click=\"vm.editTutor(tutor._id)\">\n\t\t\t\t\t\t\t<span>Edit</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class=\"btn btn-success btn-sm\" ng-show=\"tutor.isActive\" ng-click=\"vm.toggleActivate(tutor)\">\n\t\t\t\t\t\t\t<span>Inactivate</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class=\"btn btn-danger btn-sm\" style=\"width: 73px\" ng-show=\"!tutor.isActive\" ng-click=\"vm.toggleActivate(tutor)\">\n\t\t\t\t\t\t\t<span>Activate</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>"

/***/ }),
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function dateStringToDate(date) {
	  var split = date.split('/');
	  var year = +split[2];
	  if (year < 100) {
	    year += 2000;
	  }
	  var month = +split[1] - 1;
	  var day = +split[0];
	  return new Date(year, month, day);
	}
	
	var TutorsController = function () {
	  /*@ngInject*/
	  TutorsController.$inject = ['$http', 'CreateTutorFactory', 'EditTutorFactory'];
	  function TutorsController($http, CreateTutorFactory, EditTutorFactory) {
	    _classCallCheck(this, TutorsController);
	
	    this.$http = $http;
	    this.tutors = [];
	    this.CreateTutorFactory = CreateTutorFactory;
	    this.EditTutorFactory = EditTutorFactory;
	    this.showErrors = false;
	  }
	
	  _createClass(TutorsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.loadTutors();
	    }
	  }, {
	    key: 'loadTutors',
	    value: function loadTutors() {
	      var _this = this;
	
	      this.$http.get('/api/tutors').then(function (res) {
	        _this.tutors = res.data || [];
	        _this.tutors = _this.tutors.map(function (tutor) {
	          tutor.fullName = tutor.nameFirst + ' ' + tutor.nameLast;
	
	          return tutor;
	        });
	      });
	    }
	  }, {
	    key: 'findInactives',
	    value: function findInactives() {
	      var _this2 = this;
	
	      this.finding = true;
	      this.$http.post('/api/tutors/find-inactives').then(function (res) {
	        _this2.finding = false;
	        _this2.tutors = [];
	        _this2.loadTutors();
	      });
	    }
	  }, {
	    key: 'toggleActivate',
	    value: function toggleActivate(tutor) {
	
	      tutor.isActive = !tutor.isActive;
	
	      this.$http.put('/api/tutors/' + tutor._id, tutor).then(function (res) {
	        console.log('tutor toggled');
	      });
	    }
	  }, {
	    key: 'checkShow',
	    value: function checkShow(tutor) {
	      if (this.showErrors === false) {
	        return false;
	      }
	
	      if (!tutor.isActive) {
	        return true;
	      }
	
	      function compareDates(expiresDate) {
	        if (!expiresDate) {
	          return false;
	        }
	
	        var currentDate = new Date();
	        currentDate.setMonth(currentDate.getMonth() + 2);
	
	        var newDate = dateStringToDate(expiresDate);
	
	        return newDate.getTime() > currentDate.getTime();
	      }
	
	      var dateAllGood = compareDates(tutor.wwcExpires);
	      return !!(dateAllGood && tutor.wwcID && tutor.wwcState);
	    }
	  }, {
	    key: 'addTutor',
	    value: function addTutor() {
	      var _this3 = this;
	
	      this.CreateTutorFactory().then(function (res) {
	        return _this3.loadTutors();
	      });
	    }
	  }, {
	    key: 'editTutor',
	    value: function editTutor(tutorID) {
	      var _this4 = this;
	
	      this.EditTutorFactory(tutorID).then(function (res) {
	        return _this4.loadTutors();
	      });
	    }
	  }]);
	
	  return TutorsController;
	}();
	
	exports.default = TutorsController;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _students = __webpack_require__(46);
	
	var _students2 = _interopRequireDefault(_students);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('accessApp.students', ['accessApp.auth', 'ui.router']).config(['$stateProvider', function ($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('students', {
	    url: '/students',
	    template: __webpack_require__(47),
	    controller: 'StudentsController',
	    controllerAs: 'vm'
	  });
	}]).controller('StudentsController', _students2.default).name;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StudentsController = function () {
		/*@ngInject*/
		StudentsController.$inject = ['$http', 'EditStudentFactory', 'CreateStudentFactory'];
		function StudentsController($http, EditStudentFactory, CreateStudentFactory) {
			_classCallCheck(this, StudentsController);
	
			this.$http = $http;
			this.students = [];
			this.EditStudentFactory = EditStudentFactory;
			this.CreateStudentFactory = CreateStudentFactory;
		}
	
		_createClass(StudentsController, [{
			key: '$onInit',
			value: function $onInit() {
				this.loadStudents();
			}
		}, {
			key: 'addStudent',
			value: function addStudent() {
				var _this = this;
	
				this.CreateStudentFactory().then(function (res) {
					return _this.loadStudents();
				});
			}
		}, {
			key: 'loadStudents',
			value: function loadStudents() {
				var _this2 = this;
	
				this.$http.get('/api/students').then(function (res) {
					_this2.students = res.data;
					_this2.students = _this2.students.map(function (student) {
						student.fullName = student.nameFirst + ' ' + student.nameLast;
	
						return student;
					});
				});
			}
		}, {
			key: 'locationReturn',
			value: function locationReturn(letter) {
				if (letter === 'O') {
					return 'Online';
				}
	
				if (letter === 'H') {
					return 'Home';
				}
	
				if (letter === 'P') {
					return 'Paddington';
				}
	
				if (letter === 'C') {
					return 'Cannon Hill';
				}
	
				if (letter === 'M') {
					return 'Mt Gravatt';
				}
			}
		}, {
			key: 'toggleActivate',
			value: function toggleActivate(student) {
	
				student.isActive = !student.isActive;
	
				this.$http.put('/api/students/' + student._id, student).then(function (res) {
					console.log('student toggled');
				});
			}
		}, {
			key: 'editStudent',
			value: function editStudent(studentID) {
				var _this3 = this;
	
				this.EditStudentFactory(studentID).then(function (res) {
					return _this3.loadStudents();
				});
			}
		}]);
	
		return StudentsController;
	}();
	
	exports.default = StudentsController;

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n\t<div class=\"row\">\n\t\t<div class=\"col-sm-6\">\n\t\t\t<h1>Students</h1>\n\t\t</div>\n\t</div>\n\t<hr>\n\t<input type=\"text\" placeholder=\"Filter here...\" class=\"form-control\" ng-model=\"vm.search\">\n\t<br>\n\t<table class=\"table table-striped\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Name</th>\n\t\t\t\t<th>CRM ID</th>\n\t\t\t\t<th>State</th>\n\t\t\t\t<th>Tute Location</th>\n\t\t\t\t<th>Actions</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr ng-repeat=\"student in vm.students | filter: {fullName: vm.search} track by student._id\">\n\t\t\t\t<td>{{student.nameFirst}} {{student.nameLast}}</td>\n\t\t\t\t<td>{{student.crmID}}</td>\n\t\t\t\t<td>{{student.state}}</td>\n\t\t\t\t<td>{{vm.locationReturn(student.tuteLocation)}}</td>\n\t\t\t\t<td style=\"width: 138px;\">\n\t\t\t\t\t<div style=\"margin: -3px 0px;\">\n\t\t\t\t\t\t<button class=\"btn btn-primary btn-sm\" ng-click=\"vm.editStudent(student._id)\">\n\t\t\t\t\t\t\t<span>Edit</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class=\"btn btn-success btn-sm\" ng-show=\"student.isActive\" ng-click=\"vm.toggleActivate(student)\">\n\t\t\t\t\t\t\t<span>Inactivate</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class=\"btn btn-danger btn-sm\" ng-show=\"!student.isActive\" ng-click=\"vm.toggleActivate(student)\">\n\t\t\t\t\t\t\t<span>Activate</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>"

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _reports = __webpack_require__(49);
	
	var _reports2 = _interopRequireDefault(_reports);
	
	var _studentHours = __webpack_require__(50);
	
	var _studentHours2 = _interopRequireDefault(_studentHours);
	
	var _totalHours = __webpack_require__(51);
	
	var _totalHours2 = _interopRequireDefault(_totalHours);
	
	var _totalHoursRange = __webpack_require__(52);
	
	var _totalHoursRange2 = _interopRequireDefault(_totalHoursRange);
	
	var _tutorCount = __webpack_require__(53);
	
	var _tutorCount2 = _interopRequireDefault(_tutorCount);
	
	var _tutorHours = __webpack_require__(54);
	
	var _tutorHours2 = _interopRequireDefault(_tutorHours);
	
	var _totalHoursWeek = __webpack_require__(55);
	
	var _totalHoursWeek2 = _interopRequireDefault(_totalHoursWeek);
	
	var _studentOverview = __webpack_require__(56);
	
	var _studentOverview2 = _interopRequireDefault(_studentOverview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('accessApp.reports', ['accessApp.auth', 'ui.router']).config(['$stateProvider', function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('reports', {
	    url: '/reports',
	    template: __webpack_require__(57),
	    controller: 'ReportsController',
	    controllerAs: 'vm',
	    authenticate: true
	  }).state('reports.studentHrs', {
	    url: '/student-hours',
	    template: __webpack_require__(58),
	    controller: 'ReportsStudentHoursController',
	    controllerAs: 'vm',
	    authenticate: true
	  }).state('reports.tutorHrs', {
	    url: '/tutor-hours',
	    template: __webpack_require__(59),
	    controller: 'ReportsTutorHoursController',
	    controllerAs: 'vm',
	    authenticate: true
	  }).state('reports.totalHrs', {
	    url: '/total-hours',
	    template: __webpack_require__(60),
	    controller: 'ReportsTotalHoursController',
	    controllerAs: 'vm',
	    authenticate: true
	  }).state('reports.totalHrsRange', {
	    url: '/total-hours-range',
	    template: __webpack_require__(61),
	    controller: 'ReportsTotalHoursRangeController',
	    controllerAs: 'vm',
	    authenticate: true
	  }).state('reports.totalHrsWeek', {
	    url: '/total-hours-week',
	    template: __webpack_require__(62),
	    controller: 'ReportsTotalHoursWeekController',
	    controllerAs: 'vm',
	    authenticate: true
	  }).state('reports.tutorCount', {
	    url: '/tutor-count',
	    template: __webpack_require__(63),
	    controller: 'ReportsTutorCountController',
	    controllerAs: 'vm',
	    authenticate: true
	  }).state('reports.studentOverview', {
	    url: '/student-overview',
	    template: __webpack_require__(64),
	    controller: 'ReportsStudentOverviewController',
	    controllerAs: 'vm',
	    authenticate: true
	  });
	}]).controller('ReportsController', _reports2.default).controller('ReportsStudentHoursController', _studentHours2.default).controller('ReportsTutorCountController', _tutorCount2.default).controller('ReportsTotalHoursController', _totalHours2.default).controller('ReportsTutorHoursController', _tutorHours2.default).controller('ReportsStudentOverviewController', _studentOverview2.default).controller('ReportsTotalHoursWeekController', _totalHoursWeek2.default).controller('ReportsTotalHoursRangeController', _totalHoursRange2.default).name;

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class =
	/*@ngInject*/
	['$http', function _class($http) {
	  _classCallCheck(this, _class);
	
	  this.$http = $http;
	}];
	
	exports.default = _class;

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function dateStringToDate(date) {
	  var split = date.split('/');
	  var year = +split[2];
	  if (year < 100) {
	    year += 2000;
	  }
	  var month = +split[1] - 1;
	  var day = +split[0];
	  return new Date(year, month, day);
	}
	
	function dateToDateString(value) {
	  var result = new Date(value);
	  var dd = result.getDate();
	  var mm = result.getMonth() + 1;
	
	  var yyyy = result.getFullYear();
	
	  var today = dd + '/' + mm + '/' + yyyy;
	  return today;
	};
	
	var _class = function () {
	  /*@ngInject*/
	  _class.$inject = ['$http', 'JSONToCSVConvertor'];
	  function _class($http, JSONToCSVConvertor) {
	    _classCallCheck(this, _class);
	
	    this.$http = $http;
	    this.JSONToCSVConvertor = JSONToCSVConvertor;
	    this.filteredTimesheets = [];
	    this.total = 0;
	  }
	
	  _createClass(_class, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.loadData();
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this = this;
	
	      console.log('initial load...');
	      this.$http.get('/api/students').then(function (res) {
	        _this.students = res.data;
	        _this.students = _this.students.map(function (student) {
	          student.fullName = student.nameFirst + ' ' + student.nameLast;
	          return student;
	        });
	      });
	
	      this.$http.get('/api/tutors').then(function (res) {
	        _this.tutors = res.data;
	      });
	    }
	  }, {
	    key: 'create',
	    value: function create() {
	      var _this2 = this;
	
	      if (!this.selected || !this.selected.length) {
	        return;
	      }
	
	      this.filteredTimesheets = [];
	
	      var studentIds = this.selected.map(function (student) {
	        return student.studentID.toString();
	      });
	
	      console.log(studentIds);
	
	      this.$http.post('/api/timesheets/multiple-student-ids', { ids: studentIds }).then(function (res) {
	        var filtered = res.data || [];
	
	        if (_this2.startDate) {
	          filtered = filtered.filter(function (timesheet) {
	            var tsDate = dateStringToDate(timesheet.weekEnding);
	
	            return _this2.startDate.getTime() < tsDate.getTime();
	          });
	        }
	
	        if (_this2.endDate) {
	          filtered = filtered.filter(function (timesheet) {
	            var tsDate = dateStringToDate(timesheet.weekEnding);
	
	            return _this2.endDate.getTime() > tsDate.getTime();
	          });
	        }
	
	        filtered = filtered.sort(function (a, b) {
	          var tsDateA = dateStringToDate(a.weekEnding);
	          var tsDateB = dateStringToDate(b.weekEnding);
	
	          return tsDateB.getTime() - tsDateA.getTime();
	        });
	
	        var isOdd = false;
	        filtered = filtered.map(function (row, index) {
	          var next = filtered[index + 1];
	          row.isOdd = isOdd;
	
	          if (next && row.weekEnding != next.weekEnding) {
	            isOdd = !isOdd;
	          }
	
	          return row;
	        });
	
	        _this2.filteredTimesheets = filtered;
	        _this2.total = _this2.filteredTimesheets.reduce(function (accumulator, currentValue) {
	          return accumulator + +currentValue.hours;
	        }, 0);
	      });
	    }
	  }, {
	    key: 'tutorName',
	    value: function tutorName(tutorID) {
	      var tutor = this.tutors.find(function (tutor) {
	        return tutor.tutorID === tutorID;
	      });
	      return tutor.nameFirst + ' ' + tutor.nameLast;
	    }
	  }, {
	    key: 'createCSV',
	    value: function createCSV() {
	      var _this3 = this;
	
	      var timesheets = this.filteredTimesheets.map(function (timesheet) {
	        timesheet.tutorFullName = _this3.tutorName(timesheet.tutorID);
	
	        return timesheet;
	      });
	
	      timesheets = timesheets.map(function (timesheet) {
	        return {
	          tutorFullName: timesheet.tutorFullName,
	          weekEnding: timesheet.weekEnding,
	          rateType: timesheet.rateType,
	          isProcessed: timesheet.isProcessed,
	          hours: timesheet.hours
	
	        };
	      });
	
	      this.JSONToCSVConvertor(timesheets, 'Student_Hours-' + this.selected[0].nameFirst + '_' + this.selected[0].nameLast, true);
	    }
	  }, {
	    key: 'createPDF',
	    value: function createPDF(timesheets) {
	      var _this4 = this;
	
	      var timesheets = this.filteredTimesheets.map(function (timesheet) {
	        return timesheet;
	      });
	      var studentName = this.selected.map(function (selected) {
	        return selected.nameFirst + ' ' + selected.nameLast;
	      }).join(', ');
	
	      var docDefinition = {
	        content: [{
	          width: 520,
	          image: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABboAAAFACAYAAAB6J8p4AAAACXBIWXMAABYlAAAWJQFJUiTwAAAB0GlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczpleGlmPSJodHRwOi8vbnMuYWRvYmUuY29tL2V4aWYvMS4wLyI+CiAgICAgICAgIDxleGlmOkNvbG9yU3BhY2U+NjU1MzU8L2V4aWY6Q29sb3JTcGFjZT4KICAgICAgICAgPGV4aWY6UGl4ZWxYRGltZW5zaW9uPjE0NjY8L2V4aWY6UGl4ZWxYRGltZW5zaW9uPgogICAgICAgICA8ZXhpZjpQaXhlbFlEaW1lbnNpb24+MzIwPC9leGlmOlBpeGVsWURpbWVuc2lvbj4KICAgICAgPC9yZGY6RGVzY3JpcHRpb24+CiAgIDwvcmRmOlJERj4KPC94OnhtcG1ldGE+Cqhe9kwAAEAASURBVHgB7L15eBzVlfd/1Jt2S7Jsy7ZsvBtjDGYxxiwmrCEsAQJkgSSEbExIMkkmYZ6Z55n5531n5vf83jcTmBAIyQwBwhYIEIIhQNjBYCBm9YqN902WrX1Xq7v13m+1T/t2qXqRrKUlf4+fVlXdunXr3k/dqnZ/76lz83qNCY0ESIAESIAESIAESIAESIAESIAESIAESIAESIAESIAERikB3yitN6tNAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAg4BCt3sCCRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAqOaAIXuUX35WHkSIAESIAESIAESIAESIAESIAESIAESIAESIAESIAEK3ewDJEACJEACJEACJEACJEACJEACJEACJEACJEACJEACo5oAhe5RfflYeRIgARIgARIgARIgARIgARIgARIgARIgARIgARIgAQrd7AMkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAKjmgCF7lF9+Vh5EiABEiABEiABEiABEiABEiABEiABEiABEiABEiABCt3sAyRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAqOaAIXuUX35WHkSIAESIAESIAESIAESIAESIAESIAESIAESIAESIAEK3ewDJEACJEACJEACJEACJEACJEACJEACJEACJEACJEACo5oAhe5RfflYeRIgARIgARIgARIgARIgARIgARIgARIgARIgARIgAQrd7AMkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAKjmgCF7lF9+Vh5EiABEiABEiABEiABEiABEiABEiABEiABEiABEiABCt3sAyRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAqOaAIXuUX35WHkSIAESIAESIAESIAESIAESIAESIAESIAESIAESIAEK3ewDJEACJEACJEACJEACJEACJEACJEACJEACJEACJEACo5pAYFTXfggqH+uNSjjSJr2m7PxAifjy/ENwFhZJAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiQwWAQodB8i2Wuk7bauWtnd+JHsb/nEbMVkUulcmVp2glQUHUPBe7B6HMshARIgARIgARIgARIgARIgARIgARIgARIgARIggUEmkNdrbJDLHFXF9fbGpMUI3NvqVsrOhg+kpfOghKMdThuCgQIpDpbLxNI5MqtymUwed5yEAsWjqn2sLAmQAAmQAAmQAAmQAAmQAAmQAAmQAAmQAAmQAAmMdQJHrdAND+7mzn2yseYF2V7/N+kINwnClnhZXl6eBHwhqSicKrMnniVzJpwpxfmVJmueV3amkQAJkAAJkAAJkAAJkAAJkAAJkAAJkAAJkAAJkAAJDCOBo0rohvd2T6xTmjr2yebal2V7w2rp6jHxuPvh1J5nxO3C0DiZMf5UmTtxuVQUT5egr1D8PkSBofA9jH2XpyIBEiABEiABEiABEiABEiABEiABEiABEiABEiABh8BRIHT3SiTWYzy2G6WhfYcJUfKO7DFxuLsi7Ye7APTpLAO4GOduY3mOOB70h2RiyRyZWblUqkrnS3HBRClwJrBk6PPDcLlGAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAkNLYAwL3b3SE+2SJhOepLZlk+xtWmMmmdwo3ZHOIyIKodvRxC1h3O/zy7iCSU4M76pxx8qE4llSWlAlQX/hEZ2LB5MACZAACZAACZAACZAACZAACZAACZAACZAACZAACWQmMCaFbkwmWd+21Yjb66SmeaM0dOySsBG4EZc7o/XDu9tdli/PJwXBUikvqpaqkrlSVXacVBrRuyhYJnl5fnd2bpMACZAACZAACZAACZAACZAACZAACZAACZAACZAACQwCgTEldHf3tEpNywbZ2fCe1LVtk9augxI2Xt1q8bAjxiM7g97teG1nyKNl2ktbI8fklSX546W8sFomly2Q6vITnXW/SaeRAAmQAAmQAAmQAAmQAAmQAAmQAAmQAAmQAAmQAAkMHoExIXR3RVpld+MHsu3gW0bg3mHib7dJNBYxXtSZRW1Faee113V/pmWqY+DlHfDnS3FovFSNmy+zTDzvyWWLzASW+ZmK5H4SIAESIAESIAESIAESIAESIAESIAESIAESIAESIIEsCIxqoTscbTeTS74tG2teNOFJdjvidqY2pxKkcZx6ZKfLk6r8VMcgHRFT1EE84AtKWeFkOW7yBUb0PkMKQxWpimQ6CZAACZAACZAACZAACZAACZAACZAACZAACZAACZBAFgRGldDd2xuTSKxbOnuaZHvdatl84BVp7twvMZOeSmjOgkHGLAMtO91xeUZWL86vkGPGnyKzJ5xpwppMk/xAsfh9AVMfqOM0EiABEiABEiABEiABEiABEiABEiABEiABEiABEiCBbAiMCqE71huVrp4WaTRe23ub1hiR+x1p7jqQTfucPG7B2b1tF6Re3XZaNuvpysx0fMhfKJNK58qM8afKxNI5UlpQZUTvUvFxAstM6LifBEiABEiABEiABEiABEiABEiABEiABEiABEiABCSnhW4I3O3ddXKgdbPsbV4n+5rWS5vZhgf3UNiRiNWDUR8I22UFk0wM7+Nk8rgFUlkyS0rzJ5kY3wXGx5te3oPBmGWQAAmQAAmQAAmQAAmQAAmQAAmQAAmQAAmQAAmMPQI5KXRHYz0mJMk+4729VmqaN0hd+zZpDzcJQpcciUHIhvVqwOz4ZkJCdiUf2pt+kUocT5WO0ux9Xh7kELULQ+OkomiaTCyZ44jeE0vmSkGwzBxLwTv9FeFeEiABEiABEiABEiABEiABEiABEiABEiABEiCBo41ATgnd0VhY6tt3yM6G1cZ7e4O0dNVId6TdeHBnJ0HbAnK2F7I/x7jzOpKz+eNVPXdeuz66z0vkTspnBO+APyRFoXIpL6qWqeMWyrSKk2VcwZRDsbzt3FwnARIgARIgARIgARIgARIgARIgARIgARIgARIggaOTQE4I3QhRcrDtU/n0wGvGi3u98d5ulGi0x7g+93qKyKkulQrIqfYjPZs8qY7P5ljkUfMSwHVfqqX7HIfL80nAF3ImsJw87liZXXmmies9X0KBolRFMZ0ESIAESIAESIAESIAESIAESIAESIAESIAESIAEjgoCIyZ0GwlbYiZESa2Jv71+37NG4F4n4WhXv6AfFoEPH+YWl23h2F4/fET/1lKVkSo9U+kZvbpTeIwH/fkyoWSGzJ243ExieboUBscZEd+X6XTcTwIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAJjjsAwC929gvjbnT3NRuDeJJtrX5X9zZulJ9adADtQwThRgFmxy7DX7Ty67rXfTrPX9Rh7mWm/nddrPZPQ7T7GfT6fEbcR2mRm5WkyywjeZUVTJT9QYkKbBM2hlnu5uyBukwAJkAAJkAAJkAAJkAAJkAAJkAAJkAAJkAAJkMAYITAsQje8tyPGW7u5c6/sb9ksO+v/JgfatkpP9LDAPZg83WKwu2zsh6n3t8rB6SKBZyozXuLI/g0FCmVy6TwnjjcmsRxXOMURvX15/pGtGM9OAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAkNIYEiF7t7emHRFWqXOiNr7Wz4x4UnWmMkmdzte3V5tcgvQqfKoQI39XsekE6U1P461y8F2NqbH67Hu7XRleNXLKy1dGdnsgzd3WWGVVJUeK1Xj5su08pOM13dFNocyDwmQAAmQAAmQAAmQAAmQAAmQAAmQAAmQAAmQAAmMOgKBoaoxRO669m2y5eBK2dO4Rlo6ayXaG3FO5xZ3dVvF41R1Qr5sDOUgq3po2+t6DpRlp2sdtPw8k9CrmTURZWqhGdKs3YnV/hzrrg8KQRrMq5z4nvhfhIdp7NgnPZFOCfkLZWrZCfZurpMACZAACZAACZAACZAACZAACZAACZAACZAACZDAmCIwZEI3VNniUKUJpXGcEVy7TOiSsLSHGyRmBHC3gGwLt7b47CZt59N9Xmm6T5fQpt0isfu4vttxRdsWnL3q5j5Oz4mlfaydns26V7leae6y8ox8j4kpq424PbPydDNh5RyzXe4wh3hPIwESIAESIAESIAESIAESIAESIAESIAESIAESIIGxRmBIQ5fEYjETpiQiPT1d0tbVIPua18vu5vekvmO7hKMdQ8YylcCcKn0gFRnMsgZyfq9jgr58mVyySGZXLDcC92wpCJVIIBAUv9/vfCh0e1FjGgmQAAmQAAmQAAmQAAmQAAmQAAmQAAmQAAmQwGgnMGRCN7y2o9Go8+np6ZFIBIJ3j4RNOI3mzn2yv/1jOdCxQToiDSakSY8JMxLLmqWXyOxOc2+jcKTBsvGMjufs+3cwyuhbqneKVxvcOfPEJ4jJXRGaKbPKzpXKwjkS8OcbgTsgwWAw8YHY7fP5DAN6dbsZcpsESIAESIAESIAESIAESIAESIAESIAESIAESGB0Exgyodvx5jZCtyNuh8POEmI3xG/si8WiEo61S3PXTjnYvUGaw7ulO9oqkd5OJ7yJF1bVaI9EqPYqN1fTUgndSM8Tv4R8pUbgniFTi5dIRf5s8eUFHTEborYK3aFQyBG7sU2hO1evNOtFAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRwJASGReiG2I1PNBoxnt1xoRuTVUKwhud3rDcqXcazuzG8VZrCO6Stp9bx9I7Euoynd/Lsj/BH1pRUQnC2QPR4LGH9EdDtesSPzu6vnjO73H1z+fL8Uugvl7L8GTKp4ARH4A76CoyndtxbW8OUwJtbxW4sVejuWyJTSIAESIAESIAESIAESIAESIAESIAESIAESIAESGB0ExgyodsRsBGj23hww5Nbvbk1nIl6dms+YIT43RPtkvZIrbT27HW8vFt69khnpMmI4QhvohJ39tDTidhHKjpnX4sjy9kT6ZWACTtSYib3rCw4Virz5xqhe6bx6C52QpH4fCaAidnv9wecWNwqcKtnN/bRm/vIrgGPJgESIAESIAESIAESIAESIAESIAESIAESIAESyF0CQyZ0o8kqYuvSFrnt9XgoE4QzgZe3kbOdT8yENmkznt0HpTVcY7y9t0nLofAmJmcGov33tx6I6D2QYzJUvM9uxOBubAnIlJKFcvyk06Q0NFWCviLHg1sF7LigjQkn457bELqRpvsRl5uxufugZQIJkAAJkAAJkAAJkAAJkAAJkAAJkAAJkAAJkMAYITCkQrcyOixemzAlTnzuuKe3enXD2xvpKn6rMK7HYbLKnmi7dEYbpKl7u9R1fSKtkf0SjYVNsGoI43qm+FIFaF0i1b2ONPdxSOuPpZLTU6X3r2yfFAbKZWLB8bJpd0QqCqfJ8rlLDgnc8OCGsB3/JHtwQ+D2O8I2Be7+EGdeEiABEiABEiABEiABEiABEiABEiABEiABEiCB0UogMBwVtwVXrMPTGCKtCtoqcGOpIU5UEMfS12vy+4JSECiTstAxUl28TNqM0H2wY62ZyHKTdEUbExNY2oK2LWTb65jKsb8qt12urrv09QTKVOmJDBlWQv4imVJ4skwpWiJFgYnyQcdLZhCg1RGwwU49trHUDz24M0DlbhIgARIgARIgARIgARIgARIgARIgARIgARIggTFLYFiEbpsehFqYemvbojdEbkyiaAvfWFdvbyzzjOjtywvIeP8cqQjNlBmx86Sxe4sc7FxnJrLcIz2xDunNMx7iycr2YY9uR+PuK0VDvI7XK760/+o+TXMVrcnOUkXwpMQsNjDJZDCvSCYWHivTi8+W4kCV470dM3HL61sbxdcRD0cSCoUcRhC2VfAGQ3zsAYUsTsksJEACJEACJEACJEACJEACJEACJEACJEACJEACJDAmCAy70K3UVJSF4A3DEmItxGysq8AdD2sCT+9kwRsTV8ZieVKQVyaTi06RSQWLzCSWdVJvPLwbu7ea2N4N0m28oBH2xJTunCPdn3Titb3PS8i20+y8XufTvFjCfHlBKfRXyHgzweSUwlOkJDjVeK8HEqJ1R3e3NLc3S0c0IoFQUPIL8iUYCIrfeHM7ArcpCCxhunQ2+IcESIAESIAESIAESIAESIAESIAESIAESIAESIAEjhICIyZ0K18VZ7GEwK3bEHGxDa9l9ej28vTGPnx8eQUyzlctpcEpMs2ENsHElY3dO6SlZ6+099RKd6zFyN3RbDRvrZrn0hayVay20zwPshKRF8eZACTGa3uiVOTPkUmFx8u44DQjcOc77XcE7ENe2t0dPdLe1S6N5pNn0kLBkMMEeZSVLq3TcJUESIAESIAESIAESIAESIAESIAESIAESIAESIAEjhoCIy5026Qh2Kpoq0uI3fjEBe2o8fQ+PGmlen2rAI48vQht0lsslQXHGhF5rvHqbpLWnn3SbITvlp7dZn2/mdiy04jeMfvUfdYhRmcSsDPttwt1fK7NnzwjcJcGJ8uE/AUyvmCOI3AH/Pkmazx2OQRsDUmC8CTtdZ1xobulwYRliTixzVUIt8vnOgmQAAmQAAmQAAmQAAmQAAmQAAmQAAmQAAmQAAkcrQRySui2L4IK3bqEuBuLYRJLFb3jgjfEbZ3AUoXvuCiuk1hOkMJApQkNMs9MWtlkQprUmVje26UB4U166iSSIrQJRGxb7EY9ILgP1BBXvCQ4yYRYOdGI8POcGNx+XyjJg1sFbizxyfPlSbPx5O7o7pSO9hZp7miTqooJicGAgdaFx5EACZAACZAACZAACZAACZAACZAACZAACZAACZDAWCKQs0K3GzKEZng4Q2zGEmI2xGAsvSawVNFblyFfoQR8BVJsxOaK0BypLjrdCWtS3/WJNIa3GRG8xZwyLmS79ey44D0wkTvPTDJZas5ZZQTuCQXHOaJ7wIQo0dAj6sGtIjfagvY5wr6JQ97Q1iSd4U7TzqjsrKuReVNnuNFwmwRIgARIgARIgARIgARIgARIgARIgARIgARIgASOagKjRujWq6Qe3l6it4rabi9vpOPj88Eb3CzziiTYW2hE74lSVXiCdEWapb5ro9R2rpGWSI3x8g6b0yFkSvysutQ6uJe257e9D5NMTitZaiaZPFVC/lJzXsTVNqFVjHe6CtxoB0RuFbixjQ+sK9wlDa2NZtntbG+r3WWWy5x1/iEBEiABEiABEiABEiABEiABEiABEiABEiABEiABEogTGHVCt33h3KK34wXtxOn2nsQSIU4ggqsgDu/wPBPTuyg43nhanyVTipc48bzrOzdKfXiLdEYajejdLbFeM4llCrNFbtTHJ0Ep9JcZAf1EqS4+TfKN2I10/ajADXE7/gmaZdyDGwK35kPdOsNhaWhplJ5Ij3P2nXX7nPprCBXkpZEACZAACZAACZAACZAACZAACZAACZAACZAACZDA0U5gVAvd9sVT0Ve9oSFo4xPujUhTd5s0d7aZWNcd0mPE46jx6o6ZSS0RqcRvQouUhIpkQmG5EakLpcI3S8pCM2RatNVMYLnTxPL+1Cz3mtAmzUb07jCid/IklnFv7zwJmnAkxYFJJjzJfCcON7zFfb44Xi8PbhW6UV/sV4Fb2wExu72rQxqNR3csGnGauuPAblN3E7IFAj1Fbvvyc50ESIAESIAESIAESIAESIAESIAESIAESIAESOAoJjBmhG5cQxV/W7vbZXvjXtnbXCN7zHJHw17Z11wrDe2N0m0mdnQ8omO9JpSI33hzF8nJ0xbL10+6QgJmG+J4nvkU5JUbb+wyJ652Z6TBmcCypWeP8fiucSa07IkhnIiJF54XNML4NKnMn2/yLjDlTXLSfGYiSZ/vsKe233htB/zqxR1IxOF2C9x2X2zuaJVGE6NbPbgPNNRKxIje+RKys3GdBEiABEiABEiABEiABEiABEiABEiABEiABEiABI5qAmNG6I6a8CL7WuvkvT3rZFPNRtlat1NqWmqls6vVEa8d923E3DYfE307IXa3dzVJWBZKfn6+I3RrPG/1CPeZ0CYlvslSHDITSsYWS3vPAWkzYnej8faOxDqlsmCeVOTPMt7cVUY4Dzhiu4Yngbc2wpIEAvEJJtV7G8t0AjeEbXwa25uN0I1JMuPW1tYsLcYzvaigUJO4JAESIAESIAESIAESIAESIAESIAESIAESIAESIIGjnsCoF7oRSqTGCNyvbHtH3tu+WnbW75aWDnhBJ4cYca40Qlqbj4mYbWJzmxVffP3YqtlSVFhkNvOc+N0IbRKNxCewjAveJtRJzEwgmVdsQpTMNB7c002ok4UmjEnExOM2IU9MiBIVruPi9mHPbYQoUYFbQ5RgmclQhwbjzd3S2ZrI2h3ulIOtTVJVPiGRxhUSIAESIAESIAESIAESIAESIAESIAESIAESIAESONoJjGqhu6OnS17d9q6sWPu87KnbYSZvRFgSD4HbusoQpJ1QIIfmcQwEC2TW+GoJGa9r7AsGg3GxOwBxOz5xZdSEC4mamN7w9saxEL0LfeVOqTgGwnXcixve2xC2A045ELhV5EY+mC6djTR/IuZcja3NxiO943AuU5/apjpZNH3u4TSukQAJkAAJkAAJkAAJkAAJkAAJkAAJkAAJkAAJkMBRTmDUCt17Wg7IHaselPe2rjLe1+GsL6Mjclu5y4orpCx/nCNAQ6SGYamhS+KhTA4L3XZoE+SFwK2CdjAY9+SG0D1QgRtlwsKRHiN0N0mPWaoh8srOg3sdsR3tyFY01+O5JAESIAESIAESIAESIAESIAESIAESIAESIAESIIGxSGBUCd2Ird0W7pA3d3wgv3v3Yalv2GeuCeTfwwbxNy4Cmz3Juw5nstamlk6RgkC+k4JjVTyGgI1yIFjHYgHHm/uwh3fcs1vFZgjjcU/uuAc3ysDxMC3P2cjyD8rtDHfJgeY6I+JHko7a13jAqVdSIjdIgARIgARIgARIgARIgARIgARIgARIgARIgARI4CgmMGqE7pgRf2taD8rTG1+WZ02oktb2xgyXDaFCMivdM8umSlHw8OSObmFaPbPjgnfMiMyxQ97e8bJV1MZ+XUfF3OVkqGyf3R3dXVLXgjYmt2F/Q60jdEMMp5EACZAACZAACZAACZAACZAACZAACZAACZAACZAACZgoHaMBAkTu7Y175NGPVshbn74lHV1tKautArAuU2Y0O/z+oEwtnSSFgZCnMG2L1Spio1z9aNnw3ta8utR9A1mi/NaudjnYXN/n8HoToxvhTBBLnEYCJEACJEACJEACJEACJEACJEACJEACJEACJEACJDAKhG6Ivlvrd8m9qx+V93e8L2Ez4aQJMGL8nFN7NGPeR3NYRisuGCcVRRUSMDG1IVCnEqntdKyjTrbZ++30ga47QndHmzS2NfUpor2zVZo6WqWosMipx2Cfu88JmUACJEACJEACJEACJEACJEACJEACJEACJEACJEACOU4gHkg6hyu5p7lW7lz1e1m99V1H5EZV04nczv5DOnQmEXhC0XgjdJc58bQz5bURIa/9sfcd6TpE7pgJj9Lc3iJtHS19iguHw1Lb3NBHbO+TkQkkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkcJQQyOnQJc1drXLbm/fKup0fSjQW7fclcXte2wXA63uSEbrLjVf3UInW9vn6sx6JRmV/40EJd3f3OSwcDcvBlnoK3X3IMIEESIAESIAESIAESIAESIAESIAESIAESIAESOBoJZCzQndbuEP+78p75KNt7xpRNzao18cRtn1+qSqdaITu0n57dA9qZTwK64lEZHd9jdmTHCIFWXt6eowIXucI3RDy0RYaCZAACZAACZAACZAACZAACZAACZAACZAACZAACRzNBHIydEm7icP98EfPyOrNKwdF5HZrwRCI8wOFUlFcKaFDE1HmkmDcHQnL3oZaz37ZE43Igea40O2ZgYkkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkcJQRyDmP7nC0R97YvlpeWPeC9BjBd7AMQrbPFzAfv+MNXVZY5nh0+/3+nPKKhgjfFe6WfQ37PZuOEC5N7c2C8CbBYNAzDxNJgARIgARIgARIgARIgARIgARIgARIgARIgARI4GgikFNCN0TezXU75Bkjcje21w/CdciTULBAJpVMkurSKhlfON5s5ztCd2l+scwsqxa/z+eELhmEkw1aEe3dHdLQ3OhZXiwWk6bWJukId0lBfr5nHiaSAAmQAAmQAAmQAAmQAAmQAAmQAAmQAAmQAAmQwNFEIKeE7sbOFnlp00rZWvupxPox+SS8tSGS2xYM5MvcCfPl5KqFckzZNDPxZIUUm3AlvkPCdiAQkJKi4oQ3dy6ELkEb8DnY1CCdna12cxLriFfe0dUu7V0dMr60zMmfC3VPVJArJEACJEACJEACJEACJEACJEACJEACJEACJEACJDDMBHJG6EZIjo9rNsrKLW9Jd09nvzDYIjdE3/HjquXzc86T4yrnOpNNhvwBycM/sw+GcCWhUEiCgaAjfGt6v046RJnRlj0mbEk00uN5Bsj57UbobjThS6ZNmOyZh4kkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkcDQRyBmhu66jSV7Y9IY0ttX1m78K1T5/UE6uPk2+suBzUp5fKgETj1s9uJEH67pEfGuNz63H9/vEQ3AAhO4ttbtSl2z2w5u7sa0ldR7uIQESIAESIAESIAESIAESIAESIAESIAESIAESIIGjiEBOCN3w5t6w/1N5b8fqPiFIIEK7Pbbtbb1WRfnj5KI5F8jFs86UQhO2xOePx972G7EbYUpU1FaxG9t2upYzkku0C58dtbvTVqOzu0vq25pNeJdYQrxPewB3kgAJkAAJkAAJkAAJkAAJkAAJkAAJkAAJkAAJkMAYJpATQnermXzxqQ0vSqSnO4FavazdorZ7G/kqiifI5+ZeKMunnSrFoUIjavvMJyDqtQ1RW4Vu5NePit6Jk+bIyq6De9LWpNNMRNnQ2iAxE6+bRgIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAJHO4ERF7ohXH9cs0k27l3vXAuI0EhzC9ruC2WymTx5Ul5UKZ+bd6GcM22JI3LDSxsCN5aOx3bAiNyHQpigbNtU8LbTRnJd2z1n0nSZWjpewj09jphtcDgWr36e076CYEiixqObRgIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAJHO4ERF7rDZtLFpz95WcLhwxNQqtjtdXEOi9W9UhgqlnNnLZezjSd3SX6RIwBD5FahG17cGqMbZR0+1qvkkU1TYR/Ln1z+Hens7JAOE6IkEok4FTPSfyK+OAT8ieXjxecS7ke2BTw7CZAACZAACZAACZAACZAACZAACZAACZAACZAACYwMgREVuiHqbmnYLRv2rDOtj7stq+CbGge8veOi9WnTT5PzZyyTsoISR9wOhUIJkVsF7lzz2k7drvgetL9q3Hjpzi92RG7E4bYNYVmCxps7Pz9fTBCWjJ7v9rFcJwESIAESIAESIAESIAESIAESIAESIAESIAESIIGxSGDEhG4IuhBxV+58X7q6WrJmC5EbNnX8HLly3gVSUTROIHDrxx2PO5579PyFMG+3wS10Q8BXT/Vc9lAfPcRZUxIgARIgARIgARIgARIgARIgARIgARIgARIggdFOYESF7nYTrmT1rg/77ZUcChXJ9cdfIZOKx0vIeDe7w5WMVgEY9YaQjdAksFgsmvBex3bck10coRt5kHe0thXtoZEACZAACZAACZAACZAACZAACZAACZAACZAACZDAYBAYMaEbld/RtE/qzMfLEH5avbft/Xl5Plk6/XRZNHF2wosbYTyciSdNTO7hFn6jsbBEeyOHxPq4u7mRq038bPPxBUx9TJ3Mv0ym9Ya3NgxLrzAudj4K3Zmocj8JkAAJkAAJkAAJkAAJkAAJkAAJkAAJkAAJkMDRQGBEhG4IuPhsOLBVurs7PDm7RW4VvsuLJ8h5xyyV/GC+EbrNxJPm4w/EJ51UEdizwCFI7O2Nyqbal6W2dbN09bSaNsXjaYcChWZyzIlSXjhdyoumSnF+pRQESiXgR1xtX9qaqHjtJXLrgdpOLHVd93FJAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAkcbgRERugE5HI3I9oZdxhs66oi16YRd5IfwDW/uE6oWyvTyySZcScB4cRuh23z8vuH35HbqZCbQ3NXwgexqXIMaIskxiPIQtP2+oBSFyo3YXS2TSubKhJLZMr54pkmr8PTytkVre13LdS+zyeM+htskQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkQAIkMNYIjIjQDVG7w8TnPth6UKJmQspMIrdCL8ovlcWTj5PSguK4yB0MJuJUj4zo65OJJXOM0P2xVtFZQpQ3U21KLNotzZ215nNA9jauk9L8CTKxdI5Mq1gs08pPkoLguKTjdGNk2qJn55IESIAESIAESIAESIAESIAESIAESIAERHp6euS9995LzBV2yimnjGksH3/8sXR1dUk0GpVTTz1VECp3oHbHHXdIfX2949x58803y8SJEwdaFI8jARLIksCICd0tXe3S1tliBOFkT2jU2x22JN6WPKkuq5bpZVOdsCWYgBJxrDXUR5btHbRsEOd7Y71SWTQvrUd6PORKr0RMLO/Gzn3S3FUr+5rXy65xH8ixVefJlLLjTTzvEbkMg8aCBZEACZAACZAACZAACZAACRxdBF555RVZt26dM1dSupZHIhHn99KkSZNkyZIlMmfOnHTZk/bt2rVL3njjDdmzZ48Jednt/P6DUxDKhPg0efJkWb58eb/KTDrBoY2BtOW0006T2bNnexU36tLA+eWXX5Z9+/Y5bLUBRUVFsmjRIvnsZz/rsNd0r+UDDzwgjY2NffpDOBx2jl+4cKHXYdLQ0CAPPvhgn+M8M1uJECFLS0vlhhtucDQBa1e/V/X6o2+hX33729/O2F73STo7O+Xee+91ktHm8847TxYvXuzONiq3N2/eLC+88IJTd+gwaJfOLTYqG5Sm0u3t7bJixQqJGYdM9Ie5c+cKnl0DNZQzWgwDGm+++aasWbNGmpub+zikjhs3To4//nj5zGc+k1H81/sBz+ri4mK58cYb+91ntIxM/PAswLOqqqpKTjzxRDnmmGMyHTIk+3GPfPLJJ86zDO0GqwsuuCDlubZt2+b0tVAolJQnm2fbs88+K1u2bOn3czPd8xi88T2wadMmaWtrS9QJbBcsWCAXXXSRFBQUJNJzeWXYFVb13m7qapXOsInPnaRqY9LGXvNAAbK8pBsLD5kZRuSeUFzhXEwVuUcSLh5axYGJUuAvls5IvCOg7klNQkustJgJ1dLW3SDb6t41Hu1bZV7VOXLc5M9KYbBsJJvCc5MACZAACZAACZAACZAACZBA1gQghEDYzNYgaEIEqKiokK9+9atSWVmZ8tDW1lb5wx/+IDU1NUl5IACoQfjeuXOn85kwYYJcd911Mn78eN3dr+VA2wKhHUJrYWFhv86XS5kfffRR57p41amjo0P+9re/yerVq+XKK69MK9wePHhQcN28DHxTGQYx+tOP7HJQP9UX7PT+rruv/0MPPeRc1/6Uc9999wkYqKFuY9EgdI91g/akZq9r2lhcQuDGgE+6+6mlpUXefvtteeedd+Tss8+W888/PyUKiObwZIdmBgF1IGaXkel4fL/gWfL+++87A2BXXHGFM0iR6bjB2r93716Hi83v3XfflXPPPTelwA8xOdWzMdOzDd+lqZ63mdrkdU6I7njueQ3MoC4ffPCBfPjhhxm/BzKde7j2p58ZcYhqgYvfFm6XcKQ76QzaKSAU67pmCJrJJ6tNbO6ywhIJmPjcELrx0BmJBw/qhg86gT+vUIqCE4wsHzfUHabPxnhb4mn2Xwje8O7+cPeT8taW/5HGjj1J3u12Xq6TAAmQAAmQAAmQAAmQAAmQwFggAFHzzjvvlN27d3s2Z8OGDXLbbbf1EbmRGb/94P3m/g1YV1cnCBEAUXY4bf/+/XLrrbfKaBU14YUNwcQ2/M6GB5/NGL99//znP8vWrVvtrEnrRxLeIamgfmzg7e6hsO3btzuerdmWDe/KAwcOZJt91OWzB5ggPo5lgyeuin2q+4zl9qKN99xzj+PJi3Xb1NPYfW8j38qVK53neKr+oHqdXV5/1wdaBgRgiLZ//etf+3vKAeUHDwwYuvllGhTKFe9oDNClErltIGjfU089lfK728470usj4tENQJ093U58bjcAs8sxCMW6joSCYJGJzV0uAb8RuQ9NPml/+caPGp6/OK92Yr8JO1JWUC31nTsSJ1eRO5FgrUAQtx8f0ZiZlLN+tXT0NMnSGdfJpHELTCgTv3UEV0mABEiABEiABEiABEiABEggdwmcddZZTqgGvBbtNvx2giD82muvOd7X2I/fUo888oj89Kc/TfJ2g1D93HPPJRWB19EvvPDCPt55O3bscMQZePFpmTgWoQcQNmKgduaZZzqeil5tgfACQRMCip4XwtiTTz7peKkP9JwjcRziEMOLTw1e8ZdffrnMmDFDkxyx1/byREiHH//4x56hQn7wgx8kvBPh4f7www8nrneiQI8VvN5vn9MjSyIJAvzTTz8ta9euddJUkExkGMQVtBthdqZMmZK2VIT1gMc7DP3DFoXTHjiKdiJEzxe/+EWnxhpCdhRVv19VLSsrc9qKZxSeXeXl5f06fjRlxv1z++23J+5b1B1tXrZsmeCZjpAjavDKhocyBG697zDAiIG+f/iHf3AGIDXvUCwxqHXLLbd4Fo06w3scYa5wP6rB8xzP58suu0yThmSJ7x0v72rllOqk8+fPl5/97GfOMwNtQBl33313quxJ6d/97ncT1yFph2sD5WIwAoPLqmG6sshjjz2WVBauP75DdaAD8fnRRrQn1Xe3u8yR3h52oRsNBpxILJrkwYwLYIO3RW4cU2yE7rKCUvH5fSMWlxv1UEN94x+/jAtNNR7dPtOew/GX3PXX4+D67YjdltqNOOX7WzbLm1vvkaWzrpNpZSeZNo7IpUlUkyskQAIkQAIkQAIkQAIkQAIkkA2BkpISR+RLFcJj5syZcqOJ0YrXnyFUwvR1aMS6hkFAfv755511/MFvrc9//vNy8sknJ9LsFZSJWMqIJ/rHP/4x8UMdQgwEyoHGaUXcZwiWqdoybdo057wQffEqNwyiNwROHDdaDOKFWnV1tXznO9/RzcQS4QkQnxhhZGAQYhC+IJX4B5FQzV7XNK8lmGWbF0KL7YF+7LHHDglzFazvv/9+ZzAmlWcmBkMgEsEgxI1FkRttw/2dKsY69o81O+6448ZakzzbAy9kO4wFngPf/OY3Pe8pPA/PNWE4EJ8bg1iIDw3DpJ2///3vBcLrUBq8nyG8pnrGou4IX4UQIggjBIEbhucc4qzjWTEUhvBa9rP04osvdgZg9fyZzol7Sw1t02ePpqVa4nsqW7MHK/G9esIJJyQOxfcuBizUUH8I3bZhbg18D4ArNFt8d2Ow8aSTTrKz5dT6iKipjqDtUoJtkduLUH4gJEWhgoQ3t1ee4U5DJ8EXWmn+VAn68yUcjccecjUtqVrp9jV07JZVW++VpTO/KjMrl3KSyiRy3CABEiABEiABEiABEiABEshFApl+y2mdTznlFEeYVq+7jRs3igrdEI61HPzO+v73vy/wMs5kEDB+8pOfOJ6JEBdQBsJs/OhHP8p0qOd+rYPnTivxc5/7nDNpG8RNxAuHCJxKAIb4AgEenu36qj8EDXirQ1TwmqATE0TCI1GFD3iaQ2T3sv7k1eMh0iIkAZaXXHKJJvdZwusQ7WpqanL2eXm69zloiBLwVoDyQx+Bp/9gm91WiHiYKBPin5dB4FNBCyJ8IBBIbHvlt9PWr1/veIJDZNI+B0Ed3u0QE1PFm0f7//KXvziiOsQ/XDtoEhjwgWc5+hhix3/ta19zWNl54dmK6/jqq6863vYoC/0L54Jnvd6Ldj2xjnzPPPOMM5hknxP70A58cD1w/EwzAAXhDx/1ckU/w8AT+nC2Ezt+9NFHThl2/HZMhoj7HRPQot54swLngFiICVPBwTaEZMA9hLc/cC3VdFJF1Md9DPK89NJLDidcU/BNJSqmqiOEcnhEo456bfXcqZYD7Q+pysuUjmeGPoeRF9f/2muvzXSYc50xxwLC9eibDJjEFvVHGUNluBbZGARvvCn0y1/+0nku4xjcA/PmzfO81tmUmSoPri0GWfUaQ1DHPYD+kysGbrgH1HCNbHEdMc21/pg3wy1y63G4fzHYhesMw4SlFLqVjrV0wo8kIltbO1Ksmuem0zHxIMJDFJ+RNq1HUbDCTEg5LiF0a71QxXTCtuazly1dB+X9XY854UuOGb+EYUxsOFwnARIgARIgARIgARIgARIY1QTw49gWWNAYCMEQS9SuvvrqrERuzQ8h6vrrrxd44MIgjkH4GyovPpwDoiTOqwIw0twGAcH2fnTvh0gHz0gI3t/4xjeSvMghKMJ7WUUITLzpDvWC8iBkwONahTz8Rs0mdMvNN9/sro7nNs6fC57KbsFmwYIFSYKNZ+UHkHjOOec4schV0IEgCIH9XOPNatsLL7yQ1GdPP/1051qo+GfntdfRNxEb3RZw7f0QkPCB1yXuA7fBmxL7cV3QRzDg8t///d9JMe1xP+Ga2XkR9gUivpcIh36I/oV2futb3+ozUSzCVsCDE+dEv8c51RBTHwNWMAxMIcSBO1456oH2IlwOvEPThZKAOA0+KpLrebBEORDyEaLiS1/6knPvYKAAfR6DaCqio54oA7HWvUzLef311+ULX/hCH2918MX5US6uu1voRlvuM96teLvBbVo2WH7lK19JhH9w59PtI+0PWk5/ly+++GLiEPQLr76WyOCxcumllwrujdraWmcvBk+GUuj2qELKJHif4/sA1wh9AdcS/XTRokUpjxnIDvR1ff7jvkB4H30OD6S8oTgGk4zag4MXXHBB0mk+/fTTxPbixYsT614ruMf0uYjva5SLdueiJQ95DUMN0dFg+f6gmcgx9ekhErtNhWV3+khtoz4Q3vMDxVISqupTjUNN7ZOeKaG5s0bW7F0htS3mPzbmH40ESIAESIAESIAESIAESIAExgIBL888/HjW34nwKhuIIDFr1qwkj2eN4zxUzCBQ2a/9w5vXNoiDv/jFLxKv+Os+eLe6J3eDWPTzn/9cIPKpQbRDzGw1CGjwVHfbE088kSSuXHHFFTJx4kR3tgFvQ7hV0REeqtmGGRnwCVMc+PbbbycJNkPhzY1Twzv/mmuuSWonhFV78lT1oNeqYqAC4i+OTWeIif6rX/2qj8iN/uDuP+i/iJ/sHmRAPvVChh7hFrlxfj1G8yI/+o9b5Hb3Q+T59a9/7cS5t9uB667nxLptdr3ByRa5UT7qaBs8veEd7mUYnLrrrrsS/U3zuPngWYGwG3bIBfs8ECDdIjfE6oqKiiTO8MZ//PHHk64tzmm3yS4X+/QaukVurzpiAMrmgeNt07LwLMlkqfpDpuO89uOtDAwYqCFchV5fTctmeeWVVyaub0NDg7S1tWVz2LDkgQcyvLvVEDZrMM0dsgTPDI1pPZjnOZKy8F2L56YaPM4xqKGG+0jfSEE/Ryz+dIY3ivTeQB/Kpt+mK28o9yV/Gw/lmVxlFwcKTbiP1Oq/WyQOR3qkOxqf3MT9sHEVPSybWgc8EIKBAinJN0J3Gx7icWEaz3N3GzJVTL8DYr0xOdi6XdbXPC/FofEyrjD9BBiZyuV+EiABEiABEiABEiABEiABEsgFAirC2XWxvcoQF3qgBk9meHLCIHThXG5hLlPZ+kM+XT4V2lSch3hgvw6OY++5554kwXDq1KkCYUi9TiEe4/V/jTmNsnAMJlzTOsODbuvWrY43Ispct26dMwignurwjIenohoGCAbrdXJ467388svOBHRa/tKlS/uI9LpvKJcQbOCZqIZQL6lCe2iegS5xHfBbH57NKjQjDZ758KjHOsKZYAlDf0kV2sSuA0RklKHHYR+uFQRyFZzhif3UU08lBjwgJOFc8PZ3G3QIDKbgo4Z49gjH4Y5lbA8uoW0XXXSRwAMdZbj7IfIiHEM2bdLzupcQGeG1rX0d/RbtUlENoiPqaguRmEQW8c5tPujPEGH13sJAEMJQwPs8laH+CCmihjAiV111VZIIiVAmELhxTpwPcwNkE2Ma1xDitV1HlI+wKSogQvDFgJQ9MKJ1sZep+gM8brW9qCeeEToAlq4/2GVnWke5ei0wAIDwRAMxTNSKa4yBOjDBswwe+7li9vcB6jiQ7wOvtqCtdsgSvF2iz2Sv/COVhpAl6mGu971dF9z7uAdgeAbp/WrnsdfxXEF/UYFbNVE7T66sj5jQXZZfIgWhIsPBFofjE1ICmP3wAKy2cLu0drclRoxyASDqiU/QXyAzxp0p44Pzxdcbkq5oi7SGd8vBrvXS2nPATFEZjxWXqc74rjTFOYZjdjV8KOWF1XJC9ecdr/FMx3M/CZAACZAACZAACZAACZAACeQyAbzSr4ZYuTAVv/HbCiLZQA2xiSESa3kDKQeCCERyFYLsMpAGb16EYLAFRvfr4Ah9YHubQlS0wz2gTAgGX/7ylx0hWSfhhCgBr1g79Aji5t52220JL9cnn3xSfvaznznthFinhvIg6A3U1JtXf4dj2zaIkhBIR8LgBZxOsBmKOqFvIjyGTsSJ82MQBXzsUABf//rXE0J1unrgGmu/RD/HtXeLY2CM2PQQ0TQcCERd9Dn3fWGL1xDbMTEr+n86g5j193//91JcXJzIpv0QoVjU+xMiLcTVgbwZ4NXXIVhDTP3P//xPhx0Y4jmAWM9qEHRtPggD4Z4UEvW58cYbBSFH7OeIloElvIq1HIR2wf3j9laeOXOm4M0HvbbwbsYxOsBkl2evIya4PhdwDTFw5Q73gAEYDJIgrx0b2S4H6+7+gJjqbo9a1BP9wZ74NlV/cJefblvbgDx4G8HNJ92x7n04Hs9MmHJ35xmpbfv7APcLPpmucTZ1RdgXDVmifSyb44YzD+4xe3AQsf/d9zNYoB/D0Aey6Qf6/YBjBoMlyhkKGzGhuyhYIMVG7AZYwALf+LKvyI2Gd/aYuE6dTRI13s4jVmmPK4DO4PcHzISUVZKfV24efFEp7Z0iEwrmy4zSc6Wpe7vs63hPGrq3Go/0NuPv3TeIfrzt8cINikMsRCK9Ydl68E2ZVDpXplWczHjdHvyZRAIkQAIkQAIkQAIkQAIkMLIEsvGCRg3h0areYNiGAAZBVUNjIC2bH9vI52Woh/5whxCNctXT0iu/Vxom58InW0OsWndsWkw8qQaB0i1y6z4sIQwi3inEcRhEXcSJVhEB7YG4d+eddzpCDcJjQOyG2YIrxDU9xtnZzz/4LQ5mtoCqRaAOiDc8EoZ62TynT5+e0fNwsOoJcfaMM85IEoDtsnGd3AK0vV/X8Zq/7XmP49wit+bFEgI7JtODmKbtt0VhOy+uDbyRM3lj4hiEwrFFbrscDGKgjgjHg3MidrxbGLPze63jXoN3s5fBGxT3wdNPP+3s3rNnT0JcxjMAYUvUwMctcus+LDFZJ8R4vO2QznCv4N7ymsQV1xbiMvo7Yjpnunfc1xBvN7hFbrsu8ETHuTFI4TZ3WWivW+S2j4Eoj3Lq6+sz9gf7uFTr8OhWg1B7JKZvI6AMlIvnWa4Y7g18YOgL+O7J5j5JV3+EorEHMDCQkqnvpCtvqPbhe0QHY8HAK9STskEdvJ77XnXT641nBAZdhurNGq9z9yctdZDs/pTSj7wKsyiYLxNLJxnxVqtwuBN6FReJhGVvc43x6o671nvlGe40tAWfuNjtNx084HRydHSfzy8Bf0jGF8yTBeVXybFll0ll/hwJ5IX6VNP0kSSztzE55abaV6W9uyEpDzdIgARIgARIgARIgARIgARIIBcI4AcvhFqEJHB/PvzwQydswb/927+JHaIEAiFihsK7UH9k47fVkU5uZYsOEJSG2uAFqx6NOBfEBfX2Q3vc3t5e9UEerTeOh6BlG8QECGdq8PZVj1+kff7zn++3oK9l6TL5d61fkxPLW2+9tU/c48TOIVxB/9HYv9nyHMzqQLj1ErMRE/7cc8/N6lQQANXbFf0b4UUymS1MqSjsdcyJJ56YlXgHQTOdeAy26cRWr3O70yByphuoQogH7ed2Prt9ENLOOussd9F9tnHPoM5uQzu1bIhxv/vd75yQKF6CM0LgzJs3z1MId5eLOqonNAbUzj//fHeWPtup7n27P6C+y5cv73OsO8E+n83LnS+bbTuWvAqX2RznlcceOLHL9co73Gnoa9rfBuvcjzzyiDPYgPIw0IE+lGumg2NaL4TNssMEaTruH697SPdnWg7H92umOqTaPyLO0YAZMELwrPJp8qYvINFY5tAevcaTe3vDbqk3Xt2VxeVHdEFSwehvunYKPEjxhYWJI/1+n/mPmvHbPvRqBJa+WLFUFZ0kRcEq2dv+rtR0fCg9sa6sTocy9zStlT2NH8mCyXiY68BAVoczEwmQAAmQAAmQAAmQAAmQAAkMKQFMJolPtoZJ4eBNCUPoBISJUO9VeHfa4km2ZSIfPJzVyxkCDia27K/BKxVxZtUbzj4ev/kg5iA2torR8BL87W9/Kz/60Y8csRnnV+EedfASGOwysY7247xappeHPDxIMaBgewbjWHiTI97xkVpRUZH8y7/8S6IYiHrwXHzllVcSwg5CdyBOtcYQTmQeohUINnaICnhjeonOQ3T6RLGIkY3wMSq4o8+m8rBOHGStaJ9EEryLs5m0DkI6RDoI5CrcWkU6q9AjshGFkTlVGXaZKsbbaf1Zx/VKZ/Z+vUeQ3+YDj/1sBrsQMgMisfs+BVsMQNgTb+Ke0ftmwoQJzj0J0T+dV727HfZ5UMdsriGuNeqoYXe0TLu92IdBpExml5HNtUxXHsRZfYMEMcWPxOzjMWiQSwbOyhr30pFOpIs5C/SNJDwvMcCYzo70OqUrO90+XFv7LalUIafAxr4P05Wp+3QwA8+eIx0Y0zKHYjkiQjcaAsF2XsVMKcwvlu5IZtEXD8XdjbtlV+NemTN+elYP6qEA5i4TnVdHibAei0XN57DQjS8L/ZT5pkm+v0TyfWWyve1VicTSz8qs5+qJdsmmA6/IzMrTpSBYmhMiv9aNSxIgARIgARIgARIgARIgARLIhgB+NyEUhO3pqM5DOB6/+VpaWvodMkHPrZPL6fZAlgiLkGlCR3j5wivzoYcecrw8UW9MpIcQEmij3aZs6oDjVZjAeqpXwhEmRQU7lIvzYNK/oTCI7ZgYFB7Dv/rVrxLtROzha665ZihO2afMtWvXJrhgZyrBps+Bg5yA3/mYnBHhY3B9vvWtIwsTk031IKyqCIV1rzA8CLmRbegALSubc49knmzFdlwTL6EbdYf4j4EjTFxpC9TYh9j5+CDOPu6fZcuWpQy3gvxHYqgjrpEtUnuV546H75XHTkvVH+w82a7399zucnXwx52eC9v29wGeZ14DiNnWEyFL3nrrrUR2PIsgFNvtR3/C9xeeETB4PGMAF+noj+gPQ204tz04iAEhxOfOZNnWDW0ZDTbsQjfA6GdqyQSpKpsmTe3Jr2alAtfR2Srv7vpITpu+WMpNmJBcgIw6oFPoUsR4dpvOhS8SfPCgxmg4PrgRinwVckzpWU687a0tLzpxuBPtRZ9JMQha17ZDtte/LcdN9o55lSiDKyRAAiRAAiRAAiRAAiRAAiQwjATgaYvXuNV7zuvUU6ZMcSak89oHL10N94HJGAf6OjiOVZEB51OHJK+7bI+bAABAAElEQVRzpkpzC2Op8s2cOVMwEeF9993nnLOmpsZpg+2N2h/xAF7sEEbwuzJVHFlMUmgb2gqB/YYbbrCTB3Ud3uYQdZ577jmn3G3btjm/cQfCtr8VswUbeOcPtF/097xe+SEoQ+DH9YFoNVDLlhtEXPQf6Al4MwBe5G4bLeK1u97ptrPlg76voUS8ysObDvhoWCWE+8AEm/p8wDFYR+ihvXv3OgMZXuV4pfWnjvb5vMpCWrbl6fG47umetZov1RKTNKIfo24QcPHswvOyv4Z47hjwg6G8bN5ecTIP0x/7+wDPj/5ytquJCUvta/nUU085IbnsPO519M877rjDSUaYrv68BeIuK9ttDITqdymOsSc2dpeBN3PwZgIGYvC9h+uZbuAM3086IIuybB7uskd6e9iFbjQYNwEe2oUmTvfJUxbJ5pq1BlLfSRrdcJDn/d0fys6mC6W8cIF794htoy24yPofGazrBw8hjBzhQYT98QdSsUwrOUOi0iXbWl6TWG80XvcUIjd2Is/6fc/K3InLJegvdBiOWIN5YhIgARIgARIgARIgARIgARI4ROC0005zwn0MFAgEKX2VHpPMQXjqr2iCH+l23OqFCxcOtDpZHweBHqKnvs4OIUB/G6IQCAj4ZArFgt+OttenLZZrZV5//XXPie22b98ub775puN9rXmzWSLkAH6bQuzIVD9cnxdeeMERXYdLXMW1VK5ojx2zOpv2DUWegfYp20vZblO6OqI/DBfrdPUY7n2YwBG8MomS4Gh706aqJ7xZbY9WPFswjwBiv+O+gyF+N0IvoZ+nMvsawiMc10b1n1THwLsXn3SGAYyf/OQnGctKV0Z/92GSUdz3EC3B4Pnnn++X0K/nwzNB+yjK6+8zW8sZiiW4298HiA8/kobvhuEwhFdRQ4iwdOF50H81tA76ASZ3TSd0Q0C374NM3xtaj5FYDr3vvEerIHSr2H3G1BOlqHCcR67DSSZ7wlra6mXFhlekJxpJpOXCirZJ24VOg4czRG78RwWjsOhEWGLUJD9YJNOKl8nkwkVZi9aNnTVS07wxF5rLOpAACZAACZAACZAACZAACZCAQ+BIvAtRAGK7qscqfnA/+uijST+oM2HGMYgfraILfncNRtzqTOfFfpzbNrRDBQDUZ9WqVfZuz/WPPvooEWIBvyf1eM0M8Q9Ct9opp5yS1D7E0YaAl63B6w/hSH7zm9848cWVW6rjETtcBQ4vET7VcUeSjjapYTBh/vz5ujnqlojVjOsKA0t4GWcyOzY6+kMm4TdTebm8HzGvVTRGKA3cD5kM94P73sMx7777rhNS6OGHH5aVK1f2KQZiLGIr//M//7MTG18zZBKk7WsIwQ9vNmSy999/P/FMsvPaZUFsxmBVJkM+THqLj+2xm+k4r/3oi/bAEYR+xOPvj+EZYodRQriYXOqjuP76XMMzCxOlHokhtju+pxYtWpT2Y88hAC0QgyeIBw+P7qE2zB1hD6TZE5imOrc9OLFu3bpU2Zz09957L3HP4a0j9/dU2oOHeeewC924qfBRIXhySaWcUn1q4sFvt//Qd4GBeTgVD7O3trwpq3Z/lOi4h/fmzpq7nejkjsBthO78/JCzXpRfaTy7l0lpYLKpuKXmp2nG9rpVpt3RRAdLk5W7SIAESIAESIAESIAESIAESCDnCeC30+WXX56oJ0QdTNBmT3SW2OlawSvXEG11Ikfsxg/84RBd3K+J4zcf2mKLGgiNAA/QVAZPP8S9VoP3qS0gQKyBiK+iHiZBQ6xuiHXwooRh34MPPph1OAM9DseCNTxc0xk8N9Ug+Aw1Wwg2NjPETVchVOsxmpbwkrQ9JZ944onEwIFXOyCi2t6op556qle2MZOG8DgQf9UQW9u+/pquy02bNgnit3sZ3uzYsmWLfPrppwJhLpVBm+nP5Im4fvbktk8++WTa+w3PrlSDXJgU0Q5P9Kc//SltWWjTf/3XfzkDUxiceu2111I1K+t0xN7HvayGZ5D9HNJ0ryXeIEHIJDUM7uGtnlwwPAvvuusuZ0BA67N8uYmKYMTuI7GpU6fK9ddf74QvQgijVB+EkdLnI/rY1VdfLV/60pcEdRhqe/HFFxOnwDXJ5g0UDJqq4W0qDHp4GQaC7O+JdG8/eB0/3GnDLnRrA/FFFf+Y0aQZy6SksEJ3JS1V7LYTw93tcu+7j8qO5n2JL3x7f66t28I+brBQKO7VHQqGTAiWmVJVfKIEfQVZVftA2zZp727MKi8zkQAJkAAJkAAJkAAJkAAJkMBoIACPXYgvavDsRHxTiC9er30j/umrr74qP//5z5O82GbNmnVEoks2ggg82OFx+/jjj2t1HSFTxUx4S0L0hkF4+fWvfy0Qb90GT20I+t3d3c4u/G783Oc+l5Tt97//fSKsCfZDbIGQgvXrrrsu4TCGUBcQu7MxeB3aoh2ExRUrViTqoWVABP/d736X5C2ejXiixw90aXtzQ9g/4YQTsioKoSwgCuKTyUM3qwIHMRMmMFUD11/+8peeAznwAsZ11IENvJ2wdOlSPXTMLjGpKvo0TO8Zt1CMex7Pg0ceeSTBxw3EHmRCH0AsZS/DNbA9WPXcXnk1zZ4MFc8niM9eb1JAiMc9r29B6PH2EoNVaunKQgxtCLfqnYznin0smGifx7I/hjkG9DmF4+DVffvtt8uOQ3G33WWhrb/97W/FDo8BbpicNd1AVLp97nOk2kYZma4RBjb+4z/+w4k7ruVAoPYSmW1m4D9YZoegwjXT+3iwyk9VDgbH7MGhc845J+010XLwfWm/TXWfmXPC/YYB3kDBYLL2Z1wHWyDXsnJpOaIxuvEF7TeTSh5TNllOrT5ZXt/yqukIybG6zf8LPG33gS3yyIcr5KZlX5UJRWWeeXIpEZ1Bb0ws0eHxKegtlqqi46W+07xm0L3DzEXZt8Emu2Ng0R1plbr2rVJSUJkoL5faybqQAAmQAAmQAAmQAAmQAAmQwEAIfOELX3DefFVPTPxegviCD7wP1RMZwoR7YjmcD6+Iw3vuSOyll15yBPR0ZXgJI7YIBnEWgvUzzzzjFIN2/OEPf3DagAkV8XsQnnMQum3D6/W2pycmU7M97M4888ykOLgQcZYtW+ZMqIdykBfenueee65drOc6BPM777wzIaAhZjE+4AyPU4RHsL3kUQgE8iVLlniWN1iJEFkQnkENgo16SGqa1xKiEsRjCH8wCMS33HJLVsd6lTfYaRjIwSCBhnuA0ArxCB788GbGYAc8ke2wFOgn1157bc60YbCZ2OWh32OASL1Scc9gHYMeeMMB1xVvbyA9nc2ePdu5R1SARhgUxB4GewxEgTvuE3ivalkQUe1BtlTlu68hngN33323VFVVOROlog/iGtqCI8pC+XouLRv3ErygV69e7STZZaFPoCwIzu6yLr74YucZqeXce++9iecI+ssPf/jDpLcHNJ/XEp70P/rRj5zngA62IfQFBtcQcheTVqLeqD8Ed/dzD+e76aabMk7OiuMwIJmNYVATQr77OYMyfvGLX3gWgXpgv5sxno/f/va3+xyD6w9uasM1UaSebyiW9ls3+P7JNnQX2OG7Sj30wfD+++93xG94pGPb/WYVvofst46Goj1HWuaICd0AihsGX1qFwQI5e9qpsq52g9S11CTalO4ZBkF81ZZVMsWI5F8+8VIpMmWMBkObYfAUQKfBp6xgqkwonCctPfskEouP5tttsTlEot3S0L5TjqlY4vwHCRxpJEACJEACJEACJEACJEACJDAWCMCzE15meJ1fPcjQLgg+btFH24vfRJdccskReXJrWSr46HamJc6NOrsn/UK4CXhLwqMUv/lg6dpwrhGnEaJDTUVr3YYHth1XV9PhKQxvcRWlIY5DTEfc43QG0e873/mOI2rZbU5VRwhzeC0/W7OvXbbHIJ/tLQqx2i14pSprz549CZEbecA/G4E8VXlDkf7FL35R4D2vAzk4B7wlvWJ2o+9gMAL3Qi6Y9uGhrAsENMRjR2gXCL0w9CMv7/wLLrjACV8CARZm1w8exgjxgcEwGMRtxO5OZRikgjioZpdlr2M/riHefsCgkJrGztZtXc6cOdPxtoZ47KXbQNCFYIjBKbVUZWE/4mDb9wNEYW0/9mOwQN8qwXY2Bm/ef/qnfxLEtIZIr4Zngle/1P0Q97/xjW9IYWGhJiUtcd1sdvYzJimjx4bO+eAuwy20exyaSMIAIAYFvAwe92q4LmeffbZuHvHSXef+FDjQY+HNbQ8Ooj39efZhEAjfP3Y/xD3jZRhM9voe8so7kmkjInSjwehQEH0DgfiEjTMrquWs6afJM588Zx5mPSmZ4DjcMGYhHV2t8tza56WyqFwuOfYcE/5jxJqTsr5eO9ButAFfXniAR6OFMrFogextf99T6LbLiElEWrpqnXx+/+GHsZ2H6yRAAiRAAiRAAiRAAiRAAiQwlATg8acGQXIwDT+88YF3NeKCwpPTy+BxdtJJJwnE3v78sHeXZbfFvc9rG/krKiqcicYgzqkzkzvv4sWLnUkU//znPzsxg23hR/PCmxee7G6B6tlnn00IRfgN/LWvfU0P6bOEIKqhEnAOiKnf+973+uRzJ0yZMsWZlA+cETLDfu1e88LrE8JGtuFD9Dh4U65fv97ZRP2zMQhZ+/fvT2TtzwR3ei4cjPNB6MrW9PrjOPd1yLYMdz47JIS9D4MiYPncc88ltVXzoA6Y8O7KK6/M2KchCmfb7/uTF3WxrxnWdTtVOdhvv42g7Um1THXP4L5H7GyEKME1tfskxGgI/4jBj7c7ELpITeuHbZT9/e9/3+nTEO8Q0sZtyI+yIIa6661MscTbDW674oornGuENzbsyf80H+oJsfGMM85wvKU13WuJwS30B4jnqYRleHhDFHfX0z24M1DBFiy++tWvSk1NjcMdg2xezyrwmGnEezzz4DmfztD/cR10wCJdXvc+PHNg/SkDedE30X9QP72n3WVjGx7+ari+mQYFNW82S7vOqfp4qnLQp9F30F/7c6wdggfHDyTUEfohPPjxXeA1oIwBEYSAyZVY7KkYanqe6cDx4WVNGaYlTotOj9EajO7gAfZp/U554OPHZfOBT7KuhXnkytTKY+R7y78pZx5zkvjy4h7TWRcwQhnRfozY4BUctL+9s1VW7/tvqe3A6FLqS4KH0NRxi2T57O+ZuOaV/boBRqipPC0JkAAJkAAJkAAJkAAJkAAJDJgAvMvgsWz/dIXQDGFjtBh++0HExW8//KZzftcZMRhifa4YRDs7dAaEtVx/RV3ZIQyLCjQQMPvjfa5lDPcSAzjwxNR+De9YiE20zATa29ud+PbQlDKFqXE/PwaTM8rWfgeREyKtlzieuUXiaEMQr7U/4NmAwahUoufTTz+dmCAwE4Nszm/nQbgKxLGGp7eGA8IADCZhHM2GwbTbbrst0SYMkmJAgnaYALRZfN/ijQH0aQz+jZbvAW3FiLpA48sdo0KAh8/MsqlytpmYsrbtgDR3NGgd0y4R03pv/S757aoHJN8flJOnLpSAz5/2mFzYibbjgaXtzw8WSmXhXDlgYnXrg82znkYDj0S7TKzuNinuHe+ZhYkkQAIkQAIkQAIkQAIkQAIkMFYIwJtMJ8warW3C777q6uqcrj4GD/AZbQbxyvashSf4aDAIrjONhyxN5PXXX3dCZ0AjgVicSVBFKBL1Fk4lBCvXoXx+DGbZjibWj/5ge4Dj7RE8YwbLIG7ig7AuePsABs9hDNjh2tjngvMq3kD5+OOP5cYbb3Ri+Q9WPQa7HMQ9V+Ee/QYhjmjJBDBokuvfVck17rs1YkI3hF6YCr24qUPBkCydcoLsbt4nb2xfKd093q+o6bEQhLGO5Z6D2+T2N34nN535NTl9+mIJGdE7180Wu8GhvGCG+PP8ErEm5AQm07zDltcrPSaOd3ckHmxfGRzOwDUSIAESIAESIAESIAESIAESIAESODoIILYwBDgYhEd4dNNGFwFMgoowI2rwik4VCxgxid966y3N6lxvW3hN7BjDK4hbroM70JUGGrYkEyKEwYCX+dq1a52sGzdulH//9393Jq3FvHMwvKmizpoPPPCA/OM//mNOvaniVPLQHzs+N8Kc5NIbNXY9uX5kBEZM6Ea1VbDGQwk3Cb6cxhWUyIWzzpID7XWydt9HErNEX/sYbbbeUFCD9xzc7ojdX1tyrZw753Qpyy/RbDm5RPvxUbG/NH+SCcSCUbjUMcohesdiUYnGUufJycayUiRAAiRAAiRAAiRAAiRAAiRAAiQwyATsmLuIIZvJw3eQT8/iBoHA8ccfLytXrkxMqgchGwMYmHwRE7HC+x2xi995552kGMvQU1IJ4oNQrZwtAuKzerQjxjTiOw+VXX311Y53Nya6Vf1Nw7W4z4lJa3N50GH37t1OldFvEHOaNjYJjFiMbhunxupGDBgnXnd3l3xSv10eXPMn2Vm/zWS1XZrjR5p+mezpbJKRBisuGi+XLbpYLlt4vkwrNeKx7ojvzqm/eFBA4EfbW4y4/+LW/y2dkZa0dSwrmCpLp39dqitOSAToT3sAd5IACZAACZAACZAACZAACZAACZDAGCSAUAQQ/mAQ2ih0j86LjHjXt99+eyK0RDatuPzyy4/a8BN79+51dCRM/Jpu8sVsOGaTB7Gb4XUPr254lKvh3JhU95xzzsnpsCWoL+LiwwMdjraoM21sEsgJoRtiL7yU4xNThp2JKbvC3bKhbqvcv+YJqW3enRg5yvYyFBnP8CUzl8gXFl8miybNzem43RD6IXS3dTbJC5/+L2kL16dtZnlBtZzmCN2LKHSnJcWdJEACJEACJEACJEACJEACJEACJEACo4EANKGnnnpKNmzYkFYDQix5xIoe7bGER8M1YR1JYLQRGNHQJQoLHtd5eZiYEZNSxpzRFYi/Cytny/WLrpL7Pn5MGltN3B/LsxvH6GsTWo697Ohqk7e3rJI9TfvkmpOukPNMKJPCQL6dJafWMeqcZ+Jvx3rjscXgnG77satTOkKX+Ewcb19eIG37c6pxrAwJkAAJkAAJkAAJkAAJkAAJkAAJkAAJpCEAT9trr702TQ7uIgESIIH0BHzpdw/fXgi9+GBSSjzcnE8gKIsmzJWvL7paykomJioD0TedyI2MyNMTCcu2/ZvlV6/dJXe+/ZA0dB1+vSJRWI6sQLhH3O1ILOzUyBa5kQCBGx/TMjNhZUiCvkJs0EiABEiABEiABEiABEiABEiABEiABEiABEiABEjgqCeQEx7dehUg9iJwvXvm08VV8+VredfIExueMWFM9hpP55geknIZF4Xju7u62uXZD1fIh3vWyk1nXC+nTj1eioKFxiv6UFDvlKUMzw60G9YVbTJti3t0pzozcgZ8BeZDoTsVI6aTAAmQQLYEIpGodHR0OHMl2McEgwEpKipijEcbCtdJgARIgARIgARIgARIgARIgARIIIcJ5JTQbU8aAY9ueG3r55RJxxlPZr/8ZfOLsqNhm0SiPf3C2tsbk5qD2+T/e+4/5ez5y+WyBefJvIkzpSRUZHykc0Pwbuzcaby6I2nbhRAvBYFx9OhOS4k7SYAESCA7Avv27ZPHHntC9u2rSTrguOMWyFVXXSETJlQmpXODBEiABEiABEiABEiABEiABEiABEggNwnklNANRPFY1X2FZ3g9nzzpWCkKFMqL216Tj2rWmNl4u/tQVSdt26NbM0E0D4c75bUNL8knNRvlnHlnyzmzl8rs8cdIvj+o2UZkGeuNyMH2LUbYT+2tjrb584JGnK8Svy9owrP05TQiledJSYAESGCUEsD3QiRqJkOOJA8yIg37aCRAAiRAAiRAAiRAAiRAAiRAAiRAAqODQM4J3cAGAVfjdWPbFhuONaJ0WegymVg8UVbufFvau0y4D0uMsFZxqKdhost99bvlTy1/lnV718uZc5aZySrPkKri8SMmHrd010pT5x4TuiS9sBLw5Ut5wXSnntS5PS8vE0mABEiABEiABEiABEiABEiABEiABEiABEiABI4yAjkpdOMaaBgTTE4Jg/itHsxTSibIpXPOkWAgJH81oUzCPe1G7Hay9etPuKdT1pu43Tvrd8p7uz6UixdeKGdOP8l4TA9v/OtYLCr7m9dJe7gxbf3RRoQtKcuPC92YmJJGAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAiRAAkc7gZwVunFhvMKYhE1s7k8b9sgrO9+VzQc+Ma+bd2V1DeMiuarhcYEYnuD4tHY0y4c73pftB7bK2zOXyLUnXioLKmeY8CD+rMo+0kzt4TrZ27xWemIdGYuaUDhP8gPFCeFfxf+MBzIDCZAACZAACZAACZAACZAACZAACZAACWRB4ODBg/K3v/3N0R7OO+88KSwcXofALKrILCRAAiTQh0BOC92oLYRcn99nBO2o/K12g6zY8KJsqlkv4W63KAzxWoXs+HEQsXG8CtqHW384n6b1mnAmjW0N8vr6F2XN7jVyxeLL5MrjzjdhQko1y5AsY2byyb1Na6WubZsgpEo685nJOKtLTjMDAP6Ex3u6/NxHAiRAAiRAAiRAAiRAAiRAAiRAAiRAAv0lUFNTI++9956jqSxZsmRIhO6O7nbZ07BTyooqpKpsSn+ryPwkQAIk0IdATgvdXZGwNHQ2yft71stfNr4s2/Zvlp4eTEDZV6j2TkuO792n9a4ECMj5gQLxmwkh39/5ocyqmCZnTF8sQf/QYIIA39ixR7bXvyudkRZXbfpuTiw4VsYVTHFEbni7e3m89z2KKSRAAiRAAiRAAiRAAiRAAqONQHt3m1z+f8+QznCHIwD96aevD9sbp6ONFetLAiQw+AT8/sNvuA/2m+Sf7t8o//9T/2pCyX7kVDxgNJcVt7wl402YWhoJkAAJHAmBoVFwj6BGEH9bwu2yq2mffGwE7pe3rJI9ddslGg33Kw43yrFNPbvdaX5/UErzS6WysFwmmRHEOZPmyolTFsjs8dUmvVgCQxi+pDvSKtvq3pLa1k2O17ldN/d60Fcgs8svMP+5DQq+cDSGuTsft0mABEiABEiABEiABEiABEY/AfyeiZi3P2E9JnwjbXAJbNu2TVasWCGhUCip4Gg0KqWlpXLDDTdk/ZvrpZdeko8//lja2toSZeE326RJk+T888+XuXPnJtJTrRw4cEBeeeUV2bFjh3R3w7krbhUVFXLyySfLWWedlVV9Nm3aJCtXrpTa2lqJROL9B3WZOHGiU8aiRYu06AEtW1tb5a9//ats2bIlqZ75+fkyc+ZM+exnPyvjx4/PWHZnZ6e89tprsmHDhiRuKGfatGlOOeCXzlDGyy+/LGizzb6oqEgWLFggF110kRQUFKQrIuO+d9991/Fqrq+vT/rNjnMsXrxYLrjA/Ea3BOGMBR7K8MADD0hjY6NgTjL0OZSzcOHClIc//PDDUldX5+RPmcnsQFmo24033jigeqUre7D2Pbn6D/J/VvxrUnF4u73LzKE2lsy+xna7wuGw07/TXW87/65du5x+vm/fvsQ9jf24zrifcc9l0wcH49kwHPfcRx99JG+99Za47zk8C5cuXSrLli2z8aRc/+STT+TNN9/s8ywcN26c80xdvnx5ymN1x2A9l7U897KhocG5tlu3bk16nuJ6TpkyRc4991yZM2eO+7A+2wPtI88++6zzLNe5EfsUnCKhv304RTFDlpxn/gOVrAgP2anSFxwz1Wg2XgsbD2yRD3atkXd2vic1JhY3JmqMjx4innb6MrLZm5fnk1CwUCqLKmVKyUSZXFIl1WXVMnf8dJlSOlEKQwUSDAadDy42OthQiMrRWI9sObhS3t/1R2nrbkhbdTMNp0wrWSInTPqKFBUUO68MoY6o22CPrKatCHeSAAmQwBgjsHPnLnnk0cdk7959SS1buPA4uebqq8yPQnqVJIHhBgmQAAmQwLARaOtqlUv/z+kSjnQ7Xo5P/+MqenQPIv01a9bIk08+6VkixNFbbrklo3gEsRwCJMTFdFZdXS3f/OY3U5YHwff1119PV4RAAP7ud78rlZWVKfNBWEOd0llVVZVTTjbCmLsc1BF1zWSnnXaaXHrppSmzIe7zc889l3K/7oDI85nPfEY3k5Zo50MPPZQ2/Cd+K1955ZWOIJ10cBYbCNvx4IMPSkeHO2Rq8sEDOYcXx2OOOcbpI8mlx7cgKv385z9PEjm98mlatv1X86darl+/Xh5//HFHc7j55pudwZJUebNNr2utlS/ceq4JTRtOHHL8tJNk3uQF8r2LbpFyE8JkrNitt94qGBjyMojTZ5xxhteupLRHH31UINims2z64GA8G4b6noOIfvfddwvE33QGgf9b3/pWymchBk1+/etfO0J5unLKy8udZyHK87LBei57lY00DLR++OGHqXYn0vFswMBrqmf2kfSRdH00UYEUK9n24RSHD2myb0hLz7LwFhOX6fUdq+WuVffLr9/4nTz10QrZW7fTEbnjRXgr3OZ7y9OSxV8T49sXkOLCCpkzcYGcP+c8uW7R1fK1E66R646/Sr4w/7Ny5pQTZXJhpeSZENn4T4p+MAagH88TDTARZe5v2SBr9/4lo8iNUxQHJxihe5kJoRJyRnAZtmSA4HkYCZAACZAACZAACZAACZAACRgCR+rpC+9KCKFukRuCtNs7bu/evXLPPfd4cn///fczitw4EF7e//M//2NCeXp79z/22GMZRW6UA0/v+++/H6v9sjfeeMNT5IZI5BZgVq9eLfBy9zJ4cHuJ3Cgn+Xe8OOeDR7XbMEliJpEbx+B391NPPSW7d+92F5F2G9cWrN0iN64rrq9tOMef//xngRdqNgYRDyzd5mZo78c1zzSfl53f3SftfSO9vnrrqoTIjXAl9938lPzu756Qf77yP8aUyA3O7r7SX/YQp90iN/qJ+17RPgivYC8bjGfDUN9z6N+33357H5EbDN0ccV/+5je/EQwAedldd93VR+T2KqepqUnuvPPOPs9wlDlYz2Wv+iEN19ZL5EY93d8f8Na+4447PJ8Bg9VHUtVztKaPaOiS9nCnvLdvvfz1k9dl6/5PpN5MBhn1eC3PfHd4mlc6vhxxoyPednFBuUwvny7HVc6WGeOqnfAk40IlUhTIj3tDGKHcZzy848IxBHG/+ZL2OV+w+iWrS88KDDDxQNun8s6OB5343OmKgJDvzzOvbpUslbKCaU6Hx4MN9R2KeqWrC/eRAAmQAAmQAAmQAAmQAAmQwFghMH/+fPnZz37miBz4bQXPS3gTZmP4vfnII484vzuRH8fjdXp4IGsoFLzyDo/x/fv3O0VCPF23bp0TakDPAaHm+eef103n9x48oRGqBAYPR4QzwYSAMIjdEK2uv/56Z1v/wNMSArIaPBWvuuoqmTFjhpMEcRVirAq+EE4gRsPzOhtrbm5OEuMhxlx88cWJeqIMhEWAh6KKw6tWrXKYlJSUJE6B9rq96E844QTH61qFXoQaQJvBGAZRGBMh6n6kgYEt/IL9eeedl2APXhDTkUev1U9/+tOkMlCOlyE/BjD0/MiD6wHP8rKyMucQhIRBeBh8NB9CABx//PHOm+Fe5WoavC/tumt6uiUGSvQYsP/+97/v9DlNcx+L/mjzcu8fye31ez5OnP6G5d+TBVOPLJROorAcXPnBD34guHdghYWFztsfO3fuzKqmCIVkv50xYcIEufzyyxP3NApx3yu4/3784x87epGeZLCeDUN5z6Guf/rTn6Srq0urLXg+X3LJJYJnGQzPQtxjeIbCcA8+/fTTcs011zjb+ueFF15wQvzoNu6XL3/5yzJr1iwnyf1cxvMKz4vTTz9dD3EE9MF4LicKdK3gjRb72qKNeJ4i3JIa7vlnnnkm8f0BUR7PQnzHqA1GH8FbQqmeI3oeLPFMwYAbBgb0mWfvz7V130hUqNvE235n71r536/cKbe+eLu8++mbcqC51lPk7k/9AL+woMw8LE+WL534JfnZ6TfJzYu/IhfPPFsWTZgn1SWTZJyJux0MBJ3/RCD8B/4jEv/ER4pCoXxnG6MoKiij3MEw4x/uxONe+elvpKF9l9lKoeDryXrzZELBfKkqOlHyTbgV1EmFbs3CJQmQAAmQAAmQAAmQAAmQAAmQQP8JQISFeImYrRAbshUHIRhrSAL8VrzRxEPGa9wqcqMmiC/9d3/3dwKBSg2hIGyD2KxxtFEORAcVuZEP4thll10mdixZxMa241Ejn+0hDG/PH/7wh0mCGGJm41V/vAKvBpE2G4ED+eHdqHkhHGGAwK4n8hx77LECYU+9ESGGuL1REdtb24tjEHf86quvTuJ+9tlnOwIX9sMgRG3evDm+Yf5CqEKsajUIRPjY7CGMf+Mb30g4h6GMtWvX6iFpl6gzRDUYrslXvvIVueKKKxIiN9LRRgjruF6qFUAEyuTVjeuE+sOgNaDe2ZjWB3kRugb9FXHk0Xe9Ptifq1ZaeLhuC6ctztVqDlq99Pqgf2I9W9PBLeRH6CPcWzpwpWXgXkH/VMMzqaWlRTed5WA8G4b6nsOzxb7H0a7rrrsuIXKjIXgWQtQ+5ZRTEu3DoIH99gLuc4jIanhWYYBLRW6k47l80003OfeP5nO/NTJYz2Ut37185513EklTp051BidskRs7cc3x/TF79uxEXtTLbu9g9JF0zxHtu1jimQJhXUVuPPcwSJmrNqwe3ZhMZYeZZPKPa56Tt4y43dGBmzBZ7AUwheeG1ncfvLB9RgQukinlx8hpUxbL4sp5Mqm4wnhCxzV8HIMP8qlwrWIxtrF+eDvu1a359Fh3PQay3dsbMyL3J7Jq233Gk3tvZpHbxOUuDU2W6SVnSEn+JFPHuMitdUXdaCRAAiRAAiRAAiRAAiRAArlDAHFn//uV26TbxNWeUj5NrjvzW9IZ7pBnPnhcXlr3F6ltrjG/dWLmf/p5sqB6kdn/bVk8Y0lWDcD//uvbTMiGN++WVZtfM+W2m99BZsL6SfPlohMul/OPvyQhuqUrcOfBrfLQW3fLml0fOGUgL8pZWL1YvrTsBkknPv3pbw/J9oNbzI/tiPzk0n+VgD8oj666V/66ZoU0ttc77Zpq5j5afuwF8oWl10uBcdbJZC2dTfLEuw/Jaxv/Kk3t8dis4DO9cqZTxnkLP+fZrk/2rZMV7//R1CFgxNMeuenCnw5b6AMIzfg9ht9mEI9tAdndXgii8IaE2ZNMYtsWXyHgpJp8EWVARIWQhd/K8GrUCdngJQ3vPzWIsqiXl0FURngACEtoAyZ7wySVmay9vd0pE8chrjAcxrwMIjsm2EP8c5gdZgXH2l7nEJ8uvPBCr2IcD26wgYcnhB38PleD6K56AURf5aD7dYlrgrro4ALqdNJJJ+nulEv1GEWG/8feecBZVV37f9EGGHrvMPSOIAJSBaQpYu9dY4wtzyTGxDz/eXkleS+JPk3Mi4kmRqMx9gYICIggTXqX3ofeex34r+++7DPnnjm3zdyBGd1rPndO23Xtcvb57bV/OysrywD4sRyzWZw/Dj+IH/QTtIrHWjVZQNpv/YmOi5ts3L1O3pn5mlQoW1Hen/WGl/zfjf2lLNK92U6cPi7lFdN58PIf5tmH4MDR/er3VZmyfLywbwFSPqOC6Tdv7HGncnu3lc17NshbM/5m+tbrut0ureq1k7U7Vpq4ypTOMFQpN196rzStHb4pbJjbrFrN5Y2pL8ku5RSnrVdWg8r7+z+mdTG8bXmZStMJ7RqgliN1JZZg+cwkHRa/CO6tpKtvKOw2x0QOOmYygEmkfv362SzkObK5L30h/Ym/f8EhVCAWCCY8Jrv8E2A2MJ4xycRGtsRHOyQ828+ko1+2cQWPTETYsiIdQYv0oHv6c9tnk0a/pKOO+MOLd07cfoCe1Sv+1Trx/F6IZ+cF6D6lA6Hth3fLxDXT5dNlE2UvA7xAIdnM25eWvfYfzTOtDKVLlpGK2rnVUAvt1jVbSefabaVRpdpSTjmsqSz+XwTMBuSOUH5YoNgeec7P74dzxB79acjP+amcY7J533xZlP2J7PFZcp+LRjtk4oJDLDf0cqUqS6MKPZVupbkZvNkNMm3jy3XpzpwGnAacBpwGnAacBpwGnAacBpwGioIGjpw4bACX0/r9U6dKPalcvor86qOn5IyC20HZfmCrTP56vHRu0k3+966/GhAo6MZeAxCNXfSx/NeHP7G3vOOm3es1nM+kVuU6ynX7odSuXNd75j8hDfgfu/Aj/23vnHDGaRxdsnrIs3e+nCc9fIv9c8Yrkr1nowGjurfoK//xwRMGyPcC0RPyNX/9LPnDZ7+W5+56RS5tGRu0eFtBcsCuMCGcOetmSM1KdeQP976eB6QaNe89AXhHoKO8s++D5w3oBtz8t3/7t7Bk57kXC/wEPLaWyXx3Bi2k/QHxvEOHDjJz5kxze/ny5R7Au3r1as9KGt7xFi3CwTw8YpkHsA1PN+UJCNy/f38TZrx/I0aMEH7JiAWagm6J0wL95GfYsGFBJ941z7FADxPya+Wii+JbBDN5YIFuqGMAxmKB9DZMrMwR9NO9e3d7O+bRX742f2GO33rrLc8qHmtNrM5t2sLc++9RV6z4LTztvaJ+3LYv22ur/rTSlwAmI7Thay65RepXa+Q54dkfx//Wu/afbNAJt0/mvi2DOg6Xqy6+0Qv/4LED8qtb/qBgeKaMmv+e0BcjTA5+8MPJBlvxh3PmTI78y2v3mElE7pdS3Oiefg8bJ6MXvC/0iwh98L2XPSq5Uy7mdqH9Y/PPZIR6GqvNpatvKOw2V6FCBfnZz36WTHa9vi7MsT+dWTpJxURULAGo5ReUdPXLwXDtNaB6r169DNiNlTqrbRIJZYxwBHC2E5npqCOJ4rbPocmxEwv0z5dffrl9VCSPhQp0M5jadmi3zM9eIh8t/Uw27YzM/vs1gZIQW3j+Z/5zgOpKOotWp0It5d1uLB1qtZZmVRpKJbU+4Bnh8LPANUcLZnO05/7nNm7r18Zn79vrghyPntwra3fPkOXbxsvB45EBhQ2P+nou+5p/e1ekTMlMaVihh9SveLHSrJQzL2NeyDYP6UxfbqzuzGnAaeB8acD2d64tny+NF494bL0gta5uFI8yc6l0GnAacBoIagAL55IlSukYvqSx3g4C04A5QdB74cY5ctVve8o7j08IBamxSMRi0R8W74kq5dWK7+g+Lwm7Du6QG57rL2Oemq3fTbn0ADgAgL/z/4bLtv3ZnntOqmRWNVbY/nAWbJglQ/+nq7z/g0lSt2qDKPfWQjtHwaGn3ooGYggL60sr5POHb9wvL9zzd+nWPAIe2me8837yz4dk6oqJ9lbM4261qLz9/4bJ/9z6R+nfLpfqoVxG+Zh+isoD8unflNFvsQ0oat/9WG7WrRs+QWHzwtJ2C3RDJQC4xfehH1wlfO7FEyxAAZ0RuLrTKXCBA8Jb8ecXuhebXywB/ZQuACgAxlhXxgOi8W+BZdpAItC3YcPIPlf4wfpx3759Ma3mbZqhErjpppvsZcKjBX9wGEv306dP93QOHgEtQyqC5T1CntEplv3Z2dlGn1isMnmRCi1GKnGnw21NNUpMRSjnsP7B9nuA2bYfnbjkU+GXKxF8CcD8v2/5o4bzPfOI1TQvfPbf8qMroyeonv30PzyQG4e/vf0l0++Rhgzd280Kq16KokBnYWmUqH/+epCOvuF8tLlU9ApPt7VsJq+2zXHP0gIRXqdOnaKCtfQ/gMvxJF39crw4Yq1kCfPjL0PqP/1HqhKvjiQTFrq17x7cM5lqudOT8X8h3BQK0A339KETR2X+lmXy+aovZd5GXRZ3/HBo/mg4saWEDhLLSp1KdaVV9SxpWr2pNK/SSGqVryZltBGX0IFipLAjlCNsJAnoTWUPAt1c49b/88fL/XQKSxL3HFkvK7ZPlPV7ZsuxU5FlNsE4gtkvVaK0NFa6kiaVe+sSwooeyM1L3+YhGIa7dhpwGij6GqCt79+/TzeeWC+79+iyXL1RqVJFadSokc421zUD+6KfC5fCwtAAA5jNm7Nlc/YW87FaWt9hdbVONM1qIlg4OHEacBpwGnAaKH4agMLEL9d1u00eGfykVFILb2T7/i3y7Oh/l2krJ5lr6E0efPkm+eBHk/Ms3feHhbXhz6//rQzpOMJ89wBQ/2nCs8aykYBO5ZxSQPxJA9aYgPUf31tYLPpB7h5qjf3UNb809Cq4C4aDFeT9L10vI388PY8FpA3XHu+97BG5s8+DUrFcJRM/VpbPffqfBogi7l+8/6M84UDv4ge5G9ZoIv/vut/IRY0vMd9r6OPjOW8Zq3AALcL517cfk7f/Zbw0rtnURH38ZIRHmQu+5YoaELVhwwazwZoFofiWY9m9FYBKC9gkA1ADDPOdC8BNWFb8tBbxrLmt+3hWjtZNfo7QG/hBqDp16kjz5s29oPygOlzD5IFJgPnzFSs4x4mNY/KYlZVldAXo7Bd0aa2bmRzwA+l+d/YcEBgOWgBuJN3f/FCx+PUfTC9xQlnC5ppWoKFIZXwHQG852WkHbJQZJlCawG0MtUxRkxZ128gXP19i+rbfjf2VZ33946v+Xa7peouc1D3c6OeqZFYzSX91yh+j+oeqev/fb3pOejTva8oQPYxfMkp++dFPjb9Y+e3XdpBc3/0OL773vnpdLm9/pUcXtXjTPO8ZYdzc8x7p3XqAF9whBdStZCh7QMk0Y0Y27PwcmWCBesPPL80KBNqFFX/dzG/fUFTaHG2YzTbpV60MHjzYnpo2YkFh2jkTg0yusS8AqzmoM1awqobGiA1m/X0pz9PVL9u4Cnr84IMPvLSTbgvsJxNuMnUkmXCgLLEbhaJbv96T8X8h3KQd6GYgsn7fFhmz/AuZue4r3WRyu76MI8tF6Bd89StmfgGwy6sVQqsaLXQTyRbSWC2361esJRWU4w0rCJTLzwLapUsDbFuAm2OEjoRKizt75Px8yInTh2X97pmyaucU5XRaJzlnI/lPFHeZkuUU5O4jWZX7StnSlQzwxcvZWnOfr/QnSqd77jTgNJC6BrZv3y6TJ38pXy9fYTYJ4WWbmVleGBD37tVTN3NoH8ohlnpMzkdx0gCDhnnzFsj0GTPV0menWRLGu41lbB06tJN+fXubTYeKU55cWp0GnAacBpwGcjXA+P0/b/qd4dDOvSvGYvDZO/9iQJbfjopYGELV8emCD+Tqrjf7nXrn1SrUkHd/MDHKWhsA6GfX/EoaK581VCHI9JVfGCDdWmPPWjNVlmUv9MJ5ePCPvaX59qYN55JmPeXn7z5ubu9V6smP5v5Tbupxt3UWdeS77MXv/NNQr9gHZdSi/cYed0n7hp3lOwqU821IOJ8vGyNDO11tnMHD/Y9pf7FeBDDqN7f92Xy32ZvQDtzW+zsyuNNVctPvBhl6FMJicuCFe/9unN3X/xEZ0TVieVu1QnWltaxlvV+Q49ixY81mXbzHASet5TGJoR7cfPPNUWM9P2DhP4+VeMLzgzXWnd9vPGto696C61z7/drnyR7/+te/egAyQLU/bYBtd98dXW/8cWGJ+eyzz3qgtT9OgPy1a9eaH2DUNddc4z0mDPtNzDd+EKTyHPpO/Onyp8HnJF+ngIjvv/++5xe+8KbKOx4UP2UJz6EsSUUAq/xlFssvG/GNHz/e0KFA+5KMbmKFVRj3adOIPXLOyhNWrPCTc/gs/cNrU17ksRH2DPjLd9+LmgCkDtCfMGF32wtDzf4A1n3wCJg+e+00Q7lEXXjqrUd04m2aCe+JNx7wnDOB9viwp71r4mA1yrFTxyRH95prUrO5wZw8B+f5hPJ98cUXvXbGtV+gwwkCkP76nt++4UK1OTanpH2RbvoEC2LbPMPN759I86eT/oVJAP9mjdYfR3iy2aSTSYL77rtPmJSz4teZ/9w+Dx5j9ctBd/m5fvXVV6Os1KE8iSf5qSPxwuMZbQbaEitMUiazr4N1f6GOuVPBaUgBS9imrJ8rz0z6k4xZ/Kls27vFA7kJPhHIDVhdXa23L2s+QL7X5U65s/01clmjHtKqWhPdmLGCsSawy5l4ecJBxtKDcuX4lTO/smUjwLAFh6mcFuhOQxbjBnFGAe2dh1bLV+tfk7mb3pPtB1clDXKXLVVBmlW6XLIq9dMlMhFLbgtyk2c6WvtSj5sI99BpwGmgyGmAl87cefNl/oKFxqrDDriPHj1mLLy/mDzFWPPa+0UuAy5BhaIByjs7e6tQ/lu2RHgjiYjB3K5du3TwNVvmzJnnzaAXSiJcoE4DTgNOA04DhaqBO3o/kAfk9keItaEf2P7bF39QUCXH78Q7/w+1aAxSktiHgMJZtVqYS/xDh4LwrvnLpN+bc/71bTMoD8jtPdQTNrW8o893vVv/mPpyzPTcpBtXwi8eJm0bdJRr1YrdypfLJ9hTeeer1zwrzOoVa8qvbv5DzO8c+LmfueNlz+9c5ezGGh7hWZv6HcyvbpVoy1/Pw3k8YfIaMIZxnwW5LdjYsmXLPJsapvptx/etDQ9g2VqK+8GYZMaS/qX7UJgkA6KGqRHLavLKLxjv8OHD1aAjAmyG+YXKw1pm85xve/vzu2fTuXfeece75ddZsukmXIQ0bty40QurICezZ882ltU235QLgJktHxv2jBkzPMoSvulvvfVW+yjpIxuNBvMKTgAFDWAfdcuvF9wDrhcHgQkgKB/O+aec1M18kcyyFeTP33krCuT2u2eC7qUH3jHGkP77/nMm5P50/1sRMF0fsGnuc2P+U54Z/Qs5dPygccqGtn8KiaeJbkhJH8PEHStWLqRQ12j3ts3500L5h9WtdPQN/roVrIf+NPjP09HmmODhR34tyG3bF/U/COrb+HHDZo9BkJs00Sf580O4L730krdXAmH4n9sw4x1j9cvx/CR6xkQpkxr+VTBdu3aVRHsS5KeOJEoLerQrbtBNKrQricIuzOdps+g+pLt+vzLvI+VHGidHdTdc2+knk3g6HwDuXgpqd6/XQWqWqyoZJUubGWaUSWWlkYb9eGZ/uLW/ZOJNn5uzcvTkflm9c7Ks3DFZaVuUMy3GAJU4NZmqn8iR6/KlqhqQu05mF11yV14tucuY2X4aMC9Emz/cOnEacBoofhrYo1QlK1eu8l7S/hwwYMhWyoo1a9ZKo4YNoix9/O7c+TdPAwzeVumGSrt27Q59ZzIRsnzFSt0opZ1S3DT85inA5chpwGnAaeAbrgHAk7v7PZQwlw9e/gOz0SRL93ce3C679Getsa1nAOGuTWNTEvA91b/dELWEXGO9mONR/UZbt3OVOcfNQ4N+FPU87OIupSFhiT9gE7zfO9TS3L9BHH4I65ae94Z59+4N6jDcRwugH0AqfCOyUaWVhwY94QFQ9l7w2LXppQL1wZrtK4yFOCD+sAB3eNDPhbjmuw3hm5XxHXnlyDXWia+//nqUlbN1n9+0Mo5AUg3HgvD4ZXI9le92/Fix8ZI/wrHC9YcffijwSvfv39/eDj0CPMGHnZWV5T1fuXKl8Q/Yg6xYsULHyWsML2xBv/VtmF5kKZ6gK8pxg48+gTQ98MADeehIsBr1U5Zgmc73faoCoA2IiU5JPzqFcsEvAFFvvPGGbNu2zdxGX1jF+y1e/e6L6jn6nbN2hpe8u/s+FMWT7T3wnWCJ3b15H/lqzZe+u9GnbNT7i+uflf/37r+YBx8pLZJffn3rixd8RYg/PWHn1DNwIY6Iv81x/dxzz8ldd90VtarAtlGeJyNhfcOFanM2n/QnCPm1/Snt4H//93/l8ccfz9OmcOMXNvll41vb9ug3P/nkE28jWOrc22+/LY899pjxlqrO/HFxbvvl4P1kr9mglrbuzweTWVdddVXCIPJTR+IFim6mTp3qOWElOisHioMUGOgG0F29d5P8+at/yuJ1c/RFGV2xYimBQiijPEc1KzeQ3o27S6+6HaVq2UoeUG3BXSo2PyqcPedoG7ktTOKxjSFWnOm/f1ZOnTmhfHdLZfHWkbLjoG62qctaEPofrRehYu8r+Ypupqk8rJUHSq1y7XSQV1bzWco0QhpimTKRPJNXJ04DTgPFVwNHdfAJP18s4UW2e/duM3i1L+FYbt39b44GGEzGArltLg8cOOjxMtp77ug04DTgNOA0UDw0ADhcUb9vEkmNirWlVd12hl6E7xkA8qBACZJI4OcOCuD56XPfJ9B7WKvvoDv/NTy5Leq0lq+3LDbfVxnQCoQIYHc8yTmbC3763R0+Z0XJvT+O/4288sUL/sd5ztkAc+Pudd59viGLoowYMUL4WYEXdvTo0R74uH79evn444/l2muvNU5SBURwb8EPrLKhOUOstaO5SOKfP16W7PNtnR959NFHo7wBSI8aNcpYYPJgypQpZol7+/bto9zZC7izAaqC8bdu3VqeeOIJef75571VbePGjTNAlF8HNpxER6sf2laizSvjhQVVCZbSfjAQK9Hvfve7oTRz7777rgdGAlR16NAhXvB59OB3jE5+9rOfme8J/2aD1g31gXSgM2vpj9V8cQO6yc/BYxE+dfqXYRfl0tbYvIYd+7cfGhfoxs+gjsNlvm60++HsN6OCYGVKnzaXR90rihdMCj399NNe0qiHcCczmQIgiTDZ8aMf/UjY7BWxdd9cJPEvrG+4UG2uXbt28otf/MJLNfUaTv/Fixebe1h6/+lPf5Lvf//7Bhv0HPpOhg4dalY9+G4ZKpQbb7zR9E2TJ082j5iUA2Cmr/LrwO8v1rlfP/5+OZb7ePfpM/yb+eIWqiNWyCQj+akj8cJF17Y/wV0sK/p4YVyoZ/FHJwlSdUT5iixVyeL1iUFuwF/4tysqF1OLWm3l5k43yZPdvyNXNukl1fQeLzkAbYAeXhqWmoQKwzU/nvlBbz/gnSC5aXx8VjdMOGpoSmau/Zt8ser/ZOv+FR7ITUQWzA5GGpl/05n3krrJZvl20qbqtVK7fIdzIDd5j+QzsgQil4MsGI67dhpwGig+Goi0e9v6w9NtJuroJJ18qzSQaILWVAlXL75VdcJl1mnAaeCbo4EOutwdasZEgqHQ+l2rjTOMiNbvjLbK5kEYiJ0oXJ6XVoBc17wm49RzA53A5r0bzTXpWbFlqfcsHSd8D1o5cHS/Woxvi/vzg9z4W7RprvVepI9Yvz344IOCRaEVgAO7sWDQItO6iXXkG9iOGyzgjdtUwyksIyo2f/vxj38ctUEkwJRNazCdWDgHQW6bd775sfS2As1J0H+y+bA6s2Hl54gFKCCiH+Ru3LixPPnkk6EgN9QmUIggxD9kyBADGGH4Yn8AdbYu4A5ACWAynnFMGMiNX4R4sPa24geo7L3icPT3D8mmt1GNrKScsj+BXwDTHx4Ufc//vCif0x+w+egPfvADg4+RVgBvNl+0Emwz9n6sY6I2lei5DTcdbc6GZY9MjF133XXmZ+9BUcKGsAh5tYA/10ziQe0TS1gVUbduXe+xbS+p6ixWv+wFnMQJKzF+/etfR4Hc6PD6669PGuQOiyaZOhLmj3vocvK5iQCu0Sf83MVF8poLJJnygyeOyITV0+SjhaNk695sVURiS+5yZSpK8xrNpFOdDtK5dhupqbuO07nwgitZkqUYEaCbAuGe/dGg+FHY/kbjP08y2QV2lnPmlOw/li0b986VNTunyoFjO3QoGMN0OyQ26zKzVDVpUKGnVCnbyCzXI8+A24D5HCM6yV2aEhKUu+U04DRQTDTAZF2VKpVjDlxp7zVr1pAMbftOvj0aoN+n3HmX+Qdmfg1UrVpFKp2zyvDfd+dOA04DTgNOA0VfA1v38Y10Nur7JSzVADv1lIpj7Y5V5tuoTiHxTSdjFU76AMbrVKknh44dMOlJFkQKy1uie1hrpyLQqRw5fjgVLxfcLVbeWDtDL0F9wHKwR48eOgao6Y0B4MoGYGFMGEussEDS1gAAQABJREFUm+Dz2rVre8vwsTru2TM2xQ1+N2/eHAwibdeMadh0849//KPJK6At1pJsXoY1NXlHMGjLysoy57H+NWzY0AB4gMsWAK5aVSlOFQSHDx19Er61bA8LB4oDC2DxPNZ4K8wv9/APh+/evXs9J+QRKoTu3bt794Infm5d4kQfiYTyBexCrrzySunWLZz/Pl44LVq0MLgJkwuA6InqVLywLvQz9By2uiUsXaxcSUZ++eFPopyxwe2vPv6Z/OqW+KtKojwVsYvKlSsbS1s2w0XoA2y5p6NvwDr8fLa5ROrt1KmTseqGmgdZtGiRWS0BEF6hQgWvvSfis8Zv06ZNZfv27ZwavQGMp6tfNoEm8Y9JMVt21jmg8j333GP2I7T3CnKMV0dihcsEAhMJVgYMGGBPi8UxX0A3ltwfLxsvoxaNkd2Hdnrmy7E+1kvp8rIWNZpL13qdpGPttlJbl8OVVlAb8NqC2Rz56Ie6oyQg97nndtaIsPldSGGzyR0HV8iSrboE7cBypS05zkhQ859aqsjGsdP7ZNPhL+X4mT1St1I73X24vpRVa24HcqemS+faaaA4aKBGjerSpk1r3TV5l7cE06abfg1u7pY6MKX9O/n2aIDybtmyhQ7QFuuy5sggy5/7ChUypa1aRwGGO3EacBpwGnAaKH4aWL19uZxWOpEyMag/bI4wGNp/JLJcn3vJgjvWf7wj8VujnL2Hd+u+Qkdibmhpw8G9Pz2J0m/9JXv0G0j9UgGmPq0HJuu1yLgDaLWWt4AS8YSxHtQVdsm9tXDGOpdnAKHJgLaWf5m4AHQsKF6jRu44AboUC3LFStPOnfr9fk7iWQhbNxwBi7FA5nvdH5/fjT3nOYD0vn2ROm3BZQy6UhHi8n//A3iDDQCSo3/CBeyKB3QD1KAPK+gtWaFMfv/730fRP5Cv+++/XwDVClPIX34EHVl958d/UfBj+we7uoVNZxPJtJWTEjkRNrmc4tsU13r4fOmncmnLvjLi4twVBPbZhTwyuQItBkBzonoL5cb48eNNXbf9C2n3t9X89g3nq83RL1F3ac+Jvokvvvhi0/bJo23f9BW2T+S+f/UF12FCH2PFuk9Xv2zDjXfE+h76Gb/011UZQQ5+/3P/eTrqiD88//nnn3/uXVarVi3PZsrewyJ6kluySSYQrrW3FeAeueATOahLzfwS7FSx0K5dub70000mO6oFd/2KtTyAm0plQe7oc+g6cq23/S83f1wX5ryEZGZUl8ZVL5HSJcrJ9kMr5fjpAxKLf07bmhFtr3lE56Vl1/GVcuBktuw6sUya5FwsWTUvlXKlannW63k8uRtOA04DxVIDWHT36NFNjuuAef6ChbrLfGR3enj4G6m1ysCB/aWhgt1Fq78rlqouVommvBvrJpODLh8oX0z+0lgUMMjiPoPaS7XOdO9+ifmgK1YZc4l1GnAacBpwGjAaOHLisMxaOy0hkDtp2TjZc3iX8YOxDxtPpksqZ1Y11tnZezYa+pNR896V23s/EDf46Qoa7T60w0tPJV2Fmy7hHdclq4exXifMf0x9OaF+cLd132bPtqieWrwnQwmDv8KSl19+2QNyoeDo3Llz3KiwarZiwRX4VLG0A4zlOxpr5759+1pneY4LFizw7sHZbAXLZ8AoAC7AWSwUY20YhoXyxo0brdeEvNE4BOD+3e9+Z8Kn/PwcwF5AvhPS4beixhoUAewn74x1AHLhLMcCOZZg4WzBJ0BywBaEvFlLw6VLl8a1fJ47d64H/GLdmggwtGkhDy+++GIUyE0ZU9bJCNbrAHC2rGP5oSysrgDPoQbAet1SKgBO/v3vfzdjQ/L/ve99L1ZQ5j76sJgMIKcf+IvrsYg8pH61V8onVrcgf574nHRr3jtu6s4ovdKYhR/GdQP90bOjfuG5ua//o6Y+//3LP5l7//Pxv0qnRhdLk1rNPTcX8gRr2vfee88kgXoBPYk1AA1LF/2LBXz9IHG6+obCbnMfffSRNxEIaA+HdjyxtEC48U+gsXErFtIIE4vx+lPc+PtCrLuRdPXLJrA4/0inH+Smr2BT20QTpzbIdNURG57/yObJdqKS+wMHFr/J6JSAbgNyL/lMPpr3QcwlY3ROdK7lMipK14YXS38FuRtXrifl1JKBxklnSyHanwW77TP8I/ZoLorIPyVXkYoZdSSrelW1Sm8vB6vuUp7uVbLt8GLZf3yzWnjrcjRvCOYZunupJ2dg3hb4LlFCub7PHJadh1ca/5sPzJc2dQZKUwW8S5cq5/lzJ04DTgPFWwP0ZzV1sHnFFUOlfYd2ytm3TQcjp6WaWoUwoMXiO9FAuHhrwKU+lgYYnHXu3EnqN6ing63N+rFz0NSFJo2bSP36dc1gK5Zfd99pwGnAacBpoOhr4FcfPSWf/HiqZOim82Gy/+g+XTr/lPdocMerJFU6D89zyAk0kYM6DJfXprxonr444RkZ2OFKqRuDHgVqkP9W0MdKv7ZDElqAW7fJHod0GiHvz3rDOF+4cY6Mmv9eXGvKZ0f/u+cea/exT81Je5qSTbt1BxhigQA2g+vYsWNMUBFAF8ASYUxoeU45b9u2rcycOdM8mzp1qqE0scCwuXnuH6ANG5cj+GOjNitYIEINAjDMdzjL4AFMwuTTTz/1wGMso+GZTiS445sd8JfwCeOWW26J6Q1ebj9Aba2fyRd5t5QDI0eODN2MkoCJ54MPPjBHrkmDBfCw5rQUKNCwQBMSlo+DBw/K/Pnz8W4k1qaY9rn/SNx+/mwsLLG0TFZII79EAs0E3N8IANcNN9wQ5YXvA6x60QcTGABjsXiHmeSgDllhEqU4yvAuN8hInZBDlmUvTNg/vPDZ/8hRpdWNJQDhj7xyu0BTgtD3PTDgcdOOJiwZbSbRePbw326XT56YmnAFTqx40nnfbiZJmEyEUI/ZlDCWYM1tBeoNO8GRrr6hsNucf2WJpcxg9USYMFlnwWye+9t+165dZc4c9g48a/pLJrpi6Y0+1U8xZFeGpKtfDku7vYcltp9LnT7yscceMxQx1k2iY7rqSFg8EyZM8G6TNv/7xntQxE9KppK+yevnyT9n/iMmyE1YVIxaasV9a8cb5c52V0vLao3VCpoXU2STSV5S9scHPj9eWnTi+LW/VNJ1PtzSWHi588s5fVZKni0vFUrVVZ7tS6VzzXuka+0HpFnlAVI5o56UKhE+fxA07NYgtRECfp+VE6ePyLaDK+XLNX+RiSueUWqUpbq55anzkTUXh9OA08B50AB9G1YkbdQCZ+CAy2TwoMvNi7dOndoO5D4P+i/KUfAObKAbVmHBTb0Y0P8yad68qQO5i3KhubQ5DTgNOA0kqYF9R/bINc/2lY27Inyifm9fZy+Sq5/pLcdOHjW3seZ+ZMiTfidpOb+r7/eUJjHThHVaJ9pvfH6ALN40L0/YWD2SHtKMAJI/Wgjp6dS4q/RokWu5zGTAK1/8wQM1bcL4/vrrFy94IDf3AagqlYsAeIBUV/y6u+q3jwz/zaWy/UAETLb+C/PYq1cvL3iAKCgu1qzJu4koQAtAJnlBACf8dAKAMIwREQDNP//5z56Fr7mp/2bNmiUff/yxvdR9X6rksdj280Vj7fjuu++a71bPk54A3gLuWMEq3ILH9l7YEYO0Dh06eI/gG3/11Vdl167IKgTvgZ6MHj3aA+65n5WV5YFuXPfr14+DEas3AHq/QGHwhz/8wXB72/v+pfxN1fLSgufo9bXXXjPW4dYtRyw1CcNauaLjZIBn/EJJQx6tAJ6lAnJbf8kcAaet2LTaa45YofOzAjjGD0zCL+SXOmgnGMgvG2AWR6F/wKrbCv3DXyf93mtD9j7g9H9+8GN5e8ar9lbo8am3H/FWzNCn/f6e1yI0uXr+/N1/M/0cHqF2evrd73thULd+8Pf7ZMQzvUwf892Xb1R8Jsd7XpgngLf+foLJJSaGsPb3C23olVde8TY+5VkQlExH31DYbY5+0ILz6B1OezsB6M9vWD33rwqhrfgtotGbH1C2YX3xxReCFbkV+hMmHa2kq1+24QWPTI7aNkz/+uijj6YEchNeOuuIP31MvtlJVe7TZ5PG4ibhiGxILjbs3yZvzX1fjh6PPVvGrt4tlIP75rbDpWklBXx15helAGJbMJtzftznRydsX+4h0Ra5WzQ8+ztzBpQaO+8MqVymkVSq3EAaVegrB09ukh3HFsm+kxvkRM5hOSOnNR/MgEeyo1n2zqMzeFZpUE7J5v1LZPfhDdK8Vm9pXedyqVJedVkysuQr2r27chpwGihuGihufV5x029xTm9xHEQUZ327tDsNOA04DRSmBuC1ZoM03vsAx7e8MER5YPsZgBfe7C+UruTrLbmgI2n54ZU/l2T4aFNNd4WyFeUXN/yvPPXWw8YrYPeDf7lZ2jW8SC5rO1iBnlIyd90MmbUm1xoUhw8NekLqV2uUanRJuf/vW//PAEjWEvMvk34n/5j2sgzuOEKaKn3Amh0r5Yuvx0VZarIpJqC9lUUb50aB8lhuni8BTOKH9SEC4PTmm28aIy5oJ/hexIrbAo+4oS6wJN8COtzDihBKDEtLgpX4c889Z2g6+GaGNuTIkdzvb8Jgc8ugAOLOmDHDA4eXL18uv/zlL83GariF2sACK1zzbc6Gh8kKcWKZbilDsISE2gOACAtSqEiwOCbfVojjuuuus5fmCDgT1BvgPmFg5YhRCLr0C3781DDogM0gLbUDcb7++usmLViNc01YfmFiIlnaEsA0v66gA+GXSLA0RaexLEgT+Y/1fOjQoSZ/9jlW3Ux+oDPKAyPCoM7IbyyLWBtOUT1Svr+5/UW57rn+pg8lnUx4vTfrdRnS8WrJqt1c1m5fKaMWvO89j5WXj+e+LV8un+g9/v6wn0XRkzSp2UwnF38i//fZr40b3H4w+x9yQ/c7zfWuQ9tl18HIRMwp9jvw1W8v0EI6uf322w3ga+sifQQ/yp3JLsreT4lEMmgrwfqXjr6hsNscqw9oO6NGjTLapN/ESh2eaMBr6jgTYP6+EIeAsKxm8ctNN90UpTfaCxOOUP/QL5CXYL+MH/93WLr6ZX+6/Od+S3LK9/nnn/c/jnnOSiJAcfsOSVcd8UfoXx1AfF26dPE/LjbnSUHzJ0+fkkmrZ8i2vZs1Y7kvL38uK+rMep/m/eXhzrdL8yoNzMuTl1vZshELbmu9zcuHl7YFwaloxUVIKz8aAeknf/xsfkrpUrqypStKrcx20rbaTdKl+n3SsspQqVWujZQvVV0tvSMbzSXqH3l+9NQhWbZtgkxZ/UdZvn2iHDzOwCF65ra46M2l02nAacBpwGnAacBpwGnAacBp4NukAUDuKsqP3bZ+Ry/bX63+Un4/9lfyx/G/jQK5+b74+fXPyI097vLchp0UBGTp326IPH/X36I2usSi/E8TntX0/CYK5CY9P736l3J3v4fCkuHds1QA3o0UTgDfRz05QwCarGDZPnLeO/L7cf8tny74IArkrlOlnvztoY+MJaZ1X7ZMeqkesahNRceAI1CW+AWLS4BSgIwgmAItBUBUUK6++mqB09kvAN5YTAeBHUDPoFvr78EHH4wCc8kLYfCzYBluKV82VAyjSLFhBY/4eeSRR6Ksi3EDwAoAzkaZft0BkMAnHRYHegvmAQtC0hgEbHF3zz33BJNjwPL+/ftH3ccvwF8Q5MZSc9CgQVFu411YEMm6oUyT+ZF/rPLTLVjT3nXXXR64Rfi2bIkvqDOoTVLJb7rTm47wmPB77wefS9XMCC87YR7Q/eEAu59Rrm02lqSPRaAzuveyR825/99anSz77cife7faNegkt/a8z7u2J3fongU8s/K/o//D4wi399J1DLPajxU2YCsUROBofqGtQP8TBnLffffdfqfeeTr6BiaoCqvNkVAA+SuuuML0Tzbh6Iu+hT4m2BdSz4PpwR96u+OOO6LCoS+mHyS8YL986623SqNGeSd009Uv27z4j/ntY/wrQGxe01VHCA9rbv8Kmz59+kT1O/48FPXzhEA3neiOI3sVdP1al9XlLq2xGeOlV7NibRnaaojc1voKqVa+kgF+ealFKErKmmNxBrjJK/nkZwDuDAD8CO2Kn4bFAt+4wbq9Ytm60qhiH2lb9QZpXeVqaVihh1Qr20Q35ExuUHZGN/7cpZbdcze+LbPWvy4b9s6Rk0px4sRpwGnAacBpwGnAacBpwGnAacBpoGhroHyZTPnrg+/L48P+1aPbCKYYK++RP54uw7tcH3wUdZ2lVs5QmyQrJXRZflB6trpMxv9svuHDZgl/mOCG9FzX7bawx969chnlU9o0s6xauAcFsPudxyfI09f9WmpUjLbKs25rVa4jP7vmV/KxcudayhL7zH/EEKmgm2ZCKwJAi/it+/zxBM+vv/56+e53v5uHSsS64/sRbuif/vSn5mjvB48AmYCTbGAeJliJA/j26NEj7LG5x/f2E088IRdddJH5Hg86JC3NmzeXJ5980tvsMOgm3jXfug8//LBce+21Ma2F+UZmAzji8FMvBMMlv1hl+3lm/W6w8ES3uItVFtCZAFJh4RomWJtjJXrzzTeHPY55jzJAV/mRVP2hUytB8Mve5wjg//TTTws0KrH0gR6+853vCJMhxUXC+imbdri04eO/v/9jURN09jm67t9uqIz+yVfSu1V/e1sNDyNW/c8qYG0n4wDDn7nz5dByJZzf3P5nbx8F/Dwz6t9MeLUq1fXCrVu1ga5+yV+9sIHUV6pCK8nUlXr16slTTz0lvXv3Npia9es/2rZy3333xQQl09U3FFabs/mBZoW+gz4zln7YYPOhhx6KW89pLz/84Q/NZrdh4XCPOGhTbGAZS9LRL4eFDYaYHwlr++mqI6THv3KFd6Gf9iY/6b2QfkookB1uon0uVcysTt04X16a+ops27clT1qrVdAN1loOlr6NLtGNGjNN46IhWdDX0pRQmewvTyDF6Abqsj9mhNAPP87ttT3PyeEZlgEclZbkzAk5fHqnHDyxWfacWC37T67Ps4FlLFWguwoZ1aWZblTZolZfqVEhS/UZPkCNFUZRuY/+0BkzUsyOR6pgCe28y0p5bVCldKBa1OTIkaOGr42yzSibIVV08MVAjnJJVcgv+T506LBZ5sc17aR8ZnmppANsBjn5CTfVdMRzT5r4sVySdFJW1kKBtk3nXKlS5GMg3qAsXhyxnlE3jh49Jgd1U75jemTWFX0QLwNP4uUY1tHHCtPddxqIpYGNGzfJ2++8p9x2W6OctGvXVm64/lpdDhf+8RTl2F04DTgNOA04DTgNnNPA4eOH5Mrf9FDjlBMGCAY0BmRBWAIPjQlAin4ZSdPaLTxw5Zz383aAviR77wY5fuq4iRPgGzA91qaZ5yNh6GfP4QjvM/qpXaWu8K1ZXITvBOg7oLBAGK8CUKcq1jKZsTjjXzhnOaYqWDbDN43kNy3x4uT7wG6AiTsAt3jgdqywyC/ptN8aWGT6N6eL5c9/H+oULFzRPd9VhJEsVYk/nOJyjt7Rm/0Og96hMPLLpp/vv/+++RZjkiNIE3G+9EVb2Lh7rddfMekFrdKF/mY+X/m38bDSw9IHcS+/5Z6OvuF8tDnqOXgEQrumP81PX+gPB6yyQYMGJsxU/qWrX04lzvy4TVcdyU/cRclPXI5uOpRTDIL2bZUDxw7mSXepUhlycf0ucmn9zmq9nCkZZXIBbiogHS9gFB3QN6UTsnlBNzZPAHNc+wFvwDmu7ZHzUmdKSdVSjXXDygZSs3xrOXRqq+w+vlx/q5TL+5CSwmiYquWwmQfCP3Jyj3ytdCa7Dq9V7u4B0qR6d52xrJCnXIriDdJ/+PAR2bBhgy7l2yw7du4yndZpdpHWBJPv0lpnKiovW7369aRli+bSoGEDKasdUVDYAXvv3n3nAPLcp2UVfK1Zo3qoBYN1xQBq69Zt9tI7UpbMsJYunWspw2B18+ZsWbR4iWTr8ZgOoChHOlnSmdU0S7pe3EUHUtW8uuAFGDghrD062Fy3br0uZ9xkBmInTpz0BnS0E9pMxYoVNB3kv4UuoWmYZ6kSejxw4KA3aPVHA/gMKFcQABj9bNu2Xdbocqgt2druDx6QE8cj6bSbb5RUayI2ly2nQH9lNsPR9LKkrn79uvkG/9Hrnj17ZdXq1UY/+/bt98B1niH0J+iIfMKx1UjrR8uWLUye7SDPr490nFNu/NA76Yj0Z1AXReiL0hFHYYRBem3aT506beosaad+p1o/yDf9GOGd0XBLs2JF20BEF6lP9OQnvzY/pIXziEAjFVllk2qe8pOGb4ofq0vK0wr9H20o3e0oUgcps8iEsK0zhRGXzYs7Og04DTgNFDUN2O8F0oV1Mr+iIIDvWbVaFIWkeGkoSvrxEpXCCe+3/AAowSiwROZXUAHs5VdYAnielZVV4ODTkV++D9Kh+wJn5jwFwOSHf9O98xTtBYuGfrSo9VcXQhl8A/MrqKSjbzgfbS5ddTwd4aSjnypouSXjP111JJm4irKbuEA3CT9+6oTsPrRLTpyb7fdnpppyJrWr1UqqZVZRkDtC5wEQBQjCi95+1Pr9fFPO6WztwNUeARDIN2AMerBAkz3mgt4KKJSsKeVLV1cqk+ZSL3OHbD+2QHYeW2YAb6sjjUIBAnsVOT999qRsP7hKJx62q8XDRulQ/0pdxsdSv/MDOOWmJrkzdMKs46zZc2XRokVy8OAhtWaOAKe5gFVuWOhy2dfLZdq0GTpYqafLdHpJ2zatTZ3CFbP9I0d9qruarzPgSa5PMRxwQ4cONuBzGPAFiPvhR5/IsmWRTWP8ftFfl84X6VK8yOYuBw8e1A1dvpJ58xbIPk2/tTCwfkjn6jVrZb4+Hzp0kG6QcpFXH6wbjuRxx46d8tVXs2T58pUKHB801tx+kMnvnnBxN3PmbAPk9u7d04C51Cdkp04QvPPuB7oTbt5dzpnFv/KKoboreuylPv64/OdYUK9WkHnO3HmSnb3FWFRjEUFdjifoeenSZQbgrlmzhnRo31Y6duok1atV9cosnn/0s1sB7hnTZ8jiJUsN9xb1I5Z+bFi0s0WLFqvlQqa0UrC7Z88ewjIm7hdUyDN1dtXqNcp/ts5Y5hw9irVTZHKLQX1tnVBorpMR7dq20aWbVZKOEssXa+VjPaFDBgq2jO19/zFZf+ht587dslStL9Zq/dyrs/70O1hpZaquGurkQMcOHXT5Y1aeSRR/fJwf0dnzVStXy3LddZ7JD2bT6Y8Ay+vUqS2tW7eSTh07GOudoN+wa9IR5FbDHSsjyH9QqBtYCmzcuNnUzS06QXVg/wE5eSpiJcWeCFgO1a1bW5rr8rSmTbP0ulLKQH4w3oJco3/KKlb9pX1Tf4JljW7wF2xvuLNLqMPSRb907Njx0L6QePxCHJQj/d/6DRuFyaQcncim78vM1EmymrW0XjSVNtrfMnkX1of6w4t1Trnt13561cpVsnbdem0/EUsM7iOm/dSuJS106TR1qJr2FfmNK1Ya3H2nAacBpwGnAacBpwGnAacBpwGnAacBp4FvpwbiAt18mLIR5bFT+gGufNF+4YO9dsWa0kiXlJVVzuqMjAhnNUATP57z+zaIzafNMx/t6A7AHytYQI+c0zmRaz0HcMjJKRmxEFUr7zIlM6Vq2Szl8L5UNh/+UkHvZYbm5BwukEeFWMcdPblflm4bJ3uOrJeeTe9TXrusPO4u9A3oOQCKJ34+yVjrWqAjXrpwYzf7ANReqUBb165d5IphQ4xFAiD4ihUrDZ1GWDiTJk0x4BvgWVDWrd+gO1TPMfoPPuN6ypdTZcDAy+SkpvvTMeNkiQKvp7XcwsSmc6tujrBi5UrlwuuUp74DQs38arZMmPB5qAV2rHABQvkBtmJZ3aNHd7l8YH+zhO/r5SsU5F8T5tVYek9XcL5582ZxwTG/Z/KBhf1nn03QfKyKqRu/H/85wBxgJD/Kiw0MPhv/uQLe7cwkRVZW45jgM4D2vHnzZczYz3QCJO+KEX88wXMLKAIOYglOvejXr4/06nlpgZbtEd6MmV/J1KnTDRAYq85ilT9X63Z1nVEfMmSQ7m7dVcHLuN2pycKnn44VysgPaDLreu01I3SyJHcTlGB+P/p4lMyZMzfKH2DkDTdcZ3SNe8rgi8lTNO0zFFA+bEDpqHB0bmSDApyzddKpS5eLdLOPoSb9UW70gnq7ePFSGTtuvNm0I0wHgJdLliyTr2bOkuHDr1Bus5Yxy9mGv0F19oc/vGgvveOAAf3k6hFXRYGd9AG0v8lTvtRVFVtMf+p58J2wPHjVqlWmvJhw6N6tq7AxSTKrLHzBpOUUy/nZWkZjxow1q1eCgfJ+YKUGk2ms2rDvDdwxofLBBx/rSpednjeed9Z+5d577/Lu+U8oF8pp5KjR2ldEliXb5z16dJPbbr3Zi4MlbJ+Nn2jaG+0uTJhQmDd/geHc7NOnl/Tu1VP7kWiwPMyf/x51cKpOUk6dOs30R2F1B/f0ObwbWN486PIB0k3LLQj++8N1504DTgNOA04DTgNOA04DTgNOA04DTgNOA04DyWggLjLDR+ppBWpPKdgNasKHN/c4wg9dvXx15YquZkBueIv9y9n9H/HJJOSb4iaim4ieyBOgN0sDz5TO5fHGig4ANQJ4w/MNGH7GUJq0rXqz1M/cJFuOfKU83uvk5JlDeSYZrK4AvLceWC4TVjwj3bJuk8bVFCwolRowYcNK5xEQD8Dmiy+myIIFiwxwnd/wATTnzp1vqD6uGDbUgHBaBWMKOon1nLobC3ghQJ7t3LFLAe8v1Ur567hubQKo8z26d4sC6cj/rl27Zdy4z2TBwsVR4KT1l+wRa80vv5wmOxRYvOqqKzWsOJk/l4dkwiavWHEDnjIRgaV9OgTdA3bNVQD7pAKmNyoQG7R4Jm7A6cmTvzTxQwlTECE86FzGjZtgrEeHDB6kfGW1PJAvmbAps20Kmo4cOdpMrviB6Fj+TT6Ujubd9z4QQNyhQy43S8ni9X3QE+GPnxX/ub2X53jOj9+tPSetAM8ffTTSUL/Y+3nCOHeDSRTAbkB9OKjt8jf8wW0IuDx79jxTjrHC4D7xbtqcLe8rQHvllcPMBFM8sJ/ww9LmU4WZFMxWruxJkybLMl0pQB1KRggXC2UmWeYvWCwD+vczqyyw+I9XHsmEnYwb+nI272BSC077oDD521ytpa+8cmgekBu36CBMP9SXeMLzUH/nlEpZs0KEVTDsNJ5IInrcJ6NHjzG7mzMBAxdjIh1SF+A4H/3pGJ2IXBVazsG4iYtd49//4CNDEYVu0rFMOxiPu3YacBpwGrjQGqC/c+I04DTgNFDcNeD6suJegi79TgPfHg3EBLptR8ZmKVglc20/djkHvK2aWVUqlss0llhcA+rixrr79qgxb06tDjha3RnQW4HRM2dKK2Ab4c0FyLWAt7H8zikh1cplScUydWWfAt07ji3Uo24Uk6MWryXCQdyDx3fJtDV/lU71t0mrOgMls2x1XYx+YazpySvWehMmfm4AFvJWUAFEWa/W2KPVGhbQFD0VhpD2sQpOr1u3PimghjQ0zWqiXNqNvOSQNmgBxqk17GqlviDMggr5x9r6qILedeqE70ifShykCdDrCwWaZ6nF+elC0qdCd+bPnzbi3r17j0ycOEkByQWGxsb/vCDnWCJjJcrGodep1WyyXFykaXN2trGoxeI5VaHM5yrlyxk9DlGwu2bNmuetDyRu0vyJAvS0kWSFPGORXbFiJaMrrGmh2GHSY9GiJXnoVeKFS12aNOkL0zabNc3Kd97pK1ZqPQcsZuKAep8fIT0ffTxSKU82Sv/+l0m9enWjJqLyE2Y8P6R7iYLylAF7BwSFfr+x9hGDBl8uWdpf2HdD0F26r5nImr9godGnf9OaZOKhfixbttxMLN504/Vmo5tY/iinTZs3y6hRY4xlOn5TEfTHKgooaYbrhElhcommki7n1mnAacBpIL8aOJ1zyjNSydD9jErqt4ATpwGnAaeB4qgBKOcYm0GRaY1jimM+XJqdBpwGvl0aiAl0owY+WM3vnFWZ/wO2dKkyUrl8ZSlXpqxZsv5toytJpZoAbFjAG39soMaGfgAEAFV86POzlt4cS5TIlFql2qmVd0PZe2KN8ncvUQvvtXL6bLj164nTR2Xx1k/lyKn90r7eMJ2EaKBQd8lUkpkWt1u3bjVgMZQj+QWqwhKCJTMAOhtJoqvCEigEkhXqfLdul3hL7mkfAD7QgBCOv70kG2YsdybsTZuUYzfvRpqx/MS6j7U9aYT2oPBA7vDY4WieOm26AeBiUSiE+0zuLnVuudK7MPF2ww3XJDUgg3Jl0ueTZbPWr/wKIDublpYvX04uv3xAyjvF5yde0yaUbmKj1guoVFIV6hQW/a1aNpeGuvHpxM+/SBnktnFizTtHrcTrK6gc5Ia2bhIdV61aYyiDCKugbYfygFqGDXAHnwOYAZzTLfRFCxYuMiBvLDC5YcP6MnTYYMMlf75A7uM6KQYtEFQ21G+/MKnBbuOkBYoYdBUmlAF7IUyeMlWuGn5lTBoTwp8+faZOuGzId59PXPPnLzR87cOGDk6a9z0s3e6e04DTgNPAhdZA1QrVZdq/r7zQyXDxOw04DTgNFFgDzXQfnO9///sFDscF4DTgNOA0cD41kBTQrahDnjSVVqC2QkamAbmdJXce9YTesCBHiRJwmJ81VoboDsAUCgwAbiy9c3JKKZgbAcBLlqgq9Up1kaoZjWX3idWy9cgcOXhqq4af17obsHvNzmlyKueoXNRQKQkyG59Xy24AjzFjPlPO3PSC3FaZgJgsxS8qAj0G3MRWsFSG23nduvVmAsPeT9cRMKig+Yer98sp0ww1SyyAK13pDYZD+tlwEnAVgK2whHjYjLFWrRqGUiMe9y91is354ELP0fOg0GarVKmigHlV8wguZOp52CQOlC12kz/8FLawOSSbhzJ5YNNTrmxZady4kdTWzSLhqQfw3Lptq9nQ0brxp4s6MGHiJOOHzT399YsNJ5s1bSrVqlc1/QgbW2I1zoaowbC4Rufde1xi/PjjSOYccHvM2HGG/oLyS4cwibhS+yL6V/jIg7zYBY2D8LF+p8+LBXLXrl1bRowYbri5CwNoj5WHjUwK6qQYFuZWn9CCsLFvw4YNjFUOdZvVD5s2bzLW29SnoJDHr79eYTao7BiyyS3P165db+hKeHcFhTwTL+2H+Gg/6Mqmye+esADW91yy1wHdfsW4c6cBpwGnAacBpwGnAacBpwGnAacBpwGngaQ1EBPo5kPU/AB/QnCH0iXLGKCbD9nz+QGfdM6KuEM++u0P/QHGQGlSqhRAt/KiKwDFPc75lSxZW63nq0mVjEay/eh8BbyVA/lsXmDiZM4x2bCHTetOS9cmt0nV8vVUE4W/ZBLLRjaCZLNE+MaTlYgOcB1JYxBASzacwnJHGQBo169XzyytZ2M8gE7S3alTRwVkKpmoATkXKE3AUqUwON8AcrJ5P378hFpSLzIWqIUJNMdKDwDXhAmTDLgWy43/vu1b0HW5cuUMOE5boI6EAWV+v7iBtqGpArWdOnXwP4o6h95hlVLMABYHpUqVymZzSyYzWK6HHFVe6+zsLWZT0y1btniAL2msp3WkX98+SplSOxhUoVwDSvuBaYBc+MmxICa91F3aJVbNX3+9XMZ9NiGUd5tVEnDK27DKlSsrvXQjwou7dDYW8Vwj1B84vKE3YTVAUA4dOmwAU8DxVIT0jVJO6M3K9+0vVyb/GjSoL9ADAdxX1cmDUmqpj9DeoCjZsGGTmaTgOkzIP7Q/VZTyaMiQQVKlcuUwZynfox4uVP798RMmKpi8N9R/3bp1DAd6q5YtTX8R6qiQbtJHIeiTutla6/DAgf1NHYW3nLqB0E4OH+5kgOzPPpuokxi5m2EaB/qPjWK/VhqTVi1bmHZo73OkPaxZszZ0M1kA7ksv7W7A9QoVK2gPX8KUG5Mas2bNNvzu/v6ejSmh/kFvTpwGnAacBpwGnAacBpwGnAacBpwGnAacBpwG8qOBmEC3DQyMO4hz63ezlFJwtkzpMh5Yy8e0k9Q1gN74AUhYYA8QxYLcgKaANfxK5pSUKmUbSWbpmkpp0kg2HJwsh05tV4yYSYncuE/lnJD1e+aZcuvd7DtSPiNijZrrIv1nbECGpS5pTyTkF3oDLE+bN28qtWrWVPqPDAWIT5oN5bYo8LZ+3XrZr2BNMuElii8/z0kjAPcA5fht166tWsdmmDICEFyxYqVUrFRR2rdv5wFG25XfePqMrwwYmEx8gHhY/aKDmjWrG4v+MzpBQJ4BUrEOB3j0A3/JhBvLDeHAQz1z5qxQUDeWPwDT+vXrKtBfX8pnlte6quCWgsPbtIy26QaIWIEmW0ZYDgOUxhP0DhAHuNyubVtjhUsaSijdT462ATYcxEp3/vwFBpyNFxYbVM7WOtmiRfOYtAv79u01Vq/BTT5JA2Xfu3dPj+bBxtVYaT4A/QCOFytdCW2TenzN1SMMMEvZnm/Jymos99x9pwGmgxOPFStWNBa1J06eMBt2BusU1xbkhnplsILlPXv2kAqZmVHZwDK+ogKW1117tW5+uTMPKEo4axT0RB+p6GCJWvn76zp+Kf++fXtJo4YNjWU698gX9QMBIKXenTx5SrnFd8iXupKCSSabD3/CuUd9adKkiXS9uLPXZv1uUjknXtL82fgJhtc8qE/Cqlu3tgG5W2o9sWlOJY6CurVpQmedO3cyZVZZQf5gWnjPMKHTpfNFpsw+Vm5z2phfKE+sw9lAlokHvxzTvoAVAzY++4z+8rLL+urET29Tfv54G2qZNtP2wmbFlAuW4M2aZcnNN98otXXjSwvC27Dc0WnAacBpwGnAacBpwGnAacBpwGnAacBpwGkgWQ0kjcjwoWo/ZhXPkNIlS0tmmXJ5PpyTjdi5i9aABQIsmGOBbq5Lly6lYAC/UwbsLlmipNTN7CIVSteVtQfHye7jqxXUjl42fubsaQW7Z2sZVZMeze6SUiXKREeYxius+qZPnyFHQpa+B6MBtOyiwEvfvhHLV/IXJlhoAibBG8wmeX7LvzD36bxHWTRtmqXA5VUS3DyuSZPGCpg1jooOsO2rr2YpQJR3I7ooh3pRpkxpBXWaSf/+/ZTOoLkBUYNuaGfbtm03IC2bK2JRadte0G2y18eUwmLOnHnGCjaRH/IP+IV1che16q1evVpoO8cKetWqNQasWrtunbHUjpVOrG9nzZoTN2rqfPPmzeXKK4YYvYfVDaw+Aa57q8Xxhx99IksUaA6jHCEi6gzWo6QN2oUwOXr0eCiNSv36DaSD+oH+IyiArlid3njDtZjMGgD2Bj2nbl8Iqak6ueWWmwXdxBLy0blzZ2OJjU7CBP1T3t27dc0Dclv31A3i6a8g5nvvf5inXgKGUi9SoW7xW2MDytM2+vbpFZfrm7rBD/C9WbOmUl8B2Fmzsswmp9aa2aaZIxQdM2bMlObqtkaN6v5HKZ1Tp9hkdszYzxTs3xHql/ZyxbChpp6G1eFQT4Vwk70gOnZsL9fqxESi8qBOQ2uSfcnFBoCGOssv9EE7tQ0HgW5AcCzyg1KtWnXppmGxEiMovM/q1a2r7XyYTphD41VChg+/wkxwBd26a6cBpwGnAacBpwGnAacBpwGnAacBpwGnAaeBVDSQAOgOs+eOBM8HPGA3H6lO0qcB9MkPwJAjeraUJgBRAAsA3iVOKxhZtoG0q3ajbDj0hWxVOpOTys0dLWdl+Y6JUqNCY2lZZ6Du+h4OKkf7Sf1qpVo4b9FNKGOBnIRIXuqohfTQYUOkU8cO3gaOsWIDIOnW7RJp27aN4RDGWjwMUInlP7/3SScg5pBzG9hxnUiwUoarN54QDjtVX9avj1nOH2/DPtxCQzHiquFGV5MmTTb0C2HWqvHi9D/L3pJtLF7jlRHu0TuW6lco2Ix1ZTwxkxZdLjJgGuDpVwpkQ5Fx6NBB9RahG2HlB3HOnj3P1NtY4ZHn1q1bGSvYWrVqxnLm3a+qVBR33XmbvP1Oad10b0HMiZADB/bLWrUyhrqBDfjCJW8ZY9mMVXc8AZS99dab1AK1tJnAiOe2sJ4B9PbTOlU7CZ1V1lUITZtmGfA/LD01dWUFdDxQTiQSVjlQh4O8zlznlxaHyZWhQwdLjx7ddbVQgldTIIFwk/fudamUzSijm+FOCJ102rBhowGpq1fvlq/3FiA3HOVjx44PBbmpwzVrKv2G9h1MktBfX0iBSodVCcnStdD227Rubfj7mWjzCxNlB5RfGx0kA95n6uqPzMz4Ez+04WuvHWH0BNDuxGnAacBpwGnAacBpwGnAacBpwGnAacBpwGmgoBpIgHwCAEVAoCBAZp7kxYcKmh7n/5wGAE0AFABLAAEA6QAisMzkxzX3y5epKi2qXCHNKg1SShMsbyMB2GOOcnUv2fqpHDmxu1B0izUmVBLw88YTQLRrrhlhlsgDziUrgIlDhwwyYB60CYUt6PZipTeAOoEySEbmzpufB/AL+gPkHjx4oHIfXxrXUtXvr1SpksZa9eqrrzKAd37BIMApNho8fDh+GUFVQfquU/ApEcjtTyfpwsr9huuvlTtuv0Uu6XqxdO9+ifS8VOkv1MoZqpMVK1f6veQ5h3/5St0wMBmQ23qmHg3RusGkQCzBMnXzOSqYMDel1LoUMD4oWOdjsRvs94LuaJNY6V8oqVevrloONzN9QaI0ULfrqiVtGADLPehPoNJJpt4DUvILChNxQWvgoJuwa+oQVvo9undLGeS24RFGV617vZR2JWxSg3YAlU1+JoyoB4DcI0eO1g1HN9goo45suNj/sn7GKj6VPi4qkDRdkP+LdNICC+xkytNGS30K45hHZ0xioEO/EDZ6D8rBg4dka4LJT/xQJ8P8B8Nz104DTgNOA04DTgNOA04DTgNOA04DTgNOA04DyWggL8IT8KX2xecsgaNBvwgldMT6OODFXaZRAwAJ/PyAN+CA/QGyZZQuJ40q9lSwe6BklorQFyguoyBdJCEHT+yS7H2LEoJ2+Un2rl27FdDYFpenGcvPwWrliBVoMtaAwXRkKgDbvVs36dC+faGDItWrV1egu0vS8Rw/ccJQrMQDRCkrOHA7X9TJlFswf4mu4QofooBuVoAyJZE/+xyAe/ny+EAzwFz7Du2kT+9eusFm/jbsg5KACYLrrrtGrh5xldKQNDP1dpvy+7IRZTzppnQZjZT7OlWpoeXVQ0H1MPDWhrVz5y7ZtXt3aP2vpFbOmRXKW6feEZB7mtLxYKkeBPc8Rxf4hH6hcaNGCjhXTQrMpO0xWYS1elAA7OHDDvJyB93Za+KGMiVdAsc5fOgFBYjxz0aaTZtmhSZt06bN2l9FWyuHOvTdpG1DVwJVznq1Cg8TrOABuS9Ruo4wkD3MT2Heg54FHmz6nlSEiaka1Wvk6f8MH7quJApKhnJxA/AHhfYOB/emzZvjvhuC/ty104DTgNOA04DTgNOA04DTgNOA04DTgNOA00BBNJDXFCsQmgFZz/FoRoF5gKie9XA0CB4Iwl0WUAOUAQKYx7kpEz03nN0KXpUocVKfKuVGhYslR//WH/xCjuccMH74h1X39oMrpGXtAVJaaRbSKdt1Izh4eeNJ27atjXWhzUc8t7GeYT3KpmobNm4MpQ2I5S+V+6i5adOslAA8rBYT5R9r9q5dlVO9ABzOWFnCXbxpc3bKFqlYou7dG5s/nHIhfKxpC8JfbHUdpGVhIiQenQX1GlA8kR5t+MEjQC+0F7HyCGf0bp2Qwdo4CKRiSV67dm211t1ontuwaVtLliwzfNM9e15qOL6LmuVphtJ0YAGfLJhJOZfNiKwGUdZqm1VzhGoCa+9U2iibk6ZDAIaZYEmGMiWZ+Ji8gCJo7Vo2xozmmqZcly5bqu28STJBGTfr1q2XTz8dK5u17YUJ6b9CKZkuuaSrrrpJDVgOCy8d96rrCpJaNeNTD4XFQ/mjP9oJ7SVK7Myp72amTmKyuSRc/YDhVvD79fIVckxX/FyqVDTt2ivVjU6mOHEacBpwGnAacBpwGnAaKIoaYI8XO/bhWwZDKydOA04DTgNOA8VTAwlRT4VRvQ2j/N+5Z86eUQA1JyVgpHiqqGil2lpEcwSUsEfO+dUu304OnNgg244u0oSf1T8su8/IgePb5dTpY1qWFdNWZgAbexXkPno0GjTza6ysWvxBZVFQAIh8Qo+BBSsWuoVjZVtCWijgih6TlfXrNsblngYcbanUElACFERIU9u2bRSgayorE9CA+ONhcmrFylVx9QWohSU2+k0l7/54Yp0TP9bRduAY5o6yHDV6TL7jPnUqfEM8Gxf1FCoS6BeCQDcgZft27Qy3+L590VbnuAfAYzPUZcuW6+acvRXUa5CvVQk2Lek8kvYKaqEdz5o9GB9ULSV14jIogJBhlrlBd/7rdH0A1KlTy9Q/f9gFPW/ZsoWuEGhk6Eb8YZn2sGKV4b/33w8917q7Tjcyhe4Ey+QwoQyGXzlMecWVckXbUVGR8vpxll+qJ6z7k61TuGVT3cW6KSztxC+0Hyzhd+7caaiL+mr7YdVAuvsYf5zu3GnAacBpwGng26GB3Yd2yOy1M0xmG1ZvLJ0adzXnvOefeuthmbJ8gvl+/eCHX0jdqg2+HUrJRy55R+/WVY9I/fr1zSrBfARzQbwwRoNCk3EFm9kzJktFMH6YNWuW0jsuUmObPXlWfjIWYr+T7t27635EHVMJ2rn9Bmlg06ZN8tprr5n60aJFC7njjjvy5G758uXmOd8CLVu2zPM83TeKc7tNty5ceE4DsTSQEOgupaBImVIZ+hIBWM3RRqy2w4oD5pzNkeOnsSR2cr41AOjLQI4Xe/CXebaaVCpbX3Ye+1pOn80tn5MKch89cUDKlqlg/KQjzXC27lFL4ZycaN5Wf9h16tSROrq5YzrADTY3g0N42ddfq6VtcONNf6z5P0+FI5pYNm3eFDcyBl1t2rROGjiKFxgvz67KH75q1SpT/vHc2mcM4qDfiCdY87Zr1yblAWK8MO2z48dPGG7wM2eYcgkX6nK28mgXlhD+IaVvQRdBoV62atVCVxx0kqnTpkdZpeIWEB4AfN68eUr/skJXFVwkl13Wx1j90w4vpDCJUq5suaSBd/JKHcJfUMoAmifYfDOPHw0rHdJKB4TJWqUnGx/htWvbNg/QjX8s/w8cPJhwk0Y22N2u4C00HGETa2yAeaWC3PDaFyWQmzzC758sWI17v5TQep1sf427rKws034mT/kyz2oT237mzp1vVkh07dpZBg7oL1BEJRuHP23u3GnAacBpwGnAaQANvDXjVXlz2l+MMvq0uVyeveNlTzHZezeac8Z/TuJrYMqUKWrs8bVxNHDgQOnbt298D0Xo6QcffODtkfTwww+bFZrJJu/TTz81Y3tbRxgz1apVywD9jJMP6jiRVbvZ2dnmN27cOLnpppvMmCfZOJy7b4YG+A6w9cS/etHmjpUA7733nnHD98BPf/rTfI/BbZiJjsW53SbKm3vuNJAuDeRFPM6FzEcov9IKdJcro2BKiVIKbkeAIsYNNHisup1cGA1YkCAIZpzRCYjypatouZWV0zkntQyx61bA7uxpOXH6kAFsbNkWNOUnTpxMuMFhQ90MjeXt6RDyUldB8/LlMwsN6K5UuVLSScVKeffuPXHdA3SztD9d0qBBPV1KVz7p/J88ecpYKcSLv2qVqrr5ZO14TvL97OTJE3L8xHFvgJDvgAro8cjhowp0B6gYzoVJGQ0bNlh279mtg/0VoaAmkzmHDh2SqVOnydIlSwQ6k27dLjEbMgbbYAGTmrR32nFJBTRTEW1Cpk/w+yEc8pA6WEtoBRM+JurpZqK2PytYaNG+oSchXDs4tU+xNN6nYHeVBFz0Bw4ctF7yHFmhAic3ltypWhDlCayQbhSGTsOSii769u2lk5571CpqSejqDT4MmBidOnWGLFy4RDcevdRsWMsmvReq/YTlxd1zGnAacBpwGih+GiirexX5BeMsJ8lpwG/84D9PzveFdYVRA2MLxjvJjnmwhP373//uAeTNmjWTfv366arWJqGZYRUtoDjfAPi77LLLpH///qFu3c1vpgYSjVNpNxg/MdZN/Vsqfzrzt1X/ef5Cc76cBr6ZGogJdNvsllFO54plWR5fWqkv7F2R08r7fPTUsdwb7uy8a8C+1P0dMDQl5TMq63I95YrNOaQgTyRZ3D995mQe0KcgicZC9vix4zGDIH3VqlVPa6fPRokFpUGJmWB9kIqVLsvlAJLjCdzRYZv/xfMT71kVBaWhC0jWoj0nR9vp0djtlDKqrOB+qta88dLof0YdSaQjv/vCOj+hgHvYLLyNDxqO2269WUaPHiOLlZubgXMQILVu9+0/IOM+myBLly7TDRR7GWt4+KVTqTs2rKJyLKUDtPM1OPPnmcFZFeVJ1y8U/+20nFMm1OvDh6OplagHwXupREiaL9KNZXsqWBvko08lnG+SW8rw6hHDJaNMhixSGhPaTyzhY3HCxEm6Mme5XHppd6UOamssqIpz+4mVV3ffacBpwGnAaaBwNHD8ZO7Y9sTp2N8ihRO7C7U4agDL9ffff9+M79nf56677jIrzOLlpXXr1sJv4sSJMn36dMGSln2Hhg4dGs+be/Yt1UDYCtBvqSpctp0GLrgG4gLdgGCldFa8QkZFyShVRvzDiBxd0n9KQTTAIH4WdL3gOfqWJcDq3YLdOTllFGwor0B3XlqBs0ofkc7yojOHpz2eADTZtMVzl+wzQOMLAciFpQ8ANye4YVvAYcWKFdMKgLIBYSr6xOo+0UsXi9SiotOA+tJ2yaA0HtBNRACj11wzwmzKOG/+AuUW3x4TpEenbAy6/cOPZcWKtgp491T+9KxvvB7RUzoFcJM2nX6YW9TSuoxSopTLA2pTdvE445PJ3xm18D+l7d+9+3K1hXX21VdfJbWVc33+/IWGmz+MLggftMXN2n526Saxa1avNe2nhXJ9O7A7V5/uzGnAacBpwGkgtgbu6POADOxwhXFQrUKN2A7dE6cB1QAgN/QSSDvdmwcaklRk0KBBhq8bupSvvvpKsrKyDACeShjOrdOA04DTgNPA+dNAXKCbZPDhWVktusvpsjD/Qm44uk84ju7zV1JxYrJgN2UFCFpaOdWhmvELlt2AMudb2PzOpi8dcbOyoGRJlqiRn3SEWLhhXOjlRMkAeumc/ChcbeY/dCZ5IiQ+8cPAsrtPn17SSLngFy1abKhM2KAm1mQBNBgL1R0UNgOUe7hTp/ZFlsoifs4vzFPacmFNssA1XRjAKW2KfQLY7HHgwP4Ri/QLo74iFysTm1C6NNUPQNoFvPa0jViTTKyKwd3OXbtk8KDL1VK+Y0oTeUVOAS5BTgNOA04DTgPnRQP1qzUSfk4KpgH/d0phjccKlsLkfLPaNZbAt/3hhx+ax5dccokMHz48yunGjRt10/llZk8WvqMrVKggbXWfFza4ZCPC9evXG2C7ffv2Ah/zhAkTZOTIkfKjH/3IjVmiNPntvPC3G7470ol7xNLoN6Xdxsqfu+80kA4NJAS6iaRy2YpSvoxSYfgEfu4Tp08YACgVC1NfEO40jRqgU+VHWZRk49CAjSTPSpYofd7B7tOn2cA0fYg0wGLO6TNFAuSOAO6KuMeRU6dyNwSN4yzpRwBGsUDXsECSoXnB6hLwzv+iDguruN5jMNC4SSMzcE0mD+ihebOmUqdObd3QsI0sXbbcgN4MlMOE+s3GhZ9PmiRlMkpLxw7tCwVgDYu7uN9jk9LCorbJ0b4nmYme/OgQOqA5c+dpeWcoQDsw7Ztp5idNRcUP76CmTbPMplBt27SRr3Un+iVLlppNXcPeBab96Ia5n44Za95fgN1OnAacBpwGnPNdGYEAAEAASURBVAaS18DGXWvlzel/lcWb5suxkxG6rrK6v1K7BhfJzZfeLe0aXhQa2Pb9W+SNqS/rmPqMXNZuiPRo0Ve+WDZOPprzlmzas95YlNSqXEdGdL1JRlx8cxSAs/vQDnl/1psyc/Vk2X9kr5TLyJS29TsKltYt67YNjc9/k75/5Lx3ZMzCj4R0IKS5eZ3WGtdN0qtVfzmp35l/GPdrXT16Wi7K6iZDO13tBYGf16e+ZNLYqUlXGXbRtd6zsBPie0Pd79J0801UuVwVub//YzpeizYMCvPrv7dlyxbdb2KqWfVnVy3BFV2nTh2l47o0JtezPwzOp02bpu/GJVF7HWFs0apVK51EHxgTQAWQ5UceunXrJlk6sTx37lzzgxoMIT2NGzfWzbJ75dmgkTSPHj3afEswPgbktbJgwQLdwH6LGTtBSYYVc1AAfqHwwJ19pxMfXNd9+vQxVGTz58+XNWvWmDxceeWVMWneUtUlm0MStzXsOqwbzSOkY9SoUYbakXFfS93kvEuXLl7SseTm+6lp06ZRIDf6euONN3R12S7PrT1hE/r69eubjex5zrcBmwyiU/S0e/dumTlzpsmz9TN58mRzH7dXXXWVyT9lQzmzoaEdkwKkX3zxxaa+WL/xjuSTOodOMRCwQhkRDuB9mFDW8IuTdyYCrrjiCqM7eMfnzJlj6nDdunXlzjvv9LwT/owZMwQ3Vr88pIzRK3zmpD+RXKj6HStdCxcuNG1k3759nhPoUJnQ6N27tymrzz77zHCxsxp7yJAhcb/l/HWccrXf5uAUn3zyiblG7+gLHVv3/nbrJSTkBP2xsphV10zMEH5B2m1+6xBJs/WaNFCHWAEN1z1tkf6D9vfoo49GGXrRfhYvXmz2CbP9BN8HDRo0MBve0rbyK+Tlyy+/lNWrV+s3ZARnoS9jo/vOnTur0Uz4+y4YH/0o7YC2bNNI24WvHy5+wgsT+gN0gh/qT8eOHU3dol9gIoz7tBHuBzf33bt3r9Hbhg0bTFsm3bVr1zb9SKx9AsLSEHavIH0zfSH1nzJu1KiR7kXWMywK7x79w6JFi8w174lYuvI8XKCTuEA3jZFfJbXoztQBjF6YAQVpPaOUFcdOH5PTatldRv+cFB0NUGYBnFsv1bpRoicrCppiGmfZjIy4wRw5csS8YNM1GXL02FE5mWbwOG4G4jwE5EIH8YQOj40M05V/uLlTAQbpsHlJQt0RJnTGvDAA7qpUSX87Rj+JdNRdN3Vsq4ByYUmZMrrhYb16ykVeOekoTL+nA53WrVuZj4Vul1xsLE/nzp1vdmIPBsSLYdu27TLrq9lSVwFyPnicJNYAg0D6COqh6bcSe0naBZugHtP+Iih8INEmCiqHDx/RD9XpZvA/6PIBaU9/QdN3If1Tlli8t27dUttPQ+l6cRczWTRj5iwtk1xeVX8asfyePOVL/bCsK7Vq1fI/cudOA04DTgNOAyEawOjovz78iYxVsDhMNu1eL+MWfSxdsnrIs3e+LBXUcMkvGxQg/2D2P8ytzXs3yl8m/V6Wbl7gdyLbD2yVJXrvxfHPyGuPjJS6VerLh3P+Kb8d+fMod1wAuBPf9d1ulydH/GfM9+LcdTPlR298xwDZwUBIM2B7oxpZ8swdL8knCoYDeE9ePl4GdRiu1IwRYJq0fzj7TeN99+GdCYFuHI5e8L4QPoIu7r3sUf02Sk4Yp/zzn/80YGPQB/tSAKCtWLFCatasKTfeeGPMcSAAgQVew8KxACoc0D169Ag6MRQcy3UCGSGusWPHGtDJ79CmByAiaMHMM4BX8hMUgGR+CN8PAwYM8L5fcA8ojHVzUAgTYIsfABGGITaNAFpB0CS/ukQ3UJCECaCXFcaVFuhet26dZGdnm2+RW2+91ToxAN3rr79ugB1uMm4BhCPfgHeM660ueM53hP2WGzFihLz66qu6ufbCKKAbMBPAiLAaNmxoLL/Dvr/QF6DSZAXLAJlxG0s+//xzMykS9pxwALInqaHN7bffniccngM2om+A7mHDhsnLL7+s3yvbvOCYbGAsTt5I06xZs0LrBmHNnj3b/ChPgOAwudD1O5gm2uVrr70W+u1GngCTKYc77rjDgPu4p/yYQACAjCVr16716rjfDaA3OrdCvQHo9runnmXpBFU8Qde2LjGBxkRDftotcRSkDuHfX68BuseMGWMAYp4h6IuJHPRF+2T1BHUqTOgj+TXVSSd0bttUmNuwe/HyQr8DgEyfyOQAQHOYUMb0ZRzDhPLjh//rr78+jxPaj+2HyDeTUMHJMuoW7ZLJgAceeMD01fD7U9eCQrqZxAI0v/nmm4OPE16no2+mXwf4R+g/g312MBHox/bx9F9MABZFiYnSUWkRjpUyKhiebsDSsxKpuHAzHz95VE7HqMhFMbPfljSdLaFc3PrnF6hMMkqV998q8HnZshlSQcGMWELDg/aB2bZ0AEvEQ6fkn82OFff5uJ9ZvryUz4yv00OHDp/r/NMD3DATSOeZrAAyV61aRXbs2BnTy34F4/ft26tAd/JAcMzAAg8o93L6cqYfoT6ECXQHXbokN/sa5j/RPeK2/Vkit8HngKKkLzOzsQ4gG0i3S7qajfSwULWWPNYPg+LV+qJavWateaGl+vK24XybjuiQPqIwZO8e+oq8Ezy0CTZgTUaoN23btpa9e/ebwXDQDxNEY8d+JhXUCqtnzx75rmfBcL8p15H2oxPlqh/aT+8+vdQiZawZQLLaxy/0D1vUsnvBwsXGSj6/bdYfpjt3GnAacBr4pmrgyInDcuf/DZdt+7MTZnHBhlky9H+6yvs/mCR1qzbw3EMHiLASdM7a6VKmdIb3rEpmVTlwdL93vf/oPvneX26WG7rfKS9OeMa7T19dTvcGOqbfhFYAwgHhn7rmV/aWd3xn5mvy/Jj/8q7tSdXManL81HH9RSZDN+/ZILe+MNQ+znO0aedBmVLJGfJklM51h/V4ssJ3zAsvvGAAgKAfxnp+UAcw9qWXXpL77rvPWMb53ccCaXhHMglsx8kcx40bZwDaG264wR9ElPEIVo1+AQwjrTYcnmFRzDUWxkhko+4KUda65kGcf6SN/Ae/v8g7Yyo/mAuYE08KokuAfeqbP39hcfnH3+PHjzdOAODttyhp+Mc//uGB3ABM6Nnv780334ya1PAby2Atjx75JsNYCAtgxBr2kD6sb/3CeIjvBL+gt1deeUWuvfbaUCtUwHSsNBMJ5UM4lHHXrl0956SHeKmf6A2QG0tcv9i6u2rVKsM97n/GhusA5Hx3+ssYS3Z02b9/f7/zmIDq+azf/gQxyUE5B+sL7YR8Wwt7nuPOL4nGoIDVFuz0+wue2zphjzxPFDZugu7z024JJ6wOUc+Z0PG351h1KJgWOOr9q0B4boUwgiA3cdF2aHMAqFYAVploop9MVgCnKdOgEIetxzyjrpIOvi+DdTTZOkE4TCwwSYa1ur9vsOeUI6A3bcwKdcvfVjinDDp16pSnfVHGtg7iH+D4nXfekVtuucUGl/CYrr7Z5okI/eexEhCsn7HcXej7MYFumzAKEdqSCmrVDVWDxbXpFE6oZe1pXU7mpGhpIOcMGxBGl0vpkrrhYJqBbl6A7FpNHQm+RKxGtmRvNdbCdhBg7+fnyACB8LBqLgpCvuvWraOdbl7rBps+OvY1CnzWrp0eoHvt2nVRnaKNJ9aRDhfr4nhAN53k2nUb1PKyiWnjscLKz30GSCzfQVexZOs5ywL/iyKW20T3D+tLFCv6WjoYxuI+dqyJQop+Tvrp1Bs0qC+33XqTZDVprDO1ulxX4/ILm3+uXLla2rdrK2zO5yS+BmjT67Tu9ep5aVIv1vih5T6lP8JiIExoEzVqJN64ihd9q1Yt5dprrtYBfRl58U8vm80Tg30dg5SPPh5pJr06deyQ1nyEpb843rPtp6bq/Y7bb5EWuvHkhAmfm0lAvz4ZENJfdr24c1JlVBx14dLsNOA04DRQUA3Qb/7La/dEgdyXtuwnP1ErastbvevgDrXQ/p3Sg7xrojudc1ruf+l6Gfnj6bqXT/TnH6A0cur0Sbnq4hvl8SuelkrlKhvw+ndjfyWfzH3bPN9xYJsHcgOO//Tq/zI0I9B/bNy9Tn7y5vfMEcfEe5PSpkBFYmXxpnlRIDdh/PDKn8s1l9wiFoT+OnuR/Nv7P5TsPRutt7QdDx3LHbNlmP2Mkhsl/u1vf4sCaQBcsbhu0aKFSRuA0WS11MMaFqF83n777SgOZ4BE6Ais8F4cPHiwsdq249+lS5caCg6+HRCuGcNDCRJPAF6xYLQWqPiDPsGCKFhkYuEMOEdcTzzxhBkrA0AB8FnwCJoF4sIfebCAB/n3g2LkH3CW8BCewVtNPImkILrEOvzpp582ZcH3xfPPP2/iRpd33XWXsbrGgIJnCN8DWFpy7bdQxAra6gbaijCKFiykCR+rWsTm1VzoP3QXWRF71AO67TP/MagrvrkmTpwYpSvKirz5V7NBxeIHuQE6oYFpo5RwCDrHkhTQ2Y6jyBfhYEXsF8qcePlZoT5ghQlgTTkTlhW+X7A099MRAOp//PHHupH4ZuMMS1XrnxtFpX7bPADOv/XWW55uuM+EBpboYBdIME/mZpL/yDtW33zHYITHRAPlQF175JFHzDcj7TgZmpdkosxPuw3WISYcrrvuOq/fog1Q7vwS1SHSiBtAbtob51BtQLMEhQ4/LJgt4Mw3Mxu+QsVkJdhPUr/50X8lEqy0bT+FW77laLcAyHYCi0k9JghtGpgIhFfftivqBKtybF4JB6oTVjoQHsIKB9qjtdCmbOkj77nnHvPc/8+GQx0gn1dffbUpb/JJGPY7lHjZwBZBd/11goh+ljJl1QjgtqVHZUVEsjohvHT2zYT3TZPcKYiQnFEYSNlSZaRq+Wq6XCx3YITF8HFdSnZcB0VOipYGALnPKqWMFcqxbKmK2rgiy/3s/YIe6RRq1qyhnXquhUQwzJ27dkbxuAWfp3K9Z89e2bBxk5kVTMVfYbpt1jQrLogLzcjXuiGbf3CR3/Qw2FqslsSpCJ1os2ZZcb0Azq5evcZYdcd1mI+HxF+zVg1vsBwWxMaNm81gNOxZKvewrp06dZpa0vzV8P1u27rNG8imEk4it9T7vn17m40ImewJSnb2FjmkFh5OktMAkzexlo8lF0JeVwwYVqxclfeB3mnQoJ7yRUY+gkIdnLtZR5fgDRxwmX5k1jaD/fvuvVv91jcDk6A/ANrRo8eYtm4/noJu3HVEA1iRdO/WVYYMHpjHsp5B4969+3Rzyt1OXU4DTgNOA04DMTQwa81UWZa90Hv6gyv+n/zu7lc9kJsHcGv/67X/I8/d9Yrnbu/h3fLR3H9618GTRwY/Kf/vut8YkJtn5ZW28mdqlX177weinAJQv/HopwpQ36rvxMi3RZOazeSt74/z0gB4/ua0v3j+6N9/O+rfvGvC/vCJKQYMtyA3D+ETf+/xz6Vvm0Ge23Sc8C30wj1/l9ce/kRe+d4H8o/Hxnhpjxc+y7l37NjhOQEsw8LPgtw8ANwCLLnttts8d4AbgJAIeQeoscI48vHHHzfgK+NkKx06dDA80H6AEbAG8DaWQG+CVaQFuXFHOE8++aSx2uSa+AHi/QIwhU78hkiMaXlHcwQUQ8g/VupWAIbIvx/4Jf/QeUANYrED695/TIcuAWUBmQG3/GNw8kE6AITJAwJoBAhFWVnQnnKxS/RxC1AXJuTDgsqcAyD7xeo7Xn5tXfHrijSjK4B565fy8VuAA9BDi2IFIJCNL216uE9emSh57LHHPOvfYDjWPzqwAgD5ve99z4BygPDoEgG0R0hTEOTmPnWS+1aPjHXt2L0o1m9oWOx4nDwxMQMthAW5bZ7uv//+pLnS8eMXyoB2Qpi2HXPkHuVMG/Nbvvr95vc82XYbrEPUXya4/P0WaYOe6KGHHvLKNVYd8qcXN6weuPfeew1ITZoQaDysMKHgB7m5j77oJ/2GYLGsw204HLEEhxbJCv7p36BlsiA3z7imnVidk05oVqz4QXDqBP3VNddc44HcuKOtMlFB27VCGv2TTva+PUItQ99vJzXIJ1bZgPB+IU76aiYUbX2hXHgX2H6YNPsnnfz+g+fp7JuDYX9TrnPfrjFyRKGU0kZbXZewlSkZeXEYpzqAOXbymAG7Y3h1ty+ABpiAOH32hOSczbXohnKmXOkqujSxlPdSTVfS6tSuox1WOFk/cQD0zlFe4yM6sCiIMMj7/+y9B3hexZn+PbZ6t6xiyVVywR1XmhvGNhhMJ4UAKSSbAGmbhL1Istns/nf3y34pm3/YhC/ZXUJCNgsJYHo3YGyabTDuFfduuUmyerW/5zev5tW8R+ctqhZmHl2vTpsz5Z457Z5n7vlox04ZQtI6+Uln4uuqc4uKhkUkzXi5OHjwkPTqBV62OpouvZNr1q6L6JkdLm68Uu2XQW848sjQnM2bt8pwm67vuOImjsxNOKPn88M1oZqQ4cKG2w/RuGHDRvGm+VAetKflhf4d9cTip9Tadet1LykPjq40XvSmTZuiSVBvvDzoa2TUQVen6U3nfNmGlP7ggzXBHvjOlov2vHbtBk2YeuPieTZBJguNxfpl99Mv9pyDDRxYqK6/bpEaLGS32WfHQ0ccXspI15iXa/u4W29FgBfTMWNG6xdk87JnjtaKrnp5Wbm7fgwgbukQcAg4BCwEeLdAS9sYhPDnZnzZbLZZMqnjnZd/I7j/EZl8EvlJr6GJfcesr3l36+27539Pk97mIOFGDGj11DP7Ib0h3Y2t3ft+MK3tRzarXSWBkVY8Q3/7lUe13rcJay85/vPbfhck3O1jnVkfljdCjRk4QY0fPFmlJ8cmYWYTxIwGi6ShCrFjkxvo7PJOgn60IYEoGySnIYe85eGZCPlmCEW+f/BU9DMItnBayTxnIZWM8Z5vPB3NPu/S773VLj/e5RBD4Wz06NFq7ty54Q4rO66OYhk2cp8DhpyC+DcGoUudYEzm6X0HMeFYGvKJdUMIs45Fw5K6idRWmLzTyMkQH57SeBhjdG6YPEKaQTCHMwhovHSNIaVgvFHNPrOk7X3ta1/TmtFmn3dJG0BCwc9oUxB1eLt/8Ytf1KMNCNfb2jee1LasyMUXX+wrDWPKyOiMWLyKTfhIS1NvkcJ09TG/69ZuQ3SsQUqHa+t02sTahsg7eNkSOaY8tC9jtIlwRnumDaHR7TcPgfc85JDM9UYZ7rrrruD90RuWTgY6koxBUnPv9bYJyGbuV+HM7hQB33DkM51lfiNCiJdRNoZ0Z5tJMpno0WuUiQ4HY3h5m/KafX5L+37a2XuzX/znw76YiO4+0nOfm9pfJVnabVR6nUxGWSte3X4X2PkAzseyDFIvjc11QnQHev8DtxzkZ7J9yZnOlnFAQb48MPPD3jyJn5vd6g8+FPKn7Yt1LOnz0IAsXrMmMMlHLOf0VBhe1IZEmESEfNCruur91VrHqSPXCufs2bNXJjRYFXzxaU/58mVityFDBkc8pbKySn2w+kPt2d0Zko5z98swpH379gc9UAYJ0W2/LPpl5P33PxDduBN+h6Lu4yNgm3jNvy3e3LZ3wd69+8RD4hX1mpCPBw4cjOmh0Z4XFHpuvcMDySxx1NbWufti1JoLBACv9+VjEAmTjlwf3mR4QVhhDeW0j1NnY1uGfdr7Y1nnBW7kyBFq/vwrdL3bL3Scb+5Ty0TSZr+MPGlPW4ol/d4ehrprT5n5aMzJ6d/m2cFzgo6r9sTV27Fx+XMIOAQcAl2FQE1DtdpzPDBiCc/q7y5qJZbDpfFlmXTReE0jaXJMJpj02sQhU4ITPXqPce6g/q3DyyGLw9nU4kuCaTU0t+pFv7/r7eApk4ZOV+MGhXq7BQ+2rECaf23ed727e3QbcsQQ1CSMB200gzD60Y9+pH/f/va39TOOicaM4fxhe/ia/faSdxWG3BsLRxpBEoUjrzgXD2BDmEcKZ9LxLjtSfobk2+SOibMjcflhaeKLZUnZeVcz0gWcw+SDvK+wH7I5kpk5ZCAKIbRsM7iGe2+dP3++Hdx3HfkQ0+FBPMh/YHRKGEMiw3iom33e5bhx44JessRjtzc7LJ0wxhPd3s86ZTSGtMpDDz2kPd+9owlou6NGjdKTCZrwdnq9oX2Dn/mWpS2G89o3+WcZS33Z4Xv7ut2G8HSO1oa43xhP60htiA4cPJj9zHg0c4x71q9+9Sst2WFrc3OMzhnaEN7ldJ5EM9NhRTiuGTp/Ihnt/Mc//rG+B//93/+99rjft29fkAcAC66raGYT2OE6CiGYzb3AGx9ls+8bXBvhDNLdxBPL909H7qfh7s3h8nQ+7I+PVAgeAuaXJx7d3ok7ahrqFD9nvQcBoRrEe0JIghaPbvxYeRFOiw9M4GHqs6tynC4vY6NGjZSH867gsCdv3HgJL1v2lr4xXSRD1v1egLzn2NsHheTGUxLyKNwLhR2+J9e5KU2fPlV7cYa7MbEfXak3l70tvaALtH409RCLUd49e/aq1157I2wPfbR4uNFOmXyhjsc8+L3nkM4Rkfp47fU39KFx48ZEfHn2nt8sZTxEZ4To8+3ZvU/1jeurLrl4uu7xZeK/4TK78tGjJd7TgtsnT55SS99cJh6z1wopnhbcH22FHs8tW7epJYIP8dvtg3U+UCDRGQkw9/LZMoOyv4YyxNrGjZt0madOnRJzp1BfmbfAz85I2s5iRwAv/NdE3zEj42atex/7maEhy6S+31i6TK6V1mG2dojx49FO72fvatc6L0cMZ6uXj1/uSd50aI+7RIolXvJw/Q3XqULR8P8kGB07m2V4MxP0jhN9+ljub5GeRfZ1/EnAz5XRIeAQcAjEigA62mZ+JORB7nnoVv2eH+l8+ZpTDeKYhHHvTbQcl8x59RJvLMY3xdhBE2MJqsOY50FlXUDrmJ03X9Qq8REpInTHSc9oiEcK2x3HGHFo3u0hV+xh/5HS85JKvGMas72LzT6/JcTTxo0b9SFDgHjDRXtW2sdNObxxRNr2lr+oqChScH0MQh0y1CtJ4I2ro1hGzYBPANs70sYy0mhXsDMEG8ScfR5JGDkbP6KONj84ihMUcRBuxIgRQb1ukwYklrH33nsvqO9r9nmXfFcbjV+O+X1nkxZ65OEMfWHIbdNm0Cp+8skndXAcE3DsgZycOHFiG3Kyt7VvWy4UD1q/OvLiQH1xjdNOzwczbYh6x5M4FiuWb3XjMObXhogjHMnNsbkymmPdunVBDJFcRUKGH9canSy0d9oQhHmsZtoXZcE7PxbjWjLXE+HtDhvqOpY2AR7Ewf0jXEehfW+JlC/yjqZ5V5n3flrUiXtzV+WpN8YTkeg2GaZyclKyZNgaBBTEToDEqW2qU9WNAUkKboyEc3ZuETgrL714dJ+xNLp5SUxNjD75WkdyTp2PGztGhtWJPIloKJkHpDcuJu17+ZUlmnicOXNGG21Wb3i2uSmtWbteLV/+tn6hiPVm4hdXd+4bI+VnUkqI4nAG2Y+0Rr08QK++eqG8AIXv1TNxcGNfL+e89da72hu8Iy+pJi56CgcPHqQ9rc0+7xJ88Xx+8qmn1fR9U7UOtfE08IY125xz+PAR7Q2+ffsO/YCk3mgXPMTGi0wEGu50cKxc9X7wg8Gcb5aUbf36jfolA13kaOlyHmm/995K6UB4S6cbru2BPUQ3Gt5+xgzkkKNbhTDPSE+X4WtDQrw//M5hH2RnSUmrbqMdLkFeOt390EYk8jp1t3v3Xq1zfc01C+UjKfr14Y2RkRN0CG3ZstW3nTGc7eKLpoe8+HjjiGWb9jxZXhp5yXhDyO4KGQ1hG51J6IP3Ec3u22+7VTTbAjqXdpjzZZ16o5OKezTzB9CpNUwmao02goPyM3EsHVHe+xrXDS+W7vo5X1qJK4dDwCHQlQjExyXIl1jr9xYe2u0xZEu2H96sZo3peEcs3xWdMWQWY7GcjDyZODMhSNLHck5XhrGfReGIjvamF+5d1RuP7UkOqco7r03ceMN3x3ZHy+/3Dt/RuLq6XOCIUQ9o3M6ePds3CQg7Uwe8P9rG9y6e4bzreCVNCAepZ3ty2ud61/kGMQa5jJyK/f5jSD4TJpYlBD3x2EaeIOzDGd6mX//619UTTzwRoslOeEh0fmieoyWORA/SDn7t8ePUvm0suL7B6Hwhuu02ZJcz0jrfUcZw0PO2IeKksyOcQR5///vf1xM+2l7+hKfzgc4vfkxaiT48GtmMjI9mdlns9WjndfY4eTbfKKxD3LeHoPem35V57+j91O/e7M3n+bQdkeimQvhx8fcTLbOMZCau4OEQgKC2sVZVNzgt2t7UIJrPNqj65kqpo1aZkPg+ySotMVfXY1deZKbcXPQXX3yRlhcxPYjmmL3URJQQQ5s2b1EzLrtE9+hlZDBJZusLOw9IXiy2bt2u3hUS07zc2fH0tnW82mfNmqEWiya0uTb88gg2lB2Pz8suvVh61mfIS0eopAzlZ6KUzRIOuROI53Be2H5phNvXr1+W6GBdrMn4SHXEDZ3J4F5/40313opVWs94wvhxauiwISpThu1RV+Tx2LHjaocMS9q0cYs6KEPEeBGzX25YPyMfU2ZfcXGR9vz/KMwEgeSbh8g777yn83jllfPFC7yojVcC8fGSygSGr7z6mn5gNje3TrJCPF4jz+gBjxlzQchLGbhu3LhZ4lmiZVOIu6qqWr0gcief+fTNEV9SCbtOOmHQwvMaL0q8/Nrt2hvGbbdFgPrg+iiVGa6vvfYaNWZ0aH21PSOwh7ookY/Al156RT5atun24Rf2Ihl5gZdRV9QLZPfsWTN158nSpctCPAVIm7JwDf/1sccVk1j6fQz45fHjtI97xZatW9ULL7wi188xud7Papmmxx5frD5/x2260ypcebiGd+zYqUeZmJdIE1YPERbCvKtIBROvWzoEHAIOgfMRgeSElHYVq05/u1W365yuDpwQF324OmnivR4rKd7Veeyu+MJ5SnrTs2UAkBT4OL1H8F7WGwysyQuyBUa+BG9O8y2DjjEyB17yZ/fu3SGTQ3on1WOCO95d8C71e1fhO4v3wFjqDPLZyExA/nktljjsc8iXHznufdeyzzHrYMREo2iFMxkmOEDEUxbbkFhBloJJ9Lyesb2tfceKH+2kt7RbG+uuWI8VA/ueE05mw3QUhcsX1xba23QYbNq0SeYo2665HDqHbGOC29/+9rfqzpYJLe1jkdZjLUtXxIGHP9c3ZfaTL4qURm89dr628XB4RyS6OYkGyy9OtNIKMgvUZunFb24hURuaGlVlXZUMoev5XuZwBfqk729qblT1TTUhw/xS4mV26rjUYF12NUa0j6lTJmlPyk3i1RfpIuJmgXftE4ufVk8/87zuyUNKgBsXN0UerhUVlWHJqq7Oe1fER97R/cVrGiI3Uvk5BpG9VHR8l4kXJBq1/OLi4nX5y2QSNj8vx87mkxePsUL27hDSGs/yaC885JOHErIf/DDKSTx+L1DR8kcbuVGkHH7zwG+lnK1DOL3n8TIFhjt37tJe8niH0pGCJEKlTCDDkCokbPAijVYGE3eevDjSsWC0x9jfIF7nK1euktmYX9V62iYscdKGmRBv3rwr1CCZgJCXOPNgpf1CyOO9unTpcl8v8aFDB4uHR7qJ0i2jIJCVlanrgA8D2h33h4cf/rOaIDIjdKAxWoIXjDhpe32lHWHUEyMH8DBZv36T1vhG/sTPaHt82CBJk5ISWdfN7/xw+2gTC69aoK/bd99d0eZDgLLQkbL4yWfUTTdeF5H4DZdGb97PnAHPPf+CnuDFzidl/u/qPwg2V6rCgQUqKeT6Qb++VhPkb8r1c/p0hX2qfkblyEdfgWjeOXMIOAQcAg6Btgjwnm/IX77Nnrp3mcpJz2sbsJftwfnB2LbDG9X8CYvMZtglE1hCdp8r452PZznGs6ujHn0mDuJhHpFYzCaGzDtoLOd1ZRhv+flOs8kwv7QoK8Sy17xxdRRLb7yRtvkuWyuSikyuaLxTIZaR4aAe+Ob49a9/rY8hKcM2E3/aExkS/5o1a+Qdcqp+93z66ac1eYeX92WXXeabPGWFyIumxc7JTI5pzNSz3V6YsHLy5MkmSI8swQhda6Ntzbf55s2b5Xvwff0NSyb4loXwv+mmm4LXCPt7Q/sGf2PUA98Mfh0SJgxL47Vu7+uudb5LIhn5Bd/OmGlDLOmsiOTNb9Kxvdlj7bAw53qXkMRcc+a64/7JiACkeKgTjLw988wzysxl4I3DbNtlYbRCLGUx55ql3SaMPIs5Fm4JHtRFbzTv/bQz9+aOlM+MdunIuT15TlSim8xwQfIbljVQL00Gm+VlC6IbwjspIbbeeXOuW3YPAk1naqU+Ag9N7qO8n2UmFcoNXoY6ttxYzbIrcwARde2ihfrm5dVKDpcOLxR4bBuds3DhPg77IWNnzrhMl//UqdKQh364/HPzROOXX08YHQozZ1yqOxMOHjzU7ps3N1X7QdHePCNHMUu8YN96620hKUO9A7xxgQ1SMJHkYLzn+G2j932pkNxMImi3+3ghKSHA8bxGX9g2yvjRRzu1Nz092gPlhTirX6ac31cT7cyMfuRISRsvXuLgOqDTw+sdYsfv1kMRmDhxgu5MWLFiZbATBNJ77boNIt2zSeXn5ao80XVjVAKkKZ+c1dU1+lqDFLdfzEJjDjy7GDUxe/ZMNVgmZLXbgDdsR7b5KLl20dW6LaxevaYN6UucfDRB5s+RPET7QOxIHs7VOQOFxGZEDvc7rzHi4g9//JMaLB70BYUDdGcVQ93LT5frkT/UG/d/r3H9cK3m5kYfyug91207BBwCDoFPAgKZMmfSgKxCdejUfpmTp1m9sGaxuvPyb0QseqN8rx2vCMyTAsUyMHtIxPDdcXBK0SXqryv+qKN+fOWf1FfnfUdF80Z/bMXD3ZGVmONEfoLnNqQsZMtbb72lbrzxxojn4+26evVq/b7BMH+InqKiIu3dyIkQhtdcc00bT1g7UtJ69913g7s6QuwET+7Eirf8y5YtUxCvkYx3ZPDymjeujmLpjTfSNrhD2O0T4h1ixsgOIJmAN6kZjfqBTIjOz7ahQ4fK+8pBXe98p/7kJz8JHibOr3zlK0EnmOCBlhXqD0IPeY9IxmSXe/fuDQYxE0VCkBsiadWqVTER3ZCZhhDEMzsasRtMVFYgD9955x2NFQTl9ddfH3I+7W/OnDn695e//EVPNMj5kMNYb2vfttc+OCLDEU0Tns6M7iQ17fd/CN9IWtcQwZFGX2vQo/xjkkTThpYvX64npo10CqPubbkR2zks0nnmGET2c889p+97fEfTAWJL/jDamQ4bflwbTHiK8Q1n2q2Jy7u0y8IojGgdP9x/kNjhGuB7/Oqrr9YOT3wDkhbXHRIq0TSzkVgxeaP+TEeUN3/nYtt7P+3MvZn8Uz/GGK1OHYYrL9eJLblkzuuNy5hE1mgY/IaIR3dcy3Az2ZQbQpOqrq9SjbJ0du4R4GJsEG/uuqbAg0c2tfVLHqo98k09dldOCwoKtORAfn5elxNK3ZXnroo3TiZfHDVqpHgOX6J1nrsq3q6Mh/ofPrxYXX757HZNiNlVeSD9GUK0j7FmFu6quP3iQV5imnjxXnTR9JDZxAnLw6+4uEiT4JDdfgYBDmH3zrvvyQPzFZFoeEk+PFbIw/GgL8nNA2GUkHSjRSLFOxGRX/xuXwABsFowf5723obotI2HaYnI5OBlj6wNWupL5bdq1fvyQrY7IslNPBDMM2deJjJJ4xW66d1hgU6+q8XbZ7Lvh2tDQ6PWkn9fpIhsD63uyEtPxomW/ZzZs8Le7/iA3C0fF+jov/SSXD8vvqTrcN++/b4kt37HkM6IyTJxrrt+erImXVoOAYfAxwkBOg0XTb4lmOXfv/kf6sDJVrIseKBlhYkc7/zPG9SnfjVX/77/l3uCH+/esN25PW34pTLXU6pOAuL93575YcTk3t72hlq16+2IYbr7IM8lW5N2w4YNmjQLly7vLEzgB2G0U+T98CTGINkMaUAn77PPPhsuCr0fgsWQxeQh1gnYIkbagYPe8uMd7SfZZ6LmOxQPTT/zxtVRLP3iDrePEZlMfOfNFyTRD37wAzVt2rQ2Eokcu/nmm9WXv/xlrSFsv49QhnHjxqkf/vCHUbWFkWyAYI1k6GGTNwxSsEiIeQw5FWOQ7Hanh9lvL2lz//mf/6n+67/+S/33f/+3Hn1gH4+2DqlFmyXP1EskktWPoO1t7Rti3tZ+pk0yCjSc4bG+YsWKcIe7ZL/t3Q/JeuLEibDxPv/888F2ETZQlAPeNoTTTSRbvHhxkOins8O+70U6zxzj/obUDW2Ie1+ktk8bMvdDc36k5ZQpU4KH8cY2JHlwp2eF64oOR9Oead+0CbvD8KmnnorovEf+zf2b6LlX9Cbz3k87c2+mXHQmmM4xOh8itRfwj+Rk1ptwahfRPSCtv0q0tOC4OZ+urxRiNVSftzcV8JOVl7NatqS+xaObsvNCnJU0RDdeLoruNOJHHmPBgnkys27Xk92QyUgPsOyNlpqaIqTqNDVdfqx3tXED4gWsM4YXwkSZIHLBlVJH0uPf09ZfdAbnzZsrsy4HZjLurvQhH9EknzuXiS0zfZOh93L6tKmaoOSh3hmjbniJmTVrhhog3sfO2ocA18t8kYpBYqarJm/Ek5uJTS+VdpAmHxDdafT0Q9ZPmsRs9AltkuKDlTkH1q3f8LF5OWhTCM8OPv6Qg+Geh7RQZ23AgHw1f/5cLVXT2bjc+Q4Bh4BD4HxG4M45X1epSWm6iHh13/bAQgUx7LUG+T6D2N59bIc+xHv6j2766TlxRklLSldfmH13MIuvb3pRffd/vqxqZa4nrz31wSOS79aw3uMd2eablfSu//cZ6sZfzlJfe/DT2iM+WlwLFy4MkqHE8cgjj2iPRO95POd/97vfBQk1sDbez0xYiPSFMQgUPGMhYLyGV6RNbBYJ+Wk8fb1he2LbW/7f//73WsrDmzbl/4//+I+gF6n3ONveuDqCpV+8kfbhzcm3D17LNq6mfv7hH/5Bk95MovejH/1I3XvvvUGiGW1u9v2f//N/dJh/+qd/Up/5zGdiIulMW8FT2Gtg9Zvf/CbEK3Lu3LnBeEnX1kheunSplgnxxsP2Sy+9pCfVNMfoFLG9h83+SEu+X8AII99/+tOffNsmx/AO9lpvbN9XXnllMJvIgNA2mezTa3hXc936XYvesJ3Zhjg2nSbg+Ic//KHNiHbI+D//+c+++Wxv2nTI2JrvtBM60LyGJ/aDDz4Ykibe++0hoomTTiXbCxyPaiNR4k0TotQP74ceekj9+7//u/7ZdYIEEUSsMTzCIbP9PPDZbzTvCY/8jinLVVddZaLQHYnIFtHJ4TWuWe5N1BMGR3CuOhtpu7/85S81Jj//+c8VBL0x7/20M/dm7hlIOhlbsmSJln0y22ZJ3a1cudJs9vplVBc3HgQYRE6WvKT0S8tVldWnpPLZe0aV11ao2sbwmruEctYzCJyRSqlvrhayu1W6JCkuQ6Un5uuXWurS1Gd35YgH5eRJ4pEnS7wvDx8+ErxRdCbN+Hjxlh01UhO9m2WSt5qa2s5E123nMkRmrnhMJwvR+uay5UJqdc21wU16ukymB4H79tvvdir/xDF1ymQ9ueSrS15T+/Yd6JI6iiVT3EfQ3b7qygVqydmlusfX72EXS1zhwiDRAmmKZ6jfbOj2eQxjvGLuHL1r1aoPInox2Od51/FuvXrhVdJGRwQfqN4wbjsyAkiToIueLnIYeM6H09yOHEtArmT48OHqiivmqAvkntHZToxo6XGc+2pubo60pcv1UFjvpJi8LDFU7q233pX8yPA9IcTNR0Us8ffWMJkyaSSyMLwO4LHeUU1B7gnXX7dIOsCGBz0KemuZXb4cAg4Bh8C5RqCvaHPf/4U/qrsfulVnBbIbYnhwzjA1d+xVKjOln9p0cJ1676M3Q+bsuXHarWrcoFZv0Z4uBxIrSze/FCTe8die/5NJWq97/ODJqrymVL264TlVUt6WkOqKvJ6oLFEnKo7pqPAqN0RGpLghcCCsjRc25/CxD9kCIcmoQCQuIFJtgxixPQiRK8HLEIkADK/Hn/70p3p+HwgiZCDwQLQ9T3lP+PSnP21H2+PrlJ+8v/DCCzptyg+JhfQI5ecdy6/8fhntKiz94g63z84/hDEj6yCIbIv0nkh9LBdyd64Q0R0xsIJgh6yjPv2wQibFaBmbNJjQ7/777w+OgEMOZ926dfKeNEJ7K+MRjOyJLQOHM5RN8Jq4oi3BCL1x5EswvMh/9rOfae91CHdG6EEeetO75JJLglH3tvZN24TsNXrrvJ9CpEKYgiEkKV7sXjKW79RY7gvBgse4AsYLFixQr7zyij4DTPHARz6DjgbywT2hK9O+7bbbtESPIYSpX0jcsWPH6usW+QkwsNOkvsNpz0crKvfJhx9+OFg+5IHAukg668C1pKREf/fbo1vHjx8f/G5mv/mOMHk2aSIDZJPfdBYiJ0QHAlI9ENZ0WtjnUdf2deVtE3Q4PfDAA7oOkLuhTsDDSL6QNt933IMNWW7y01NL6obOCFMuGzv73kZ+CNvRezPnI8vFyBDi4cc9H1KbOgQb8CUvHyeLieimkmmgCTJh3hDR6T54/KNgGSvrq4Me3YDS3URqMGG3EoIA2J8506TqGspV09nA8BzZpdITcqXeum8iypBMtGxApF544USthbZkyetqh0ws2BkykxeDSRLfVVctkBvQbnlobfdLtlfso/1Dns4V8jRPvNqRuygtLetU3sDz8jmzhFCapdasXdepuMzJ9CqPHn2ByhX947fffleTVF05DAXPex4waCp7jfqE0PrULenq9Tfe1JNj2i9q3vCxboN9cdEw0eK6Ssdves4jnc85fIhcI+cMkPpa8tob8rHRVlswXBzUzUXTp4kczCzdc36uHoTh8vdx2k9dZAnZjRwGvcpvLl2m9orMhXm4x1IWPhZniVQJMiKs89zqKSOtgTJ56ZUyooUXtd2794a8PHKP5qXyNbknZglBPGrUyJ7KWrelY66fq66cr5hEks5N+wUxWsKMqkBeaI7c3xgF1JP1FS1v7rhDwCHgEOjNCEwaNl09fM+zmuzGcxtDt/uRd3/vm+25465S37/+X32PBXZqD6YIx1sPIYcSq/HsM8Yo0//95kvqO/9zp1q9+z29m7jw7ubntS/OuUeh023K5z3eut2aRuu+wFp78uo912xPmjRJe2MiEWHKwwc/Mg9+hoYsnsS28bz8zne+o/C6M/IffBsZIs4OyzrfEnfddVeIdqo3TE9t443O+y3e5qb8kER+3sqQrRBP4aQLugJLU26TF7btdXPcLMk/HQmQ82heQ2bhmR3NU57yQUxST7y/QT7HYtQ15KXxLOW9iIkc/QzS0U/LGykTvMshQ40WNt9KkE1+Rvi77767w4Qcnq/kc9OmTTp60tq4caP++aUHwQh5b6w3tm/qGBkQOgiMQeLz81qRkLF0QiGNQVnaa5Han4mLzi/IXjs/yJjws41vICYp5RrrjPF9+81vflN7bENUYnyf+F23HKNOb7/9dlbDWqRy0mGDvjtkqwmHnAk/P+NeQQdJLGbKQmeFIcNJg85Dfl5DThcdfa/RJvBut6U5/OqA8+ArwKO4uNgbTYe2DSbtOTkaf9aV92bu22ir2/JTdMB4O4O41/B8inXi2faUt6vDRiW6TYJc9HyEjs4doVbuWh5swBUiXVIlZLeZAdyEd8ueR6DpTIOqbDghddP6ApqdUqziRVfd3LTNsrtzx80BPeg77/yC9BCv0N7N5sbUnrTpZb/m6itF2/ky7c28Z8/e9pweEpbh9bThcDcNSMtYyNGQSMNskG8IHIjXF198RSbV2yC97m2HKIY5Xe/mMTugYIA8BBZquREwRdaBMviRf9QtnuSxkkWEY0LGG2+4TuKfoF57/XVNzoXDJ1JezTHixJMaon/okIBkjjlmL3lhhhS8/fZbpWd5tHQIvKxf5DryECBePLeRDZlx2aWy3j55F3BjyA4dCUyMiKYwHQp+k+yZMlAPYIbeeWFhQfD6MsfDLdEnTxGPXruckH2QfJFs3Lixulze86i/9hgPpktFR77K8/LEw6191keNFPmZs0Lqei2c5rk3nN82bZ5rB3md0ReMkhfuLWqlfJTs2bMv7HVLm6MOLr54uu4Qo4ztuc/Rdi695KI2HRzUSXsliMgLL3q33HyT/nitr2/wK6a8NJzS90fTMZKT01/ucVIvVdUh4e1hZCEHZIMyFsqL3OxZM9vIoQwRreuOGtclE2d6NRpHjPD3tm69fmZKB+cErWm/Zs06+VgoD5sFrp8JUsczZ86QCSsHdvjDLGwC7oBDwCHgEPgEIDB20ES19B/WqwffvF9P9NjU3HbOpFEFY9W91/6TmlJ0cURECBeLcc9PjG/rxOB3bnZajkgo8mRvNcjuB+78s1qy8Xn1m1f+X3Wqqq1WLd7d9177j2rMwIma6ObshLiE1khkTcaoBrfD5Z1nclJCqzRdXkZB0Ju8oN+gNnkLRuizgnfofffdp55++mlNlPoE0Z6BixYtCkuggh3kNUTTcvEShszyGt8iM2bM0BP/eY/Z28QVjai1w4OFn5n3kGjxQVAzWo7y79u3r01UxEOYa6+9VhNJJgDxeq0rsCROk3eW0SaBnzt3rnaAgKyHuMFzETKaTgm8OXkXh9yF6MRbFMLXeNfjuBMrIWfKCnmNBzTe/36EJe+exDlGJrAPZ+Tpe9/7nvYIZwSBn0MSpBOe1chNRDLejQ1e4cLdcsstWov41Vdf1YSsXzi+F+bPnx9CcptwvbF933DDDfK+OUGTr9St18Bv1qxZ2osZD+Ro5icLQ7lNO0cbPBLO5KeoqEi9Lt/c3uufOPBApl0gbRPJTBqcE+k+AEGMpjx1yn3Hz7EMxyBkPSK1RfISy3UG8QphDtkdzkMdghudbu5ztoGtcZbhW9JgasKQT+7ByGoweawfF4JcC+0zUlm4R6HdTycWHQ9eI13aDB7OBmdvGLMdCXsTxizhcWIxvoNN2VknD6asfve5rrw3o+3Otyf3eT9s8O5mpMDLL78cJLpNXmMpW0+H6SPESfhu8JbcAC4XBr1B24/vVT98+Z8F8MDLVKrM/n3v5feo2cXTRa4iIVgxPV2QT3p6VGNFzQm1cu8f1YHytRqOvn3i1LSCL6nhuZcKSZys9ZPCveh0N36nT1fIRA8rRUdsqzotveoQQLxA2M2PCyVeJEoYipGeli43qQs0kchN2pie2OzlV9s8HMxxSJrvfufbQpYlmV0hy7VCYC59c1nIPjbiZLTCzTfdIL12RbLVtQbBvU96a1euXCVDGw/KsLkaTSJBKLctf7wmq/uJ/AakEZMf9Jd1Y5BPS5cuU1u2bg05l+PZ2f01aZ0nXtodMa7xPdKRsPrDNTqfdEyQHvubm1s7T4ibuqItJSTE6w4IXqDwEL9YJn6EtGvvTY97y6r3PxDPgc2aYOZljvbhJd296fKiOGH8OK0V3NFy+2FF2pCRx2QiRHBgu4+UF091CFB0uHn4OIsdgZ0yGuOBB37X5oQrREebzpZw9yauETynSkqO6Q8QIwfEg592V1g4QHd0tLfNtcmI29FlCHDP40OSOjP3EV7wEkS/vEA+GHkx5Fpy5hBwCDgEHAJdh8D+k3uCmteJ8UlqQFahQhu7N9vR8kOqtOqkiusr75PxyWpQ/yFCpPu/w/eWcvBuCglgOoQDDgv5Yd9jwuUb4g1ZM0Om8E5rT6IX7rxzvZ/vAryVzTdMZ/LdVVjGignvk5B+ENkm/+HOjYU0s8+FnKROeR+95557ggQkRDfewua7BrLYj7Cy4/JbR57BSN9wnO/jjsTjF7d3H99htHGDEe9wEP58o8dqva19Uw/GO5Xy0G67C79YMLLbBfcQvJC72/BmJ11zz+nONkRZ8Po13uRs8/7v11nAsfYaZTFOlB1pn6TH/YB4TDvvqXpob1ljDd+V92biAhuecx3FN9Z8d1e4mIhuKp/C0lAra6rUV5+9T9XUBjTGEhKT1T0z/0ZdM+ZylZyQ1G6Cq7sK9kmLl86IsqrD6s2d96uy2kO6+Mmizz1zyN+qvMxiTcrRSMORST2FF9pCBw8ekhvfUf2wqZEbzJkzAckbyOlsTVwVqqKiob7kVWeJ7p4qp1861BFewocOHVZH5eXhdPlpVSfXFNeXnmhTiNNsmUBv8KDB4hU6uMseBH55ibavQh6C1NExIapKy0o1Od/Y2BR8EFBX9LbmSs91oXQu4FkarnMhWlr2cW6mkGOHJW3056oqqzRGhOnbV7yI6ATR6fbXXrxoieH94qz3I9BRorv3l8zl0CHgEHAIOAQcAg4Bh4BD4OOEAJ7pSKzgRQrPwfcY3xRDZETqyJEj202C2kT317/+dS3h8nHCw+XVIeAQcAicTwjE5kMvJTaelIkydKyw32C1p+60PBCUPBgaVFmNPCCkd1uFjio7n3Dq9WXh4dzQXCMTg7YOF08Tfe6UhCxNblN/vcHjkV68MWNG6x+g6t5tIYAZ2ohsSG/IY3dVNp0MeB3zm6Im6Rcqyh8guuN072pvKX+mDCvKHJ2hxoiXNmZGdTDhKYMQu4tchshmYkd+xuhgY9hJnOBHZ01vwcjkzy0dAg4Bh4BDwCHgEHAIOAQcAg6Bjw8CRSIhwc+ZQ8Ah4BBwCJx/CLSL6IZggqy7IGe42n10i0bjrJCUx6tLlZm92pFQPd9IIEr5q24o1WS3yUFW0mDR504OEt1mf29aQm5/UvtHuFbaMwTsXNYb1/25ymt3kernEk+XtkPAIeAQcAg4BBwCDgGHgEPAIeAQcAg4BBwCDgGHQNci4D8zhU8ahuSG8BqVPTTEq/KYTCTS0Nzoc5bb1VMI0OFwuvaw0rOLi8ttXJ8ElQnRLZp31J3rgOipmnDpOAQcAg4Bh4BDwCHgEHAIOAQcAg4Bh8AnEQGc0Jw5BBwCDgGHwLlDIGaimywawnRIZoHITKQGc31KpEvqRcIEczf2ICw9unLmbLNocx8IpCnP1sS4VJWRxMQoccF6c2R3j1aJS8wh4BBwCDgEHAIOAYeAQ8Ah4BBwCDgEznME7En3ztUo2PMcYlc8h4BDwCEQMwIxSZcYgtQQ3ZnJaSortb860VCtEzotRHdFfZUmuU3YmHPgAnYaAS1dIj3H5eLRbSw1IUf0uftpohsvfGcOAYeAQ8Ah4BBwCDgEHAIOAYeAQ8Ah4BBwCHQtAvfdd1/XRuhicwg4BBwCDoEOI9AuBhQSOy4uTiXHJ6thMiGlsTohvE/XVZpNtzwHCNQ2nlaV9ceD3tuZiYXi1Z2u6wui23VAnINK6YIktfr62TNag7190cmZaLdzrvxkrEX7TnehPwYI6NZxTuu44+3zYwCvy6JDwCHgEHAIOAQcAg4Bh4BDwCHgEHAIOAQcAh8rBGLy6DYlgiyFNE2KT1TFQnR/KNvCsqimpnp1tPJEB8g4E7NbdhQB481dWr1fNZ9plOo4K7rciSJbMlAlJaT06okoO1rm9p4HGVdTd1I1NAVGHdjn9+0Tp+LjU1RyQqZM3Jkkh6RNazurahvKVV3D6RaiuGW3z4LzMlIHypl9JI1qVVtfqusiJCidRH0TVGJ8uvzS9HrI8ZCNsxJPjaquO6FqJA/NZxoU+UySczNSBqikxCydVsgpeuOsTApb15Lvch3HmTNNUiSZSFLKmJrYX6UkZesJSsmrsSaJv7r2uE7H7JOeEZWenK/zGtxnrdDWKmuPqDNnmoN705LzpM1lBLe9K9X1J1V9Q4VELfcQwTslMTtsBwxlrqqTPDUHJJGol8SENJWWlKvP98YdaZu81tSfUo2CaXuMsjCZa21DmZQvU4WaAABAAElEQVRTcBQzeU8VHFvbCrfBZlUtaTQ0Vulw/IuT6zArbZBqaq5XVbXHRD+/FatgoDArpAM+yVLXoUbbqJU8leq22dhcq+uA9pFAHQs+KYn9JN+JclprHZs4mqR9gAV5CjXaZ7zEkabrPNz5nMM9pk461qif+sZKnT7huYYyUgtVQlxKaNRuyyHgEHAIOAQcAg4Bh4BDwCHgEHAIOAQcAg4Bh0APIBAz0Q3JbX6J8QkKne5E8exuaKxVTIR4uOK4LIVS7HM2LHnVA+X5RCYB8XSqercmoAAgKS5DZSTmizd34nlHdDc3N0cknuOlbdL/EmKCz5GyDerA8VUWcRoI0VfI56TETJWZUqjys0arAf3GCWYJ2v/5VMUutevom9LGAxI9IXFaGwNzJqnxw26WPX00ob714Iua2LSCwJAK+QgRma36pQ1RBdnjRf5niOz2Dqo4q07XHFT7jq1Qx0/vEPL0pJCSAaI7WYhXzptY9CkhE1s18kkHMpf8lpRvUaVV+zRJXi+kKwQtaUASZyQPULmZI9TA/pMlD0OlnIHLv1lIz0OnPlRHSzcGCV3yOyz/UjVq4FWaZA8pi2w0NteorQdfUFU1x/Uh4ppcfJtKygpHdJ9V2yR8acVeiTpODcyZLHEvCEukQ8juOLxElVWJ7rzUH/EPzp2uLpD8tMXMm7vQbTo5th16SZUTV6xG+fMuU/n9xqjN+5/VnRecSqfI8ILZcmyG5KO1oTULzodPrVX7pY3JjVCnkps1Uk0Z8Xkpw361cd+T0va85HL4zECwjx2ySBVKXRlrElL7ePl2dax8myqrPqAJazpEqGO0+BPjU6UdD1J5WaOkjifpzhcIcNvqGivUjiOvSz3ssXfr9hnXN0l3hGSlDpLrYKzqnzG8Td2fkXZ2rHyrOnDifd3O6Aii7HT2pCb1VyMLrxB8Lg+N2205BBwCDgGHgEPAIeAQcAg4BBwCDgGHgEPAIeAQ6AEEYia6TV4gd+KEVMlOzRJSJVudFKIbO1xRIoTHGS2VYcK6Zc8ggDTFqZo9QY/6tIRc8d7N1vVkyDiz7JkcdV8qTPTR3BwgEv1SSUlJlt2tBCRhIEbj+yQKgXxUPFBbPW7t8yEEDwlROWrgPDWi4ArBLkF781bWnhDP1RN20JB1CNgJRbdIigHCOkHIRsjEU0Ju+pt4Jsev06To2CHXCZE5Sc5tzW951UG1fu/jQnJ/pMlrOw7yDqE9ZvC1IUR3nXhJ7y55Ux088aGqqOU6bLRP0+sQolVSlpNChh8TsnT0oCuFbJ4iRGa8Jkjzs8ZoAvNk5d5gRwLe6f3Ti4U4HdMmvr59ErQnryknBH58PB7x/lYlHuMHTnwg+Ae8qvvIPaSw/4U6fr8zIJTxTi8Vcpr2DYk7WO49ELrts7Oqsq5EdxpUild1rJYgRHMfGb2CV7Vdn2nJOTJiIqkN2d5X2hhtprz6UBD/gv4ThPRW6lTlHnVCcA9IyMSWA/BMSmj15q6qOyadLsvUoZNrpRPjZFvvcHEWr5cOGdrriYod8tspnQILpPNmbLBDg5TJe3OzdIqEbZ9K2laybp+jBy9UQ3MvCZYVj/RDp9ZIBwedBgeD9xviDYwkOC2dN4WO6AYQZw4Bh4BDwCHgEHAIOAQcAg4Bh4BDwCHgEHAI9DgC7SK6IUv5IV+SlZSpCjLyhDg7ojN9tOKYahACJTEhoccL8UlPsEG8a81ElBC26Qn5KiWeiSgD2tznC8mN53pNTY1I5QRkJPzqPS01VcrdShybMClJgoeQuhjEclbaQPHWHas9W8uqD2pyskKI8I8Ovy6SHXniETtFZCMypeOmlbyFfMSbt1GkIyprj6qyygMqM60whAjGaxtpEsh1iE08XYvzL1ONZ+rUifId4oVbpqUnjp/eKcdf0J7k6SJHguHFvP3wy+KVvVWfC3Gan3WBeHFP0PkrKdskkhWndVjzD4/aTQeeFm/1D7RUCfXfL22w9vxGSgS5Djy9Ic4bxaMYQhISFOkJPHghm/GwzskYIcTolSKHUSkdAoFrurrulHhVv6bSRMIEb13bIJxThfQ1lpSQrstqtr3LfcffC5LcHKuQNMqEVM9KHawJYm/4OCHSkeCgrlAXB4vkeLzF29at91x7mzZTL5I1KYkZQqoP0dIqyHMg37FfiHekV7g+CrMnyvFhgk+t5O2oOiN/mSkDtQd3irSDQD4CskBt5UToTBFpGfG4p+ODjgbiBP+zEk91/QmVJ570tKtEcBJJk0On1mtSnLyC3cD+EzXGdFqUi0c/HvuZQhpjFSIRs2X/80I+r9P1RzvOzSxWA7LGBYj4pkq5D+8Qb++PhAA/o9vB0dJNgnelmjw8UeVmjJL8BDpiGOVBerQTI6UyqnCu5LJZnZARBBDltJFTUjcb9z6pRx9QRzofNYfVThnhAJmPHBCE+ODcKSpbOkOQ6zlcukGHc/8cAg4Bh4BDwCHgEHAIOAQcAg4Bh4BDwCHgEHAInAsE2kV0k0EIHH7pSamqMD1PbZF1yKSyqlOqqr5GNHSdPmtPVSS486sUb9naFk9lSLT0pHzR2k3V9QTZ3ROGl3Vp6ak23tbSPFRmpugxp3S+XdTUCAlZiSZweI/urCwhJUnUY5roM/tl2U9Iz8nFtwpBV6427HtcPGXXaeKvRsjdQyfXiHTDBIknLoRWxbt3/JAbNPGKhAOetRiEnzGSwLvXGB60o4RATkvOFfJwl1q35zG5Vg7J4bNCaB4WcnCdumDQQk2kVoo3dol4WxvP3/4ZxWrqiDuUJsKF7R0hshD7j6+QfAXih1DdeeQ1LZfR2FSn9xcKYTqp+DNaX5v8S2QBklwkTTbuWywkbomOv6LmmFq39y8iT1EkxGemELQJKidzlBDPA4VYParbFaQppPveY29pL3I0p41B/EKWGmM7nKFdfVA8kW3D+7ikbIv2aE9NaiXM7TB2/Oz3q1c7fLj1gdmTVGG/iULEp7TE0UeI/22SpzWa4MUbf2D2haq4YI4+jhQIZK/usKBmrPqEaLfr106TeGwUyD/7xg5aJIR5spD1Rjf7rNa3hjDGIMiH5l0qbW68bMmcB2fqpTOnVo8oqJfRAbuOLNWjDQK62n1UUf7F6sKiTwtpTluXtiB1TCcJ8jxrdj0qRHe1bst4km898IK6ZMzdLZ0E5L6lPDRUehDERgjRjcZ8heRn0/6n1VGpF+4rVdK+9x1/V00qulVvn5QOEjooAu2zjxqUO1lNG/FF3RmERnnRgJl6xEAgVvffIeAQcAg4BBwCDgGHgEPAIeAQcAg4BBwCDgGHQM8i0CGiG/I0VSY6LMgYoL04Idlqa0+rUvkNyMzRpEhHSameLf7HPzUIqVPVe1Xz2YBcRZLW56Ze4rWMTE/UA8Tz6tWr1YsvvaoaGrw6xH3UtKmT1S233KQSOuntf/r0aVVWVh6R6M7NzdWe7NFqFsIP4jE9JV/kGS5Sx8q2iedvtSbxasQ7FYKxrQltKYQwhodxv/ShbYN492jiO16TlnmZY7T2MWQzJDU/PMMlUVhcPcFg6+SLSst1QAJrT3SJJ7lvptaohq7Ejgl5vf/EavHartPb/cTzdurw26RMBXpb/yN99K1zpooncYJau+dRISuR8BAt8OoStfnAs0JWfkG2QYQRAK0kPecz8eHeYyvFu3iwjkOT5xyI2c6K9vd6PVEjpzApJnEgw3K8Yrt4Bx/UXsnedGOOPkpA4oXIDzXR/NYkdABHjpEncGI/7YKOIow66oyRfqp0ctgGUQzWxsgFdUybwkg/SbzXIY+p44MnPwxOHpnf7wI1bdSdWoJEB+afRJDYN10I8BlKplZVH+7+s3jsByZePVq2WR0RuZHhA+YGg3tXSJsOmez0IhkJMFF7c9MRgZVV7tf3c7y/8TZH9gQjz+ky8SUTYOotwQ3d90zR93bmEHAIOAQcAg4Bh4BDwCHgEHAIOAQcAg4Bh4BD4Fwg0Mq2xJA6pCk/iO7E+HiVk9ZfPFXT9ZmQN9tP7tOkSAxRuSBdhABE98ka9H8Dk4CmxPcXAqpA6ki8SfHaFDPLLkqyTTQVFRXqvRWrFMu6unrPr06tWbNObd++o1NtAzL94KHD6vjx8HrZiYki9TEgr93lRQ9aBJmD5WJyvc4SnMHIrBV0qeNFOiJYH1JnzSKdYSy+r+hCW/moFEK8RIhKOy8c53wkNvCIrm7RD2f/yIFzA97fJkJryXG0tocPuFzISeOBflbLYdSKnEokQ19799G3RNLksNDjLW7AkU6wjiGtckQkLfA4Jg8jZKJCZEKwuoYqObZeezBbp7jVFgTqRHrkiEiQ1NYH5Gog4icXfzaU5A5Bq48qyJmohhfO0YQ9h7gv7Cl5OyhTEhLcuyH1E2ifodcCnSLUnX2MdoC3fwVtQtIwRkeBM4eAQ8Ah4BBwCDgEHAIOAYeAQ8Ah4BBwCDgEHALnAoFWRiPG1CHZILrxGM5Py1U5Ka3avdtPyoSIFukRY5QuWCcQQKagTMgmOG2ZDk+lJ4qeckJ/XUfUU5BU7UQa0U5NTk5RGRkZYdOqkwkkX3r5FXX4MLIHraRYtHjNcc6B4N60abOqqvKfTJKweXl5KiszK2w+THz28szZJvFa3SdkckNgt+CYILrathxJa3hRMpZw3l8s5C9hIKXL9GSFAXIb4jIN7WsqTyxDNJkzW/S62WZiya0HXxSP3IA2M/uM1YisRHn1ASEwAzIu6C4XiPyG9q41gTxL9MLz+40Wr9uBwSO14qVbKnrMfmYmWCTvSH3sOrpc1Uv4WI3zmBjxdDVk6BmVLBIdIwrnaf1wPLuxw6JVXdWOSSJjTft8CFfbUCaTce4VFAPXTFZqgeiID49YNORZCkSmJS2l1Yv8VMU+6VQI1XZvG8lZHaZMJpk0IwQIkyEjHiC5IbCz0oaI933rBJml4u3NxKmnKnfLKIvwuvlt03J7HAIOAYeAQ8Ah4BBwCDgEbAQamurVtT+/VF36jyPUjb+cJd8brc4wdji37hBwCPQcAgcOHFD/+q//qv7lX/5FPfroo74Jb9u2TW3dulXt3LnT93hX7zx+/LhOjzTLy8u7OnoXn0PgvECg3dIllNqQ3TkpWUJ256g9JwMT7+0p3a8fyjIQ/rwAp7cXAgK4qv6k6HOXC5GotA5wv6Qh0gmRoInuniC5wSgxMVGNGX2B2rFjh0iX+Es9HD1aol5+ZYm6euFVavDggTp/seBLGUtKjql33nlP4t8ZVraEsg4bOlSlpwdGGESLG69ttKNPCRF7UKQdDNGNbEQ/mZSQSQOZxNA2JE027F1s79JermMGXyMjHPzTheCtrDsqvyNC6m5QJ0/jfR94cWWCRyaaRDQES07IEj3veVoj20hHlAoJv2n/M7qOiwfMFgI+QBDj7cvElsaSEtKEhOxnNsMumRAxQyaXhNwGW/LHZIeD1LQ254BBXuZInW/wOnBilWh4F6qRQlbHYg0in3GsfFtwAs2hedOFOB0gWNfrSQ6Py+SHlOHAifc15gaHWOI+38NQL5DTyIUYy0yRySlbOkXMPu8SDNNE7iZT5GsqtUSN0t7cp6WDxTuhqDm3SjpguIeUlCJzsl7qJ3ANJyakinb4JRIs0D6ZsHRg/8ly3ZRqKRXkTI6WbRVivF403K/WbZnrx5lDwCHgEHAIOAQcAg4Bh0D7EKipr1YVdQHHhMYWqbj2xeBCOwQcAl2NAEQy38xYc3PbziekVRcvXqzDINP6gx/8QMvHdnU+7PjeeustTXSzb968eWr27Nn2YbfuEHAICALtZqQNeYq3cEZSmsrNyNPEKmTHidMlqq6pQSUJ8WnIEYdy9yHATbe89pBqEBkL+K/EvqkqO2VYiDe3qa/uywUa0H3U2LFj1LvvrlAlx475JkVet2//SDXUN6jp06eqUaNGKiaOjBcJHK81NTVp+ZOysjK1a7dMqLdlq9ovvanIooSz1NQUVVw8TCUnG1mOcCEDcg5M1Ld6xx9FI/uYkK2lwQdYXtYorXWsdbE9UdQK8fjR4ddC9g7Jnar1lUN2WhuNonG9cd/TmhhEIqRJe44LGZmcrcYKQZ6dXhwMjefsoJzpoq9cobYdfFkI4grtzXtaJgDcKtuQ8aMHLhS8E4TwR+O7FY84rfHcFstg5C0rCULIM/khhGjAU/is1ib3hmMbr3YmwIRsPVGxW3S1q9X2Q0s0Sd0/I7JnMXIXkKsnK3Zp4tTERbxpou0MzqeEbIdU3X98lWiPL1QpSdGJes7/pFhTc4OuZ1NevLVjMXSz6TSxrb6p0t4MWacjhfZEpwOTcGIpSVlqzKCrtdyNCczknCOlI6ZBOoD2HluhCXQ8uU/IJJVN+wPnFfafFJRNMee5pUPAIeAQcAg4BBwCDgGHQGQEcFRyTh+RMXJHHQI9jUBcXGRZRrgMeDFI8M7ORxZr2Wz+xF6P9XwXziHwSUAgOjPmgwLkKb/khEQ1QCakTElM1V59NTXl6lh1qXgTpkdzPPSJ1e1qLwJ4fUJ0a2/ks0KeimRJeuKAEKK7vXF2NHxOTn910UXTZELKV4KksTcuCOxdu3eroyVHVU7//opz+vXrF3wo0FmKzEl1dZXW+y4rLVdV1dVCcNeFjdOkMWTwYDVUPLrj4yM/jALhkREpVTXyM7IQSGkMkgkbxw25VryOxXPWx+KF+M1MHSBEX7XoJleI1rV4sosnK/vDGV6vZVUHgodJh4khhxdeLjIUxcEJCE0A5EVGFFyhksU7e8v+50QXWyarFIMk33bwVZWamK2GyaSDgQss4GnL8SYhvZua6yPmhXBIUARIfHOuSBEJwe5vfTSpDblJZwCevHj/rt39FzVjzDf8T2nZS15OiMd2pcivYP3SB+s6RMYEEpwJIiFOaxvKNcG6/8QKwXKRDuv+BRAIOG+belLSIRGerLYxY2JNM7Gl2R++jmXCSat90v4Ks8er4aKlni+a7l4PbUYETCz6tEywmaO2H1yiteK5D5XJpKKbDzynPfbdhJQGdbd0CDgEHAIOAYeAQ8Ah4BBwCDgEPgkIMKeYM4eAQ6B3INBhopueqziZXG9gukghJKbLpGRl4hXYpA5XHFcjc4ZoUqsnvIl7B4w9nws8pPHkPl17VIlytO54yE4u1lIaPaXNbZeaNC+99GK1dt16rcVtH7PXeQBUVlZpre39Bw7qfNvHWTfDg8zSe9y7nZaWqsaNHysa3a26xN4w3u1EmZAxPTlXexEjyYC+dXb6UCF9E7xBg9tZom0978IfCu7VIgtRoj1bo2kmcw2g+d3QFPB4hUgsLpgtkiAXSLytJGYwEVmBOB+Se7GWIlm/Bw3kvfpwvciV4Nk9QIjI+L6iI47OtRDgWL1M7IhHbqZIi0QyvMCZGNIQ/IRNScgOewqEKXIV5VWH1M6jb8i5DaIbfUDkVBbLyI3MsOfViCzMsdNbdHgClYme87KNvwiGpwOAfGDkZdfRN7V+t782evC0T84K7SY+VdpCUtDLmokf5eJo6eQIDwUdX4wksA05k3CWJOnUN9Xow9T34NzpovM9QTrM/B4PfXS7HDfkBi2Bs0Y6PepFogayG83uXUeXqakj7pC4/Nt2uDy4/Q4Bh4BDwCHgEHAIOAQcAg4Bh4BDwCHgEHAIOAQ6i0A4V86I8RqPbsjNwoxclZ3aTwjLQFQfndwbJCojRuIOdgoBSOAamayuquGkdDCcEVopTvTSx2lNKIbYmDrqVCLtPJkJKW+4/tqYdLLh6ygDeff+2B8ryU1ZLxg1Sk26cKKvDIpfEWirhaKNPW/Sj9Wscd9T44ferCC7I5HcgXj6aOIxNbG/GtBvnCajkRGJZAlxqSL3MF+fR7ia+nLtqQ05GMnwvM7LHKMmDLsphLzGo7q0Yo94fGeJ/EleMIp6ITYPi9a4TWAHD1oryJDQbgy+8ZL/7IyhVoi2q3heDxdyPj9rdMt1flZ0zdergyfXtg0seyCxS6v2aeLTBGgSaQx0xc2vQYhVM5EmYaqFpD948gMTvNcuwRe9cn+TRt1FxtBVNNdTk1o7ISprT6rj5VuipkDbqhbtfmOJQmRnpYWvY9qYmRyUc3cceV3rtpvz/Za0TzpjJg37tDVx61nR7N6oRzz4neP2OQQcAg4Bh4BDwCHgEHAIOAQcAg6B8wUBW66kp5wNbbkSO/3zBVNXDodAVyDg57IXU7wQqVzMWUkZKke8uvuKdzeE5YFypAmc9QQCFXUlMolcpZCPonucIBPQJQ3SdXIuSG5T3lGivT3visvVm8uWi9d2tdndLcu+UvBhQ4eo2XNmqezsVkIwlsTwVu1a72FIzrZerFwXhf0uVA2ib42uMd62x05vF8/s59XEYbcIAd6qu4xXrOkwogzUY37WWE3CoyXOcX7IiAwQor5/epE6VrYtIF0jBOw+kf9AIzkrbbDkpG1emAQTbfJykZnAjxrrlz4kIgmqA8k/PMWZKJN8VNYel2u9SeRU/Gd5bhRpl8On1mpPZHBmEkXIVq9BiFeI/jik91mZWZ5JKYfkTBNP5jRv0HO2DY5amgY4BbJGGUXBJKZ5Gr9WjKkXJi+lTF1l6GznZo4SaZGDOl7S2HzgGZUlIw+8GtwmTTTPS6WOT+P93WJDcqfJ6Jsks9lmmZM5QjTSr1TbRX8eL3smQN1++FU1dfgdWl7GnADJHyhx4D+dPHn9LlD9M4r1pKOEgygHo3CTs5q43NIh4BBwCDgEHAIOAYdAdyKAU8fjK/+kDpcdEP3cJvXlud8SJ5IBvkm+te11tWrnW1qWsLDfYHXbjK/4hmuQOan+e+n98q4jc1LJ6NC7598r74mhn9MVteXqqfcfVcu3LZF37lIdD++TQ3KK1M0X366uGHe1fsf3TcCzs7ahRr249kn1xuaX5PvhqP4OIK4xgyZIHv9GHA6me84IbG4/slk9v+YJnbempkZ114J7Vb/U8N9Ka9euVbt27dInT5w4UeZeGusb79GjR2VOpnf19yZk23XXXRd24r0lS5bIKN5KzQ8Q3/bt2/V5/UW+8oorrvCNv7GxUb344ov6HDSPL7/8cjVggH+dbdiwQX300Uc6HsIcP3682+IfM2aMuvDCC33zbHYuX75cnTx5UktyGlw+/PBDtWnTJsWEhkh4YmlpaWrq1KkyEvpSc2rEZVVVlXrnnXd0/SDnaSwrK0vHM326fxsAy5deeklrRzOH1TXXXKPxAbPVq1erkpISVVBQoD7/+c+bKLVc6IoVKzSupGssKSlJ5tcapebMmaPzb/aHW9JGKLcdR2pqqrrgggv05InhdK+3bNmi+PENfNFFF6mioiIFhvxoSxh5Qa50xowZKj8/P1wWQva//fbbOl6TH9LPyclRkydPVpMmTVJg9dxzz+l2R9zR6sZcL8RDvcKBYQ0NDcF4aL/gBcb2tUA94BwYzrhvUW81NTWqsLBQTzRpXxdcd/v37w+evm7dOhlNf1jngzaxYMGC4DGz0tE2xPmmXVNGk3eutffee0/ng/x+85vfVIl6jr5AimvWrFEbN25Up06dCjrXgdWgQYN0eQYOHGiy1u4lZaE+d+7cqfEmAjDhvmLqM5ZIO9pGT5w4oTGh3NzXuF/SPqkHJiZlP9c4+72ThJaWlmrc9u3bp6818k0bnjVrlho2bFgs2Q4b5oDMZ0ed0BbIA8a1Mnz4cB0/csF2u120aJFKSQnwUFxbtFHqeMiQIeqyyy4Lmw4HuIdw/8Vob2DfGy30ydyOHBoyNSUhSQ2RF4JEmUCjTkiW4+VHhPBpUCl9k2N+iLcjWRdUEKDx4lV6uvawltGgLeenjtUSGXQ+9FRvol9lcMFeeukl+ma7YuX7wQveL2xn9lHGIrkhLFq0UI0YXtyZqDp8LsQjxDU61H0kln5CPPsZ3tejCudrPeqjZZvlJiJa5UeXi55xgRo+YI7UV8ArHNIXYpz9hjQXn3e5jlpjle4lTT6inVyYPVEdLd2oiUlIyIrqY0Kgvyg649eprNRBcl7rgA3yCsG9//hKLXFCjJDPowdeJe2mlWxvTcm71kfLu4woPKI27XtWyt3oDRDcJp2Ssq16O0sI8ukjv6TJ0GCAlpVGkXNZu/sRIbg/0EQu+t3HTm8TDXP/Fzbv+Zpclo4eiPUMLdliAeUN3MHtQH0gB0PcIhckHRYnTn8kWEwUsrlVuqWhuSY48WYHk2pzGp70hf0nqpLyrTKx5xGd/omKvWrLgeflA2eh6GTnSa5ay8x9obRqr3SovKsnDiXCNNHSRm+b+3U4gwQfUThXPP1LdV0gT3Pg+AfSQVGgRg+6Rut9nzkr9xtpn8kymWmK9jIPxKcfo1bUyPR49cHDpev2OwQcAg4Bh4BDwCHgEOhOBJ5e/ag6IKONsfysQnXn5d9okxwjDH/72s+D4SCur5v6aZFoa33PMydBID/67u/1JuG+OOcelRHXGu6xFQ+r/3jlJyZ4yLLk9BG1es8KlSvzWz1w559Vcf7IkOP2RnZaf7Vsy6vqnxZ/N2QEpAlDXMu3vqYmD7tI/d8vPCQTvaebQ3r5wprF6ukPHtXrzNPy+dl3RSS6Ic62bdumw0NOhSO6IVK2bg284xN49OjRChLYa5B0kKmQfRgEnDmPb7iZM2eGEGPmfPIAQWYM8uymm24ymyHLt956S5WVBSQcSc+Qf90RP/mIRnRDIkEY8c49WOaOev3111W9zD3lNfIKqbRciHFIZsKGs6VLl+qOBb/jxAMh+uabb6rbb7+9TTwcB0u+DyC6r776avXggw8qOiuMQYpRR5CQ5On9998PkmQmDEvi+uCDD/QPEuyqq66yDwfXIcAWL14crPfggZY46AhYuXKlWrhwobrkkkvsw3qdNmLaYW5urnrllVd0B4YdkLxQ7xBtkPzXXnutfThknfiefvpp3/xQVxCOYHzrrbfqjhiw2Lt3rybZwSSc7ZY5x0w+7TCQ3nb7haiG6Ia8N21j7ty5EYnuiooKTUhSb3Q+QehTZjoO2Oe1I0eOKH4Y3t10Itl570wbIk67XUN0v/zyy/ra5hhGe6cjB8I2Et6EpbOLX3FxsbrjjjtC8snxaBapLOBGfdJmaBMQzX7W2TbK9WPuZZSbTijIb9uoL65L7pdf/epXFW2Z+xXXvNfIN/XMPfezn/2s93DUbdrE//7v/+p26w1MPuh04EenIWmZdktngyG0afO0Uaxa5scz+73xmW3auImH+xdttDdaKxPWjtwZkpsHCb/h2UP0hJRce1XSi31C9LqddS8CDSJVUVF3TG7cDSK5EacGpE3QNwtubJFIre7NVSD29PQ06TmaKQ/BBfLQHST56lAzC5vVFHlYT5s6Rd108/XSMzyqx8oLqY2n7KnKnepI6VqtWb1h7xNq3Z7HgpMu+mUaMhIv67FDFoknyUhdX5CJHx1eIiQmD61AL/Cpyt1q476n1KGTH8pkmSe05zbrJ0WqxIRJTswQQj0gQ5EtxPrwgjkqOSlLJwsZefjUOoljsdp3/D3xlj4shGeFjuvQqQ/V5v3PirTEZh0XRPmIwjlqYM4Uvyz77mMSyxEF89TQvLZENMQ3eeS37/gK7aUdkF8ZrYl7zvX+khLSRf/7QvE2SdLpoUF+tHRDWOkL8CcMHQIlZZtEYmOJ2iBlPVGxwze/7dvZ9sUhcH4frYme1OJlTjmPlm5Se0re0t7tjeKNjh753mPvSJsIvEzGlq43Pe82Lw59xZt/pCrKv0xI9UDPP/juKXlHyv2kOige8JWi0U8dszxwYqXatPcpwSPgkQO+FwxcINrzwyJmCZ46Jam/kNpX6/qAqKac2w+9KnIyvPA2S+dMszp8co3uSDkunRF1DaflXn9Mt1X0243lZAx33twGDLd0CDgEHAIOAYeAQ+CcIcD30A3Tbg2m/7Z4bfsRRacqT6gjZYx2DFiTeH9v2LfabIYsIZ+NzbhACKsWMpx473v07rAktzmH5cnKY+r2/+9qIaqX2LuD60x2v/vYDvXjJ/42hOTOEqnQlMTQEZLr969W1/3iMnW8IjD5u4kkOTEWJxYTWqlp06YFNyBtIDu8Rhn37NkTstt49YXslA2IG0NyQ7LisYgzFIbXoDcefUD+2SQh+whnvGVNGJYQNnhPYtQz5GF3xo93cTQz6YMTXuk2yQ1f4jWO/+EPfwh6RnqPP/zww2FJbjtsbW2tjgcyyzbyY9IFIy/JTVhTRzt27FCrVq0KuT7w9mTENF6htkFU+xF2kJCPPfZYME5zDp7cNjcBPq+++qp66qmnTJDg0mDIDrx28Rw2Rj7seNiPJy1Y+xn58SPdiccmgiGgH3rooTb59ovT7MMzORYz5TFLzvGWwRuPXW9GlgQPcLyE22t+bYiyc03aFq4NEcbOO3VGB5afEYe3U4G0aEPevEOs/vnPf/aLJuw+yFy8sL1m1yXHuK7IR3e1UZMe9QjpTcegMe+1Ql6oA9OxZcKxtHFlG+L48ccfZzVmA/Nf/OIXbUhu8ujNC0Q7Xud+ZsrEMXvdLyz77LxHa8/h4uiJ/YEnTgdTMkT34Ix8edBniTfhSe3Nvb/8qBqShVeqs+5AgAdEXaMQTaLDi1RCWkKuykoerL2BqRMa3LludJDdF100TRVKL6YevrIp0JNJ3jtqSUmJMpxisJDcU9W4cWPaJVdCh4DoYwSTxiMez+q+Iq0Rzpqb6zVxa46jj/3+R/IgFBKQSR0bxJOYDoeMlHyVK/rVGEQkx/H+1SYLCFpDWo4bcr3a2LxYyPJ9Qk6eUNsOvirEYKZCPgJCsaRsi3ho79XEIwQ5MhlIlWAQx8UDZqr0lMAQPgjJoXmX6Pi3HnhR6183SZ6PCBHLhJGpidmaRNYyI6LLzWSVtJcEGWo5fMBsIUEXivdtoo6bf2eFKCds0HRZrG05gBf4uKE3Svz7W7yMA6EpI3FDuB4Ssh1LEnI2V8rlJ1sSOEu8a0TrHB1q5Euok1NC6pdV71cDRLKl0Zo0k+N4we8/8aGeaLFRJgRFb5xJOUcJmSuvDSbKqEtqho4G6grDG75J6jNYZ3pv679+qYPVsAGXqR2H39DnoCf+kch84E1PGeulHQQkWKoFz3hdDqrfTLbZGpNZO6sadXqB7WbBPdBmzPHWJV7dxQNm6bh2HVmm06KODwoOJ4XQRsebOgR/6rdWfpQnRSYKHSle2kX5Mzx1HGifpuykRNl1Z4yMAhgzaJGkVa898uvFe33rgZekjJlSjxfo9r5PRgTgdY90CvVVJZ1tdD5gaVKPwwvm6g4NvcP9cwg4BBwCDgGHgEPAIXAOEZg/4Rr1u9d+oQnjHSVbVWXdaRmx1i8kR5DXkNu2vbLhOTVrzHx7l47jnY+WBvctvPDG4PqDb96v3tn+RnB7cM4w9eObf64mDZ2uv8mQIHl29V/VA0t+puPhe+hHj31LPfa3r6mhucXB81hplJHRtt180W3qG1feJ98bAceWEpEJ/eWL/6ze/ehNHYy473rwM+qpe5fLO1/AC7WuoTYYBd+ESQmhxFbwYMsKXnmQX0hjkDdkAZABsA2vUVs6g2P7xIPSeATbYY3HI/uIG6ILctB4XeM96PUEh9Bm+L1tyBTgBeyVqIBINwQ4hCzD7bszfrxyO2J4cuKRbohRiKk33nhDe8ma+JDMwLsyLy/P7FIvvPBCCBYQnUgNGMyoBzxJIZ3NtzXe3cSDF7FtcAOky8/YlClTtBcmnuoQW8RlDGIST3NbjgDJhWeffVYdPBjoEMJTFS9OI1cBUW6TkLS5K6+8UnttG7J98+bNulzIe2BsIzlDJ0gkQ0oED13TBjgPzIwUDB7HlMdgTFx++SEdfibPeGUTD0R3e42yIz9DG8S7nA4L6oFr6Bvf+IYmAimnl+BtbzqmjYPh3/3d3+nOnczMTPXII48EO4uQR6Fc4EEeDFHpbUN0ONx8881q5MiROhuEp975RWtDnEAYrl/qlnWkNubNm6dHazBiAw9m03ECEfqZz3xGS9WYMtNmIZ8ZNYBxrfOjfqMZXtp0ehmDxEUyg1EWpj7p9KADxeSBjpLx48cHryu/NtGZNmowo46Q5Lnhhht0fVNO2hWe6xhe1XQiYWA3VzrlqC/qlHsq5DYddxje5rFiQvg//vGPIfdk7/2GvDCyhGvkk2htuxdjRIGK4kclZSWnqwGZgZtqY3Oj6HQHhk/EGJUL1gEEqmUSSqQGILXyUkaJTlyargtTLx2IsstPSZKH5/DhRaLftkh99W++JA+8eZqoNnpAsSTIjTIvL1d7cH/u1s+qO27/nDw0L2oXyU06EMatZKIQjUJO1jdFfrDVCjkM6WcM4tJoXKNTDREIYTgs72IhFgMvn5B+gf0Bohsv6+r6QG80RHV+v7Fq+qg7xVNXXmrlIXFSvLi3HnxBSONDOhniq6o7KfIYO9RxkciolnX2xceJB3bBbCF1rwwhEiFCRwi5eMloGRaTOVyT4YSH8CSvx8q3iYfvTh0nbSVTSPIJw24W7/LrQiY6JPE6wYOfuXFDNNdKG/Ma0ioThOy2JSoCRHWjEMCvaHkPzgGTtORcuU8EXrq98bCNrIvGouUguB49tUHV1J3SUi+GfKbuSiv3CwG7Wcq1W4jlEk2O52eNlKGYsfWqB9MX3GtaOonYpzFv0UAPhrFWIJLHDb5OhpheJmWmY0Q6moRkPy51BKl/vFweZIJ5kXQ6ZLd424O1rZNtRaeapUOgWiaWNEa7ouOKfPhZinRYjBl8rZo64jaRpOFFu4/uVKgWjE5W7NZ1zFJ3iMg9OVt01ycWfUraylUaXztO6hRvbDstPP8xOmP6ZxSpycM/J57dEzT5XSGyPIwEOCm68hgdBMio0K5OSrsCB4zOirFDrtWEuN7h/jkEHAIOAYeAQ8Ah4BA4xwgMyBoo7zRDdC4gs1fvXhGSI955l2x8PmQfUh8rdy6X98zWbwACHBO5kCOlAaIP2ZKLRszQ56HD/UiLnAk75oxdoBZ/Z6mWFeG7DMMT+7aZf6Oev+9dvc4+JFMgrMMZ5/4/n/21+sENPwmS3IQt6DdI/fLzv1ffv/5fg6ciZfLSulYP2S/P/Yb609ef0z8IcObTimR8z6PlaswMYzfbLPHeBi9TJs7BYxH5C9sgfgyhzX40kDFb+mPPnj1BQkoflH+Q12gRE68x0vN6eXPMzh/5htzr7vhNnmJdIkWAdrFNwPINfP3116svfOELQRwpo+2VjKf6+vXrg8lABN57771BkpsDEKqQdN/61reC3pXeeEwEhixlm+/qu+++W5NykGKQppjRrqZuvSQ3xyG92W9IVEhSIxtDuhCRxiAhv/Od72j5A7suJ0yYoH7wgx+EEOiQkdR5OEPe5Mtf/nKQ5CYc8dx3331apoNt0odAtQ3C0xhlhnyGlDWkKMdGjBihcY2FaDVx2UvqAPIY7WNTTpbso54hf0m7K404qaP09FapItLC85slaWPeNkQHCES5IbkJQ96QObnnnnuC9RquDRHeGGHQoL/zzjs1SU2eMGQ8jCFtA/lrG3ghn2PPq2bfJ+yw9jqjS+zRCpxP/SNbY9cn21wnBnPyicwKxnp3tVH03G+77bZgpwblRArHvh+RB+qNtkzHhGkv1AvXiqlP8ml3OnFeOOMeSCegMTomvfcb8sL95nOf+1zwfmPCfxKWnbr6qDAqKkEe9qOkN3r1XiQLGtQRmSyDh3ffswHv4k8CkD1ZRjwpK+uOq5rGck1s5qeNl3qI03VBfVAvvcXICzfdoqIi3fO3YP58PcSDoR6HpRfr5MlS/YCjl5m8J8vDkQdkVr8seajlqUFyA2CyCDzEO1ouyGbIyXyZOA+vaSw1KUd7qEIi+hlEYJPgnJNZpPqdGegXRO/DE3ZEwRWyHngpYyK+zLQCldjiOYFcR2Njaw86ZHf/9GJ1+YTvqS37nxOv/OMSw1mt+8zEk+NE3uRI2XrtndsspGKcyHowEeTw/NlqUO5UIVpDh4+RCSZLHNh/spCMo0SaZKNITHyoyoW8bJCJAblh4sGdlpyv9Z4Hy2SPaUmi7Swv8V4jvUzxTk+U8Bh5Nd66dljKjEb1qIFzxYO7JHioTsh1NKwH5UzU+zJkEkq8gSMZcQ0Qr26IXmMQv6drDmmPdAjXSDZSvLmNxnmkcKHHRPlcPKAL+48P7sazH3I6nEHITx35Rfm4GK9lYU6L5zp4gS3SICNFgx1P+z0ly6XMgaFllE1rrLe0DRN3fUOl1GmBaGwH2h51Ada007g+iSZYyBKv+CLxwh+YM1m8uVfLh9Y6BQndKCMKqOPEhFSVnjxAsJ8sv2nyEdVPzm97H2AkQnJSZrCOSISOGWN0SmSJB/slo+8Sb+4XJA0+XvroTpOC7ABeJ4T0rqmnvs5I+VOk3Y3QnS050v5o784cAg4Bh4BDwCHgEHAI9AYEIK2vnHidenj5b3V2lmx8Ts2fsCiYtdMit4mnN4Y0SHZarkzuvkvec6rVlkMb1JSii4Nh39m2VH/fsmPC4ClBz/DHV/0p6IXdPz1X/dtnHwj7zYI+97/f8aD61sOf1/F+KJrdeGhDXnvtjplf1Xn37jfbt1x8hzKTTrLvj8seUNdO+ZT26iYdfu0xCGnjiX3o0CFNRBtik3dNvLyN4X2MxAnGcHibLORcPAkxvu0M4YU3MsQTHpd89yFLYXsf46mLQcxCwpqJ7PCMtCfY47jxLCa88Tzv7vhJK1aD/Iyktws5D1mI1y1GefCahlCG/DXkNEQVBHM4Izxeukh0YHxfUy+2d7g5l+/or33tayGksTlmltQzEgpoqHsNUhGiDg9VyEQzSSjtwpCcpAGJb8hPbxy0h6985Svq/vvv1+0AkhtPXD9NYDAMpwVOXiBNDX52e6UTxZDwpA/JR3sKZ1/60pfUz372s4iEe7hzvftNvXn3d+c2deY1uw3Bq0BKg72f4SlPG3ryySf14UhtiADoq9tSRyZOm6ehTYST+6E9c20T3r5vmHi8SyQ3jJc2ZbjrrruCxLw3LJwTxO4zzzyjD0Gk0za513RHG2WkhX1vsvPDKATup2bkAfdXRp54jTLR4WDaMl7elNfce73hzbbducO1eOONN5pDbZbMpTB37ly1bNmyNsfO5x0dZiVonObHS8S4HHpTRdtVPLpLq06pahkylZWScT5jd07Kxs0ML+PTIhnQIKRqWnyOykwaqC8GLhT7JnNOMhghUfKWnJwkPdsD9W+6mqZD6zJJzzDHTS9chGjafQjyDe9WfrEa5OOwvEv1L9ZzCIemMr9oliTSDxCnXstKG6QuGHyNXEe1mvjsI3lPiEsN8Z72nmO28e4elneZGpJ7sbSROvFgD3iiQAQnCBnet0+CCeq7hCjnF4uR1pThbV+8BuZMjeX0kDDD8mcqfl4rFPK+Owwyd7R4SPNrj4HhMJGOGSwe/I0y+SSdJmAKCW281icO+3TUKJkgcsbYb0cN5xcgMT5DtNXnqWKZYJJOFQh7DII8XkhnCPNIRufD1OFfiBREH0uUSScnD7+tTbjC7MnSAVSn2xedR4G2RbrRHyXDxCPlH3/8wzZxpqSkhn35ahPY7XAIOAQcAg4Bh4BDwCHQDgTmj18UJLrX7FmlSWl0sLEP96wMktQzL7hCTSm+RP3bM4F3ldfE09sQ3XyrLLM0tRdNuVmfz/61ewND8dlxz4K/EycAf6cFfYL8m1Z8qRpZMEbtKtmuiXN0tq/2EN1moktzTrjlXfO/q17Z8KwuAzrdJ+TnR5qHO9/eXyROSXyHQcwYT21DREHCGk1sPEchcf7nf/5HO1sgAQHBZ4g029sa2RLjdQkJBQFbUlKizyOcIbrBEY9ujO9ByKpHH31UIf9A2pBUEJ/YPpFLMV7AEMEmj90dv048xn/z58+PGhK5DQhJcKX8SCvgHQppawyJDKPTbPZ5l+PGjdNespC7Bkc/ohsPUyP/4Y0DMtQY0iqQ3ZDPdFLY6dve6Sa8qTe28VD1C2PCskTOA0kJ46kPKepHdOPNbdqUfb5Ztzs27HDIPxiDAMRzO5JxLrjH6kkbKa7ecsxuQ3g623Xol0fqA03zaG2IaxCs/MyWaaFOf/WrX2l5GyaFtI/ROcMvVrPljLhmuOYjGe2c8phOB8q+YsWK4Cld2UZpX+EIae57EOGm04V0wxlEtOkENPkOF5b93BcNcc82ozuiGXIptHFDvEcLfz4cj85ORCklDyNuEEMzC8STNUeVijc3+meltRUqUyRNOO6saxGok8nntKelPBSzU4aJB2mGrgPqAbw/bpiT32g34K5FsHfHFi9SGfw6apCdENHyKtHRKNx5ERBAsiWub2CYVoRg3XqIOk4SMrqnTV+rcTJETn7ttcTEBF8Pk/bG48I7BBwCDgGHgEPAIeAQiBWB4fmjtHTHqSqZ6L2hWntwjx8ccKZ4af1TwWjmiaf36MLxMlJSyF6ROXlLJq/8u2v/WW9z3pZD63VYdLCZiNJYVV1Axo3t3772c/WHZb8xh3yXyQkpav/JVr3ZBJEn9NrA7CEqPSm6w1hOer66oGCczhvvaOS9owYxA2mMRyyEKd6IhkQ2siXEjTYv+yFH8dz26mhDchlDZsI2SC+IbgxC0nhD2vrfEOnEj/cjJDp5wdsbogYznt+sQ6Tb35DdHT9pRjPqgXxFM8JBwhr9XEOYGQ1rzkcL2+j7houPzgmj8UsYP6cx0vLz0jZxoi/MhIxgjR0WORrj4Yu8CR0So0aNUuBrOi7MuXSKGPPWt9nvXdpEtym3N4zJi3e/2baP2+SgGU1AOOPtb84Jt0RmBo1xO85wYT8O+00bot6NdFC0fBcXFwdJWb82xPnhSG6OzRWPYUZ3GPzRPmcSRn5c03Sy0N5pQ6bTivOimWlflOXii1tH2EQ6jzZltysTB+d0ZRs1nuaR8sIx8s59s6sMjE2bh/gvkk7KaAZPSCdULHIx0eL6uBz3H8MQY+6pNH4AlyJSDaPyRsm2zIRcV6VKZGJKZ12PAJIaNY1l6nR9ifbyzUlhsr9kfTFzQVMfzhwCDgGHgEPAIeAQcAg4BBwCDgGHwCcdAeQdrxh/tYYBIovJJ7H6xjq1ft9qvQ5BPGnYdBmVmacgmTG0t/ef3K3XN+z/MKjZXZQnozeFYDZmywGerikXLe+jEX82yU0cGw58aKIKLicIEU++oxnfhXtPBIjl5jPNau/xgFd0tPPCHYeANGZ7xpqJ1ThGGL43Ia0wMDXeuXgnG89vwuBtbBvnwhtgyBegv4txviEZIVQxW+MWD2OMMLYHsZfE6+74dSai/IPUw5MzFkNSwRjkMmZ/y0PQIRUS6WeT3Jxve8CyjZGnSF60eJt+/etf95X4IH7aAjriP/3pT9Vf//rXoJREIPbW/6YOW/f4r9neqMeOHQsbn//Zse+NNT9IrZh2GXvsvTek3YZizaW5bglPZ5fXiNNcm95jbNMB8v3vfz9EB9yEQ6oIgpUJK3/961+r3/72t/r6N8cjLe2y2OuRzol0LNY20dVttCvybsplc37tabfhJIVMvOfbslNEN2AArv7F9VXTpRccprtKdM2OVTKJXlvNoPMNwJ4uDy8xVXXikVBfrpLjs0S2ZJAmvKmDrryAerpcLj2HgEPAIeAQcAg4BBwCDgGHgEPAIdDVCFx14fXBKN/e/oZ4wzWrdfs+kInPa/R+NLczkjNFiq2vunrSTXof800t3fyyXrcnrETzO9w3F97a7fmRXrU4iHntSNmhmL6jIdkLW2RPiIvJNztjyEEYT0iIL8geiE5IaQxPT0N22US0IcIhRI2nIR6ctmQB50O0GMIVnsB4fyPbYQyPT4yJ84xnKbrBeDEiY2ImTuTb1+h/m3O7O36TTqQl3rSxygMYLIjPT0eaumjPj3Zpe6+afJo6Mdt+S+ROmMzu29/+tpo9W+YFEvLb4G+Hp66QpTBew/Yxv/D2cbNutwsmFzRtzhzvqmWs+aG+egtvFe7e0lFMYsXWrpNwMhvRPJjJ+x133KEnHV20aJGe4NaO15SBSRQhu/06ZUwYv2WsZfE71+yLtU3Y+e7ONmry1RPL3tLGe6KspNHx8U1yMo2ZHw8ahnGNzx0uk6Kl6JeG45XHRctVNGwdAdulddksmrxlMtFg09l6lZ80VqUl5qi4+MBD0NRHlyboInMIOAQcAg4Bh4BDwCHgEHAIOAQcAh9TBMYMnCAT0afpSSYPndovo48r1JtbXgmWZtGUW4Lrl4+9Uj249H69/cbml9RXr/hbtWLHcr0NmXzFuIXBsKzgVW3sJ7f+Rs0aPc9sdni5s2SbyKc0RtX7Ju3y6rJgOp2RLiESdK4LCgq0dAWkyN69e3XchiiFADPSFYaIhiSEgIaINpNZcpLtHa4jafmHTITRQyY8xLnxJrWH4ZMXNHDxdCYveHIjh2DIGlv/uyfjt9PyW4cMhMiLplXNuYa0Z92QeKZ87GPCyljlNwjfFQb5Pm/ePP0jPuoWuZj3339fe5azDw9zNIVvuummYH2wHwmaWMx48hPWlDuW82IJY+NH2wk3KaIdF7rvpo3b+7tq3c5TtDjRdO5sXkx6LBk1YHeohEvfSI5wPFYyOFxcXMfgbrDHo5tOMKR4uDYw8sakkXSswBeGM7ssEOOxlMUbl4mD/b2hjXrz195t7jGmTGBL3dnEvF98hKedd4XZ3u5dEV93xRG+VbUjRUN256RkywzPhfrBfEpPSBnoJW9HVC5oBARooI0yyWBp7R6ZfC5BZSeJPpro9NLJEOkGESFKd8gh4BBwCDgEHAIOAYeAQ8Ah4BBwCJy3CCTGJykmm8Tw1H594wt6Ikq2+Y6aOTpwjO1iLU2Sx6o6UnZQCPFXxeu6Um/ny5xUg3OK9Dr/+AaeUnRJcPuRdx4MrkdaId7DLT+8y71WXV+l3t/9rnd3m23yhvY4Rjn6p+e2CdPeHbbcCES0TV4bb2vi5NvT6M7yjbpy5UqFDAUGLnZYvbPlHxq5HMcgItGgNqRNUVFRCPFp5wWy1XiAc244rd3ujp+0IxllgdCLZnjJm44EwpqJIm2CPJo+t0kDMhPs+bWXJIU8ZOLPxx9/XD333HNtzodYnDNnjrrvvvuC3vykayRTqDNj1JGfp7c5zhJ80MM21hHi0pzrt7Tzs2nTJl8Pd+95H3zwgXdXl26bCRQpuy0J5JcIEh/mevA7Hss+OoiMLV++3KyGXdLRZEsC4cHcHoNsfeyxx3Qb+stf/hLsEDFxIJ1Dhw0jBowuP8cgaKOV1S4Lk7dGMzrDkNehPb/6akCmym4TvaGNRitDtONIIxliG/yWLVsW7RR18OBB3VHoF5D6McbomUie+9xfbMklc15vXHaa6OZBZX7xMrxmwoDR0mDPqNIa0ZGuq47aeHsjKL05Tw1N1YLtQZUUlymTfQ6USeGSg17z5qWhN+ff5c0h4BBwCDgEHAIOAYeAQ8Ah4BBwCPQkAtdMvjmY3P996V80ic2OYpmssn9aK0Fsa3ozKeWPn/hbTY4TdsHEazWhzLoxWxZl/f7V6oW1i80h3+UvX/xndcuv5qpPye/WXy9Q1TLRpZ/92zM/DOqC+x0vl2/tf3v2h8FDSKogm9JZs3WuIb8MAcZ3Jt7YttnyJZBQxisUCZFwE84hkZGenq6jwTPYJj295LWdFwhCQwyTF5sEt/PU3fHbaYVbR8rFT+fYDv/EE08EeRK814taCGMbU4hrG5//v717D9KrrO8A/mQv2exukl2yQhIjIRnASL1EoS2Cl2opMugQiuMIOtMZhj+EMh0RqzN22v4nlduMDKWKQNFp+cexTqnUmTJqGdva2gp1pAVawAs0QMIm5H7dzabn94bnzdnNu292T3aTk+znOO+8l3N7zuc5+2K+53l/p7x+fh03jfzqV7+a7r333vS1r30tReg4nSlCrejjaHPcdLRdUN3qZoQxsj+Pyo7R/Q8//HDb3Ued5ggjY4p+ESDbfgAAHSpJREFUnOoNBttutDQzyu/kEckRyoVzuyluBprro7db7ljm5YsYsY24IDRZkBj2Uwktj9aWiefQ448/3naVb33rW80LHBHK5/JEbVcqzYz+jxvHxjkUF6PanftxDuXzpbSJSV++613vas6L0e7f//73m+9bvYj+jvI6+XwO67qdo63aPZ3P4u+m3EdxDkdAPdkUYXiMnp9siosJedBsfIe3O1/CP3/PT7a9unx+zEF3HEjAxCPQ39G4IWVHGi5u4LGp+A+waeYE4iTdsnt92juyIy2af0ZaWDziiyKfmDO3J1siQIAAAQIECBAgQIDAqSEQN5uMkd0Tpw8XAXj8G7Y8lcPr/Hks89tv+3B+23x+x8oL0oXnvK/5PgLqv3zsz5shZp4R/4574LG709/8+1/nj4qyKDc1aoM3Pyi92LJrc7ryzvelF4YP3RCzNCs9vf5nad0d72nWGI/R3Dd+6PPNRb73X3+fLr/1N4v135s+ctu704ZtUyspERso17lubrB40armdi5fUl4uXq9Zs2biR833E0OaPCPCyXJ4E59Ppy15O7O5/QceeCDdcccdjcdXvvKVSQPL6OuHHnooPfHEE7lZzecIee++++5xoyI/8IEPNMO/qDterpH8gx/8oFEmpLmB0ovvfve76amnnmp+EqFxHunZ/PAoL2IEeQ6Go93f+MY3Wh5XzGs1Onjx4sXp/PPPb+4lbhwao3pbhbkxYrwc3K8qwv1yCNzcyDG8iIsG5XA0Qtfot1bhXBzPI488cgx7m9qqF1xwQfM7Ji7uPPjgg0f4RImYe+65Z8r13dvtOS4ClWu+x3kSFxgmTnFR5L777hsX9Mfo/ekE0bHNKGdUHgUeNy7NJUom7jOC0lbnxmR/W/FdUh7VHb+WiDC71S8X4vP169c3dxkleOJY6naONht4lBdxrtx5552N75vbbrstffvb326ucdlll437u73//vsn/b656667GvdbaK484UV8Zyxfvrz56aOPPpoiPJ84Rd/FhZqTZTqmGt35IOM/KPGIwPXMxcvTwt7BtH3P9sao7gPFlTRBbJaq/hz/cRkrHhu2P11YF3+wxU0o++af1rDNFxmqb92aBAgQIECAAAECBAgQODUF+nsWpvOLMiM/fv7wz9+j5vZ711xyxAG/7U3vbATQO4pa3nk6rX8ovXnZr+W3457/7Jp70hV3XNyoAR4z7v/Hu9JD/3JfuvTtVxSlUM5Oz2/83/TY0//QnB/LnFmUQPm9910fL8dN3V3z08jo/sa/rSPsvvruD6V3n/v+RpgedbsfK8qVPP3Sk+PWufnDf1qUDz1cruBnLzyeYt2Y4hhblUcZt4EJb8p1tPOsVjW3y3W083KRCUxWtiQvs3bt2iOClHL977xcPE+1LeV1Zmv7UVs6wqeYWgVt5TbE6wj8ItiNsC7C5CgfMPEGfCtXrmzWMs7rxw39vvzlLzdDz5/85Cfppz/9aTr77LPT0NBQGh4eboxuL9/0MsoZXHrppXkTU36OkPKiiy5q1k2PUeS33nprY8R89Enc3DLCwxhNX97fhRceLtlz+eWXN0bR5lrrMar3S1/6UuO4IwCNMicxwnZkZKTZrvD42Mc+1nw/ky+iPdGGXEs4RmzffvvtafXq1Y1AL/owRv2Wa4XP5P4nbiv6OC7i5JuuRp3oW265pXFuh0+r82LiNqb7/hOf+ETjho/5PI26+HHhJf6eYtR2lJ+IkfyRMeUp+jvOhSpT1JP/+te/3lg1zpm42WScr6uKixmRVW3YsKEx0rtsHt8pOVRv97f18Y9/PJUvLMXFlC9+8YsN0/gFR1wkKN8INxoR4XiuER7v63aORpuONkXfxMWI3Idlu/i7jWPKF2pi2fi++eEPf9i4SW/08XTOqyuvvLLxy5DYTjxiuxFqRx9Gf4bvdH8tcrTjm+35xxx0x3/MAqOz89Co7v6e3rR6yar0zMan06aiTvfI2GjqOtjZvIo12wd0Km//QPF/bl7d+Wzq6ViYBnvPLG5Q0tv44sgXGuLZRIAAAQIECBAgQIAAAQLjBS5bu25c0L1iycoUj4lTlC+5uKjb/ejP/q456/1v+Z002c0eI0R/5PP/mq6796r0wqZfNNbZs393+s4T32yuX36xdGB5evCGvz2iDEosEyF37/y+RhD+7CtPN1b78XP/lOIxcYp/+/3JVbenj5RuphnL9HQvmLjotN5HCZEIaOPf+DHFfiYLr6NMQrn0Q9R7jRtatpviRpIRxJRH2U62/em0Je9ztref99PqOaxilHQeWRpha9zIsdUUoWOEeBOnuIDw2c9+tlGOJNfCjpB5svrOsfz111/fDA0nbu9o72Pka7QzalrHFPt68sknG49W60ZoWx61H8d80003pRhVmksoxKjdcn338nairM2nPvWpVK4NXJ5/rK+jPZ/+9KfHtSfO5Rjd3aqsRtSPjmNvNdJ4Km3Jfyftlr3mmmsapWXiQkJMsU4rn7CNMiA53Gy3zXbzovZ51MSOEdsRVMYUAX+rXxnEvNjvJz/5yXg56dTuOCPMv+KKKxpha14ujiMeraa4MBNB7VSmfCwx6jtfaIp9xIWDfPGgvJ34/rnuuuvKHzW+w07kOZpNxjXqKG+Odj7GLyniQkH8UiJvP34x0qqPwzsuCrQ6/6MZMS9uLlsucRKj8ieOzI/vmvj7nepNPY9yiLM6u2Mmth5fJvOKq8UB3VvUBjt3aHXxRTFahLKbijIbe2diF7ZRCOzcN1zcJXxj6utekk5bcGbj/xyF+SF/IbeThAABAgQIECBAgAABAq0ELjr3t4qBQvObs6KudZT9aDVdvvZ3mx/Hv7UuW3tl832rFxF2f/Om76U/vurWNLTw0M0sJy53+uKl6Y+uvCU9/If/PGnJklhn7cpfT3914yPp9y/9XOrr6Z+4mcb7i978W+k7n/vRESH3xIVjNOWi3oGJH7d9H6FHlA3JU4winqzmdtRELv96O8LbPEozrz/xOZaPkYJ5ivexXqtpOm3J68/W9stlQaLOeJwXraYIr6+66qoU4VKrKUopXH311S1D7rx8hMA333xzuuSSSxoXBfLn5ecInT74wQ82bhRZblt5mXgdfXe0PvnoRz+arr322rYXKaIvIrBtFYiGRYTXMbI312Cf2I6enp5GeyNwbBdyx7amU9KkfP7lfeb2RImHuKjSaoryHjF6Ptqcp1bbyvNaGcd+4hFT/J1M5hzL3HDDDeniiy9ulpzI243nsFm3bl3jvMjbm6wteR+xXDunCIi/8IUvpBh9n8vTlPcZr2NEeZyLrfq0vGzss/ydUJ6XX0fwGudslN/Jx5Dn5ef8y4O4kJOPI+aVbVv9bUU744aoUeN7MpfozziWuOjT3d2dd9l8jjbN1DkaG21n39zp6y8m85+4XJyr2S5el41a+cevV8J81apVEzfVeB/rR7985jOfGfcdnvdRXikuWt54442TfgfEd3b0W/lCZqvtlLd5Il/PK9L/w79XqNiS2ERcdYqfo+zeuyf96IUn0l/824Np7Zvenv7gPdemNw0ua3ZYxV3M6dXCNx5Pv/xo+o8XH0pnDVyY1i67Oi0o/o9P/Gwh/nAm+4Of03AOngABAgQIECBAgAABAsdZYHj7xrR553Bjr0UUls4YWJai/EmVKbYVpUjGDo4VW5pX3EDznJb1xqts2zozIxB1t+NmeRH8RKCZQ7AYYRklPSIniRGaE4P7qe49yjPk0iCxToSYrYKvqW6v3XIx0j5KTeSYKLKGKAURucNUp7DYvHlzM6iLcD+C4BM1RamOGB0fwV+EoNE/0zmemW539Ge0J4yPl02MJo/zMYens3kOhVeM+s2jyeN9mJcD7fis6hTHkkd3Vzk/Y791O0erWuT14pcY8UuS/Hd7LOdVbCuM4wapVX1zu07U8zGXLomGxxd6PCJsjZ90vaFvKA0Vd69+aduGtG3vzrSi+AOO+abqAnHCrt/6n8Wog57C99ziC2p+wzvM2VZ3tSYBAgQIECBAgAABAgRmUiBGb8djJqaZ3NZMtMc22guU/20eI1gnG9ndfivj50YoGY/jMcVI0lWTjBCd6v5jBG486jJFyJovPtShTcezP/PxxsWK8o0d8+ez9Vy+qepM72MmjqNu5+ixGkUgfax/t7kNsa0owXQyTzNSuiQA4gs9Hh3FY6hvIK0ceGPasru4krf7tcbV53xl4WTGOpFt37N/e9q06xeN+txDfec0fmYn5D6RPWLfBAgQIECAAAECBAgQIECAAAECBAjURWDGgu44oEbQXYwwXlzUKDtrcEWKO0Nv3L4pjRQ/0zFVE4gLBPEY3vlc2ndgT1rSu7Ko0T00bjR3+apxtb1YiwABAgQIECBAgAABAgQIECBAgAABAievwKwE3T1d3Wlp8VOt/u6+9OK2V4rAe/TkFapByw8W9dg27nimCLzH0hsXvbMRcucR9ELuGnSQJhAgQIAAAQIECBAgQIDAnBfwS/Y5fwoAIEDgBAvMWNCdR3NHOY0ocL980RlFCZPT0otbX0l7R/ed4MM8uXe/f3R32rzrV2lB16JGfe6wDmOlS07uftV6AgQIECBAgAABAgQIEDi5Bco33TuRNzk8uRW1ngABAjMjMCM3oyw3pRF0d3SmpX1L0rJFS9OzW19M2/ftLG5OOdhYzAjkstbRX8cV4e17NxSGw2n5wrelnu5FQu6js1mCAAECBAgQIECAAAECBAjMusC6detShN2nn356Ghw8lHvM+k7tgAABAgRaCsxo0B0hdh7ZvXhBf1o+uDw9+er/pOFdW9Kq01Y05rVshQ/bCBwsbkL58zRSjOo+a+CiYhT3oZHcRnO3ITOLAAECBAgQIECAAAECBAgcB4E1a9Ych73YBQECBAhMRWDGSpeUdxZh9/yu+enMgRWp+2BKv3xtfXm219MQiBt6bt75QlHvfEka6FvpJpTTsLMoAQIECBAgQIAAAQIECBAgQIAAAQJzQ2DGg+4YaZxHG68eXJGW9J+Wnhn+RRorSnC4McP0Tqrw2rX/tbStKF1yxsK3pK6OnnFB9/S2ZmkCBAgQIECAAAECBAgQIECAAAECBAicmgIzHnQHU0fHvMbj9L7BtHRgefrVlv9Le0f2npqCs3hUEXRv2/NSGj2wJ53ef17qmHfoIkK+kDCLu7ZpAgQIECBAgAABAgQIECBAgAABAgQInDQCsxJ0pxS1ujvSgu6etHrJ6rRj92tp0+6tJw1KXRp6YGwkbd29PvV2DaTFPcubI+Xd0LMuPaQdBAgQIECAAAECBAgQIECAAAECBAjUQWDGg+7yDSljBPKaoVUpdvL8lvVKl0yjx2M09/7RXWn73o1psPestKBr4biyJcLuaWBalAABAgQIECBAgAABAgQIECBAgACBU1pgxoPu0IoQ9lD5ko501sCy4iaKS9JTG59tBN3qdE/9fNq1f3PaN7ojDS5YmTo71eeeupwlCRAgQIAAAQIECBAgQIAAAQIECBCYSwKzFnRH6ZKoJb24Z2E65/Rz0jOvPpdGxkbnku0xHevYwQNFfe4NqXNeT1rUszR1dnQ2S5cc04atTIAAAQIECBAgQIAAAQIECBAgQIAAgVNMYFaC7jA6NKr7UNh9wfK3pg1bXko79+05xfhm53Bi1PvogX1px75XU3/3G1Jv96CyJbNDbasECBAgQIAAAQIECBAgQIAAAQIECJwCArMSdOc63fn5vKHVxYjkrvSrbS8rXzLFk2bvyI60d//WNLBgReru6m2O5g5TEwECBAgQIECAAAECBAgQIECAAAECBAgcFpiVoDtvPgfdA70L0+qifMl/b3zODSkzTpvnGNG9Z2RrGhsbS4sXvDHFTT2jDIyQuw2aWQQIECBAgAABAgQIECBAgAABAgQIzFmBWQu6I5SNcDYenUVQ+xsr3p5+vumXaawIcU3tBcYOjhZlXjan+Z0LU//8oWbInS8ctF/bXAIECBAgQIAAAQIECBAgQIAAAQIECMwtgVkNunPYHc/nLzuvuLnitiLA3TW3hCsc7eiB/Wn7nlfSYO+ZqauzpzGSW8hdAdIqBAgQIECAAAECBAgQIECAAAECBAjMCYFZC7qzXg5o39A7mE7rG0ov7RjOszy3EIiyJfsP7Em7929JS/pXv35Tz3nKlrSw8hEBAgQIECBAgAABAgQIECBAgAABAgRCYFaD7hxyR/mS7s7O9Nal56bnNr+gTvdRzr1d+4bTgq7Fqbd78PXyL53N8iVHWdVsAgQIECBAgAABAgQIECBAgAABAgQIzDmBWQ26QzPfRLGjozOdu2RlemX7q4LuNqdZjOge3vl8OmPReW5C2cbJLAIECBAgQIAAAQIECBAgQIAAAQIECGSBWQ+6Y0eNm1IWdboHexYV4e28tHP/bmF37oHSc4TcY2MH0o59r6YlvWeNq80do+NNBAgQIECAAAECBAgQIECAAAECBAgQIHCkwKwG3bl0SX7un9+bli46I71c1OmOUNd0pMD2vS+ngZ7lqbNjfjPoPnIpnxAgQIAAAQIECBAgQIAAAQIECBAgQIBAFpjVoDvvJAfdfd0L0rL+obR597Y8y/MEgQ3bn0nLF69thtzZbsJi3hIgQIAAAQIECBAgQIAAAQIECBAgQIDA6wLHLeg+dEPKrrS4py8dOHggjRYlOkyHBWKE+8iBvenA2Fjqmz8k6D5M4xUBAgQIECBAgAABAgQIECBAgAABAgTaCsx60J1HJOfnxT0L0/zO7rRrZE/bhs3FmTv3bUpL+lY1bkIZXnFxwESAAAECBAgQIECAAAECBAgQIECAAAEC7QWOW5JaDrp7Oxek3fv3qtNd6psY0b1vZEca7F3R+DR7xbOJAAECBAgQIECAAAECBAgQIECAAAECBCYXOO5Bd4zmXljclDKmg8X/TIVDEXKPFeVcujp6U1dxEaA8mlvQ7QwhQIAAAQIECBAgQIAAAQIECBAgQIBAe4Gu9rNnZm4Oa6MUR2cR6vZH0F2MVB4rXncYsNxAHjmwp6jNvSTNi/8VNvkxMz1gKwQIECBAgAABAgQIECBAgAABAgQIEDh1BY5L0J35cng70NOf9o2NKl2SYYrn7s7eNDbvYCPojgsC2aq0iJcECBAgQIAAAQIECBAgQIAAAQIECBAg0ELguAbdsf8IcLuL8iXdXd3FaO55jbA7PpvLU5QuKW49WXgUxVzi9Rz3mMvngmMnQIAAAQIECBAgQIAAAQIECBAgQGD6Asct6G6Gt0WmHeU5YsrP02/2qblGGOXHqXmEjooAAQIECBAgQIAAAQIECBAgQIAAAQIzL3Dcgu7c9Ai34yaUzeA7z5jDz60sWn02h4kcOgECBAgQIECAAAECBAgQIECAAAECBCYVOK5Bd4S3UX86ynPEJMw93C8sDlt4RYAAAQIECBAgQIAAAQIECBAgQIAAgekIzCtC50Op83TWsiwBAgQIECBAgAABAgQIECBAgAABAgQIEKiJQEdN2qEZBAgQIECAAAECBAgQIECAAAECBAgQIECgkoCguxKblQgQIECAAAECBAgQIECAAAECBAgQIECgLgKC7rr0hHYQIECAAAECBAgQIECAAAECBAgQIECAQCUBQXclNisRIECAAAECBAgQIECAAAECBAgQIECAQF0EBN116QntIECAAAECBAgQIECAAAECBAgQIECAAIFKAoLuSmxWIkCAAAECBAgQIECAAAECBAgQIECAAIG6CAi669IT2kGAAAECBAgQIECAAAECBAgQIECAAAEClQQE3ZXYrESAAAECBAgQIECAAAECBAgQIECAAAECdREQdNelJ7SDAAECBAgQIECAAAECBAgQIECAAAECBCoJCLorsVmJAAECBAgQIECAAAECBAgQIECAAAECBOoiIOiuS09oBwECBAgQIECAAAECBAgQIECAAAECBAhUEhB0V2KzEgECBAgQIECAAAECBAgQIECAAAECBAjURUDQXZee0A4CBAgQIECAAAECBAgQIECAAAECBAgQqCQg6K7EZiUCBAgQIECAAAECBAgQIECAAAECBAgQqIuAoLsuPaEdBAgQIECAAAECBAgQIECAAAECBAgQIFBJQNBdic1KBAgQIECAAAECBAgQIECAAAECBAgQIFAXAUF3XXpCOwgQIECAAAECBAgQIECAAAECBAgQIECgkoCguxKblQgQIECAAAECBAgQIECAAAECBAgQIECgLgKC7rr0hHYQIECAAAECBAgQIECAAAECBAgQIECAQCUBQXclNisRIECAAAECBAgQIECAAAECBAgQIECAQF0EBN116QntIECAAAECBAgQIECAAAECBAgQIECAAIFKAoLuSmxWIkCAAAECBAgQIECAAAECBAgQIECAAIG6CAi669IT2kGAAAECBAgQIECAAAECBAgQIECAAAEClQQE3ZXYrESAAAECBAgQIECAAAECBAgQIECAAAECdREQdNelJ7SDAAECBAgQIECAAAECBAgQIECAAAECBCoJCLorsVmJAAECBAgQIECAAAECBAgQIECAAAECBOoiIOiuS09oBwECBAgQIECAAAECBAgQIECAAAECBAhUEhB0V2KzEgECBAgQIECAAAECBAgQIECAAAECBAjURUDQXZee0A4CBAgQIECAAAECBAgQIECAAAECBAgQqCQg6K7EZiUCBAgQIECAAAECBAgQIECAAAECBAgQqIuAoLsuPaEdBAgQIECAAAECBAgQIECAAAECBAgQIFBJQNBdic1KBAgQIECAAAECBAgQIECAAAECBAgQIFAXAUF3XXpCOwgQIECAAAECBAgQIECAAAECBAgQIECgkoCguxKblQgQIECAAAECBAgQIECAAAECBAgQIECgLgKC7rr0hHYQIECAAAECBAgQIECAAAECBAgQIECAQCUBQXclNisRIECAAAECBAgQIECAAAECBAgQIECAQF0EBN116QntIECAAAECBAgQIECAAAECBAgQIECAAIFKAoLuSmxWIkCAAAECBAgQIECAAAECBAgQIECAAIG6CAi669IT2kGAAAECBAgQIECAAAECBAgQIECAAAEClQQE3ZXYrESAAAECBAgQIECAAAECBAgQIECAAAECdREQdNelJ7SDAAECBAgQIECAAAECBAgQIECAAAECBCoJCLorsVmJAAECBAgQIECAAAECBAgQIECAAAECBOoiIOiuS09oBwECBAgQIECAAAECBAgQIECAAAECBAhUEhB0V2KzEgECBAgQIECAAAECBAgQIECAAAECBAjURUDQXZee0A4CBAgQIECAAAECBAgQIECAAAECBAgQqCQg6K7EZiUCBAgQIECAAAECBAgQIECAAAECBAgQqIuAoLsuPaEdBAgQIECAAAECBAgQIECAAAECBAgQIFBJQNBdic1KBAgQIECAAAECBAgQIECAAAECBAgQIFAXAUF3XXpCOwgQIECAAAECBAgQIECAAAECBAgQIECgkoCguxKblQgQIECAAAECBAgQIECAAAECBAgQIECgLgKC7rr0hHYQIECAAAECBAgQIECAAAECBAgQIECAQCUBQXclNisRIECAAAECBAgQIECAAAECBAgQIECAQF0EBN116QntIECAAAECBAgQIECAAAECBAgQIECAAIFKAoLuSmxWIkCAAAECBAgQIECAAAECBAgQIECAAIG6CAi669IT2kGAAAECBAgQIECAAAECBAgQIECAAAEClQQE3ZXYrESAAAECBAgQIECAAAECBAgQIECAAAECdREQdNelJ7SDAAECBAgQIECAAAECBAgQIECAAAECBCoJCLorsVmJAAECBAgQIECAAAECBAgQIECAAAECBOoiIOiuS09oBwECBAgQIECAAAECBAgQIECAAAECBAhUEhB0V2KzEgECBAgQIECAAAECBAgQIECAAAECBAjURUDQXZee0A4CBAgQIECAAAECBAgQIECAAAECBAgQqCTw//B267pNM5aqAAAAAElFTkSuQmCC'
	        }, { text: 'Student Hours Report: ' + studentName, bold: true, fontSize: 18, color: 'green', alignment: 'center', margin: [0, 10] }]
	      };
	
	      var reportText;
	      if (this.startDate && this.endDate) {
	        reportText = 'Sessions before ' + dateToDateString(this.startDate) + ' and after ' + dateToDateString(this.endDate) + ' have been excluded.';
	      }
	
	      if (this.startDate && !this.endDate) {
	        reportText = 'Sessions before ' + dateToDateString(this.startDate) + ' have been excluded.';
	      }
	
	      if (!this.startDate && this.endDate) {
	        reportText = 'Sessions after ' + dateToDateString(this.endDate) + ' have been excluded.';
	      }
	
	      if (reportText) {
	        docDefinition.content.push({ text: reportText, margin: [0, 0, 0, 5] });
	      }
	
	      var table = [[{ text: 'Week Ending Date', bold: true }, { text: 'Tutor Name', bold: true }, { text: 'Session Duration', bold: true }, { text: 'Timesheet Submitted', bold: true }]];
	      timesheets.forEach(function (timesheet) {
	        table.push([timesheet.weekEnding, _this4.tutorName(timesheet.tutorID), timesheet.hours, 'Yes']);
	      });
	
	      docDefinition.content.push({
	        table: {
	          headerRows: 1,
	          widths: ['*', '*', '*', '*'],
	
	          body: table
	        }
	      });
	
	      var totalHours = timesheets.reduce(function (accumulator, currentValue) {
	        return accumulator + +currentValue.hours;
	      }, 0);
	
	      docDefinition.content.push({ text: 'Total Hours: ' + totalHours + '              ' + 'Total Weeks: ' + timesheets.length, bold: true, margin: [0, 10] });
	
	      pdfMake.createPdf(docDefinition).open();
	    }
	  }]);
	
	  return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function dateStringToDate(date) {
		var split = date.split('/');
		var year = +split[2];
		if (year < 100) {
			year += 2000;
		}
		var month = +split[1] - 1;
		var day = +split[0];
		return new Date(year, month, day);
	}
	
	var _class = function () {
		/*@ngInject*/
		_class.$inject = ['$http', 'JSONToCSVConvertor'];
		function _class($http, JSONToCSVConvertor) {
			_classCallCheck(this, _class);
	
			this.$http = $http;
			this.counts = [];
			this.timesheets = [];
			this.JSONToCSVConvertor = JSONToCSVConvertor;
			this.loadsRequired = 2;
			this.states = ['QLD', 'NSW', 'VIC', 'SA', 'WA', 'TAS', 'NT', 'ACT'];
			this.loaded = false;
		}
	
		_createClass(_class, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;
	
				this.$http.get('/api/timesheets').then(function (res) {
					_this.timesheets = res.data;
	
					_this.loadsRequired--;
					if (_this.loadsRequired === 0) {
						_this.getCounts();
					};
				});
	
				this.$http.get('/api/tutors').then(function (res) {
					_this.tutors = res.data;
	
					_this.loadsRequired--;
					if (_this.loadsRequired === 0) {
						_this.getCounts();
					};
				});
			}
		}, {
			key: 'createCSV',
			value: function createCSV() {
				this.JSONToCSVConvertor(this.counts, 'Total_Hours_By_State_And_Year', true);
			}
		}, {
			key: 'getState',
			value: function getState(tutorID) {
				var tutor = this.tutors.find(function (tutor) {
					return tutor.tutorID === tutorID;
				});
	
				if (tutor) {
					return tutor.state;
				}
	
				return 'INVALID';
			}
		}, {
			key: 'getCounts',
			value: function getCounts() {
				var _this2 = this;
	
				this.timesheets = this.timesheets.map(function (timesheet) {
					timesheet.year = dateStringToDate(timesheet.weekEnding).getFullYear();
					timesheet.state = _this2.getState(timesheet.tutorID);
	
					return timesheet;
				});
	
				this.years = [];
	
				this.timesheets.forEach(function (timesheet) {
					_this2.years.push(timesheet.year);
				});
	
				this.years = this.years.filter(function (item, pos) {
					return _this2.years.indexOf(item) == pos;
				});
	
				this.years.forEach(function (year) {
	
					var yearSheets = _this2.timesheets.filter(function (timesheet) {
						return timesheet.year === year;
					});
	
					_this2.states.forEach(function (state) {
	
						var yearAndState = yearSheets.filter(function (timesheet) {
							return timesheet.state.toLowerCase() === state.toLowerCase();
						});
	
						if (yearAndState.length) {
							_this2.counts.push({ year: year, state: state, count: yearAndState.length });
						}
					});
				});
	
				this.loaded = true;
			}
		}]);
	
		return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 52 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function dateStringToDate(date) {
	  var split = date.split('/');
	  var year = +split[2];
	  if (year < 100) {
	    year += 2000;
	  }
	  var month = +split[1] - 1;
	  var day = +split[0];
	  return new Date(year, month, day);
	}
	
	var _class = function () {
	  /*@ngInject*/
	  _class.$inject = ['$http', 'JSONToCSVConvertor'];
	  function _class($http, JSONToCSVConvertor) {
	    _classCallCheck(this, _class);
	
	    this.$http = $http;
	    this.loaded = false;
	    this.loadsRequired = 2;
	    this.JSONToCSVConvertor = JSONToCSVConvertor;
	    this.filteredTimesheets = [];
	  }
	
	  _createClass(_class, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$http.get('/api/tutors').then(function (res) {
	        _this.tutors = res.data;
	        _this.lowerLoad();
	      });
	
	      this.$http.get('/api/timesheets').then(function (res) {
	        _this.timesheets = res.data;
	        _this.lowerLoad();
	      });
	    }
	  }, {
	    key: 'createCSV',
	    value: function createCSV(timesheets) {
	      this.JSONToCSVConvertor(timesheets, 'Total_Hours_Per_Tutor', true);
	    }
	  }, {
	    key: 'lowerLoad',
	    value: function lowerLoad() {
	      this.loadsRequired--;
	
	      if (this.loadsRequired == 0) {
	        this.loaded = true;
	      }
	    }
	  }, {
	    key: 'tutorName',
	    value: function tutorName(tutorID) {
	      var tutor = this.tutors.find(function (tutor) {
	        return tutor.tutorID === tutorID;
	      });
	      if (!tutor) {
	        return '';
	      }
	      return tutor.nameFirst + ' ' + tutor.nameLast;
	    }
	  }, {
	    key: 'create',
	    value: function create() {
	      var _this2 = this;
	
	      var filtered = this.timesheets.map(function (timesheet) {
	        return timesheet;
	      });
	
	      if (this.startDate) {
	        filtered = filtered.filter(function (timesheet) {
	          var tsDate = dateStringToDate(timesheet.weekEnding);
	
	          return _this2.startDate.getTime() < tsDate.getTime();
	        });
	      }
	
	      if (this.endDate) {
	        filtered = filtered.filter(function (timesheet) {
	          var tsDate = dateStringToDate(timesheet.weekEnding);
	
	          return _this2.endDate.getTime() > tsDate.getTime();
	        });
	      }
	
	      filtered = filtered.map(function (timesheet) {
	        timesheet.tutorName = _this2.tutorName(timesheet.tutorID);
	
	        return timesheet;
	      });
	
	      var newArr = [];
	
	      filtered.forEach(function (timesheet) {
	        var found = newArr.findIndex(function (news) {
	          return news.tutorName === timesheet.tutorName;
	        });
	
	        if (found !== -1) {
	          newArr[found].hours += timesheet.hours;
	          return;
	        }
	
	
	        newArr.push({ tutorName: timesheet.tutorName, hours: timesheet.hours });
	      });
	
	      newArr = newArr.sort(function (a, b) {
	        var nameA = a.tutorName.toUpperCase();
	        var nameB = b.tutorName.toUpperCase();
	        if (nameA < nameB) {
	          return -1;
	        }
	        if (nameA > nameB) {
	          return 1;
	        }
	
	        return 0;
	      });
	
	      this.filteredTimesheets = newArr;
	    }
	  }]);
	
	  return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		/*@ngInject*/
		_class.$inject = ['$http', 'JSONToCSVConvertor'];
		function _class($http, JSONToCSVConvertor) {
			_classCallCheck(this, _class);
	
			this.$http = $http;
			this.states = ['QLD', 'NSW', 'VIC', 'SA', 'WA', 'TAS', 'NT', 'ACT'];
			this.counts = [];
			this.tutors = [];
			this.JSONToCSVConvertor = JSONToCSVConvertor;
			this.loaded = false;
		}
	
		_createClass(_class, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;
	
				this.$http.get('/api/tutors').then(function (res) {
					_this.tutors = res.data;
					_this.states.forEach(function (state) {
						state = state.toLowerCase();
	
						var count = _this.tutors.filter(function (tutor) {
							return tutor.state.toLowerCase() === state;
						}).length;
	
						if (count) {
							_this.counts.push({ count: count, state: state });
						}
					});
					_this.loaded = true;
				});
			}
		}, {
			key: 'createCSV',
			value: function createCSV() {
				this.JSONToCSVConvertor(this.counts, 'Tutor_Count_By_State', true);
			}
		}]);
	
		return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function dateStringToDate(date) {
	  var split = date.split('/');
	  var year = +split[2];
	  if (year < 100) {
	    year += 2000;
	  }
	  var month = +split[1] - 1;
	  var day = +split[0];
	  return new Date(year, month, day);
	}
	
	function dateToDateString(value) {
	  var result = new Date(value);
	  var dd = result.getDate();
	  var mm = result.getMonth() + 1;
	
	  var yyyy = result.getFullYear();
	
	  var today = dd + '/' + mm + '/' + yyyy;
	  return today;
	};
	
	var _class = function () {
	  /*@ngInject*/
	  _class.$inject = ['$http', 'JSONToCSVConvertor'];
	  function _class($http, JSONToCSVConvertor) {
	    _classCallCheck(this, _class);
	
	    this.$http = $http;
	    this.JSONToCSVConvertor = JSONToCSVConvertor;
	    this.filteredTimesheets = [];
	    this.total = 0;
	  }
	
	  _createClass(_class, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.loadData();
	    }
	  }, {
	    key: 'createCSV',
	    value: function createCSV(timesheets) {
	      var _this = this;
	
	      timesheets = timesheets.map(function (timesheet) {
	        timesheet.studentFullName = _this.studentName(timesheet.studentID);
	
	        return timesheet;
	      });
	
	      timesheets = timesheets.map(function (timesheet) {
	        return {
	          studentFullName: timesheet.studentFullName,
	          weekEnding: timesheet.weekEnding,
	          rateType: timesheet.rateType,
	          hours: timesheet.hours
	
	        };
	      });
	
	      this.JSONToCSVConvertor(timesheets, 'Tutor_Hours-' + this.selected.nameFirst + '_' + this.selected.nameLast, true);
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this2 = this;
	
	      this.$http.get('/api/students').then(function (res) {
	        _this2.students = res.data;
	      });
	
	      this.$http.get('/api/tutors').then(function (res) {
	        _this2.tutors = res.data;
	        _this2.tutors = _this2.tutors.map(function (tutor) {
	          tutor.fullName = tutor.nameFirst + ' ' + tutor.nameLast;
	          return tutor;
	        });
	      });
	
	      this.$http.get('/api/timesheets').then(function (res) {
	        _this2.timesheets = res.data;
	      });
	    }
	  }, {
	    key: 'studentName',
	    value: function studentName(studentID) {
	      var student = this.students.find(function (student) {
	        return student.studentID === studentID;
	      });
	      return student.nameFirst + ' ' + student.nameLast;
	    }
	  }, {
	    key: 'create',
	    value: function create() {
	      var _this3 = this;
	
	      this.$http.get('/api/timesheets/tutor-id/' + this.selected.tutorID).then(function (res) {
	        var filtered = res.data;
	        if (_this3.startDate) {
	          filtered = filtered.filter(function (timesheet) {
	            var tsDate = dateStringToDate(timesheet.weekEnding);
	
	            return _this3.startDate.getTime() < tsDate.getTime();
	          });
	        }
	
	        if (_this3.endDate) {
	          filtered = filtered.filter(function (timesheet) {
	            var tsDate = dateStringToDate(timesheet.weekEnding);
	
	            return _this3.endDate.getTime() > tsDate.getTime();
	          });
	        }
	
	        filtered = filtered.sort(function (a, b) {
	          var tsDateA = dateStringToDate(a.weekEnding);
	          var tsDateB = dateStringToDate(b.weekEnding);
	
	          return tsDateB.getTime() - tsDateA.getTime();
	        });
	
	        _this3.filteredTimesheets = filtered;
	
	        var total = 0;
	        _this3.filteredTimesheets.forEach(function (timesheet) {
	          return total += timesheet.hours;
	        });
	        _this3.total = total;
	      });
	    }
	  }]);
	
	  return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 55 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function dateStringToDate(date) {
	  var split = date.split('/');
	  var year = +split[2];
	  if (year < 100) {
	    year += 2000;
	  }
	  var month = +split[1] - 1;
	  var day = +split[0];
	  return new Date(year, month, day);
	}
	
	var _class = function () {
	  /*@ngInject*/
	  _class.$inject = ['$http', 'JSONToCSVConvertor'];
	  function _class($http, JSONToCSVConvertor) {
	    _classCallCheck(this, _class);
	
	    this.$http = $http;
	    this.loaded = false;
	    this.timesheets = [];
	    this.JSONToCSVConvertor = JSONToCSVConvertor;
	    this.filteredTimesheets = [];
	  }
	
	  _createClass(_class, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var _this = this;
	
	      this.$http.get('/api/timesheets').then(function (res) {
	        _this.timesheets = res.data;
	        _this.loaded = true;
	      });
	    }
	  }, {
	    key: 'createCSV',
	    value: function createCSV(timesheets) {
	      this.JSONToCSVConvertor(timesheets, 'Total_Hours_Per_Week', true);
	    }
	  }, {
	    key: 'create',
	    value: function create() {
	      var _this2 = this;
	
	      var filtered = this.timesheets.map(function (timesheet) {
	        return timesheet;
	      });
	
	      if (this.startDate) {
	        filtered = filtered.filter(function (timesheet) {
	          var tsDate = dateStringToDate(timesheet.weekEnding);
	
	          return _this2.startDate.getTime() < tsDate.getTime();
	        });
	      }
	
	      if (this.endDate) {
	        filtered = filtered.filter(function (timesheet) {
	          var tsDate = dateStringToDate(timesheet.weekEnding);
	
	          return _this2.endDate.getTime() > tsDate.getTime();
	        });
	      }
	
	      var newArr = [];
	
	      filtered.forEach(function (timesheet) {
	        var found = newArr.findIndex(function (news) {
	          return news.weekEnding === timesheet.weekEnding;
	        });
	
	        if (found !== -1) {
	          newArr[found].hours += timesheet.hours;
	          return;
	        }
	
	
	        newArr.push({ weekEnding: timesheet.weekEnding, hours: timesheet.hours });
	      });
	
	      newArr = newArr.sort(function (a, b) {
	        var tsDateA = dateStringToDate(a.weekEnding);
	        var tsDateB = dateStringToDate(b.weekEnding);
	
	        return tsDateB.getTime() - tsDateA.getTime();
	      });
	
	      this.filteredTimesheets = newArr;
	    }
	  }]);
	
	  return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 56 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function dateStringToDate(date) {
	  var split = date.split('/');
	  var year = +split[2];
	  if (year < 100) {
	    year += 2000;
	  }
	  var month = +split[1] - 1;
	  var day = +split[0];
	  return new Date(year, month, day);
	}
	
	function dateToDateString(value) {
	  var result = new Date(value);
	  var dd = result.getDate();
	  var mm = result.getMonth() + 1;
	
	  var yyyy = result.getFullYear();
	
	  var today = dd + '/' + mm + '/' + yyyy;
	  return today;
	}
	
	var _class = function () {
	  /*@ngInject*/
	  _class.$inject = ['$http', 'JSONToCSVConvertor', 'StringToCSV'];
	  function _class($http, JSONToCSVConvertor, StringToCSV) {
	    _classCallCheck(this, _class);
	
	    this.$http = $http;
	    this.JSONToCSVConvertor = JSONToCSVConvertor;
	    this.StringToCSV = StringToCSV;
	    this.filteredTimesheets = [];
	    this.loading = true;
	    this.loadsRequired = 2;
	  }
	
	  _createClass(_class, [{
	    key: '$onInit',
	    value: function $onInit() {
	      this.loadData();
	    }
	  }, {
	    key: 'lowerLoad',
	    value: function lowerLoad() {
	      this.loadsRequired -= 1;
	
	      if (this.loadsRequired === 0) {
	        this.processData();
	        this.loading = false;
	      }
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var _this = this;
	
	      this.$http.get('/api/students').then(function (res) {
	        _this.students = res.data;
	        _this.lowerLoad();
	      });
	
	      this.$http.get('/api/timesheets').then(function (res) {
	        _this.timesheets = res.data;
	        _this.lowerLoad();
	      });
	    }
	  }, {
	    key: 'export',
	    value: function _export() {
	      var today = new Date();
	      var day = String(today.getDate());
	      var month = String(today.getMonth() + 1);
	      var year = String(today.getFullYear());
	      var date = day + '-' + month + '-' + year;
	      var filename = 'Tutor-Overview-' + date;
	
	      this.StringToCSV(this.exportText, filename);
	    }
	  }, {
	    key: 'processData',
	    value: function processData() {
	      var timesheets = this.timesheets.map(function (timesheet) {
	        timesheet.date = dateStringToDate(timesheet.weekEnding);
	
	        return timesheet;
	      }).sort(function (a, b) {
	        var aTime = a.date.getTime();
	        var bTime = b.date.getTime();
	
	        if (aTime < bTime) {
	          return -1;
	        }
	
	        if (aTime < bTime) {
	          return -1;
	        }
	
	        return 0;
	      });
	
	      var students = this.students.map(function (student) {
	        student.timesheets = timesheets.filter(function (timesheet) {
	          return timesheet.studentID === student.studentID;
	        });
	
	        return student;
	      });
	
	      students = students.filter(function (student) {
	        return student.timesheets && student.timesheets.length !== 0;
	      });
	
	      var years = [2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018];
	      students = students.map(function (student) {
	        years.forEach(function (year) {
	          var targ = student.timesheets.filter(function (timesheet) {
	            return timesheet.date.getFullYear() === year;
	          });
	
	          var hourTotal = void 0,
	              first = void 0,
	              last = void 0;
	
	          if (targ.length) {
	            var hours = targ.map(function (timesheet) {
	              return timesheet.hours;
	            });
	            hourTotal = hours.reduce(function (a, b) {
	              return a + b;
	            });
	
	            first = targ[0].weekEnding;
	            last = targ[targ.length - 1].weekEnding;
	          }
	
	          student[String(year)] = {
	            hours: hourTotal,
	            first: first,
	            last: last
	          };
	        });
	
	        return student;
	      });
	
	      var header = ['Client ID', 'State', 'Location', 'First Session in 2011', 'Last Session in 2011', '2011 Hours', 'First Session in 2012', 'Last Session in 2012', '2012 Hours', 'First Session in 2013', 'Last Session in 2013', '2013 Hours', 'First Session in 2014', 'Last Session in 2014', '2014 Hours', 'First Session in 2015', 'Last Session in 2015', '2015 Hours', 'First Session in 2016', 'Last Session in 2016', '2016 Hours', 'First Session in 2017', 'Last Session in 2017', '2017 Hours', 'First Session in 2018', 'Last Session in 2018', '2018 Hours'].map(function (cell) {
	        return '"' + cell + '"';
	      }).join(',');
	
	      var dict = {
	        C: 'Cannon Hill',
	        H: 'Home',
	        O: 'Online',
	        P: 'Paddington'
	      };
	      var body = students.map(function (student) {
	        var line = [];
	        line.push(student.crmID);
	        line.push(student.state);
	        line.push(student.tuteLocation ? dict[student.tuteLocation] : 'Unset');
	
	        years.forEach(function (year) {
	          line.push(student[String(year)].first || '');
	          line.push(student[String(year)].last || '');
	          line.push(student[String(year)].hours || '');
	        });
	
	        return line.map(function (cell) {
	          return cell ? '"' + cell + '"' : '';
	        }).join(',');
	      }).join('\n');
	
	      this.exportText = header + '\n' + body;
	    }
	  }]);
	
	  return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 57 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n\t<div>\n\t\t<button type=\"button\" class=\"btn btn-primary\" ui-sref=\"reports.studentHrs\">\n\t\t\t<span>Student Hours</span>\n\t\t</button>\n\t\t<button type=\"button\" class=\"btn btn-primary\" ui-sref=\"reports.studentOverview\">\n\t\t\t<span>Student Overview</span>\n\t\t</button>\n\t\t<button type=\"button\" class=\"btn btn-primary\" ui-sref=\"reports.tutorHrs\">\n\t\t\t<span>Tutor Hours</span>\n\t\t</button>\n\t\t<button type=\"button\" class=\"btn btn-primary\" ui-sref=\"reports.tutorCount\">\n\t\t\t<span>Tutor Count by State</span>\n\t\t</button>\n\t\t<button type=\"button\" class=\"btn btn-primary\" ui-sref=\"reports.totalHrsWeek\">\n\t\t\t<span>Total Hours By Week</span>\n\t\t</button>\n\t\t<button type=\"button\" class=\"btn btn-primary\" ui-sref=\"reports.totalHrsRange\">\n\t\t\t<span>Total Hours Per Tutor</span>\n\t\t</button>\n\t\t<button type=\"button\" class=\"btn btn-primary\" ui-sref=\"reports.totalHrs\">\n\t\t\t<span>Total Hours by State and Year</span>\n\t\t</button>\n\t</div>\n\t<div ui-view>\n\t</div>\n</div>"

/***/ }),
/* 58 */
/***/ (function(module, exports) {

	module.exports = "<div>\n\t<hr>\n\t<div class=\"row\">\n\t\t<div class=\"col-sm-4\">\n\t\t\t<label>Student Name</label><br>\n\t\t\t<ui-select multiple ng-model=\"vm.selected\">\n\t\t\t    <ui-select-match>\n\t\t\t        <span>{{$item.nameFirst}} {{$item.nameLast}} - {{$item.crmID || 'No CRM'}}</span>\n\t\t\t    </ui-select-match>\n\t\t\t    <ui-select-choices repeat=\"entity in (vm.students | filter: {fullName: $select.search}) | limitTo: ($select.search.length <= 2) ? 0 : undefined track by entity._id\">\n\t\t\t        <span>{{entity.nameFirst}} {{entity.nameLast}} - {{entity.crmID || 'No CRM'}}</span>\n\t\t\t    </ui-select-choices>\n\t\t\t</ui-select>\n\t\t</div>\n\t\t<div class=\"col-sm-2\">\n\t\t\t<label>Start Date</label>\n\t\t\t<div class=\"input-group\">\n\t          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"vm.startDate\" is-open=\"startOpened\"  close-text=\"Close\" datepicker-options=\"{showWeeks: false}\" />\n\t          <span class=\"input-group-btn\">\n\t            <button type=\"button\" class=\"btn btn-default\" ng-click=\"startOpened = true\">\n\t            \t<i class=\"glyphicon glyphicon-calendar\"></i>\n\t            </button>\n\t          </span>\n\t        </div>\n\t\t</div>\n\t\t<div class=\"col-sm-2\">\n\t\t\t<label>End Date</label>\n\t\t\t<div class=\"input-group\">\n\t          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"vm.endDate\" is-open=\"endOpened\"  close-text=\"Close\" datepicker-options=\"{showWeeks: false}\" />\n\t          <span class=\"input-group-btn\">\n\t            <button type=\"button\" class=\"btn btn-default\" ng-click=\"endOpened = true\">\n\t            \t<i class=\"glyphicon glyphicon-calendar\"></i>\n\t            </button>\n\t          </span>\n\t        </div>\n\t\t</div>\n\t\t<div class=\"col-sm-4 text-right\">\n\t\t\t<button type=\"button\" ng-disabled=\"!vm.filteredTimesheets.length\" ng-click=\"vm.createPDF()\" class=\"btn m-l-sm btn-success m-t-lg\">\n\t\t\t\t<span>Export to PDF</span>\n\t\t\t</button>\n\t\t\t<button type=\"button\" ng-disabled=\"!vm.filteredTimesheets.length\" ng-click=\"vm.createCSV()\" class=\"btn m-l-sm btn-success m-t-lg\">\n\t\t\t\t<span>Export to CSV</span>\n\t\t\t</button>\n\t\t\t<button type=\"button\" ng-disabled=\"!vm.selected || !vm.selected.length\" ng-click=\"vm.create()\" class=\"btn m-l-sm btn-success m-t-lg\">\n\t\t\t\t<span>Create</span>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\t<hr>\n\t<table class=\"table\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Tutor</th>\n\t\t\t\t<th>Week Ending Date</th>\n\t\t\t\t<th>Hours</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr ng-repeat=\"timesheet in vm.filteredTimesheets\" ng-class=\"{'is-odd': timesheet.isOdd}\">\n\t\t\t\t<td>{{vm.tutorName(timesheet.tutorID)}}</td>\n\t\t\t\t<td>{{timesheet.weekEnding}}</td>\n\t\t\t\t<td>{{timesheet.hours}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<th></th>\n\t\t\t\t<th>Total Hours</th>\n\t\t\t\t<th>{{vm.total}}\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>"

/***/ }),
/* 59 */
/***/ (function(module, exports) {

	module.exports = "<div>\n\t<hr>\n\t<div class=\"row\">\n\t\t<div class=\"col-sm-4\">\n\t\t\t<label>Tutor Name</label><br>\n\t\t\t<ui-select ng-model=\"vm.selected\">\n\t\t\t    <ui-select-match>\n\t\t\t        <span>{{vm.selected.nameFirst}} {{vm.selected.nameLast}} - {{vm.selected.crmID || 'No CRM'}}</span>\n\t\t\t    </ui-select-match>\n\t\t\t    <ui-select-choices repeat=\"entity in (vm.tutors | filter: {fullName: $select.search}) track by entity._id\">\n\t\t\t        <span>{{entity.nameFirst}} {{entity.nameLast}} - {{entity.crmID || 'No CRM'}}</span>\n\t\t\t    </ui-select-choices>\n\t\t\t</ui-select>\n\t\t</div>\n\t\t<div class=\"col-sm-2\">\n\t\t\t<label>Start Date</label>\n\t\t\t<div class=\"input-group\">\n\t          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"vm.startDate\" is-open=\"startOpened\"  close-text=\"Close\" datepicker-options=\"{showWeeks: false}\" />\n\t          <span class=\"input-group-btn\">\n\t            <button type=\"button\" class=\"btn btn-default\" ng-click=\"startOpened = true\">\n\t            \t<i class=\"glyphicon glyphicon-calendar\"></i>\n\t            </button>\n\t          </span>\n\t        </div>\n\t\t</div>\n\t\t<div class=\"col-sm-2\">\n\t\t\t<label>End Date</label>\n\t\t\t<div class=\"input-group\">\n\t          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"vm.endDate\" is-open=\"endOpened\"  close-text=\"Close\" datepicker-options=\"{showWeeks: false}\" />\n\t          <span class=\"input-group-btn\">\n\t            <button type=\"button\" class=\"btn btn-default\" ng-click=\"endOpened = true\">\n\t            \t<i class=\"glyphicon glyphicon-calendar\"></i>\n\t            </button>\n\t          </span>\n\t        </div>\n\t\t</div>\n\t\t<div class=\"col-sm-4 text-right\">\n\t\t\t<button type=\"button\" ng-disabled=\"!vm.filteredTimesheets.length\" ng-click=\"vm.createCSV(vm.filteredTimesheets)\" class=\"btn m-l-sm btn-success m-t-lg\">\n\t\t\t\t<span>Export to CSV</span>\n\t\t\t</button>\n\t\t\t<button type=\"button\" ng-disabled=\"!vm.selected\" ng-click=\"vm.create()\" class=\"btn m-l-sm btn-success m-t-lg\">\n\t\t\t\t<span>Create</span>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\t<hr>\n\t<table class=\"table table-striped\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Student</th>\n\t\t\t\t<th>Week Ending Date</th>\n\t\t\t\t<th>Hours</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr ng-repeat=\"timesheet in vm.filteredTimesheets\">\n\t\t\t\t<td>{{vm.studentName(timesheet.studentID)}}</td>\n\t\t\t\t<td>{{timesheet.weekEnding}}</td>\n\t\t\t\t<td>{{timesheet.hours}}</td>\n\t\t\t</tr>\n\t\t\t<tr>\n\t\t\t\t<th></th>\n\t\t\t\t<th>Total Hours</th>\n\t\t\t\t<th>{{vm.total}}</th>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>"

/***/ }),
/* 60 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"flex v-center h-center\" style=\"height: 80vh\" ng-hide=\"vm.loaded\">\n\t<div class=\"spinner\"></div>\n</div>\n<div ng-if=\"vm.loaded\">\n\t<hr>\n\t<button type=\"button\" ng-click=\"vm.createCSV()\" class=\"btn btn-success m-b-lg\">\n\t\t<span>Export to CSV</span>\n\t</button>\n\t<table class=\"table table-striped\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Year</th>\n\t\t\t\t<th>State</th>\n\t\t\t\t<th>Count</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr ng-repeat=\"count in vm.counts\">\n\t\t\t\t<td>{{count.year}}</td>\n\t\t\t\t<td>{{count.state.toUpperCase()}}</td>\n\t\t\t\t<td>{{count.count}}</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>"

/***/ }),
/* 61 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"flex v-center h-center\" style=\"height: 80vh\" ng-hide=\"vm.loaded\">\n\t<div class=\"spinner\"></div>\n</div>\n<div ng-if=\"vm.loaded\">\n\t<hr>\n\t<div class=\"row\">\n\t\t<div class=\"col-sm-3\">\n\t\t\t<label>Start Date</label>\n\t\t\t<div class=\"input-group\">\n\t          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"vm.startDate\" is-open=\"startOpened\"  close-text=\"Close\" datepicker-options=\"{showWeeks: false}\" />\n\t          <span class=\"input-group-btn\">\n\t            <button type=\"button\" class=\"btn btn-default\" ng-click=\"startOpened = true\">\n\t            \t<i class=\"glyphicon glyphicon-calendar\"></i>\n\t            </button>\n\t          </span>\n\t        </div>\n\t\t</div>\n\t\t<div class=\"col-sm-3\">\n\t\t\t<label>End Date</label>\n\t\t\t<div class=\"input-group\">\n\t          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"vm.endDate\" is-open=\"endOpened\"  close-text=\"Close\" datepicker-options=\"{showWeeks: false}\" />\n\t          <span class=\"input-group-btn\">\n\t            <button type=\"button\" class=\"btn btn-default\" ng-click=\"endOpened = true\">\n\t            \t<i class=\"glyphicon glyphicon-calendar\"></i>\n\t            </button>\n\t          </span>\n\t        </div>\n\t\t</div>\n\t\t<div class=\"col-sm-6 text-right\">\n\t\t\t<button type=\"button\" ng-click=\"vm.createCSV(vm.filteredTimesheets)\" class=\"btn btn-success m-t-lg\">\n\t\t\t\t<span>Export to CSV</span>\n\t\t\t</button>\n\t\t\t<button type=\"button\" ng-click=\"vm.create()\" class=\"btn btn-success m-t-lg m-l-sm\">\n\t\t\t\t<span>Create</span>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\t<hr>\n\t<table class=\"table table-striped\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Tutor</th>\n\t\t\t\t<th>Hours</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr ng-repeat=\"timesheet in vm.filteredTimesheets\">\n\t\t\t\t<td>{{timesheet.tutorName}}</td>\n\t\t\t\t<td>{{timesheet.hours}}</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>"

/***/ }),
/* 62 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"flex v-center h-center\" style=\"height: 80vh\" ng-hide=\"vm.loaded\">\n\t<div class=\"spinner\"></div>\n</div>\n<div ng-if=\"vm.loaded\">\n\t<hr>\n\t<div class=\"row\">\n\t\t<div class=\"col-sm-3\">\n\t\t\t<label>Start Date</label>\n\t\t\t<div class=\"input-group\">\n\t          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"vm.startDate\" is-open=\"startOpened\"  close-text=\"Close\" datepicker-options=\"{showWeeks: false}\" />\n\t          <span class=\"input-group-btn\">\n\t            <button type=\"button\" class=\"btn btn-default\" ng-click=\"startOpened = true\">\n\t            \t<i class=\"glyphicon glyphicon-calendar\"></i>\n\t            </button>\n\t          </span>\n\t        </div>\n\t\t</div>\n\t\t<div class=\"col-sm-3\">\n\t\t\t<label>End Date</label>\n\t\t\t<div class=\"input-group\">\n\t          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"vm.endDate\" is-open=\"endOpened\"  close-text=\"Close\" datepicker-options=\"{showWeeks: false}\" />\n\t          <span class=\"input-group-btn\">\n\t            <button type=\"button\" class=\"btn btn-default\" ng-click=\"endOpened = true\">\n\t            \t<i class=\"glyphicon glyphicon-calendar\"></i>\n\t            </button>\n\t          </span>\n\t        </div>\n\t\t</div>\n\t\t<div class=\"col-sm-6 text-right\">\n\t\t\t<button type=\"button\" ng-click=\"vm.createCSV(vm.filteredTimesheets)\" class=\"btn m-l-sm btn-success m-t-lg\">\n\t\t\t\t<span>Export to CSV</span>\n\t\t\t</button>\n\t\t\t<button type=\"button\" ng-click=\"vm.create()\" class=\"btn m-l-sm btn-success m-t-lg\">\n\t\t\t\t<span>Create</span>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\t<hr>\n\t<table class=\"table table-striped\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Week Ending</th>\n\t\t\t\t<th>Hours</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr ng-repeat=\"timesheet in vm.filteredTimesheets\">\n\t\t\t\t<td>{{timesheet.weekEnding}}</td>\n\t\t\t\t<td>{{timesheet.hours}}</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>"

/***/ }),
/* 63 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"flex v-center h-center\" style=\"height: 80vh\" ng-hide=\"vm.loaded\">\n\t<div class=\"spinner\"></div>\n</div>\n<div ng-if=\"vm.loaded\">\n\t<hr>\n\t<button type=\"button\" ng-click=\"vm.createCSV()\" class=\"btn btn-success m-b-lg\">\n\t\t<span>Export to CSV</span>\n\t</button>\n\t<table class=\"table table-striped\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>State</th>\n\t\t\t\t<th>Count</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr ng-repeat=\"count in vm.counts\">\n\t\t\t\t<td>{{count.state.toUpperCase()}}</td>\n\t\t\t\t<td>{{count.count}}</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n</div>"

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	module.exports = "<div>\n\t<hr>\n    <div class=\"text-right\">\n        <button type=\"button\" ng-disabled=\"vm.loading === true\" ng-click=\"vm.export()\" class=\"btn m-l-sm btn-success m-t-lg\">\n            <span>Export</span>\n        </button>\n    </div>\n</div>"

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _timesheets = __webpack_require__(66);
	
	var _timesheets2 = _interopRequireDefault(_timesheets);
	
	var _timesheets3 = __webpack_require__(68);
	
	var _timesheets4 = _interopRequireDefault(_timesheets3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('accessApp.timesheets', ['accessApp.auth', 'ui.router']).config(_timesheets2.default).controller('TimesheetsController', _timesheets4.default).name;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('timesheets', {
	    url: '/timesheets',
	    template: __webpack_require__(67),
	    controller: 'TimesheetsController',
	    controllerAs: 'vm'
	  });
	}

/***/ }),
/* 67 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n\t<div>\n\t\t<h3>Process Timesheets</h3>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-12\">\n\t\t\t\t<div class=\"row\">\n\t\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t<div class=\"input-group only-sundays\">\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" ng-change=\"vm.addDays(); vm.loadData(null, false)\"\n\t\t\t\t\t\t\t\tuib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"vm.date\" is-open=\"opened\" ng-required=\"true\"\n\t\t\t\t\t\t\t\tclose-text=\"Close\" datepicker-options=\"{showWeeks: false}\" />\n\t\t\t\t\t\t\t<span class=\"input-group-btn\">\n\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-click=\"opened = true; vm.loadData(null, false)\">\n\t\t\t\t\t\t\t\t\t<i class=\"glyphicon glyphicon-calendar\"></i>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.addDays(-7); vm.loadData(null, false)\"\n\t\t\t\t\t\t\t\t\tng-disabled=\"!vm.date\">\n\t\t\t\t\t\t\t\t\t<i class=\"fa fa-arrow-left\"></i>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-default\" ng-click=\"vm.addDays(7); vm.loadData(null, false)\"\n\t\t\t\t\t\t\t\t\tng-disabled=\"!vm.date\">\n\t\t\t\t\t\t\t\t\t<i class=\"fa fa-arrow-right\"></i>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"col-md-8\">\n\t\t\t\t\t\t<div class=\"flex child-stretch\">\n\t\t\t\t\t\t\t<ui-select ng-model=\"vm.selected\" ng-change=\"vm.loadData(null, true)\">\n\t\t\t\t\t\t\t\t<ui-select-match>\n\t\t\t\t\t\t\t\t\t<span>{{vm.selected.nameFirst}} {{vm.selected.nameLast}} -\n\t\t\t\t\t\t\t\t\t\t{{vm.selected.crmID || 'No CRM'}}</span>\n\t\t\t\t\t\t\t\t</ui-select-match>\n\t\t\t\t\t\t\t\t<ui-select-choices\n\t\t\t\t\t\t\t\t\trepeat=\"tutor in (vm.tutors | filter: {fullName: $select.search}) track by tutor._id\">\n\t\t\t\t\t\t\t\t\t<span>{{tutor.nameFirst}} {{tutor.nameLast}} - {{tutor.crmID || 'No CRM'}}</span>\n\t\t\t\t\t\t\t\t</ui-select-choices>\n\t\t\t\t\t\t\t</ui-select>\n\t\t\t\t\t\t\t<button class=\"btn btn-primary no-stretch m-l-sm\" type=\"button\" ng-click=\"vm.createTutor()\">\n\t\t\t\t\t\t\t\t<span>Create Tutor</span>\n\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"m-t-sm flex h-separate\">\n\t\t\t\t\t<div>\n\n\t\t\t\t\t</div>\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!vm.date\"\n\t\t\t\t\t\t\tng-click=\"vm.deputyImport()\">\n\t\t\t\t\t\t\t<span>Deputy Import</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!vm.selected || !vm.date\"\n\t\t\t\t\t\t\tng-click=\"vm.loadPresets()\">\n\t\t\t\t\t\t\t<span>Load Students</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!vm.selected\"\n\t\t\t\t\t\t\tng-click=\"vm.editTutor(vm.selected._id)\">\n\t\t\t\t\t\t\t<span>Edit Tutor</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!vm.selected\"\n\t\t\t\t\t\t\tng-click=\"vm.openPresets(vm.selected._id)\">\n\t\t\t\t\t\t\t<span>Edit Students</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button class=\"btn btn-primary\" type=\"button\" ng-disabled=\"!vm.selected || !vm.date\"\n\t\t\t\t\t\t\tng-click=\"vm.createStudent()\">\n\t\t\t\t\t\t\t<span>Add Student</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<hr>\n\t\t\t\t<table class=\"table table-striped\">\n\t\t\t\t\t<thead>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<th>Student Name</th>\n\t\t\t\t\t\t\t<th>Hours</th>\n\t\t\t\t\t\t\t<th style=\"width:111px\">Rate Type</th>\n\t\t\t\t\t\t\t<th>Processed</th>\n\t\t\t\t\t\t\t<th>Saved</th>\n\t\t\t\t\t\t\t<th>Actions</th>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</thead>\n\t\t\t\t\t<tbody>\n\t\t\t\t\t\t<tr ng-repeat=\"timesheet in vm.filteredTimesheets()\">\n\t\t\t\t\t\t\t<td style=\"width: 400px\">\n\t\t\t\t\t\t\t\t<input disabled type=\"text\" class=\"form-control\"\n\t\t\t\t\t\t\t\t\tvalue=\"{{vm.getStudentName(timesheet.studentID)}}\">\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t<td>\n\t\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" ng-model=\"timesheet.hours\" ng-change=\"\n\t\t\t\t\t\t\t\t$root.changesToBeSaved = true;\n\t\t\t\t\t\t\t\ttimesheet.requiresSave = true;\">\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t<td style=\"width:111px\">\n\t\t\t\t\t\t\t\t<select class=\"form-control\" ng-change=\"\n\t\t\t\t\t\t\t\t$root.changesToBeSaved = true;\n\t\t\t\t\t\t\t\ttimesheet.requiresSave = true;\" ng-model=\"timesheet.rateType\">\n\t\t\t\t\t\t\t\t\t<option ng-repeat=\"rateType in vm.rateTypes\" ng-value=\"rateType\">{{rateType}}\n\t\t\t\t\t\t\t\t\t</option>\n\t\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\t<td style=\"line-height: 32px; font-weight: 700;\">\n\t\t\t\t\t\t\t\t{{timesheet.isProcessed ? 'TRUE' : 'FALSE'}}</td>\n\t\t\t\t\t\t\t<td style=\"line-height: 32px;font-weight: 700;\">\n\t\t\t\t\t\t\t\t{{timesheet.requiresSave ? 'FALSE' : 'TRUE'}}</td>\n\t\t\t\t\t\t\t<td style=\"width: 190px\">\n\t\t\t\t\t\t\t\t<button type=\"button\" ng-click=\"vm.editStudent(timesheet.studentID)\"\n\t\t\t\t\t\t\t\t\tng-disabled=\"!timesheet.studentID\" class=\"btn btn-primary\">\n\t\t\t\t\t\t\t\t\t<span>Edit Student</span>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t\t<button type=\"button\" ng-click=\"vm.delete(timesheet)\" class=\"btn btn-danger\">\n\t\t\t\t\t\t\t\t\t<span>Delete</span>\n\t\t\t\t\t\t\t\t</button>\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t<th>Total Hours</th>\n\t\t\t\t\t\t\t<th>{{vm.total}}</th>\n\t\t\t\t\t\t\t<th colspan=\"4\"></th>\n\t\t\t\t\t\t</tr>\n\t\t\t\t\t</tbody>\n\t\t\t\t</table>\n\t\t\t\t<hr>\n\t\t\t\t<div class=\"text-right\">\n\t\t\t\t\t<button type=\"submit\" class=\"btn btn-success btn-lg\" ng-disabled=\"!vm.date || !vm.selected\"\n\t\t\t\t\t\tng-click=\"vm.saveTimesheets(vm.filteredTimesheets())\">\n\t\t\t\t\t\t<span>Save Timesheet</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<hr>\n\t\t\t\t<div>\n\t\t\t\t\t<textarea class=\"form-control\" style=\"margin-bottom: 30px\" rows=\"4\" ng-if=\"vm.selected\"\n\t\t\t\t\t\tng-model=\"vm.selected.notes\" ng-blur=\"vm.saveNotes()\" placeholder=\"Tutor notes\"></textarea>\n\t\t\t\t</div>\n\t\t\t\t<div ng-if=\"vm.errors.length\" class=\"alert alert-danger\">\n\t\t\t\t\t<ul>\n\t\t\t\t\t\t<li ng-repeat=\"error in vm.errors\">{{error}}</li>\n\t\t\t\t\t</ul>\n\t\t\t\t\t<hr>\n\t\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.errors = []\">\n\t\t\t\t\t\t<span>Dismiss</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>"

/***/ }),
/* 68 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var toDateString = function toDateString(value) {
	  var result = new Date(value);
	  var dd = result.getDate();
	  var mm = result.getMonth() + 1;
	
	  var yyyy = result.getFullYear();
	
	  var today = dd + '/' + mm + '/' + yyyy;
	  return today;
	};
	
	var TimesheetsController = function () {
	  /*@ngInject*/
	  TimesheetsController.$inject = ['$http', '$rootScope', 'EditPresetsFactory', 'CreateStudentFactory', 'CreateTutorFactory', 'EditTutorFactory', 'EditStudentFactory', 'DeputyImportFactory'];
	  function TimesheetsController($http, $rootScope, EditPresetsFactory, CreateStudentFactory, CreateTutorFactory, EditTutorFactory, EditStudentFactory, DeputyImportFactory) {
	    _classCallCheck(this, TimesheetsController);
	
	    this.$http = $http;
	    this.$rootScope = $rootScope;
	    this.students = [];
	    this.tutors = [];
	    this.timesheets = [];
	    this.loaded = false;
	    this.EditPresetsFactory = EditPresetsFactory;
	    this.EditStudentFactory = EditStudentFactory;
	    this.CreateStudentFactory = CreateStudentFactory;
	    this.DeputyImportFactory = DeputyImportFactory;
	    this.CreateTutorFactory = CreateTutorFactory;
	    this.EditTutorFactory = EditTutorFactory;
	    this.rateTypes = ['B', '1', '2'];
	    this.total = 0;
	    this.errors = [];
	    this.deputySheets = [];
	    this.loadsRequired = 0;
	  }
	
	  _createClass(TimesheetsController, [{
	    key: '$onInit',
	    value: function $onInit() {
	      var today = new Date();
	      var todayDay = new Date(today.getFullYear(), today.getMonth(), today.getDate());
	      this.date = new Date(todayDay.setDate(todayDay.getDate() - todayDay.getDay()));
	      this.loadDate();
	      this.loadData(true);
	    }
	  }, {
	    key: 'addDays',
	    value: function addDays(days) {
	      this.deputySheets = [];
	
	      if (this.selected && this.selected.tutorID) {
	        this.saveTimesheets(this.timesheets);
	      }
	
	      if (typeof days === 'number') {
	        this.date = new Date(this.date.getTime() + days * 86400000);
	      }
	    }
	  }, {
	    key: 'loadStudents',
	    value: function loadStudents() {
	      var _this = this;
	
	      this.$http.get('/api/students').then(function (res) {
	        _this.students = res.data;
	        _this.students = _this.students.map(function (student) {
	          student.fullName = student.nameFirst + ' ' + student.nameLast;
	          return student;
	        });
	      });
	    }
	  }, {
	    key: 'intLoadPresets',
	    value: function intLoadPresets() {
	      var _this2 = this;
	
	      this.$http.get('/api/presets').then(function (res) {
	        _this2.presets = res.data || [];
	      });
	    }
	  }, {
	    key: 'loadTutors',
	    value: function loadTutors() {
	      var _this3 = this;
	
	      this.$http.get('/api/tutors/active').then(function (res) {
	        _this3.tutors = res.data.map(function (tutor) {
	          tutor.fullName = tutor.nameFirst + ' ' + tutor.nameLast;
	          return tutor;
	        });
	        _this3.loaded = true;
	      });
	    }
	  }, {
	    key: 'loadDate',
	    value: function loadDate() {
	      var dateString = this.date.toLocaleDateString();
	      var month = dateString.split('/')[1];
	      var day = dateString.split('/')[0];
	      var year = dateString.split('/')[2];
	      if (parseInt(month.charAt(0)) === 0) {
	        month = month.substring(1);
	      }
	      if (parseInt(day.charAt(0)) === 0) {
	        day = day.substring(1);
	      }
	      this.weekEnding = day + '/' + month + '/' + year;
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData(initialLoad, tutorChange, presetChange) {
	      var _this4 = this;
	
	      console.log('initial load...');
	
	      if (presetChange) {
	        return this.intLoadPresets();
	      }
	
	      this.loadDate();
	
	      if (tutorChange) {
	        this.loadStudents();
	        this.saveTimesheets(this.timesheets, true);
	        this.$http.get('/api/timesheets/tutor-id/' + this.selected.tutorID, { params: { weekEnding: this.weekEnding } }).then(function (res) {
	          console.log(res);
	          if (_this4.deputySheets.length) {
	            var specSheets = _this4.deputySheets.filter(function (d) {
	              return d.tutorID === _this4.selected.tutorID;
	            });
	
	            _this4.deputySheets = [].concat(_toConsumableArray(_this4.deputySheets.filter(function (d) {
	              return d.tutorID !== _this4.selected.tutorID;
	            })));
	            var tutorSheets = res.data || [];
	
	            if (tutorSheets.length) {
	              tutorSheets = tutorSheets.map(function (t) {
	                var addition = specSheets.find(function (s) {
	                  return s.studentID === t.studentID && t.weekEnding === toDateString(_this4.date) && s.rateType === t.rateType;
	                });
	
	                if (addition) {
	                  t.hours += addition.hours;
	                  return t;
	                }
	
	                return t;
	              });
	            }
	
	            return _this4.timesheets = [].concat(_toConsumableArray(tutorSheets), _toConsumableArray(specSheets));
	          }
	          _this4.timesheets = res.data;
	        });
	        return;
	      };
	
	      this.loadStudents();
	
	      this.loadTutors();
	
	      this.intLoadPresets();
	
	      if (this.selected && this.selected.tutorID) {
	        this.$http.get('/api/timesheets/tutor-id/' + this.selected.tutorID, { params: { weekEnding: this.weekEnding } }).then(function (res) {
	          _this4.timesheets = res.data;
	        });
	      }
	
	      if (initialLoad) {
	        this.$http.get('/api/timesheets/is-unprocessed').then(function (res) {
	          if (res.data.unprocessedExist) {
	            alert('Unprocessed timesheets exist.');
	          }
	        });
	      }
	    }
	  }, {
	    key: 'filteredTimesheets',
	    value: function filteredTimesheets() {
	      var _this5 = this;
	
	      if (!this.date || !this.selected) {
	        return [];
	      }
	
	      var filteredTimesheets = this.timesheets.filter(function (timesheet) {
	        var datesMatch = timesheet.weekEnding === toDateString(_this5.date);
	        var tutorsMatch = timesheet.tutorID === _this5.selected.tutorID;
	
	        return datesMatch && tutorsMatch;
	      });
	
	      this.total = filteredTimesheets.reduce(function (accumulator, currentValue) {
	        return accumulator + +currentValue.hours;
	      }, 0);
	
	      return filteredTimesheets;
	    }
	  }, {
	    key: 'deputyImport',
	    value: function deputyImport() {
	      var _this6 = this;
	
	      this.DeputyImportFactory().then(function (data) {
	        _this6.deputySheets = [];
	        var sheets = data.data;
	        var errors = [];
	
	        sheets.forEach(function (sheet) {
	
	          if (typeof sheet['Location Code'] !== 'number') {
	            return;
	          }
	
	          var tutor = _this6.tutors.find(function (t) {
	            return Number(t.crmID) === sheet['Employee Export Code'];
	          });
	
	          if (!tutor) {
	            return errors.push('Tutor with the name ' + sheet['Employee Name'] + ' and code ' + sheet['Employee Export Code'] + ' not found.');
	          }
	
	          var students = _this6.students.filter(function (s) {
	            return Number(s.crmID) === sheet['Location Code'];
	          });
	
	          if (students.length === 0) {
	            return errors.push('The student ID ' + sheet['Location Code'] + ' was not found in the database (' + sheet['Location Name'] + ')');
	          }
	
	          if (students.length > 1) {
	            errors.push('Multiple students found for ' + sheet['Location Code'] + ' (' + sheet['Location Name'] + ')');
	          }
	
	          var _preset = {
	            tutorID: tutor.tutorID,
	            weekEnding: toDateString(_this6.date),
	            studentID: students[0].studentID,
	            hours: sheet['Total Hours'],
	            rateType: 'B',
	            requiresSave: true
	          };
	
	          _this6.$rootScope.changesToBeSaved = true;
	
	          _this6.deputySheets.push(_preset);
	        });
	
	        _this6.errors = [].concat(_toConsumableArray(new Set(errors)));
	
	        if (_this6.selected && _this6.deputySheets.length) {
	          var specSheets = _this6.deputySheets.filter(function (d) {
	            return d.tutorID === _this6.selected.tutorID;
	          });
	          console.log(specSheets, 'specSheets');
	
	          if (!specSheets.length) {
	            return;
	          }
	
	          _this6.deputySheets = _this6.deputySheets.filter(function (d) {
	            return d.tutorID !== _this6.selected.tutorID;
	          });
	          _this6.timesheets = _this6.timesheets || [];
	
	          specSheets.forEach(function (s) {
	            var existing = _this6.timesheets.findIndex(function (t) {
	              return s.studentID === t.studentID && t.weekEnding === s.weekEnding && s.rateType === t.rateType;
	            });
	
	            if (~existing) {
	              _this6.timesheets[existing].hours += s.hours;
	            } else {
	              _this6.timesheets.push(s);
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'editStudent',
	    value: function editStudent(studentID) {
	      this.EditStudentFactory(studentID);
	    }
	  }, {
	    key: 'editTutor',
	    value: function editTutor(selectedID) {
	      this.EditTutorFactory(selectedID);
	    }
	  }, {
	    key: 'reduceLoadsRequired',
	    value: function reduceLoadsRequired() {
	      this.loadsRequired -= 1;
	
	      if (this.loadsRequired === 0) {
	        this.loadData();
	      };
	    }
	  }, {
	    key: 'saveTimesheets',
	    value: function saveTimesheets(timesheets, preventReloadAfter) {
	      var _this7 = this;
	
	      this.$rootScope.changesToBeSaved = false;
	
	      this.loadsRequired = 0;
	
	      timesheets.forEach(function (timesheet) {
	
	        if (!timesheet.requiresSave) {
	          return;
	        }
	
	        if (!timesheet.hours || +timesheet.hours < 0) {
	          console.log('alert');
	          return alert('Invalid hours.');
	        }
	
	        _this7.loadsRequired += 1;
	
	        timesheet.requiresSave = false;
	
	        if (timesheet._id) {
	          _this7.$http.put('/api/timesheets/' + timesheet._id, timesheet).then(function (res) {
	            if (preventReloadAfter !== true) {
	              _this7.reduceLoadsRequired();
	            }
	          });
	        } else {
	          _this7.$http.post('/api/timesheets', timesheet).then(function (res) {
	            if (preventReloadAfter !== true) {
	              _this7.reduceLoadsRequired();
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'openPresets',
	    value: function openPresets(tutorID) {
	      var _this8 = this;
	
	      if (!tutorID) {
	        return alert('No tutor selected.');
	      };
	
	      this.EditPresetsFactory(tutorID).then(function (res) {
	        return _this8.loadData(null, null, true);
	      });
	    }
	  }, {
	    key: 'saveNotes',
	    value: function saveNotes() {
	      this.$http.put('/api/tutors/' + this.selected._id, this.selected);
	    }
	  }, {
	    key: 'loadPresets',
	    value: function loadPresets() {
	      var _this9 = this;
	
	      console.log('loading presets...');
	
	      this.selected = this.tutors.find(function (tutor) {
	        return tutor._id === _this9.selected._id;
	      });
	
	      var presets = this.presets.filter(function (preset) {
	        return _this9.selected.tutorID === preset.tutorID;
	      });
	
	      if (presets.length === 0) {
	        return alert('This tutor has no presets.');
	      }
	
	      var orderedPresets = presets.sort(function (a, b) {
	        var aName = _this9.getStudentName(a.studentID).toUpperCase();
	        var bName = _this9.getStudentName(b.studentID).toUpperCase();
	
	        if (aName < bName) {
	          return -1;
	        }
	
	        if (aName > bName) {
	          return 1;
	        }
	
	        return 0;
	      });
	
	      orderedPresets.forEach(function (preset) {
	        var _preset = {
	          tutorID: _this9.selected.tutorID,
	          weekEnding: toDateString(_this9.date),
	          studentID: preset.studentID,
	          hours: preset.hours,
	          rateType: preset.rateType,
	          requiresSave: true
	        };
	
	        _this9.$rootScope.changesToBeSaved = true;
	
	        var duplicateIndex = _this9.timesheets.findIndex(function (t) {
	          return t.studentID === preset.studentID && t.weekEnding === toDateString(_this9.date) && preset.rateType === t.rateType;
	        });
	        console.log(duplicateIndex);
	        if (~duplicateIndex) {
	          console.log('reached duplicate index');
	          _this9.timesheets[duplicateIndex].hours += preset.hours;
	          _this9.timesheets[duplicateIndex].requiresSave = true;
	        } else {
	          _this9.timesheets.push(_preset);
	        }
	      });
	    }
	  }, {
	    key: 'getStudentName',
	    value: function getStudentName(studentID) {
	      var student = this.students.find(function (student) {
	        return student.studentID === studentID;
	      });
	
	      if (!student) {
	        return 'Inactive Student';
	      }
	      return student.nameFirst + ' ' + student.nameLast;
	    }
	  }, {
	    key: 'delete',
	    value: function _delete(item) {
	      if (item._id) {
	        this.$http.delete('/api/timesheets/' + item._id);
	      }
	      this.timesheets.splice(this.timesheets.indexOf(item), 1);
	
	      if (this.$rootScope.changesToBeSaved) {
	        var stillNeedsSave = this.timesheets.some(function (timesheet) {
	          return timesheet.requiresSave;
	        });
	
	        this.$rootScope.changesToBeSaved = stillNeedsSave;
	      }
	    }
	  }, {
	    key: 'createStudent',
	    value: function createStudent() {
	      var _this10 = this;
	
	      this.CreateStudentFactory(this.selected.tutorID).then(function (res) {
	
	        _this10.timesheets.push({
	          weekEnding: toDateString(_this10.date),
	          rateType: 'B',
	          hours: 1,
	          tutorID: _this10.selected.tutorID,
	          requiresSave: true,
	          studentID: res
	        });
	        _this10.loadStudents();
	        _this10.$rootScope.changesToBeSaved = true;
	        _this10.intLoadPresets();
	      });
	    }
	  }, {
	    key: 'createTutor',
	    value: function createTutor() {
	      var _this11 = this;
	
	      this.CreateTutorFactory().then(function (res) {
	        return _this11.loadData();
	      });
	    }
	  }]);
	
	  return TimesheetsController;
	}();
	
	exports.default = TimesheetsController;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NavbarComponent = undefined;
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var NavbarComponent = exports.NavbarComponent = ['Auth', function NavbarComponent(Auth) {
	  'ngInject';
	
	  _classCallCheck(this, NavbarComponent);
	
	  this.menu = [{
	    title: 'Process Timesheets',
	    state: 'timesheets'
	  }, {
	    title: 'Export Timesheets',
	    state: 'process'
	  }, {
	    title: 'Students',
	    state: 'students'
	  }, {
	    title: 'Tutors',
	    state: 'tutors'
	  }, {
	    title: 'Reports',
	    state: 'reports'
	  }];
	  this.isCollapsed = true;
	  this.isLoggedIn = Auth.isLoggedInSync;
	  this.isAdmin = Auth.isAdminSync;
	  this.getCurrentUser = Auth.getCurrentUserSync;
	}];
	
	exports.default = _angular2.default.module('directives.navbar', []).component('navbar', {
	  template: __webpack_require__(70),
	  controller: NavbarComponent
	}).name;

/***/ }),
/* 70 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"navbar navbar-default navbar-static-top\">\n  <div class=\"container\">\n    <div class=\"navbar-header\">\n      <button class=\"navbar-toggle\" type=\"button\" ng-click=\"$ctrl.isCollapsed = !$ctrl.isCollapsed\">\n        <span class=\"sr-only\">Toggle navigation</span>\n        <span class=\"icon-bar\"></span>\n        <span class=\"icon-bar\"></span>\n        <span class=\"icon-bar\"></span>\n      </button>\n      <a href=\"javascript:;\" class=\"navbar-brand w600\">GSPT Sheets</a>\n    </div>\n    <div uib-collapse=\"$ctrl.isCollapsed\" class=\"navbar-collapse collapse\" id=\"navbar-main\">\n      <ul class=\"nav navbar-nav\">\n        <li ng-repeat=\"item in $ctrl.menu\" ui-sref-active=\"active\">\n            <a ui-sref=\"{{item.state}}\">{{item.title}}</a>\n        </li>\n        <!-- <li ng-show=\"$ctrl.isAdmin()\" ui-sref-active=\"active\"><a ui-sref=\"admin\">Admin</a></li> -->\n      </ul>\n\n      <ul class=\"nav navbar-nav navbar-right\">\n      <!--   <li ng-hide=\"$ctrl.isLoggedIn()\" ui-sref-active=\"active\"><a ui-sref=\"signup\">Sign up</a></li> -->\n        <li ng-hide=\"$ctrl.isLoggedIn()\" ui-sref-active=\"active\"><a ui-sref=\"login\">Login</a></li>\n        <li ng-show=\"$ctrl.isLoggedIn()\" ui-sref-active=\"active\"><a ui-sref=\"settings\"><span class=\"glyphicon glyphicon-cog\"></span></a></li>\n        <li ng-show=\"$ctrl.isLoggedIn()\"><a ui-sref=\"logout\">Logout</a></li>\n      </ul>\n    </div>\n  </div>\n</div>\n"

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MainController = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _angularUiRouter = __webpack_require__(9);
	
	var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);
	
	var _main = __webpack_require__(72);
	
	var _main2 = _interopRequireDefault(_main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var MainController = exports.MainController = function () {
	
	  /*@ngInject*/
	  MainController.$inject = ['$http'];
	  function MainController($http) {
	    _classCallCheck(this, MainController);
	
	    this.awesomeThings = [];
	    this.newThing = '';
	
	    this.$http = $http;
	  }
	
	  _createClass(MainController, [{
	    key: '$onInit',
	    value: function $onInit() {}
	  }]);
	
	  return MainController;
	}();
	
	exports.default = _angular2.default.module('accessApp.main', [_angularUiRouter2.default]).config(_main2.default).component('main', {
	  template: __webpack_require__(73),
	  controller: MainController
	}).name;

/***/ }),
/* 72 */
/***/ (function(module, exports) {

	'use strict';
	
	routes.$inject = ['$stateProvider'];
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = routes;
	function routes($stateProvider) {
	  'ngInject';
	
	  $stateProvider.state('main', {
	    url: '/',
	    authenticate: true,
	    template: '<main></main>'
	  });
	}

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = "\n"

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(75);
	module.exports = 'ui.select';


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	/*!
	 * ui-select
	 * http://github.com/angular-ui/ui-select
	 * Version: 0.19.8 - 2017-04-18T05:43:43.673Z
	 * License: MIT
	 */
	
	
	(function () { 
	"use strict";
	var KEY = {
	    TAB: 9,
	    ENTER: 13,
	    ESC: 27,
	    SPACE: 32,
	    LEFT: 37,
	    UP: 38,
	    RIGHT: 39,
	    DOWN: 40,
	    SHIFT: 16,
	    CTRL: 17,
	    ALT: 18,
	    PAGE_UP: 33,
	    PAGE_DOWN: 34,
	    HOME: 36,
	    END: 35,
	    BACKSPACE: 8,
	    DELETE: 46,
	    COMMAND: 91,
	
	    MAP: { 91 : "COMMAND", 8 : "BACKSPACE" , 9 : "TAB" , 13 : "ENTER" , 16 : "SHIFT" , 17 : "CTRL" , 18 : "ALT" , 19 : "PAUSEBREAK" , 20 : "CAPSLOCK" , 27 : "ESC" , 32 : "SPACE" , 33 : "PAGE_UP", 34 : "PAGE_DOWN" , 35 : "END" , 36 : "HOME" , 37 : "LEFT" , 38 : "UP" , 39 : "RIGHT" , 40 : "DOWN" , 43 : "+" , 44 : "PRINTSCREEN" , 45 : "INSERT" , 46 : "DELETE", 48 : "0" , 49 : "1" , 50 : "2" , 51 : "3" , 52 : "4" , 53 : "5" , 54 : "6" , 55 : "7" , 56 : "8" , 57 : "9" , 59 : ";", 61 : "=" , 65 : "A" , 66 : "B" , 67 : "C" , 68 : "D" , 69 : "E" , 70 : "F" , 71 : "G" , 72 : "H" , 73 : "I" , 74 : "J" , 75 : "K" , 76 : "L", 77 : "M" , 78 : "N" , 79 : "O" , 80 : "P" , 81 : "Q" , 82 : "R" , 83 : "S" , 84 : "T" , 85 : "U" , 86 : "V" , 87 : "W" , 88 : "X" , 89 : "Y" , 90 : "Z", 96 : "0" , 97 : "1" , 98 : "2" , 99 : "3" , 100 : "4" , 101 : "5" , 102 : "6" , 103 : "7" , 104 : "8" , 105 : "9", 106 : "*" , 107 : "+" , 109 : "-" , 110 : "." , 111 : "/", 112 : "F1" , 113 : "F2" , 114 : "F3" , 115 : "F4" , 116 : "F5" , 117 : "F6" , 118 : "F7" , 119 : "F8" , 120 : "F9" , 121 : "F10" , 122 : "F11" , 123 : "F12", 144 : "NUMLOCK" , 145 : "SCROLLLOCK" , 186 : ";" , 187 : "=" , 188 : "," , 189 : "-" , 190 : "." , 191 : "/" , 192 : "`" , 219 : "[" , 220 : "\\" , 221 : "]" , 222 : "'"
	    },
	
	    isControl: function (e) {
	        var k = e.which;
	        switch (k) {
	        case KEY.COMMAND:
	        case KEY.SHIFT:
	        case KEY.CTRL:
	        case KEY.ALT:
	            return true;
	        }
	
	        if (e.metaKey || e.ctrlKey || e.altKey) return true;
	
	        return false;
	    },
	    isFunctionKey: function (k) {
	        k = k.which ? k.which : k;
	        return k >= 112 && k <= 123;
	    },
	    isVerticalMovement: function (k){
	      return ~[KEY.UP, KEY.DOWN].indexOf(k);
	    },
	    isHorizontalMovement: function (k){
	      return ~[KEY.LEFT,KEY.RIGHT,KEY.BACKSPACE,KEY.DELETE].indexOf(k);
	    },
	    toSeparator: function (k) {
	      var sep = {ENTER:"\n",TAB:"\t",SPACE:" "}[k];
	      if (sep) return sep;
	      // return undefined for special keys other than enter, tab or space.
	      // no way to use them to cut strings.
	      return KEY[k] ? undefined : k;
	    }
	  };
	
	function isNil(value) {
	  return angular.isUndefined(value) || value === null;
	}
	
	/**
	 * Add querySelectorAll() to jqLite.
	 *
	 * jqLite find() is limited to lookups by tag name.
	 * TODO This will change with future versions of AngularJS, to be removed when this happens
	 *
	 * See jqLite.find - why not use querySelectorAll? https://github.com/angular/angular.js/issues/3586
	 * See feat(jqLite): use querySelectorAll instead of getElementsByTagName in jqLite.find https://github.com/angular/angular.js/pull/3598
	 */
	if (angular.element.prototype.querySelectorAll === undefined) {
	  angular.element.prototype.querySelectorAll = function(selector) {
	    return angular.element(this[0].querySelectorAll(selector));
	  };
	}
	
	/**
	 * Add closest() to jqLite.
	 */
	if (angular.element.prototype.closest === undefined) {
	  angular.element.prototype.closest = function( selector) {
	    var elem = this[0];
	    var matchesSelector = elem.matches || elem.webkitMatchesSelector || elem.mozMatchesSelector || elem.msMatchesSelector;
	
	    while (elem) {
	      if (matchesSelector.bind(elem)(selector)) {
	        return elem;
	      } else {
	        elem = elem.parentElement;
	      }
	    }
	    return false;
	  };
	}
	
	var latestId = 0;
	
	var uis = angular.module('ui.select', [])
	
	.constant('uiSelectConfig', {
	  theme: 'bootstrap',
	  searchEnabled: true,
	  sortable: false,
	  placeholder: '', // Empty by default, like HTML tag <select>
	  refreshDelay: 1000, // In milliseconds
	  closeOnSelect: true,
	  skipFocusser: false,
	  dropdownPosition: 'auto',
	  removeSelected: true,
	  resetSearchInput: true,
	  generateId: function() {
	    return latestId++;
	  },
	  appendToBody: false,
	  spinnerEnabled: false,
	  spinnerClass: 'glyphicon glyphicon-refresh ui-select-spin',
	  backspaceReset: true
	})
	
	// See Rename minErr and make it accessible from outside https://github.com/angular/angular.js/issues/6913
	.service('uiSelectMinErr', function() {
	  var minErr = angular.$$minErr('ui.select');
	  return function() {
	    var error = minErr.apply(this, arguments);
	    var message = error.message.replace(new RegExp('\nhttp://errors.angularjs.org/.*'), '');
	    return new Error(message);
	  };
	})
	
	// Recreates old behavior of ng-transclude. Used internally.
	.directive('uisTranscludeAppend', function () {
	  return {
	    link: function (scope, element, attrs, ctrl, transclude) {
	        transclude(scope, function (clone) {
	          element.append(clone);
	        });
	      }
	    };
	})
	
	/**
	 * Highlights text that matches $select.search.
	 *
	 * Taken from AngularUI Bootstrap Typeahead
	 * See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L340
	 */
	.filter('highlight', function() {
	  function escapeRegexp(queryToEscape) {
	    return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	  }
	
	  return function(matchItem, query) {
	    return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
	  };
	})
	
	/**
	 * A read-only equivalent of jQuery's offset function: http://api.jquery.com/offset/
	 *
	 * Taken from AngularUI Bootstrap Position:
	 * See https://github.com/angular-ui/bootstrap/blob/master/src/position/position.js#L70
	 */
	.factory('uisOffset',
	  ['$document', '$window',
	  function ($document, $window) {
	
	  return function(element) {
	    var boundingClientRect = element[0].getBoundingClientRect();
	    return {
	      width: boundingClientRect.width || element.prop('offsetWidth'),
	      height: boundingClientRect.height || element.prop('offsetHeight'),
	      top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
	      left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
	    };
	  };
	}]);
	
	uis.directive('uiSelectChoices',
	  ['uiSelectConfig', 'uisRepeatParser', 'uiSelectMinErr', '$compile', '$window',
	  function(uiSelectConfig, RepeatParser, uiSelectMinErr, $compile, $window) {
	
	  return {
	    restrict: 'EA',
	    require: '^uiSelect',
	    replace: true,
	    transclude: true,
	    templateUrl: function(tElement) {
	      // Needed so the uiSelect can detect the transcluded content
	      tElement.addClass('ui-select-choices');
	
	      // Gets theme attribute from parent (ui-select)
	      var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	      return theme + '/choices.tpl.html';
	    },
	
	    compile: function(tElement, tAttrs) {
	
	      if (!tAttrs.repeat) throw uiSelectMinErr('repeat', "Expected 'repeat' expression.");
	
	      // var repeat = RepeatParser.parse(attrs.repeat);
	      var groupByExp = tAttrs.groupBy;
	      var groupFilterExp = tAttrs.groupFilter;
	
	      if (groupByExp) {
	        var groups = tElement.querySelectorAll('.ui-select-choices-group');
	        if (groups.length !== 1) throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-group but got '{0}'.", groups.length);
	        groups.attr('ng-repeat', RepeatParser.getGroupNgRepeatExpression());
	      }
	
	      var parserResult = RepeatParser.parse(tAttrs.repeat);
	
	      var choices = tElement.querySelectorAll('.ui-select-choices-row');
	      if (choices.length !== 1) {
	        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row but got '{0}'.", choices.length);
	      }
	
	      choices.attr('ng-repeat', parserResult.repeatExpression(groupByExp))
	             .attr('ng-if', '$select.open'); //Prevent unnecessary watches when dropdown is closed
	
	
	      var rowsInner = tElement.querySelectorAll('.ui-select-choices-row-inner');
	      if (rowsInner.length !== 1) {
	        throw uiSelectMinErr('rows', "Expected 1 .ui-select-choices-row-inner but got '{0}'.", rowsInner.length);
	      }
	      rowsInner.attr('uis-transclude-append', ''); //Adding uisTranscludeAppend directive to row element after choices element has ngRepeat
	
	      // If IE8 then need to target rowsInner to apply the ng-click attr as choices will not capture the event.
	      var clickTarget = $window.document.addEventListener ? choices : rowsInner;
	      clickTarget.attr('ng-click', '$select.select(' + parserResult.itemName + ',$select.skipFocusser,$event)');
	
	      return function link(scope, element, attrs, $select) {
	
	
	        $select.parseRepeatAttr(attrs.repeat, groupByExp, groupFilterExp); //Result ready at $select.parserResult
	        $select.disableChoiceExpression = attrs.uiDisableChoice;
	        $select.onHighlightCallback = attrs.onHighlight;
	        $select.minimumInputLength = parseInt(attrs.minimumInputLength) || 0;
	        $select.dropdownPosition = attrs.position ? attrs.position.toLowerCase() : uiSelectConfig.dropdownPosition;
	
	        scope.$watch('$select.search', function(newValue) {
	          if(newValue && !$select.open && $select.multiple) $select.activate(false, true);
	          $select.activeIndex = $select.tagging.isActivated ? -1 : 0;
	          if (!attrs.minimumInputLength || $select.search.length >= attrs.minimumInputLength) {
	            $select.refresh(attrs.refresh);
	          } else {
	            $select.items = [];
	          }
	        });
	
	        attrs.$observe('refreshDelay', function() {
	          // $eval() is needed otherwise we get a string instead of a number
	          var refreshDelay = scope.$eval(attrs.refreshDelay);
	          $select.refreshDelay = refreshDelay !== undefined ? refreshDelay : uiSelectConfig.refreshDelay;
	        });
	
	        scope.$watch('$select.open', function(open) {
	          if (open) {
	            tElement.attr('role', 'listbox');
	            $select.refresh(attrs.refresh);
	          } else {
	            element.removeAttr('role');
	          }
	        });
	      };
	    }
	  };
	}]);
	
	/**
	 * Contains ui-select "intelligence".
	 *
	 * The goal is to limit dependency on the DOM whenever possible and
	 * put as much logic in the controller (instead of the link functions) as possible so it can be easily tested.
	 */
	uis.controller('uiSelectCtrl',
	  ['$scope', '$element', '$timeout', '$filter', '$$uisDebounce', 'uisRepeatParser', 'uiSelectMinErr', 'uiSelectConfig', '$parse', '$injector', '$window',
	  function($scope, $element, $timeout, $filter, $$uisDebounce, RepeatParser, uiSelectMinErr, uiSelectConfig, $parse, $injector, $window) {
	
	  var ctrl = this;
	
	  var EMPTY_SEARCH = '';
	
	  ctrl.placeholder = uiSelectConfig.placeholder;
	  ctrl.searchEnabled = uiSelectConfig.searchEnabled;
	  ctrl.sortable = uiSelectConfig.sortable;
	  ctrl.refreshDelay = uiSelectConfig.refreshDelay;
	  ctrl.paste = uiSelectConfig.paste;
	  ctrl.resetSearchInput = uiSelectConfig.resetSearchInput;
	  ctrl.refreshing = false;
	  ctrl.spinnerEnabled = uiSelectConfig.spinnerEnabled;
	  ctrl.spinnerClass = uiSelectConfig.spinnerClass;
	  ctrl.removeSelected = uiSelectConfig.removeSelected; //If selected item(s) should be removed from dropdown list
	  ctrl.closeOnSelect = true; //Initialized inside uiSelect directive link function
	  ctrl.skipFocusser = false; //Set to true to avoid returning focus to ctrl when item is selected
	  ctrl.search = EMPTY_SEARCH;
	
	  ctrl.activeIndex = 0; //Dropdown of choices
	  ctrl.items = []; //All available choices
	
	  ctrl.open = false;
	  ctrl.focus = false;
	  ctrl.disabled = false;
	  ctrl.selected = undefined;
	
	  ctrl.dropdownPosition = 'auto';
	
	  ctrl.focusser = undefined; //Reference to input element used to handle focus events
	  ctrl.multiple = undefined; // Initialized inside uiSelect directive link function
	  ctrl.disableChoiceExpression = undefined; // Initialized inside uiSelectChoices directive link function
	  ctrl.tagging = {isActivated: false, fct: undefined};
	  ctrl.taggingTokens = {isActivated: false, tokens: undefined};
	  ctrl.lockChoiceExpression = undefined; // Initialized inside uiSelectMatch directive link function
	  ctrl.clickTriggeredSelect = false;
	  ctrl.$filter = $filter;
	  ctrl.$element = $element;
	
	  // Use $injector to check for $animate and store a reference to it
	  ctrl.$animate = (function () {
	    try {
	      return $injector.get('$animate');
	    } catch (err) {
	      // $animate does not exist
	      return null;
	    }
	  })();
	
	  ctrl.searchInput = $element.querySelectorAll('input.ui-select-search');
	  if (ctrl.searchInput.length !== 1) {
	    throw uiSelectMinErr('searchInput', "Expected 1 input.ui-select-search but got '{0}'.", ctrl.searchInput.length);
	  }
	
	  ctrl.isEmpty = function() {
	    return isNil(ctrl.selected) || ctrl.selected === '' || (ctrl.multiple && ctrl.selected.length === 0);
	  };
	
	  function _findIndex(collection, predicate, thisArg){
	    if (collection.findIndex){
	      return collection.findIndex(predicate, thisArg);
	    } else {
	      var list = Object(collection);
	      var length = list.length >>> 0;
	      var value;
	
	      for (var i = 0; i < length; i++) {
	        value = list[i];
	        if (predicate.call(thisArg, value, i, list)) {
	          return i;
	        }
	      }
	      return -1;
	    }
	  }
	
	  // Most of the time the user does not want to empty the search input when in typeahead mode
	  function _resetSearchInput() {
	    if (ctrl.resetSearchInput) {
	      ctrl.search = EMPTY_SEARCH;
	      //reset activeIndex
	      if (ctrl.selected && ctrl.items.length && !ctrl.multiple) {
	        ctrl.activeIndex = _findIndex(ctrl.items, function(item){
	          return angular.equals(this, item);
	        }, ctrl.selected);
	      }
	    }
	  }
	
	    function _groupsFilter(groups, groupNames) {
	      var i, j, result = [];
	      for(i = 0; i < groupNames.length ;i++){
	        for(j = 0; j < groups.length ;j++){
	          if(groups[j].name == [groupNames[i]]){
	            result.push(groups[j]);
	          }
	        }
	      }
	      return result;
	    }
	
	  // When the user clicks on ui-select, displays the dropdown list
	  ctrl.activate = function(initSearchValue, avoidReset) {
	    if (!ctrl.disabled  && !ctrl.open) {
	      if(!avoidReset) _resetSearchInput();
	
	      $scope.$broadcast('uis:activate');
	      ctrl.open = true;
	      ctrl.activeIndex = ctrl.activeIndex >= ctrl.items.length ? 0 : ctrl.activeIndex;
	      // ensure that the index is set to zero for tagging variants
	      // that where first option is auto-selected
	      if ( ctrl.activeIndex === -1 && ctrl.taggingLabel !== false ) {
	        ctrl.activeIndex = 0;
	      }
	
	      var container = $element.querySelectorAll('.ui-select-choices-content');
	      var searchInput = $element.querySelectorAll('.ui-select-search');
	      if (ctrl.$animate && ctrl.$animate.on && ctrl.$animate.enabled(container[0])) {
	        var animateHandler = function(elem, phase) {
	          if (phase === 'start' && ctrl.items.length === 0) {
	            // Only focus input after the animation has finished
	            ctrl.$animate.off('removeClass', searchInput[0], animateHandler);
	            $timeout(function () {
	              ctrl.focusSearchInput(initSearchValue);
	            });
	          } else if (phase === 'close') {
	            // Only focus input after the animation has finished
	            ctrl.$animate.off('enter', container[0], animateHandler);
	            $timeout(function () {
	              ctrl.focusSearchInput(initSearchValue);
	            });
	          }
	        };
	
	        if (ctrl.items.length > 0) {
	          ctrl.$animate.on('enter', container[0], animateHandler);
	        } else {
	          ctrl.$animate.on('removeClass', searchInput[0], animateHandler);
	        }
	      } else {
	        $timeout(function () {
	          ctrl.focusSearchInput(initSearchValue);
	          if(!ctrl.tagging.isActivated && ctrl.items.length > 1) {
	            _ensureHighlightVisible();
	          }
	        });
	      }
	    }
	    else if (ctrl.open && !ctrl.searchEnabled) {
	      // Close the selection if we don't have search enabled, and we click on the select again
	      ctrl.close();
	    }
	  };
	
	  ctrl.focusSearchInput = function (initSearchValue) {
	    ctrl.search = initSearchValue || ctrl.search;
	    ctrl.searchInput[0].focus();
	  };
	
	  ctrl.findGroupByName = function(name) {
	    return ctrl.groups && ctrl.groups.filter(function(group) {
	      return group.name === name;
	    })[0];
	  };
	
	  ctrl.parseRepeatAttr = function(repeatAttr, groupByExp, groupFilterExp) {
	    function updateGroups(items) {
	      var groupFn = $scope.$eval(groupByExp);
	      ctrl.groups = [];
	      angular.forEach(items, function(item) {
	        var groupName = angular.isFunction(groupFn) ? groupFn(item) : item[groupFn];
	        var group = ctrl.findGroupByName(groupName);
	        if(group) {
	          group.items.push(item);
	        }
	        else {
	          ctrl.groups.push({name: groupName, items: [item]});
	        }
	      });
	      if(groupFilterExp){
	        var groupFilterFn = $scope.$eval(groupFilterExp);
	        if( angular.isFunction(groupFilterFn)){
	          ctrl.groups = groupFilterFn(ctrl.groups);
	        } else if(angular.isArray(groupFilterFn)){
	          ctrl.groups = _groupsFilter(ctrl.groups, groupFilterFn);
	        }
	      }
	      ctrl.items = [];
	      ctrl.groups.forEach(function(group) {
	        ctrl.items = ctrl.items.concat(group.items);
	      });
	    }
	
	    function setPlainItems(items) {
	      ctrl.items = items || [];
	    }
	
	    ctrl.setItemsFn = groupByExp ? updateGroups : setPlainItems;
	
	    ctrl.parserResult = RepeatParser.parse(repeatAttr);
	
	    ctrl.isGrouped = !!groupByExp;
	    ctrl.itemProperty = ctrl.parserResult.itemName;
	
	    //If collection is an Object, convert it to Array
	
	    var originalSource = ctrl.parserResult.source;
	
	    //When an object is used as source, we better create an array and use it as 'source'
	    var createArrayFromObject = function(){
	      var origSrc = originalSource($scope);
	      $scope.$uisSource = Object.keys(origSrc).map(function(v){
	        var result = {};
	        result[ctrl.parserResult.keyName] = v;
	        result.value = origSrc[v];
	        return result;
	      });
	    };
	
	    if (ctrl.parserResult.keyName){ // Check for (key,value) syntax
	      createArrayFromObject();
	      ctrl.parserResult.source = $parse('$uisSource' + ctrl.parserResult.filters);
	      $scope.$watch(originalSource, function(newVal, oldVal){
	        if (newVal !== oldVal) createArrayFromObject();
	      }, true);
	    }
	
	    ctrl.refreshItems = function (data){
	      data = data || ctrl.parserResult.source($scope);
	      var selectedItems = ctrl.selected;
	      //TODO should implement for single mode removeSelected
	      if (ctrl.isEmpty() || (angular.isArray(selectedItems) && !selectedItems.length) || !ctrl.multiple || !ctrl.removeSelected) {
	        ctrl.setItemsFn(data);
	      }else{
	        if ( data !== undefined && data !== null ) {
	          var filteredItems = data.filter(function(i) {
	            return angular.isArray(selectedItems) ? selectedItems.every(function(selectedItem) {
	              return !angular.equals(i, selectedItem);
	            }) : !angular.equals(i, selectedItems);
	          });
	          ctrl.setItemsFn(filteredItems);
	        }
	      }
	      if (ctrl.dropdownPosition === 'auto' || ctrl.dropdownPosition === 'up'){
	        $scope.calculateDropdownPos();
	      }
	      $scope.$broadcast('uis:refresh');
	    };
	
	    // See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L259
	    $scope.$watchCollection(ctrl.parserResult.source, function(items) {
	      if (items === undefined || items === null) {
	        // If the user specifies undefined or null => reset the collection
	        // Special case: items can be undefined if the user did not initialized the collection on the scope
	        // i.e $scope.addresses = [] is missing
	        ctrl.items = [];
	      } else {
	        if (!angular.isArray(items)) {
	          throw uiSelectMinErr('items', "Expected an array but got '{0}'.", items);
	        } else {
	          //Remove already selected items (ex: while searching)
	          //TODO Should add a test
	          ctrl.refreshItems(items);
	
	          //update the view value with fresh data from items, if there is a valid model value
	          if(angular.isDefined(ctrl.ngModel.$modelValue)) {
	            ctrl.ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	          }
	        }
	      }
	    });
	
	  };
	
	  var _refreshDelayPromise;
	
	  /**
	   * Typeahead mode: lets the user refresh the collection using his own function.
	   *
	   * See Expose $select.search for external / remote filtering https://github.com/angular-ui/ui-select/pull/31
	   */
	  ctrl.refresh = function(refreshAttr) {
	    if (refreshAttr !== undefined) {
	      // Debounce
	      // See https://github.com/angular-ui/bootstrap/blob/0.10.0/src/typeahead/typeahead.js#L155
	      // FYI AngularStrap typeahead does not have debouncing: https://github.com/mgcrea/angular-strap/blob/v2.0.0-rc.4/src/typeahead/typeahead.js#L177
	      if (_refreshDelayPromise) {
	        $timeout.cancel(_refreshDelayPromise);
	      }
	      _refreshDelayPromise = $timeout(function() {
	        if ($scope.$select.search.length >= $scope.$select.minimumInputLength) {
	          var refreshPromise = $scope.$eval(refreshAttr);
	          if (refreshPromise && angular.isFunction(refreshPromise.then) && !ctrl.refreshing) {
	            ctrl.refreshing = true;
	            refreshPromise.finally(function() {
	              ctrl.refreshing = false;
	            });
	          }
	        }
	      }, ctrl.refreshDelay);
	    }
	  };
	
	  ctrl.isActive = function(itemScope) {
	    if ( !ctrl.open ) {
	      return false;
	    }
	    var itemIndex = ctrl.items.indexOf(itemScope[ctrl.itemProperty]);
	    var isActive =  itemIndex == ctrl.activeIndex;
	
	    if ( !isActive || itemIndex < 0 ) {
	      return false;
	    }
	
	    if (isActive && !angular.isUndefined(ctrl.onHighlightCallback)) {
	      itemScope.$eval(ctrl.onHighlightCallback);
	    }
	
	    return isActive;
	  };
	
	  var _isItemSelected = function (item) {
	    return (ctrl.selected && angular.isArray(ctrl.selected) &&
	        ctrl.selected.filter(function (selection) { return angular.equals(selection, item); }).length > 0);
	  };
	
	  var disabledItems = [];
	
	  function _updateItemDisabled(item, isDisabled) {
	    var disabledItemIndex = disabledItems.indexOf(item);
	    if (isDisabled && disabledItemIndex === -1) {
	      disabledItems.push(item);
	    }
	
	    if (!isDisabled && disabledItemIndex > -1) {
	      disabledItems.splice(disabledItemIndex, 1);
	    }
	  }
	
	  function _isItemDisabled(item) {
	    return disabledItems.indexOf(item) > -1;
	  }
	
	  ctrl.isDisabled = function(itemScope) {
	
	    if (!ctrl.open) return;
	
	    var item = itemScope[ctrl.itemProperty];
	    var itemIndex = ctrl.items.indexOf(item);
	    var isDisabled = false;
	
	    if (itemIndex >= 0 && (angular.isDefined(ctrl.disableChoiceExpression) || ctrl.multiple)) {
	
	      if (item.isTag) return false;
	
	      if (ctrl.multiple) {
	        isDisabled = _isItemSelected(item);
	      }
	
	      if (!isDisabled && angular.isDefined(ctrl.disableChoiceExpression)) {
	        isDisabled = !!(itemScope.$eval(ctrl.disableChoiceExpression));
	      }
	
	      _updateItemDisabled(item, isDisabled);
	    }
	
	    return isDisabled;
	  };
	
	
	  // When the user selects an item with ENTER or clicks the dropdown
	  ctrl.select = function(item, skipFocusser, $event) {
	    if (isNil(item) || !_isItemDisabled(item)) {
	
	      if ( ! ctrl.items && ! ctrl.search && ! ctrl.tagging.isActivated) return;
	
	      if (!item || !_isItemDisabled(item)) {
	        // if click is made on existing item, prevent from tagging, ctrl.search does not matter
	        ctrl.clickTriggeredSelect = false;
	        if($event && ($event.type === 'click' || $event.type === 'touchend') && item)
	          ctrl.clickTriggeredSelect = true;
	
	        if(ctrl.tagging.isActivated && ctrl.clickTriggeredSelect === false) {
	          // if taggingLabel is disabled and item is undefined we pull from ctrl.search
	          if ( ctrl.taggingLabel === false ) {
	            if ( ctrl.activeIndex < 0 ) {
	              if (item === undefined) {
	                item = ctrl.tagging.fct !== undefined ? ctrl.tagging.fct(ctrl.search) : ctrl.search;
	              }
	              if (!item || angular.equals( ctrl.items[0], item ) ) {
	                return;
	              }
	            } else {
	              // keyboard nav happened first, user selected from dropdown
	              item = ctrl.items[ctrl.activeIndex];
	            }
	          } else {
	            // tagging always operates at index zero, taggingLabel === false pushes
	            // the ctrl.search value without having it injected
	            if ( ctrl.activeIndex === 0 ) {
	              // ctrl.tagging pushes items to ctrl.items, so we only have empty val
	              // for `item` if it is a detected duplicate
	              if ( item === undefined ) return;
	
	              // create new item on the fly if we don't already have one;
	              // use tagging function if we have one
	              if ( ctrl.tagging.fct !== undefined && typeof item === 'string' ) {
	                item = ctrl.tagging.fct(item);
	                if (!item) return;
	              // if item type is 'string', apply the tagging label
	              } else if ( typeof item === 'string' ) {
	                // trim the trailing space
	                item = item.replace(ctrl.taggingLabel,'').trim();
	              }
	            }
	          }
	          // search ctrl.selected for dupes potentially caused by tagging and return early if found
	          if (_isItemSelected(item)) {
	            ctrl.close(skipFocusser);
	            return;
	          }
	        }
	        _resetSearchInput();
	        $scope.$broadcast('uis:select', item);
	
	        if (ctrl.closeOnSelect) {
	          ctrl.close(skipFocusser);
	        }
	      }
	    }
	  };
	
	  // Closes the dropdown
	  ctrl.close = function(skipFocusser) {
	    if (!ctrl.open) return;
	    if (ctrl.ngModel && ctrl.ngModel.$setTouched) ctrl.ngModel.$setTouched();
	    ctrl.open = false;
	    _resetSearchInput();
	    $scope.$broadcast('uis:close', skipFocusser);
	
	  };
	
	  ctrl.setFocus = function(){
	    if (!ctrl.focus) ctrl.focusInput[0].focus();
	  };
	
	  ctrl.clear = function($event) {
	    ctrl.select(null);
	    $event.stopPropagation();
	    $timeout(function() {
	      ctrl.focusser[0].focus();
	    }, 0, false);
	  };
	
	  // Toggle dropdown
	  ctrl.toggle = function(e) {
	    if (ctrl.open) {
	      ctrl.close();
	      e.preventDefault();
	      e.stopPropagation();
	    } else {
	      ctrl.activate();
	    }
	  };
	
	  // Set default function for locked choices - avoids unnecessary
	  // logic if functionality is not being used
	  ctrl.isLocked = function () {
	    return false;
	  };
	
	  $scope.$watch(function () {
	    return angular.isDefined(ctrl.lockChoiceExpression) && ctrl.lockChoiceExpression !== "";
	  }, _initaliseLockedChoices);
	
	  function _initaliseLockedChoices(doInitalise) {
	    if(!doInitalise) return;
	
	    var lockedItems = [];
	
	    function _updateItemLocked(item, isLocked) {
	      var lockedItemIndex = lockedItems.indexOf(item);
	      if (isLocked && lockedItemIndex === -1) {
	        lockedItems.push(item);
	        }
	
	      if (!isLocked && lockedItemIndex > -1) {
	        lockedItems.splice(lockedItemIndex, 1);
	      }
	    }
	
	    function _isItemlocked(item) {
	      return lockedItems.indexOf(item) > -1;
	    }
	
	    ctrl.isLocked = function (itemScope, itemIndex) {
	      var isLocked = false,
	          item = ctrl.selected[itemIndex];
	
	      if(item) {
	        if (itemScope) {
	          isLocked = !!(itemScope.$eval(ctrl.lockChoiceExpression));
	          _updateItemLocked(item, isLocked);
	        } else {
	          isLocked = _isItemlocked(item);
	        }
	      }
	
	      return isLocked;
	    };
	  }
	
	
	  var sizeWatch = null;
	  var updaterScheduled = false;
	  ctrl.sizeSearchInput = function() {
	
	    var input = ctrl.searchInput[0],
	        container = ctrl.$element[0],
	        calculateContainerWidth = function() {
	          // Return the container width only if the search input is visible
	          return container.clientWidth * !!input.offsetParent;
	        },
	        updateIfVisible = function(containerWidth) {
	          if (containerWidth === 0) {
	            return false;
	          }
	          var inputWidth = containerWidth - input.offsetLeft;
	          if (inputWidth < 50) inputWidth = containerWidth;
	          ctrl.searchInput.css('width', inputWidth+'px');
	          return true;
	        };
	
	    ctrl.searchInput.css('width', '10px');
	    $timeout(function() { //Give tags time to render correctly
	      if (sizeWatch === null && !updateIfVisible(calculateContainerWidth())) {
	        sizeWatch = $scope.$watch(function() {
	          if (!updaterScheduled) {
	            updaterScheduled = true;
	            $scope.$$postDigest(function() {
	              updaterScheduled = false;
	              if (updateIfVisible(calculateContainerWidth())) {
	                sizeWatch();
	                sizeWatch = null;
	              }
	            });
	          }
	        }, angular.noop);
	      }
	    });
	  };
	
	  function _handleDropDownSelection(key) {
	    var processed = true;
	    switch (key) {
	      case KEY.DOWN:
	        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        else if (ctrl.activeIndex < ctrl.items.length - 1) {
	          var idx = ++ctrl.activeIndex;
	          while(_isItemDisabled(ctrl.items[idx]) && idx < ctrl.items.length) {
	            ctrl.activeIndex = ++idx;
	          }
	        }
	        break;
	      case KEY.UP:
	        var minActiveIndex = (ctrl.search.length === 0 && ctrl.tagging.isActivated) ? -1 : 0;
	        if (!ctrl.open && ctrl.multiple) ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        else if (ctrl.activeIndex > minActiveIndex) {
	          var idxmin = --ctrl.activeIndex;
	          while(_isItemDisabled(ctrl.items[idxmin]) && idxmin > minActiveIndex) {
	            ctrl.activeIndex = --idxmin;
	          }
	        }
	        break;
	      case KEY.TAB:
	        if (!ctrl.multiple || ctrl.open) ctrl.select(ctrl.items[ctrl.activeIndex], true);
	        break;
	      case KEY.ENTER:
	        if(ctrl.open && (ctrl.tagging.isActivated || ctrl.activeIndex >= 0)){
	          ctrl.select(ctrl.items[ctrl.activeIndex], ctrl.skipFocusser); // Make sure at least one dropdown item is highlighted before adding if not in tagging mode
	        } else {
	          ctrl.activate(false, true); //In case its the search input in 'multiple' mode
	        }
	        break;
	      case KEY.ESC:
	        ctrl.close();
	        break;
	      default:
	        processed = false;
	    }
	    return processed;
	  }
	
	  // Bind to keyboard shortcuts
	  ctrl.searchInput.on('keydown', function(e) {
	
	    var key = e.which;
	
	    if (~[KEY.ENTER,KEY.ESC].indexOf(key)){
	      e.preventDefault();
	      e.stopPropagation();
	    }
	
	    $scope.$apply(function() {
	
	      var tagged = false;
	
	      if (ctrl.items.length > 0 || ctrl.tagging.isActivated) {
	        if(!_handleDropDownSelection(key) && !ctrl.searchEnabled) {
	          e.preventDefault();
	          e.stopPropagation();
	        }
	        if ( ctrl.taggingTokens.isActivated ) {
	          for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {
	            if ( ctrl.taggingTokens.tokens[i] === KEY.MAP[e.keyCode] ) {
	              // make sure there is a new value to push via tagging
	              if ( ctrl.search.length > 0 ) {
	                tagged = true;
	              }
	            }
	          }
	          if ( tagged ) {
	            $timeout(function() {
	              ctrl.searchInput.triggerHandler('tagged');
	              var newItem = ctrl.search.replace(KEY.MAP[e.keyCode],'').trim();
	              if ( ctrl.tagging.fct ) {
	                newItem = ctrl.tagging.fct( newItem );
	              }
	              if (newItem) ctrl.select(newItem, true);
	            });
	          }
	        }
	      }
	
	    });
	
	    if(KEY.isVerticalMovement(key) && ctrl.items.length > 0){
	      _ensureHighlightVisible();
	    }
	
	    if (key === KEY.ENTER || key === KEY.ESC) {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	
	  });
	
	  ctrl.searchInput.on('paste', function (e) {
	    var data;
	
	    if (window.clipboardData && window.clipboardData.getData) { // IE
	      data = window.clipboardData.getData('Text');
	    } else {
	      data = (e.originalEvent || e).clipboardData.getData('text/plain');
	    }
	
	    // Prepend the current input field text to the paste buffer.
	    data = ctrl.search + data;
	
	    if (data && data.length > 0) {
	      // If tagging try to split by tokens and add items
	      if (ctrl.taggingTokens.isActivated) {
	        var items = [];
	        for (var i = 0; i < ctrl.taggingTokens.tokens.length; i++) {  // split by first token that is contained in data
	          var separator = KEY.toSeparator(ctrl.taggingTokens.tokens[i]) || ctrl.taggingTokens.tokens[i];
	          if (data.indexOf(separator) > -1) {
	            items = data.split(separator);
	            break;  // only split by one token
	          }
	        }
	        if (items.length === 0) {
	          items = [data];
	        }
	        var oldsearch = ctrl.search;
	        angular.forEach(items, function (item) {
	          var newItem = ctrl.tagging.fct ? ctrl.tagging.fct(item) : item;
	          if (newItem) {
	            ctrl.select(newItem, true);
	          }
	        });
	        ctrl.search = oldsearch || EMPTY_SEARCH;
	        e.preventDefault();
	        e.stopPropagation();
	      } else if (ctrl.paste) {
	        ctrl.paste(data);
	        ctrl.search = EMPTY_SEARCH;
	        e.preventDefault();
	        e.stopPropagation();
	      }
	    }
	  });
	
	  ctrl.searchInput.on('tagged', function() {
	    $timeout(function() {
	      _resetSearchInput();
	    });
	  });
	
	  // See https://github.com/ivaynberg/select2/blob/3.4.6/select2.js#L1431
	  function _ensureHighlightVisible() {
	    var container = $element.querySelectorAll('.ui-select-choices-content');
	    var choices = container.querySelectorAll('.ui-select-choices-row');
	    if (choices.length < 1) {
	      throw uiSelectMinErr('choices', "Expected multiple .ui-select-choices-row but got '{0}'.", choices.length);
	    }
	
	    if (ctrl.activeIndex < 0) {
	      return;
	    }
	
	    var highlighted = choices[ctrl.activeIndex];
	    var posY = highlighted.offsetTop + highlighted.clientHeight - container[0].scrollTop;
	    var height = container[0].offsetHeight;
	
	    if (posY > height) {
	      container[0].scrollTop += posY - height;
	    } else if (posY < highlighted.clientHeight) {
	      if (ctrl.isGrouped && ctrl.activeIndex === 0)
	        container[0].scrollTop = 0; //To make group header visible when going all the way up
	      else
	        container[0].scrollTop -= highlighted.clientHeight - posY;
	    }
	  }
	
	  var onResize = $$uisDebounce(function() {
	    ctrl.sizeSearchInput();
	  }, 50);
	
	  angular.element($window).bind('resize', onResize);
	
	  $scope.$on('$destroy', function() {
	    ctrl.searchInput.off('keyup keydown tagged blur paste');
	    angular.element($window).off('resize', onResize);
	  });
	
	  $scope.$watch('$select.activeIndex', function(activeIndex) {
	    if (activeIndex)
	      $element.find('input').attr(
	        'aria-activedescendant',
	        'ui-select-choices-row-' + ctrl.generatedId + '-' + activeIndex);
	  });
	
	  $scope.$watch('$select.open', function(open) {
	    if (!open)
	      $element.find('input').removeAttr('aria-activedescendant');
	  });
	}]);
	
	uis.directive('uiSelect',
	  ['$document', 'uiSelectConfig', 'uiSelectMinErr', 'uisOffset', '$compile', '$parse', '$timeout',
	  function($document, uiSelectConfig, uiSelectMinErr, uisOffset, $compile, $parse, $timeout) {
	
	  return {
	    restrict: 'EA',
	    templateUrl: function(tElement, tAttrs) {
	      var theme = tAttrs.theme || uiSelectConfig.theme;
	      return theme + (angular.isDefined(tAttrs.multiple) ? '/select-multiple.tpl.html' : '/select.tpl.html');
	    },
	    replace: true,
	    transclude: true,
	    require: ['uiSelect', '^ngModel'],
	    scope: true,
	
	    controller: 'uiSelectCtrl',
	    controllerAs: '$select',
	    compile: function(tElement, tAttrs) {
	
	      // Allow setting ngClass on uiSelect
	      var match = /{(.*)}\s*{(.*)}/.exec(tAttrs.ngClass);
	      if(match) {
	        var combined = '{'+ match[1] +', '+ match[2] +'}';
	        tAttrs.ngClass = combined;
	        tElement.attr('ng-class', combined);
	      }
	
	      //Multiple or Single depending if multiple attribute presence
	      if (angular.isDefined(tAttrs.multiple))
	        tElement.append('<ui-select-multiple/>').removeAttr('multiple');
	      else
	        tElement.append('<ui-select-single/>');
	
	      if (tAttrs.inputId)
	        tElement.querySelectorAll('input.ui-select-search')[0].id = tAttrs.inputId;
	
	      return function(scope, element, attrs, ctrls, transcludeFn) {
	
	        var $select = ctrls[0];
	        var ngModel = ctrls[1];
	
	        $select.generatedId = uiSelectConfig.generateId();
	        $select.baseTitle = attrs.title || 'Select box';
	        $select.focusserTitle = $select.baseTitle + ' focus';
	        $select.focusserId = 'focusser-' + $select.generatedId;
	
	        $select.closeOnSelect = function() {
	          if (angular.isDefined(attrs.closeOnSelect)) {
	            return $parse(attrs.closeOnSelect)();
	          } else {
	            return uiSelectConfig.closeOnSelect;
	          }
	        }();
	
	        scope.$watch('skipFocusser', function() {
	            var skipFocusser = scope.$eval(attrs.skipFocusser);
	            $select.skipFocusser = skipFocusser !== undefined ? skipFocusser : uiSelectConfig.skipFocusser;
	        });
	
	        $select.onSelectCallback = $parse(attrs.onSelect);
	        $select.onRemoveCallback = $parse(attrs.onRemove);
	
	        //Set reference to ngModel from uiSelectCtrl
	        $select.ngModel = ngModel;
	
	        $select.choiceGrouped = function(group){
	          return $select.isGrouped && group && group.name;
	        };
	
	        if(attrs.tabindex){
	          attrs.$observe('tabindex', function(value) {
	            $select.focusInput.attr('tabindex', value);
	            element.removeAttr('tabindex');
	          });
	        }
	
	        scope.$watch(function () { return scope.$eval(attrs.searchEnabled); }, function(newVal) {
	          $select.searchEnabled = newVal !== undefined ? newVal : uiSelectConfig.searchEnabled;
	        });
	
	        scope.$watch('sortable', function() {
	            var sortable = scope.$eval(attrs.sortable);
	            $select.sortable = sortable !== undefined ? sortable : uiSelectConfig.sortable;
	        });
	
	        attrs.$observe('backspaceReset', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var backspaceReset = scope.$eval(attrs.backspaceReset);
	          $select.backspaceReset = backspaceReset !== undefined ? backspaceReset : true;
	        });
	
	        attrs.$observe('limit', function() {
	          //Limit the number of selections allowed
	          $select.limit = (angular.isDefined(attrs.limit)) ? parseInt(attrs.limit, 10) : undefined;
	        });
	
	        scope.$watch('removeSelected', function() {
	            var removeSelected = scope.$eval(attrs.removeSelected);
	            $select.removeSelected = removeSelected !== undefined ? removeSelected : uiSelectConfig.removeSelected;
	        });
	
	        attrs.$observe('disabled', function() {
	          // No need to use $eval() (thanks to ng-disabled) since we already get a boolean instead of a string
	          $select.disabled = attrs.disabled !== undefined ? attrs.disabled : false;
	        });
	
	        attrs.$observe('resetSearchInput', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var resetSearchInput = scope.$eval(attrs.resetSearchInput);
	          $select.resetSearchInput = resetSearchInput !== undefined ? resetSearchInput : true;
	        });
	
	        attrs.$observe('paste', function() {
	          $select.paste = scope.$eval(attrs.paste);
	        });
	
	        attrs.$observe('tagging', function() {
	          if(attrs.tagging !== undefined)
	          {
	            // $eval() is needed otherwise we get a string instead of a boolean
	            var taggingEval = scope.$eval(attrs.tagging);
	            $select.tagging = {isActivated: true, fct: taggingEval !== true ? taggingEval : undefined};
	          }
	          else
	          {
	            $select.tagging = {isActivated: false, fct: undefined};
	          }
	        });
	
	        attrs.$observe('taggingLabel', function() {
	          if(attrs.tagging !== undefined )
	          {
	            // check eval for FALSE, in this case, we disable the labels
	            // associated with tagging
	            if ( attrs.taggingLabel === 'false' ) {
	              $select.taggingLabel = false;
	            }
	            else
	            {
	              $select.taggingLabel = attrs.taggingLabel !== undefined ? attrs.taggingLabel : '(new)';
	            }
	          }
	        });
	
	        attrs.$observe('taggingTokens', function() {
	          if (attrs.tagging !== undefined) {
	            var tokens = attrs.taggingTokens !== undefined ? attrs.taggingTokens.split('|') : [',','ENTER'];
	            $select.taggingTokens = {isActivated: true, tokens: tokens };
	          }
	        });
	
	        attrs.$observe('spinnerEnabled', function() {
	          // $eval() is needed otherwise we get a string instead of a boolean
	          var spinnerEnabled = scope.$eval(attrs.spinnerEnabled);
	          $select.spinnerEnabled = spinnerEnabled !== undefined ? spinnerEnabled : uiSelectConfig.spinnerEnabled;
	        });
	
	        attrs.$observe('spinnerClass', function() {
	          var spinnerClass = attrs.spinnerClass;
	          $select.spinnerClass = spinnerClass !== undefined ? attrs.spinnerClass : uiSelectConfig.spinnerClass;
	        });
	
	        //Automatically gets focus when loaded
	        if (angular.isDefined(attrs.autofocus)){
	          $timeout(function(){
	            $select.setFocus();
	          });
	        }
	
	        //Gets focus based on scope event name (e.g. focus-on='SomeEventName')
	        if (angular.isDefined(attrs.focusOn)){
	          scope.$on(attrs.focusOn, function() {
	              $timeout(function(){
	                $select.setFocus();
	              });
	          });
	        }
	
	        function onDocumentClick(e) {
	          if (!$select.open) return; //Skip it if dropdown is close
	
	          var contains = false;
	
	          if (window.jQuery) {
	            // Firefox 3.6 does not support element.contains()
	            // See Node.contains https://developer.mozilla.org/en-US/docs/Web/API/Node.contains
	            contains = window.jQuery.contains(element[0], e.target);
	          } else {
	            contains = element[0].contains(e.target);
	          }
	
	          if (!contains && !$select.clickTriggeredSelect) {
	            var skipFocusser;
	            if (!$select.skipFocusser) {
	              //Will lose focus only with certain targets
	              var focusableControls = ['input','button','textarea','select'];
	              var targetController = angular.element(e.target).controller('uiSelect'); //To check if target is other ui-select
	              skipFocusser = targetController && targetController !== $select; //To check if target is other ui-select
	              if (!skipFocusser) skipFocusser =  ~focusableControls.indexOf(e.target.tagName.toLowerCase()); //Check if target is input, button or textarea
	            } else {
	              skipFocusser = true;
	            }
	            $select.close(skipFocusser);
	            scope.$digest();
	          }
	          $select.clickTriggeredSelect = false;
	        }
	
	        // See Click everywhere but here event http://stackoverflow.com/questions/12931369
	        $document.on('click', onDocumentClick);
	
	        scope.$on('$destroy', function() {
	          $document.off('click', onDocumentClick);
	        });
	
	        // Move transcluded elements to their correct position in main template
	        transcludeFn(scope, function(clone) {
	          // See Transclude in AngularJS http://blog.omkarpatil.com/2012/11/transclude-in-angularjs.html
	
	          // One day jqLite will be replaced by jQuery and we will be able to write:
	          // var transcludedElement = clone.filter('.my-class')
	          // instead of creating a hackish DOM element:
	          var transcluded = angular.element('<div>').append(clone);
	
	          var transcludedMatch = transcluded.querySelectorAll('.ui-select-match');
	          transcludedMatch.removeAttr('ui-select-match'); //To avoid loop in case directive as attr
	          transcludedMatch.removeAttr('data-ui-select-match'); // Properly handle HTML5 data-attributes
	          if (transcludedMatch.length !== 1) {
	            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-match but got '{0}'.", transcludedMatch.length);
	          }
	          element.querySelectorAll('.ui-select-match').replaceWith(transcludedMatch);
	
	          var transcludedChoices = transcluded.querySelectorAll('.ui-select-choices');
	          transcludedChoices.removeAttr('ui-select-choices'); //To avoid loop in case directive as attr
	          transcludedChoices.removeAttr('data-ui-select-choices'); // Properly handle HTML5 data-attributes
	          if (transcludedChoices.length !== 1) {
	            throw uiSelectMinErr('transcluded', "Expected 1 .ui-select-choices but got '{0}'.", transcludedChoices.length);
	          }
	          element.querySelectorAll('.ui-select-choices').replaceWith(transcludedChoices);
	
	          var transcludedNoChoice = transcluded.querySelectorAll('.ui-select-no-choice');
	          transcludedNoChoice.removeAttr('ui-select-no-choice'); //To avoid loop in case directive as attr
	          transcludedNoChoice.removeAttr('data-ui-select-no-choice'); // Properly handle HTML5 data-attributes
	          if (transcludedNoChoice.length == 1) {
	            element.querySelectorAll('.ui-select-no-choice').replaceWith(transcludedNoChoice);
	          }
	        });
	
	        // Support for appending the select field to the body when its open
	        var appendToBody = scope.$eval(attrs.appendToBody);
	        if (appendToBody !== undefined ? appendToBody : uiSelectConfig.appendToBody) {
	          scope.$watch('$select.open', function(isOpen) {
	            if (isOpen) {
	              positionDropdown();
	            } else {
	              resetDropdown();
	            }
	          });
	
	          // Move the dropdown back to its original location when the scope is destroyed. Otherwise
	          // it might stick around when the user routes away or the select field is otherwise removed
	          scope.$on('$destroy', function() {
	            resetDropdown();
	          });
	        }
	
	        // Hold on to a reference to the .ui-select-container element for appendToBody support
	        var placeholder = null,
	            originalWidth = '';
	
	        function positionDropdown() {
	          // Remember the absolute position of the element
	          var offset = uisOffset(element);
	
	          // Clone the element into a placeholder element to take its original place in the DOM
	          placeholder = angular.element('<div class="ui-select-placeholder"></div>');
	          placeholder[0].style.width = offset.width + 'px';
	          placeholder[0].style.height = offset.height + 'px';
	          element.after(placeholder);
	
	          // Remember the original value of the element width inline style, so it can be restored
	          // when the dropdown is closed
	          originalWidth = element[0].style.width;
	
	          // Now move the actual dropdown element to the end of the body
	          $document.find('body').append(element);
	
	          element[0].style.position = 'absolute';
	          element[0].style.left = offset.left + 'px';
	          element[0].style.top = offset.top + 'px';
	          element[0].style.width = offset.width + 'px';
	        }
	
	        function resetDropdown() {
	          if (placeholder === null) {
	            // The dropdown has not actually been display yet, so there's nothing to reset
	            return;
	          }
	
	          // Move the dropdown element back to its original location in the DOM
	          placeholder.replaceWith(element);
	          placeholder = null;
	
	          element[0].style.position = '';
	          element[0].style.left = '';
	          element[0].style.top = '';
	          element[0].style.width = originalWidth;
	
	          // Set focus back on to the moved element
	          $select.setFocus();
	        }
	
	        // Hold on to a reference to the .ui-select-dropdown element for direction support.
	        var dropdown = null,
	            directionUpClassName = 'direction-up';
	
	        // Support changing the direction of the dropdown if there isn't enough space to render it.
	        scope.$watch('$select.open', function() {
	
	          if ($select.dropdownPosition === 'auto' || $select.dropdownPosition === 'up'){
	            scope.calculateDropdownPos();
	          }
	
	        });
	
	        var setDropdownPosUp = function(offset, offsetDropdown){
	
	          offset = offset || uisOffset(element);
	          offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	          dropdown[0].style.position = 'absolute';
	          dropdown[0].style.top = (offsetDropdown.height * -1) + 'px';
	          element.addClass(directionUpClassName);
	
	        };
	
	        var setDropdownPosDown = function(offset, offsetDropdown){
	
	          element.removeClass(directionUpClassName);
	
	          offset = offset || uisOffset(element);
	          offsetDropdown = offsetDropdown || uisOffset(dropdown);
	
	          dropdown[0].style.position = '';
	          dropdown[0].style.top = '';
	
	        };
	
	        var calculateDropdownPosAfterAnimation = function() {
	          // Delay positioning the dropdown until all choices have been added so its height is correct.
	          $timeout(function() {
	            if ($select.dropdownPosition === 'up') {
	              //Go UP
	              setDropdownPosUp();
	            } else {
	              //AUTO
	              element.removeClass(directionUpClassName);
	
	              var offset = uisOffset(element);
	              var offsetDropdown = uisOffset(dropdown);
	
	              //https://code.google.com/p/chromium/issues/detail?id=342307#c4
	              var scrollTop = $document[0].documentElement.scrollTop || $document[0].body.scrollTop; //To make it cross browser (blink, webkit, IE, Firefox).
	
	              // Determine if the direction of the dropdown needs to be changed.
	              if (offset.top + offset.height + offsetDropdown.height > scrollTop + $document[0].documentElement.clientHeight) {
	                //Go UP
	                setDropdownPosUp(offset, offsetDropdown);
	              }else{
	                //Go DOWN
	                setDropdownPosDown(offset, offsetDropdown);
	              }
	            }
	
	            // Display the dropdown once it has been positioned.
	            dropdown[0].style.opacity = 1;
	          });
	        };
	
	        var opened = false;
	        
	        scope.calculateDropdownPos = function() {
	          if ($select.open) {
	            dropdown = angular.element(element).querySelectorAll('.ui-select-dropdown');
	
	            if (dropdown.length === 0) {
	              return;
	            }
	
	           // Hide the dropdown so there is no flicker until $timeout is done executing.
	           if ($select.search === '' && !opened) {
	              dropdown[0].style.opacity = 0;
	              opened = true;
	           }
	
	            if (!uisOffset(dropdown).height && $select.$animate && $select.$animate.on && $select.$animate.enabled(dropdown)) {
	              var needsCalculated = true;
	
	              $select.$animate.on('enter', dropdown, function (elem, phase) {
	                if (phase === 'close' && needsCalculated) {
	                  calculateDropdownPosAfterAnimation();
	                  needsCalculated = false;
	                }
	              });
	            } else {
	              calculateDropdownPosAfterAnimation();
	            }
	          } else {
	            if (dropdown === null || dropdown.length === 0) {
	              return;
	            }
	
	            // Reset the position of the dropdown.
	            dropdown[0].style.opacity = 0;
	            dropdown[0].style.position = '';
	            dropdown[0].style.top = '';
	            element.removeClass(directionUpClassName);
	          }
	        };
	      };
	    }
	  };
	}]);
	
	uis.directive('uiSelectMatch', ['uiSelectConfig', function(uiSelectConfig) {
	  return {
	    restrict: 'EA',
	    require: '^uiSelect',
	    replace: true,
	    transclude: true,
	    templateUrl: function(tElement) {
	      // Needed so the uiSelect can detect the transcluded content
	      tElement.addClass('ui-select-match');
	
	      var parent = tElement.parent();
	      // Gets theme attribute from parent (ui-select)
	      var theme = getAttribute(parent, 'theme') || uiSelectConfig.theme;
	      var multi = angular.isDefined(getAttribute(parent, 'multiple'));
	
	      return theme + (multi ? '/match-multiple.tpl.html' : '/match.tpl.html');      
	    },
	    link: function(scope, element, attrs, $select) {
	      $select.lockChoiceExpression = attrs.uiLockChoice;
	      attrs.$observe('placeholder', function(placeholder) {
	        $select.placeholder = placeholder !== undefined ? placeholder : uiSelectConfig.placeholder;
	      });
	
	      function setAllowClear(allow) {
	        $select.allowClear = (angular.isDefined(allow)) ? (allow === '') ? true : (allow.toLowerCase() === 'true') : false;
	      }
	
	      attrs.$observe('allowClear', setAllowClear);
	      setAllowClear(attrs.allowClear);
	
	      if($select.multiple){
	        $select.sizeSearchInput();
	      }
	
	    }
	  };
	
	  function getAttribute(elem, attribute) {
	    if (elem[0].hasAttribute(attribute))
	      return elem.attr(attribute);
	
	    if (elem[0].hasAttribute('data-' + attribute))
	      return elem.attr('data-' + attribute);
	
	    if (elem[0].hasAttribute('x-' + attribute))
	      return elem.attr('x-' + attribute);
	  }
	}]);
	
	uis.directive('uiSelectMultiple', ['uiSelectMinErr','$timeout', function(uiSelectMinErr, $timeout) {
	  return {
	    restrict: 'EA',
	    require: ['^uiSelect', '^ngModel'],
	
	    controller: ['$scope','$timeout', function($scope, $timeout){
	
	      var ctrl = this,
	          $select = $scope.$select,
	          ngModel;
	
	      if (angular.isUndefined($select.selected))
	        $select.selected = [];
	
	      //Wait for link fn to inject it
	      $scope.$evalAsync(function(){ ngModel = $scope.ngModel; });
	
	      ctrl.activeMatchIndex = -1;
	
	      ctrl.updateModel = function(){
	        ngModel.$setViewValue(Date.now()); //Set timestamp as a unique string to force changes
	        ctrl.refreshComponent();
	      };
	
	      ctrl.refreshComponent = function(){
	        //Remove already selected items
	        //e.g. When user clicks on a selection, the selected array changes and
	        //the dropdown should remove that item
	        if($select.refreshItems){
	          $select.refreshItems();
	        }
	        if($select.sizeSearchInput){
	          $select.sizeSearchInput();
	        }
	      };
	
	      // Remove item from multiple select
	      ctrl.removeChoice = function(index){
	
	        // if the choice is locked, don't remove it
	        if($select.isLocked(null, index)) return false;
	
	        var removedChoice = $select.selected[index];
	
	        var locals = {};
	        locals[$select.parserResult.itemName] = removedChoice;
	
	        $select.selected.splice(index, 1);
	        ctrl.activeMatchIndex = -1;
	        $select.sizeSearchInput();
	
	        // Give some time for scope propagation.
	        $timeout(function(){
	          $select.onRemoveCallback($scope, {
	            $item: removedChoice,
	            $model: $select.parserResult.modelMapper($scope, locals)
	          });
	        });
	
	        ctrl.updateModel();
	
	        return true;
	      };
	
	      ctrl.getPlaceholder = function(){
	        //Refactor single?
	        if($select.selected && $select.selected.length) return;
	        return $select.placeholder;
	      };
	
	
	    }],
	    controllerAs: '$selectMultiple',
	
	    link: function(scope, element, attrs, ctrls) {
	
	      var $select = ctrls[0];
	      var ngModel = scope.ngModel = ctrls[1];
	      var $selectMultiple = scope.$selectMultiple;
	
	      //$select.selected = raw selected objects (ignoring any property binding)
	
	      $select.multiple = true;
	
	      //Input that will handle focus
	      $select.focusInput = $select.searchInput;
	
	      //Properly check for empty if set to multiple
	      ngModel.$isEmpty = function(value) {
	        return !value || value.length === 0;
	      };
	
	      //From view --> model
	      ngModel.$parsers.unshift(function () {
	        var locals = {},
	            result,
	            resultMultiple = [];
	        for (var j = $select.selected.length - 1; j >= 0; j--) {
	          locals = {};
	          locals[$select.parserResult.itemName] = $select.selected[j];
	          result = $select.parserResult.modelMapper(scope, locals);
	          resultMultiple.unshift(result);
	        }
	        return resultMultiple;
	      });
	
	      // From model --> view
	      ngModel.$formatters.unshift(function (inputValue) {
	        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
	            locals = {},
	            result;
	        if (!data) return inputValue;
	        var resultMultiple = [];
	        var checkFnMultiple = function(list, value){
	          if (!list || !list.length) return;
	          for (var p = list.length - 1; p >= 0; p--) {
	            locals[$select.parserResult.itemName] = list[p];
	            result = $select.parserResult.modelMapper(scope, locals);
	            if($select.parserResult.trackByExp){
	                var propsItemNameMatches = /(\w*)\./.exec($select.parserResult.trackByExp);
	                var matches = /\.([^\s]+)/.exec($select.parserResult.trackByExp);
	                if(propsItemNameMatches && propsItemNameMatches.length > 0 && propsItemNameMatches[1] == $select.parserResult.itemName){
	                  if(matches && matches.length>0 && result[matches[1]] == value[matches[1]]){
	                      resultMultiple.unshift(list[p]);
	                      return true;
	                  }
	                }
	            }
	            if (angular.equals(result,value)){
	              resultMultiple.unshift(list[p]);
	              return true;
	            }
	          }
	          return false;
	        };
	        if (!inputValue) return resultMultiple; //If ngModel was undefined
	        for (var k = inputValue.length - 1; k >= 0; k--) {
	          //Check model array of currently selected items
	          if (!checkFnMultiple($select.selected, inputValue[k])){
	            //Check model array of all items available
	            if (!checkFnMultiple(data, inputValue[k])){
	              //If not found on previous lists, just add it directly to resultMultiple
	              resultMultiple.unshift(inputValue[k]);
	            }
	          }
	        }
	        return resultMultiple;
	      });
	
	      //Watch for external model changes
	      scope.$watchCollection(function(){ return ngModel.$modelValue; }, function(newValue, oldValue) {
	        if (oldValue != newValue){
	          //update the view value with fresh data from items, if there is a valid model value
	          if(angular.isDefined(ngModel.$modelValue)) {
	            ngModel.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
	          }
	          $selectMultiple.refreshComponent();
	        }
	      });
	
	      ngModel.$render = function() {
	        // Make sure that model value is array
	        if(!angular.isArray(ngModel.$viewValue)){
	          // Have tolerance for null or undefined values
	          if (isNil(ngModel.$viewValue)){
	            ngModel.$viewValue = [];
	          } else {
	            throw uiSelectMinErr('multiarr', "Expected model value to be array but got '{0}'", ngModel.$viewValue);
	          }
	        }
	        $select.selected = ngModel.$viewValue;
	        $selectMultiple.refreshComponent();
	        scope.$evalAsync(); //To force $digest
	      };
	
	      scope.$on('uis:select', function (event, item) {
	        if($select.selected.length >= $select.limit) {
	          return;
	        }
	        $select.selected.push(item);
	        var locals = {};
	        locals[$select.parserResult.itemName] = item;
	
	        $timeout(function(){
	          $select.onSelectCallback(scope, {
	            $item: item,
	            $model: $select.parserResult.modelMapper(scope, locals)
	          });
	        });
	        $selectMultiple.updateModel();
	      });
	
	      scope.$on('uis:activate', function () {
	        $selectMultiple.activeMatchIndex = -1;
	      });
	
	      scope.$watch('$select.disabled', function(newValue, oldValue) {
	        // As the search input field may now become visible, it may be necessary to recompute its size
	        if (oldValue && !newValue) $select.sizeSearchInput();
	      });
	
	      $select.searchInput.on('keydown', function(e) {
	        var key = e.which;
	        scope.$apply(function() {
	          var processed = false;
	          // var tagged = false; //Checkme
	          if(KEY.isHorizontalMovement(key)){
	            processed = _handleMatchSelection(key);
	          }
	          if (processed  && key != KEY.TAB) {
	            //TODO Check si el tab selecciona aun correctamente
	            //Crear test
	            e.preventDefault();
	            e.stopPropagation();
	          }
	        });
	      });
	      function _getCaretPosition(el) {
	        if(angular.isNumber(el.selectionStart)) return el.selectionStart;
	        // selectionStart is not supported in IE8 and we don't want hacky workarounds so we compromise
	        else return el.value.length;
	      }
	      // Handles selected options in "multiple" mode
	      function _handleMatchSelection(key){
	        var caretPosition = _getCaretPosition($select.searchInput[0]),
	            length = $select.selected.length,
	            // none  = -1,
	            first = 0,
	            last  = length-1,
	            curr  = $selectMultiple.activeMatchIndex,
	            next  = $selectMultiple.activeMatchIndex+1,
	            prev  = $selectMultiple.activeMatchIndex-1,
	            newIndex = curr;
	
	        if(caretPosition > 0 || ($select.search.length && key == KEY.RIGHT)) return false;
	
	        $select.close();
	
	        function getNewActiveMatchIndex(){
	          switch(key){
	            case KEY.LEFT:
	              // Select previous/first item
	              if(~$selectMultiple.activeMatchIndex) return prev;
	              // Select last item
	              else return last;
	              break;
	            case KEY.RIGHT:
	              // Open drop-down
	              if(!~$selectMultiple.activeMatchIndex || curr === last){
	                $select.activate();
	                return false;
	              }
	              // Select next/last item
	              else return next;
	              break;
	            case KEY.BACKSPACE:
	              // Remove selected item and select previous/first
	              if(~$selectMultiple.activeMatchIndex){
	                if($selectMultiple.removeChoice(curr)) {
	                  return prev;
	                } else {
	                  return curr;
	                }
	
	              } else {
	                // If nothing yet selected, select last item
	                return last;
	              }
	              break;
	            case KEY.DELETE:
	              // Remove selected item and select next item
	              if(~$selectMultiple.activeMatchIndex){
	                $selectMultiple.removeChoice($selectMultiple.activeMatchIndex);
	                return curr;
	              }
	              else return false;
	          }
	        }
	
	        newIndex = getNewActiveMatchIndex();
	
	        if(!$select.selected.length || newIndex === false) $selectMultiple.activeMatchIndex = -1;
	        else $selectMultiple.activeMatchIndex = Math.min(last,Math.max(first,newIndex));
	
	        return true;
	      }
	
	      $select.searchInput.on('keyup', function(e) {
	
	        if ( ! KEY.isVerticalMovement(e.which) ) {
	          scope.$evalAsync( function () {
	            $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	          });
	        }
	        // Push a "create new" item into array if there is a search string
	        if ( $select.tagging.isActivated && $select.search.length > 0 ) {
	
	          // return early with these keys
	          if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || KEY.isVerticalMovement(e.which) ) {
	            return;
	          }
	          // always reset the activeIndex to the first item when tagging
	          $select.activeIndex = $select.taggingLabel === false ? -1 : 0;
	          // taggingLabel === false bypasses all of this
	          if ($select.taggingLabel === false) return;
	
	          var items = angular.copy( $select.items );
	          var stashArr = angular.copy( $select.items );
	          var newItem;
	          var item;
	          var hasTag = false;
	          var dupeIndex = -1;
	          var tagItems;
	          var tagItem;
	
	          // case for object tagging via transform `$select.tagging.fct` function
	          if ( $select.tagging.fct !== undefined) {
	            tagItems = $select.$filter('filter')(items,{'isTag': true});
	            if ( tagItems.length > 0 ) {
	              tagItem = tagItems[0];
	            }
	            // remove the first element, if it has the `isTag` prop we generate a new one with each keyup, shaving the previous
	            if ( items.length > 0 && tagItem ) {
	              hasTag = true;
	              items = items.slice(1,items.length);
	              stashArr = stashArr.slice(1,stashArr.length);
	            }
	            newItem = $select.tagging.fct($select.search);
	            // verify the new tag doesn't match the value of a possible selection choice or an already selected item.
	            if (
	              stashArr.some(function (origItem) {
	                 return angular.equals(origItem, newItem);
	              }) ||
	              $select.selected.some(function (origItem) {
	                return angular.equals(origItem, newItem);
	              })
	            ) {
	              scope.$evalAsync(function () {
	                $select.activeIndex = 0;
	                $select.items = items;
	              });
	              return;
	            }
	            if (newItem) newItem.isTag = true;
	          // handle newItem string and stripping dupes in tagging string context
	          } else {
	            // find any tagging items already in the $select.items array and store them
	            tagItems = $select.$filter('filter')(items,function (item) {
	              return item.match($select.taggingLabel);
	            });
	            if ( tagItems.length > 0 ) {
	              tagItem = tagItems[0];
	            }
	            item = items[0];
	            // remove existing tag item if found (should only ever be one tag item)
	            if ( item !== undefined && items.length > 0 && tagItem ) {
	              hasTag = true;
	              items = items.slice(1,items.length);
	              stashArr = stashArr.slice(1,stashArr.length);
	            }
	            newItem = $select.search+' '+$select.taggingLabel;
	            if ( _findApproxDupe($select.selected, $select.search) > -1 ) {
	              return;
	            }
	            // verify the the tag doesn't match the value of an existing item from
	            // the searched data set or the items already selected
	            if ( _findCaseInsensitiveDupe(stashArr.concat($select.selected)) ) {
	              // if there is a tag from prev iteration, strip it / queue the change
	              // and return early
	              if ( hasTag ) {
	                items = stashArr;
	                scope.$evalAsync( function () {
	                  $select.activeIndex = 0;
	                  $select.items = items;
	                });
	              }
	              return;
	            }
	            if ( _findCaseInsensitiveDupe(stashArr) ) {
	              // if there is a tag from prev iteration, strip it
	              if ( hasTag ) {
	                $select.items = stashArr.slice(1,stashArr.length);
	              }
	              return;
	            }
	          }
	          if ( hasTag ) dupeIndex = _findApproxDupe($select.selected, newItem);
	          // dupe found, shave the first item
	          if ( dupeIndex > -1 ) {
	            items = items.slice(dupeIndex+1,items.length-1);
	          } else {
	            items = [];
	            if (newItem) items.push(newItem);
	            items = items.concat(stashArr);
	          }
	          scope.$evalAsync( function () {
	            $select.activeIndex = 0;
	            $select.items = items;
	
	            if ($select.isGrouped) {
	              // update item references in groups, so that indexOf will work after angular.copy
	              var itemsWithoutTag = newItem ? items.slice(1) : items;
	              $select.setItemsFn(itemsWithoutTag);
	              if (newItem) {
	                // add tag item as a new group
	                $select.items.unshift(newItem);
	                $select.groups.unshift({name: '', items: [newItem], tagging: true});
	              }
	            }
	          });
	        }
	      });
	      function _findCaseInsensitiveDupe(arr) {
	        if ( arr === undefined || $select.search === undefined ) {
	          return false;
	        }
	        var hasDupe = arr.filter( function (origItem) {
	          if ( $select.search.toUpperCase() === undefined || origItem === undefined ) {
	            return false;
	          }
	          return origItem.toUpperCase() === $select.search.toUpperCase();
	        }).length > 0;
	
	        return hasDupe;
	      }
	      function _findApproxDupe(haystack, needle) {
	        var dupeIndex = -1;
	        if(angular.isArray(haystack)) {
	          var tempArr = angular.copy(haystack);
	          for (var i = 0; i <tempArr.length; i++) {
	            // handle the simple string version of tagging
	            if ( $select.tagging.fct === undefined ) {
	              // search the array for the match
	              if ( tempArr[i]+' '+$select.taggingLabel === needle ) {
	              dupeIndex = i;
	              }
	            // handle the object tagging implementation
	            } else {
	              var mockObj = tempArr[i];
	              if (angular.isObject(mockObj)) {
	                mockObj.isTag = true;
	              }
	              if ( angular.equals(mockObj, needle) ) {
	                dupeIndex = i;
	              }
	            }
	          }
	        }
	        return dupeIndex;
	      }
	
	      $select.searchInput.on('blur', function() {
	        $timeout(function() {
	          $selectMultiple.activeMatchIndex = -1;
	        });
	      });
	
	    }
	  };
	}]);
	
	uis.directive('uiSelectNoChoice',
	    ['uiSelectConfig', function (uiSelectConfig) {
	        return {
	            restrict: 'EA',
	            require: '^uiSelect',
	            replace: true,
	            transclude: true,
	            templateUrl: function (tElement) {
	                // Needed so the uiSelect can detect the transcluded content
	                tElement.addClass('ui-select-no-choice');
	      
	                // Gets theme attribute from parent (ui-select)
	                var theme = tElement.parent().attr('theme') || uiSelectConfig.theme;
	                return theme + '/no-choice.tpl.html';
	            }
	        };
	    }]);
	
	uis.directive('uiSelectSingle', ['$timeout','$compile', function($timeout, $compile) {
	  return {
	    restrict: 'EA',
	    require: ['^uiSelect', '^ngModel'],
	    link: function(scope, element, attrs, ctrls) {
	
	      var $select = ctrls[0];
	      var ngModel = ctrls[1];
	
	      //From view --> model
	      ngModel.$parsers.unshift(function (inputValue) {
	        // Keep original value for undefined and null
	        if (isNil(inputValue)) {
	          return inputValue;
	        }
	
	        var locals = {},
	            result;
	        locals[$select.parserResult.itemName] = inputValue;
	        result = $select.parserResult.modelMapper(scope, locals);
	        return result;
	      });
	
	      //From model --> view
	      ngModel.$formatters.unshift(function (inputValue) {
	        // Keep original value for undefined and null
	        if (isNil(inputValue)) {
	          return inputValue;
	        }
	
	        var data = $select.parserResult && $select.parserResult.source (scope, { $select : {search:''}}), //Overwrite $search
	            locals = {},
	            result;
	        if (data){
	          var checkFnSingle = function(d){
	            locals[$select.parserResult.itemName] = d;
	            result = $select.parserResult.modelMapper(scope, locals);
	            return result === inputValue;
	          };
	          //If possible pass same object stored in $select.selected
	          if ($select.selected && checkFnSingle($select.selected)) {
	            return $select.selected;
	          }
	          for (var i = data.length - 1; i >= 0; i--) {
	            if (checkFnSingle(data[i])) return data[i];
	          }
	        }
	        return inputValue;
	      });
	
	      //Update viewValue if model change
	      scope.$watch('$select.selected', function(newValue) {
	        if (ngModel.$viewValue !== newValue) {
	          ngModel.$setViewValue(newValue);
	        }
	      });
	
	      ngModel.$render = function() {
	        $select.selected = ngModel.$viewValue;
	      };
	
	      scope.$on('uis:select', function (event, item) {
	        $select.selected = item;
	        var locals = {};
	        locals[$select.parserResult.itemName] = item;
	
	        $timeout(function() {
	          $select.onSelectCallback(scope, {
	            $item: item,
	            $model: isNil(item) ? item : $select.parserResult.modelMapper(scope, locals)
	          });
	        });
	      });
	
	      scope.$on('uis:close', function (event, skipFocusser) {
	        $timeout(function(){
	          $select.focusser.prop('disabled', false);
	          if (!skipFocusser) $select.focusser[0].focus();
	        },0,false);
	      });
	
	      scope.$on('uis:activate', function () {
	        focusser.prop('disabled', true); //Will reactivate it on .close()
	      });
	
	      //Idea from: https://github.com/ivaynberg/select2/blob/79b5bf6db918d7560bdd959109b7bcfb47edaf43/select2.js#L1954
	      var focusser = angular.element("<input ng-disabled='$select.disabled' class='ui-select-focusser ui-select-offscreen' type='text' id='{{ $select.focusserId }}' aria-label='{{ $select.focusserTitle }}' aria-haspopup='true' role='button' />");
	      $compile(focusser)(scope);
	      $select.focusser = focusser;
	
	      //Input that will handle focus
	      $select.focusInput = focusser;
	
	      element.parent().append(focusser);
	      focusser.bind("focus", function(){
	        scope.$evalAsync(function(){
	          $select.focus = true;
	        });
	      });
	      focusser.bind("blur", function(){
	        scope.$evalAsync(function(){
	          $select.focus = false;
	        });
	      });
	      focusser.bind("keydown", function(e){
	
	        if (e.which === KEY.BACKSPACE && $select.backspaceReset !== false) {
	          e.preventDefault();
	          e.stopPropagation();
	          $select.select(undefined);
	          scope.$apply();
	          return;
	        }
	
	        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC) {
	          return;
	        }
	
	        if (e.which == KEY.DOWN  || e.which == KEY.UP || e.which == KEY.ENTER || e.which == KEY.SPACE){
	          e.preventDefault();
	          e.stopPropagation();
	          $select.activate();
	        }
	
	        scope.$digest();
	      });
	
	      focusser.bind("keyup input", function(e){
	
	        if (e.which === KEY.TAB || KEY.isControl(e) || KEY.isFunctionKey(e) || e.which === KEY.ESC || e.which == KEY.ENTER || e.which === KEY.BACKSPACE) {
	          return;
	        }
	
	        $select.activate(focusser.val()); //User pressed some regular key, so we pass it to the search input
	        focusser.val('');
	        scope.$digest();
	
	      });
	
	
	    }
	  };
	}]);
	
	// Make multiple matches sortable
	uis.directive('uiSelectSort', ['$timeout', 'uiSelectConfig', 'uiSelectMinErr', function($timeout, uiSelectConfig, uiSelectMinErr) {
	  return {
	    require: ['^^uiSelect', '^ngModel'],
	    link: function(scope, element, attrs, ctrls) {
	      if (scope[attrs.uiSelectSort] === null) {
	        throw uiSelectMinErr('sort', 'Expected a list to sort');
	      }
	
	      var $select = ctrls[0];
	      var $ngModel = ctrls[1];
	
	      var options = angular.extend({
	          axis: 'horizontal'
	        },
	        scope.$eval(attrs.uiSelectSortOptions));
	
	      var axis = options.axis;
	      var draggingClassName = 'dragging';
	      var droppingClassName = 'dropping';
	      var droppingBeforeClassName = 'dropping-before';
	      var droppingAfterClassName = 'dropping-after';
	
	      scope.$watch(function(){
	        return $select.sortable;
	      }, function(newValue){
	        if (newValue) {
	          element.attr('draggable', true);
	        } else {
	          element.removeAttr('draggable');
	        }
	      });
	
	      element.on('dragstart', function(event) {
	        element.addClass(draggingClassName);
	
	        (event.dataTransfer || event.originalEvent.dataTransfer).setData('text', scope.$index.toString());
	      });
	
	      element.on('dragend', function() {
	        removeClass(draggingClassName);
	      });
	
	      var move = function(from, to) {
	        /*jshint validthis: true */
	        this.splice(to, 0, this.splice(from, 1)[0]);
	      };
	
	      var removeClass = function(className) {
	        angular.forEach($select.$element.querySelectorAll('.' + className), function(el){
	          angular.element(el).removeClass(className);
	        });
	      };
	
	      var dragOverHandler = function(event) {
	        event.preventDefault();
	
	        var offset = axis === 'vertical' ? event.offsetY || event.layerY || (event.originalEvent ? event.originalEvent.offsetY : 0) : event.offsetX || event.layerX || (event.originalEvent ? event.originalEvent.offsetX : 0);
	
	        if (offset < (this[axis === 'vertical' ? 'offsetHeight' : 'offsetWidth'] / 2)) {
	          removeClass(droppingAfterClassName);
	          element.addClass(droppingBeforeClassName);
	
	        } else {
	          removeClass(droppingBeforeClassName);
	          element.addClass(droppingAfterClassName);
	        }
	      };
	
	      var dropTimeout;
	
	      var dropHandler = function(event) {
	        event.preventDefault();
	
	        var droppedItemIndex = parseInt((event.dataTransfer || event.originalEvent.dataTransfer).getData('text'), 10);
	
	        // prevent event firing multiple times in firefox
	        $timeout.cancel(dropTimeout);
	        dropTimeout = $timeout(function() {
	          _dropHandler(droppedItemIndex);
	        }, 20);
	      };
	
	      var _dropHandler = function(droppedItemIndex) {
	        var theList = scope.$eval(attrs.uiSelectSort);
	        var itemToMove = theList[droppedItemIndex];
	        var newIndex = null;
	
	        if (element.hasClass(droppingBeforeClassName)) {
	          if (droppedItemIndex < scope.$index) {
	            newIndex = scope.$index - 1;
	          } else {
	            newIndex = scope.$index;
	          }
	        } else {
	          if (droppedItemIndex < scope.$index) {
	            newIndex = scope.$index;
	          } else {
	            newIndex = scope.$index + 1;
	          }
	        }
	
	        move.apply(theList, [droppedItemIndex, newIndex]);
	
	        $ngModel.$setViewValue(Date.now());
	
	        scope.$apply(function() {
	          scope.$emit('uiSelectSort:change', {
	            array: theList,
	            item: itemToMove,
	            from: droppedItemIndex,
	            to: newIndex
	          });
	        });
	
	        removeClass(droppingClassName);
	        removeClass(droppingBeforeClassName);
	        removeClass(droppingAfterClassName);
	
	        element.off('drop', dropHandler);
	      };
	
	      element.on('dragenter', function() {
	        if (element.hasClass(draggingClassName)) {
	          return;
	        }
	
	        element.addClass(droppingClassName);
	
	        element.on('dragover', dragOverHandler);
	        element.on('drop', dropHandler);
	      });
	
	      element.on('dragleave', function(event) {
	        if (event.target != element) {
	          return;
	        }
	
	        removeClass(droppingClassName);
	        removeClass(droppingBeforeClassName);
	        removeClass(droppingAfterClassName);
	
	        element.off('dragover', dragOverHandler);
	        element.off('drop', dropHandler);
	      });
	    }
	  };
	}]);
	
	/**
	 * Debounces functions
	 *
	 * Taken from UI Bootstrap $$debounce source code
	 * See https://github.com/angular-ui/bootstrap/blob/master/src/debounce/debounce.js
	 *
	 */
	uis.factory('$$uisDebounce', ['$timeout', function($timeout) {
	  return function(callback, debounceTime) {
	    var timeoutPromise;
	
	    return function() {
	      var self = this;
	      var args = Array.prototype.slice.call(arguments);
	      if (timeoutPromise) {
	        $timeout.cancel(timeoutPromise);
	      }
	
	      timeoutPromise = $timeout(function() {
	        callback.apply(self, args);
	      }, debounceTime);
	    };
	  };
	}]);
	
	uis.directive('uisOpenClose', ['$parse', '$timeout', function ($parse, $timeout) {
	  return {
	    restrict: 'A',
	    require: 'uiSelect',
	    link: function (scope, element, attrs, $select) {
	      $select.onOpenCloseCallback = $parse(attrs.uisOpenClose);
	
	      scope.$watch('$select.open', function (isOpen, previousState) {
	        if (isOpen !== previousState) {
	          $timeout(function () {
	            $select.onOpenCloseCallback(scope, {
	              isOpen: isOpen
	            });
	          });
	        }
	      });
	    }
	  };
	}]);
	
	/**
	 * Parses "repeat" attribute.
	 *
	 * Taken from AngularJS ngRepeat source code
	 * See https://github.com/angular/angular.js/blob/v1.2.15/src/ng/directive/ngRepeat.js#L211
	 *
	 * Original discussion about parsing "repeat" attribute instead of fully relying on ng-repeat:
	 * https://github.com/angular-ui/ui-select/commit/5dd63ad#commitcomment-5504697
	 */
	
	uis.service('uisRepeatParser', ['uiSelectMinErr','$parse', function(uiSelectMinErr, $parse) {
	  var self = this;
	
	  /**
	   * Example:
	   * expression = "address in addresses | filter: {street: $select.search} track by $index"
	   * itemName = "address",
	   * source = "addresses | filter: {street: $select.search}",
	   * trackByExp = "$index",
	   */
	  self.parse = function(expression) {
	
	
	    var match;
	    //var isObjectCollection = /\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)/.test(expression);
	    // If an array is used as collection
	
	    // if (isObjectCollection){
	    // 000000000000000000000000000000111111111000000000000000222222222222220033333333333333333333330000444444444444444444000000000000000055555555555000000000000000000000066666666600000000
	    match = expression.match(/^\s*(?:([\s\S]+?)\s+as\s+)?(?:([\$\w][\$\w]*)|(?:\(\s*([\$\w][\$\w]*)\s*,\s*([\$\w][\$\w]*)\s*\)))\s+in\s+(\s*[\s\S]+?)?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
	
	    // 1 Alias
	    // 2 Item
	    // 3 Key on (key,value)
	    // 4 Value on (key,value)
	    // 5 Source expression (including filters)
	    // 6 Track by
	
	    if (!match) {
	      throw uiSelectMinErr('iexp', "Expected expression in form of '_item_ in _collection_[ track by _id_]' but got '{0}'.",
	              expression);
	    }
	    
	    var source = match[5], 
	        filters = '';
	
	    // When using (key,value) ui-select requires filters to be extracted, since the object
	    // is converted to an array for $select.items 
	    // (in which case the filters need to be reapplied)
	    if (match[3]) {
	      // Remove any enclosing parenthesis
	      source = match[5].replace(/(^\()|(\)$)/g, '');
	      // match all after | but not after ||
	      var filterMatch = match[5].match(/^\s*(?:[\s\S]+?)(?:[^\|]|\|\|)+([\s\S]*)\s*$/);
	      if(filterMatch && filterMatch[1].trim()) {
	        filters = filterMatch[1];
	        source = source.replace(filters, '');
	      }      
	    }
	
	    return {
	      itemName: match[4] || match[2], // (lhs) Left-hand side,
	      keyName: match[3], //for (key, value) syntax
	      source: $parse(source),
	      filters: filters,
	      trackByExp: match[6],
	      modelMapper: $parse(match[1] || match[4] || match[2]),
	      repeatExpression: function (grouped) {
	        var expression = this.itemName + ' in ' + (grouped ? '$group.items' : '$select.items');
	        if (this.trackByExp) {
	          expression += ' track by ' + this.trackByExp;
	        }
	        return expression;
	      } 
	    };
	
	  };
	
	  self.getGroupNgRepeatExpression = function() {
	    return '$group in $select.groups track by $group.name';
	  };
	
	}]);
	
	}());
	angular.module("ui.select").run(["$templateCache", function($templateCache) {$templateCache.put("bootstrap/choices.tpl.html","<ul class=\"ui-select-choices ui-select-choices-content ui-select-dropdown dropdown-menu\" ng-show=\"$select.open && $select.items.length > 0\"><li class=\"ui-select-choices-group\" id=\"ui-select-choices-{{ $select.generatedId }}\"><div class=\"divider\" ng-show=\"$select.isGrouped && $index > 0\"></div><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label dropdown-header\" ng-bind=\"$group.name\"></div><div ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\" role=\"option\"><span class=\"ui-select-choices-row-inner\"></span></div></li></ul>");
	$templateCache.put("bootstrap/match-multiple.tpl.html","<span class=\"ui-select-match\"><span ng-repeat=\"$item in $select.selected track by $index\"><span class=\"ui-select-match-item btn btn-default btn-xs\" tabindex=\"-1\" type=\"button\" ng-disabled=\"$select.disabled\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'btn-primary\':$selectMultiple.activeMatchIndex === $index, \'select-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span class=\"close ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&nbsp;&times;</span> <span uis-transclude-append=\"\"></span></span></span></span>");
	$templateCache.put("bootstrap/match.tpl.html","<div class=\"ui-select-match\" ng-hide=\"$select.open && $select.searchEnabled\" ng-disabled=\"$select.disabled\" ng-class=\"{\'btn-default-focus\':$select.focus}\"><span tabindex=\"-1\" class=\"btn btn-default form-control ui-select-toggle\" aria-label=\"{{ $select.baseTitle }} activate\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" style=\"outline: 0;\"><span ng-show=\"$select.isEmpty()\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"ui-select-match-text pull-left\" ng-class=\"{\'ui-select-allow-clear\': $select.allowClear && !$select.isEmpty()}\" ng-transclude=\"\"></span> <i class=\"caret pull-right\" ng-click=\"$select.toggle($event)\"></i> <a ng-show=\"$select.allowClear && !$select.isEmpty() && ($select.disabled !== true)\" aria-label=\"{{ $select.baseTitle }} clear\" style=\"margin-right: 10px\" ng-click=\"$select.clear($event)\" class=\"btn btn-xs btn-link pull-right\"><i class=\"glyphicon glyphicon-remove\" aria-hidden=\"true\"></i></a></span></div>");
	$templateCache.put("bootstrap/no-choice.tpl.html","<ul class=\"ui-select-no-choice dropdown-menu\" ng-show=\"$select.items.length == 0\"><li ng-transclude=\"\"></li></ul>");
	$templateCache.put("bootstrap/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple ui-select-bootstrap dropdown form-control\" ng-class=\"{open: $select.open}\"><div><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" class=\"ui-select-search input-xs\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-click=\"$select.activate()\" ng-model=\"$select.search\" role=\"combobox\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{$select.baseTitle}}\" ng-class=\"{\'spinner\': $select.refreshing}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("bootstrap/select.tpl.html","<div class=\"ui-select-container ui-select-bootstrap dropdown\" ng-class=\"{open: $select.open}\"><div class=\"ui-select-match\"></div><span ng-show=\"$select.open && $select.refreshing && $select.spinnerEnabled\" class=\"ui-select-refreshing {{$select.spinnerClass}}\"></span> <input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" aria-expanded=\"true\" aria-label=\"{{ $select.baseTitle }}\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" class=\"form-control ui-select-search\" ng-class=\"{ \'ui-select-search-hidden\' : !$select.searchEnabled }\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-show=\"$select.open\"><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("select2/choices.tpl.html","<ul tabindex=\"-1\" class=\"ui-select-choices ui-select-choices-content select2-results\"><li class=\"ui-select-choices-group\" ng-class=\"{\'select2-result-with-children\': $select.choiceGrouped($group) }\"><div ng-show=\"$select.choiceGrouped($group)\" class=\"ui-select-choices-group-label select2-result-label\" ng-bind=\"$group.name\"></div><ul id=\"ui-select-choices-{{ $select.generatedId }}\" ng-class=\"{\'select2-result-sub\': $select.choiceGrouped($group), \'select2-result-single\': !$select.choiceGrouped($group) }\"><li role=\"option\" ng-attr-id=\"ui-select-choices-row-{{ $select.generatedId }}-{{$index}}\" class=\"ui-select-choices-row\" ng-class=\"{\'select2-highlighted\': $select.isActive(this), \'select2-disabled\': $select.isDisabled(this)}\"><div class=\"select2-result-label ui-select-choices-row-inner\"></div></li></ul></li></ul>");
	$templateCache.put("select2/match-multiple.tpl.html","<span class=\"ui-select-match\"><li class=\"ui-select-match-item select2-search-choice\" ng-repeat=\"$item in $select.selected track by $index\" ng-class=\"{\'select2-search-choice-focus\':$selectMultiple.activeMatchIndex === $index, \'select2-locked\':$select.isLocked(this, $index)}\" ui-select-sort=\"$select.selected\"><span uis-transclude-append=\"\"></span> <a href=\"javascript:;\" class=\"ui-select-match-close select2-search-choice-close\" ng-click=\"$selectMultiple.removeChoice($index)\" tabindex=\"-1\"></a></li></span>");
	$templateCache.put("select2/match.tpl.html","<a class=\"select2-choice ui-select-match\" ng-class=\"{\'select2-default\': $select.isEmpty()}\" ng-click=\"$select.toggle($event)\" aria-label=\"{{ $select.baseTitle }} select\"><span ng-show=\"$select.isEmpty()\" class=\"select2-chosen\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty()\" class=\"select2-chosen\" ng-transclude=\"\"></span> <abbr ng-if=\"$select.allowClear && !$select.isEmpty()\" class=\"select2-search-choice-close\" ng-click=\"$select.clear($event)\"></abbr> <span class=\"select2-arrow ui-select-toggle\"><b></b></span></a>");
	$templateCache.put("select2/no-choice.tpl.html","<div class=\"ui-select-no-choice dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	$templateCache.put("select2/select-multiple.tpl.html","<div class=\"ui-select-container ui-select-multiple select2 select2-container select2-container-multi\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled}\"><ul class=\"select2-choices\"><span class=\"ui-select-match\"></span><li class=\"select2-search-field\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" aria-activedescendant=\"ui-select-choices-row-{{ $select.generatedId }}-{{ $select.activeIndex }}\" class=\"select2-input ui-select-search\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-disabled=\"$select.disabled\" ng-hide=\"$select.disabled\" ng-model=\"$select.search\" ng-click=\"$select.activate()\" style=\"width: 34px;\" ondrop=\"return false;\"></li></ul><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open || $select.items.length === 0}\"><div class=\"ui-select-choices\"></div></div></div>");
	$templateCache.put("select2/select.tpl.html","<div class=\"ui-select-container select2 select2-container\" ng-class=\"{\'select2-container-active select2-dropdown-open open\': $select.open, \'select2-container-disabled\': $select.disabled, \'select2-container-active\': $select.focus, \'select2-allowclear\': $select.allowClear && !$select.isEmpty()}\"><div class=\"ui-select-match\"></div><div class=\"ui-select-dropdown select2-drop select2-with-searchbox select2-drop-active\" ng-class=\"{\'select2-display-none\': !$select.open}\"><div class=\"search-container\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled, \'select2-search\':$select.searchEnabled}\"><input type=\"search\" autocomplete=\"off\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" ng-class=\"{\'select2-active\': $select.refreshing}\" role=\"combobox\" aria-expanded=\"true\" aria-owns=\"ui-select-choices-{{ $select.generatedId }}\" aria-label=\"{{ $select.baseTitle }}\" class=\"ui-select-search select2-input\" ng-model=\"$select.search\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div></div>");
	$templateCache.put("selectize/choices.tpl.html","<div ng-show=\"$select.open\" class=\"ui-select-choices ui-select-dropdown selectize-dropdown\" ng-class=\"{\'single\': !$select.multiple, \'multi\': $select.multiple}\"><div class=\"ui-select-choices-content selectize-dropdown-content\"><div class=\"ui-select-choices-group optgroup\"><div ng-show=\"$select.isGrouped\" class=\"ui-select-choices-group-label optgroup-header\" ng-bind=\"$group.name\"></div><div role=\"option\" class=\"ui-select-choices-row\" ng-class=\"{active: $select.isActive(this), disabled: $select.isDisabled(this)}\"><div class=\"option ui-select-choices-row-inner\" data-selectable=\"\"></div></div></div></div></div>");
	$templateCache.put("selectize/match-multiple.tpl.html","<div class=\"ui-select-match\" data-value=\"\" ng-repeat=\"$item in $select.selected track by $index\" ng-click=\"$selectMultiple.activeMatchIndex = $index;\" ng-class=\"{\'active\':$selectMultiple.activeMatchIndex === $index}\" ui-select-sort=\"$select.selected\"><span class=\"ui-select-match-item\" ng-class=\"{\'select-locked\':$select.isLocked(this, $index)}\"><span uis-transclude-append=\"\"></span> <span class=\"remove ui-select-match-close\" ng-hide=\"$select.disabled\" ng-click=\"$selectMultiple.removeChoice($index)\">&times;</span></span></div>");
	$templateCache.put("selectize/match.tpl.html","<div ng-hide=\"$select.searchEnabled && ($select.open || $select.isEmpty())\" class=\"ui-select-match\"><span ng-show=\"!$select.searchEnabled && ($select.isEmpty() || $select.open)\" class=\"ui-select-placeholder text-muted\">{{$select.placeholder}}</span> <span ng-hide=\"$select.isEmpty() || $select.open\" ng-transclude=\"\"></span></div>");
	$templateCache.put("selectize/no-choice.tpl.html","<div class=\"ui-select-no-choice selectize-dropdown\" ng-show=\"$select.items.length == 0\"><div class=\"selectize-dropdown-content\"><div data-selectable=\"\" ng-transclude=\"\"></div></div></div>");
	$templateCache.put("selectize/select-multiple.tpl.html","<div class=\"ui-select-container selectize-control multi plugin-remove_button\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" placeholder=\"{{$selectMultiple.getPlaceholder()}}\" ng-model=\"$select.search\" ng-disabled=\"$select.disabled\" aria-expanded=\"{{$select.open}}\" aria-label=\"{{ $select.baseTitle }}\" ondrop=\"return false;\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");
	$templateCache.put("selectize/select.tpl.html","<div class=\"ui-select-container selectize-control single\" ng-class=\"{\'open\': $select.open}\"><div class=\"selectize-input\" ng-class=\"{\'focus\': $select.open, \'disabled\': $select.disabled, \'selectize-focus\' : $select.focus}\" ng-click=\"$select.open && !$select.searchEnabled ? $select.toggle($event) : $select.activate()\"><div class=\"ui-select-match\"></div><input type=\"search\" autocomplete=\"off\" tabindex=\"-1\" class=\"ui-select-search ui-select-toggle\" ng-class=\"{\'ui-select-search-hidden\':!$select.searchEnabled}\" ng-click=\"$select.toggle($event)\" placeholder=\"{{$select.placeholder}}\" ng-model=\"$select.search\" ng-hide=\"!$select.isEmpty() && !$select.open\" ng-disabled=\"$select.disabled\" aria-label=\"{{ $select.baseTitle }}\"></div><div class=\"ui-select-choices\"></div><div class=\"ui-select-no-choice\"></div></div>");}]);

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _process = __webpack_require__(77);
	
	var _process2 = _interopRequireDefault(_process);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _angular2.default.module('accessApp.process', ['accessApp.auth', 'ui.router']).config(['$stateProvider', function routes($stateProvider) {
		'ngInject';
	
		$stateProvider.state('process', {
			url: '/process',
			template: __webpack_require__(78),
			controller: 'ProcessController',
			controllerAs: 'vm',
			authenticate: true
		});
	}]).controller('ProcessController', _process2.default).name;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _lodash = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function dateStringToDate(date) {
		var split = date.split('/');
		var year = +split[2];
		if (year < 100) {
			year += 2000;
		}
		var month = +split[1] - 1;
		var day = +split[0];
		return new Date(year, month, day);
	}
	
	function dateToDateString(value) {
		var result = new Date(value);
		var dd = result.getDate();
		var mm = result.getMonth() + 1;
	
		var yyyy = result.getFullYear();
	
		var today = dd + '/' + mm + '/' + yyyy;
		return today;
	};
	
	var _class = function () {
		/*@ngInject*/
		_class.$inject = ['$http', 'JSONToCSVConvertor', 'StringToCSV'];
		function _class($http, JSONToCSVConvertor, StringToCSV) {
			_classCallCheck(this, _class);
	
			this.$http = $http;
			this.tutors = [];
			this.students = [];
			this.timesheets = [];
			this.loadData();
			this.JSONToCSVConvertor = JSONToCSVConvertor;
			this.StringToCSV = StringToCSV;
		}
	
		_createClass(_class, [{
			key: "processAll",
			value: function processAll() {
				var _this = this;
	
				if (confirm('Are you sure you want to mark all timesheets as processed?')) {
					this.$http.post('/api/timesheets/process').then(function (res) {
						console.log('Done...');
						_this.loadData();
					});
				}
			}
		}, {
			key: "showMYOB",
			value: function showMYOB() {
				var _this2 = this;
	
				var tutors = this.timesheets.map(function (timesheet) {
					return timesheet.tutorID;
				});
				this.$http.post('/api/timesheets/myob', { tutors: tutors }).then(function (res) {
					var tutors = res.data;
	
					console.log(tutors);
	
					if (tutors.length === 0) {
						return alert('No tutors to be added to MYOB.');
					};
	
					tutors = tutors.map(function (tutorID) {
						return _this2.tutors.find(function (tutor) {
							return tutor.tutorID === tutorID;
						});
					});
	
					_this2.JSONToCSVConvertor(tutors, 'MYOB-Tutors', true);
				});
			}
		}, {
			key: "writeCRM",
			value: function writeCRM() {
				var _this3 = this;
	
				var day = String(this.date.getDate());
				var month = String(this.date.getMonth() + 1);
				var year = String(this.date.getFullYear());
				day = day.indexOf(0) === '0' ? day.substring(1) : day;
				month = month.indexOf(0) === '0' ? month.substring(1) : month;
				var weekEnding = day + '/' + month + '/' + year;
				var students = {};
				var tutors = {};
				this.timesheets.forEach(function (timesheet) {
					if (!(timesheet.studentID in students) && timesheet.studentID) {
						students[timesheet.studentID] = {};
						students[timesheet.studentID]['hours'] = 0;
					}
					if (!(timesheet.tutorID in tutors) && timesheet.tutorID) {
						tutors[timesheet.tutorID] = {};
						tutors[timesheet.tutorID]['hours'] = 0;
					}
				});
				this.$http.post('api/timesheets/multiple-tutor-ids', { ids: Object.keys(tutors) }).then(function (res) {
					console.log(res.data.length);
					if (res.data.length > 0) {
						res.data.forEach(function (timesheet) {
							if (dateStringToDate(timesheet.weekEnding) <= _this3.date) {
								tutors[timesheet.tutorID]['tutor'] = _this3.tutors.find(function (tutor) {
									return tutor.tutorID === timesheet.tutorID;
								});
								tutors[timesheet.tutorID]['hours'] += timesheet.hours;
							}
						});
						console.log(Object.values(tutors).length);
						_this3.$http.post('api/students/write-crm', { tutors: Object.values(tutors) }).then(function (res) {
							console.log(res);
						});
					}
				});
				this.$http.post('api/timesheets/multiple-student-ids', { ids: Object.keys(students) }).then(function (res) {
					if (res.data.length > 0) {
						res.data.forEach(function (timesheet) {
							if (dateStringToDate(timesheet.weekEnding) <= _this3.date) {
								students[timesheet.studentID]['student'] = _this3.students.find(function (student) {
									return student.studentID === timesheet.studentID;
								});
								students[timesheet.studentID]['hours'] += timesheet.hours;
							}
						});
						console.log(Object.values(students).length);
						_this3.$http.post('api/students/write-crm', { students: Object.values(students) }).then(function (res) {
							console.log(res);
						});
						alert("Write to CRM successfully");
					} else {
						alert('There are no unprocessed students in ' + weekEnding);
					}
				});
			}
		}, {
			key: "tutorName",
			value: function tutorName(tutorID) {
				var tutor = this.tutors.find(function (tutor) {
					return tutor.tutorID === tutorID;
				});
				if (!tutor) {
					return;
				}
				return tutor.nameFirst + ' ' + tutor.nameLast;
			}
		}, {
			key: "studentName",
			value: function studentName(studentID) {
				var student = this.students.find(function (student) {
					return student.studentID === studentID;
				});
				if (!student) {
					return;
				}
				return student.nameFirst + ' ' + student.nameLast;
			}
		}, {
			key: "generateCSV",
			value: function generateCSV() {
				var _this4 = this;
	
				var unprocessed = JSON.parse(_angular2.default.toJson(this.timesheets.filter(function (timesheet) {
					return timesheet.isProcessed !== true;
				})));
				if (unprocessed.length === 0) {
					return alert('There are no timesheets to be processed.');
				}
	
				var lines = {};
	
				unprocessed.forEach(function (timesheet) {
					if (!lines[timesheet.tutorID + timesheet.rateType]) {
						lines[timesheet.tutorID + timesheet.rateType] = timesheet;
					} else {
						lines[timesheet.tutorID + timesheet.rateType].hours = lines[timesheet.tutorID + timesheet.rateType].hours + timesheet.hours;
					}
				});
	
				var new_lines = [];
				Object.keys(lines).map(function (id) {
					var tutorID = parseInt(id.slice(0, -1));
					var tutor = _this4.tutors.find(function (tutor) {
						return tutor.tutorID === tutorID;
					});
	
					if (tutor) {
						var timesheet = lines[id];
						timesheet.invoiceCode = tutor.invoiceCode;
						timesheet.firstName = tutor.nameFirst;
						timesheet.lastName = tutor.nameLast;
						timesheet.crmID = tutor.crmID;
						new_lines.push(timesheet);
					}
				});
	
				new_lines = new_lines.sort(function (a, b) {
					var nameA = a.lastName.toUpperCase();
					var nameB = b.lastName.toUpperCase();
	
					if (nameA < nameB) {
						return -1;
					}
					if (nameA > nameB) {
						return 1;
					}
	
					return 0;
				});
	
				new_lines = new_lines.sort(function (a, b) {
					var nameA = a.firstName.toUpperCase();
					var nameB = b.firstName.toUpperCase();
	
					if (nameA < nameB) {
						return -1;
					}
					if (nameA > nameB) {
						return 1;
					}
	
					return 0;
				});
	
				new_lines = new_lines.map(function (line) {
	
					if (line) {
						var lineDate = dateStringToDate(line.weekEnding);
	
						lineDate.setDate(lineDate.getDate() - 2);
	
						line.weekEnding = dateToDateString(lineDate);
	
						return line;
					}
				});
	
				var day = String(this.date.getDate());
				var month = String(this.date.getMonth() + 1);
				var year = String(this.date.getFullYear());
				var date = day + '-' + month + '-' + year;
				var filename = 'Timesheet-' + date;
	
				var headers = ['"Employee Co Last Name","Employee First Name","Payroll Category","Job","Customer Co Last Name","Customer First Name","Notes","Date","Units","Employee Card ID","Employee Record ID","Start/Stop Time","Customer Card ID","Customer Record ID"'];
	
				new_lines.forEach(function (record) {
					if (record) {
						var hourly;
	
						if (record.rateType === 'B') {
							hourly = 'Base Hourly';
						} else {
							hourly = 'In-Home Tuition';
						}
	
						var additionalLine = "\"" + record.lastName + "\",\"" + record.firstName + "\",\"" + hourly + "\",\"\",\"\",\"\",\"\",\"" + record.weekEnding + "\"," + record.hours + ",\"" + (record.crmID || '') + "\",\"\",\"\",\"\",\"\"";
	
						headers.push(additionalLine);
					}
				});
				var fullString = headers.join('\n');
				this.StringToCSV(fullString, filename);
			}
		}, {
			key: "loadData",
			value: function loadData() {
				var _this5 = this;
	
				console.log('Loading data...');
	
				this.$http.get('/api/students').then(function (res) {
					_this5.students = res.data;
				});
	
				this.$http.get('/api/tutors').then(function (res) {
					_this5.tutors = res.data;
				});
	
				this.$http.get('/api/timesheets/unprocessed').then(function (res) {
					_this5.timesheets = res.data;
				});
			}
		}]);
	
		return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 78 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"container\">\n\t<div>\n\t\t<h3>Process Timesheets</h3>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-3\">\n\t\t\t\t<div class=\"input-group only-sundays\">\n\n\t\t          <input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"dd/MM/yyyy\" ng-model=\"vm.date\" is-open=\"opened\" ng-required=\"true\" close-text=\"Close\" datepicker-options=\"{showWeeks: false}\"  />\n\t\t          <span class=\"input-group-btn\">\n\t\t            <button type=\"button\" class=\"btn btn-default\" ng-click=\"opened = true\">\n\t\t            \t<i class=\"glyphicon glyphicon-calendar\"></i>\n\t\t            </button>\n\t\t          </span>\n\t\t        </div>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-9\">\n\t\t\t\t<div class=\"flex h-separate\">\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.generateCSV()\" ng-disabled=\"!vm.date\">\n\t\t\t\t\t\t\t<span>Export to CSV</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.showMYOB()\">\n\t\t\t\t\t\t\t<span>Show Add to MYOB</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" ng-click=\"vm.writeCRM()\" ng-disabled=\"!vm.timesheets || !vm.date\">\n\t\t\t\t\t\t\t<span>Write to CRM</span>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<button type=\"button\" class=\"btn btn-success\" ng-click=\"vm.processAll()\">\n\t\t\t\t\t\t\t<spam>Mark all as Processed</spam>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<hr>\n\t\t<table class=\"table table-striped\">\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>Tutor Name</th>\n\t\t\t\t\t<th>Week Ending</th>\n\t\t\t\t\t<th>Student Name</th>\n\t\t\t\t\t<th>Rate Type</th>\n\t\t\t\t\t<th>Hours</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>\n\t\t\t\t<tr ng-repeat=\"timesheet in vm.timesheets\">\n\t\t\t\t\t<td>{{vm.tutorName(timesheet.tutorID)}}</td>\n\t\t\t\t\t<td>{{timesheet.weekEnding}}</td>\n\t\t\t\t\t<td>{{vm.studentName(timesheet.studentID)}}</td>\n\t\t\t\t\t<td>{{timesheet.rateType}}</td>\n\t\t\t\t\t<td>{{timesheet.hours}}</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\t</div>\n</div>"

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jsonToCsv = __webpack_require__(80);
	
	var _jsonToCsv2 = _interopRequireDefault(_jsonToCsv);
	
	var _stringToCsv = __webpack_require__(81);
	
	var _stringToCsv2 = _interopRequireDefault(_stringToCsv);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = angular.module('accessApp.MiscServices', []).factory('JSONToCSVConvertor', _jsonToCsv2.default).factory('StringToCSV', _stringToCsv2.default).name;

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function () {
		return function (JSONData, ReportTitle, ShowLabel) {
			var arrData = (typeof JSONData === 'undefined' ? 'undefined' : _typeof(JSONData)) != 'object' ? JSON.parse(JSONData) : JSONData;
	
			var CSV = '';
	
			if (ShowLabel) {
				var row = "";
	
				for (var index in arrData[0]) {
					row += index + ',';
				}
	
				row = row.slice(0, -1);
	
				CSV += row + '\r\n';
			}
	
			for (var i = 0; i < arrData.length; i++) {
				var row = "";
	
				for (var index in arrData[i]) {
					row += '"' + arrData[i][index] + '",';
				}
	
				row.slice(0, row.length - 1);
	
				CSV += row + '\r\n';
			}
	
			if (CSV == '') {
				alert("Invalid data");
				return;
			}
	
			var fileName = ReportTitle.replace(/ /g, "_");
	
			var uri = 'data:text/csv;charset=utf-8,' + escape(CSV);
	
			var link = document.createElement("a");
			link.href = uri;
	
			link.style = "visibility:hidden";
			link.download = fileName + ".csv";
	
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		};
	};

/***/ }),
/* 81 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		return function (CSVstring, ReportTitle) {
	
			if (CSVstring == '') {
				alert("Invalid data");
				return;
			}
	
			var fileName = ReportTitle.replace(/ /g, "_");
	
			var uri = 'data:text/csv;charset=utf-8,' + escape(CSVstring);
	
			var link = document.createElement("a");
			link.href = uri;
	
			link.style = "visibility:hidden";
			link.download = fileName + ".csv";
	
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		};
	};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EditPresetsFactory.$inject = ['$uibModal'];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _editPresets = __webpack_require__(83);
	
	var _editPresets2 = _interopRequireDefault(_editPresets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EditPresetsFactory($uibModal) {
		'ngInject';
	
		return function (_tutorID) {
			return $uibModal.open({
				template: __webpack_require__(84),
				controller: 'EditPresetsController',
				controllerAs: 'vm',
				resolve: {
					tutorID: function tutorID() {
						return _tutorID;
					}
				}
			}).result;
		};
	}
	
	exports.default = _angular2.default.module('accessApp.EditPresets', []).controller('EditPresetsController', _editPresets2.default).factory('EditPresetsFactory', EditPresetsFactory).name;

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	
		/*@ngInject*/
		_class.$inject = ['tutorID', '$http'];
		function _class(tutorID, $http) {
			_classCallCheck(this, _class);
	
			this.$http = $http;
			this.tutorID = tutorID;
			this.rateTypes = ['B', '1', '2'];
			this.loadsRequired = 3;
			this.loaded = false;
		}
	
		_createClass(_class, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;
	
				this.$http.get('/api/tutors/' + this.tutorID).then(function (res) {
					_this.tutor = res.data;
					_this.lowerLoad();
				});
	
				this.$http.get('/api/students').then(function (res) {
					_this.students = res.data.map(function (student) {
						student.fullName = student.nameFirst + ' ' + student.nameLast;
						return student;
					});
					_this.lowerLoad();
				});
	
				this.$http.get('/api/presets').then(function (res) {
					_this.presets = res.data || [];
					_this.lowerLoad();
				});
			}
		}, {
			key: 'addStudent',
			value: function addStudent(student) {
				this._presets.push({ hours: 1, rateType: 'B', studentID: student.studentID, tutorID: this.tutor.tutorID });
	
				this.selected = null;
			}
		}, {
			key: 'delete',
			value: function _delete(preset) {
	
				this._presets.splice(this._presets.indexOf(preset), 1);
	
				if (preset._id) {
					this.$http.delete('/api/presets/' + preset._id);
				}
			}
		}, {
			key: 'lowerLoad',
			value: function lowerLoad() {
				var _this2 = this;
	
				this.loadsRequired -= 1;
				if (this.loadsRequired === 0) {
					var temp = this.presets.filter(function (preset) {
						return preset.tutorID === _this2.tutor.tutorID;
					});
					this._presets = temp.sort(function (a, b) {
						var aName = _this2.returnName(a.studentID).toUpperCase();
						var bName = _this2.returnName(b.studentID).toUpperCase();
	
						if (aName < bName) {
							return -1;
						}
	
						if (aName > bName) {
							return 1;
						}
	
						return 0;
					});
					this.loaded = true;
				}
			}
		}, {
			key: 'returnName',
			value: function returnName(studentID) {
				var student = this.students.find(function (student) {
					return student.studentID === studentID;
				});
	
				if (!student) {
					return 'Inactive Student';
				}
				return student.nameFirst + ' ' + student.nameLast;
			}
		}, {
			key: 'returnCRM',
			value: function returnCRM(studentID) {
				var student = this.students.find(function (student) {
					return student.studentID === studentID;
				});
				if (!student) {
					return 'Inactive Student';
				}
				return student.crmID || 'No CRM ID';
			}
		}, {
			key: 'save',
			value: function save(callback) {
				var _this3 = this;
	
				var loadsRequired = this._presets.length;
	
				function lowerLoad() {
					loadsRequired -= 1;
	
					if (loadsRequired === 0) {
						callback();
					}
				}
	
				console.log(this._presets);
	
				this._presets.forEach(function (preset) {
					if (preset._id) {
						_this3.$http.put('/api/presets/' + preset._id, preset).then(function (res) {
							return lowerLoad();
						});
					} else {
						_this3.$http.post('/api/presets', preset).then(function (res) {
							return lowerLoad();
						});
					}
				});
			}
		}]);
	
		return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n\t<h4>Edit Presets for {{vm.tutor.nameFirst}} {{vm.tutor.nameLast}}</h4>\n\t<button type=\"button\" tabindex=\"-1\" class=\"close\" aria-label=\"Close\" ng-click=\"$dismiss('close')\"><span aria-hidden=\"true\">&times;</span></button>\n</div>\n<div class=\"p-md\" ng-if=\"vm.loaded\">\n\t<div class=\"row\">\n\t\t<div class=\"col-sm-9\">\n\t\t\t<ui-select ng-model=\"vm.selected\">\n\t\t\t    <ui-select-match>\n\t\t\t        <span>{{vm.selected.nameFirst}} {{vm.selected.nameLast}} - {{vm.selected.crmID || 'No CRM'}}</span>\n\t\t\t    </ui-select-match>\n\t\t\t    <ui-select-choices repeat=\"entity in (vm.students | filter: {fullName: $select.search}) | limitTo: ($select.search.length <= 2) ? 0 : undefined track by entity._id\">\n\t\t\t        <span>{{entity.nameFirst}} {{entity.nameLast}} - {{entity.crmID || 'No CRM'}}</span>\n\t\t\t    </ui-select-choices>\n\t\t\t</ui-select>\n\t\t</div>\n\t\t<div class=\"col-sm-3\">\n\t\t\t<button type=\"button\" class=\"btn btn-block btn-primary\" ng-click=\"vm.addStudent(vm.selected)\">\n\t\t\t\t<span>Add Student</span>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\t<table class=\"table m-t-xl table-striped\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>CRM ID</th>\n\t\t\t\t<th>Student Name</th>\n\t\t\t\t<th>Hours Per Week</th>\n\t\t\t\t<th>Rate Type</th>\n\t\t\t\t<th>Actions</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr ng-repeat=\"preset in vm._presets\">\n\t\t\t\t<td>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" disabled ng-value=\"vm.returnCRM(preset.studentID)\">\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" disabled ng-value=\"vm.returnName(preset.studentID)\">\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" ng-model=\"preset.hours\" />\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<select class=\"form-control\" ng-model=\"preset.rateType\">\n\t\t\t\t\t\t<option ng-repeat=\"rateType in vm.rateTypes\" ng-value=\"rateType\">{{rateType}}</option>\n\t\t\t\t\t</select>\n\t\t\t\t</td>\n\t\t\t\t<td>\n\t\t\t\t\t<button class=\"btn btn-danger\" ng-click=\"vm.delete(preset)\">\n\t\t\t\t\t\t<span>Delete</span>\n\t\t\t\t\t</button>\n\t\t\t\t</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n\t<hr>\n\t<button class=\"btn btn-success btn-block btn-lg\" ng-click=\"vm.save($close)\">\n\t\t<span>Save Presets</span>\n\t</button>\n</div>"

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EditTutorFactory.$inject = ['$uibModal'];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _editTutor = __webpack_require__(86);
	
	var _editTutor2 = _interopRequireDefault(_editTutor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EditTutorFactory($uibModal) {
		'ngInject';
	
		return function (_tutorID) {
			return $uibModal.open({
				template: __webpack_require__(87),
				controller: 'EditTutorController',
				controllerAs: 'vm',
				resolve: {
					tutorID: function tutorID() {
						return _tutorID;
					}
				}
			}).result;
		};
	}
	
	exports.default = _angular2.default.module('accessApp.EditTutor', []).controller('EditTutorController', _editTutor2.default).factory('EditTutorFactory', EditTutorFactory).name;

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	
		/*@ngInject*/
		_class.$inject = ['tutorID', '$http'];
		function _class(tutorID, $http) {
			_classCallCheck(this, _class);
	
			this.$http = $http;
			this.tutorID = tutorID;
			this.rateTypes = ['B', '1', '2'];
			this.loaded = false;
			this.states = ['QLD', 'NSW', 'VIC', 'SA', 'WA', 'TAS', 'NT', 'ACT'];
		}
	
		_createClass(_class, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;
	
				this.$http.get('/api/tutors/' + this.tutorID).then(function (res) {
					_this.tutor = res.data;
					_this.loaded = true;
				});
			}
		}, {
			key: 'edit',
			value: function edit(callback) {
				this.$http.put('/api/tutors/' + this.tutorID, this.tutor).then(function (res) {
					callback();
				});
			}
		}]);
	
		return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 87 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n\t<h4>Edit Tutor</h4>\n\t<button type=\"button\" tabindex=\"-1\" class=\"close\" aria-label=\"Close\" ng-click=\"$dismiss('close')\"><span aria-hidden=\"true\">&times;</span></button>\n</div>\n<div class=\"p-md\" ng-if=\"vm.loaded\">\n\t<form ng-submit=\"vm.edit($close)\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>First Name</label>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" required ng-model=\"vm.tutor.nameFirst\" >\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>Last Name</label>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" required ng-model=\"vm.tutor.nameLast\" >\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t<label>CRM ID</label>\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" ng-model=\"vm.tutor.crmID\" >\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>State</label>\n\t\t\t\t\t<select class=\"form-control\" ng-model=\"vm.tutor.state\">\n\t\t\t\t\t\t<option ng-repeat=\"state in vm.states\" ng-value=\"state\">{{state}}</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t<label>Invoice Code</label>\n\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" ng-model=\"vm.tutor.invoiceCode\">\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t</div>\n\t\t<hr>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>WWC ID</label>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" ng-model=\"vm.tutor.wwcID\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>WWC Expires</label>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" ng-model=\"vm.tutor.wwcExpires\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>WWC State</label>\n\t\t\t\t\t<select class=\"form-control\" ng-model=\"vm.tutor.wwcState\">\n\t\t\t\t\t\t<option ng-repeat=\"state in vm.states\" ng-value=\"state\">{{state}}</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div>\n\t\t\t<textarea class=\"form-control\" ng-model=\"vm.tutor.notes\" rows=\"4\"></textarea>\n\t\t</div>\n\t\t<hr>\n\t\t<button class=\"btn btn-block btn-lg btn-success\">\n\t\t\t<span>Save Tutor</span>\n\t\t</button>\n\t</form>\n</div>"

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	EditStudentFactory.$inject = ['$uibModal'];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _editStudent = __webpack_require__(89);
	
	var _editStudent2 = _interopRequireDefault(_editStudent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function EditStudentFactory($uibModal) {
		'ngInject';
	
		return function (_studentID) {
			return $uibModal.open({
				template: __webpack_require__(90),
				controller: 'EditStudentController',
				controllerAs: 'vm',
				resolve: {
					studentID: function studentID() {
						return _studentID;
					}
				}
			}).result;
		};
	}
	
	exports.default = _angular2.default.module('accessApp.EditStudent', []).controller('EditStudentController', _editStudent2.default).factory('EditStudentFactory', EditStudentFactory).name;

/***/ }),
/* 89 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		/*@ngInject*/
		_class.$inject = ['$http', '$scope', 'studentID'];
		function _class($http, $scope, studentID) {
			_classCallCheck(this, _class);
	
			this.$http = $http;
			this.$scope = $scope;
			this.loaded = false;
			this.locations = [{
				fullname: 'Cannon Hill',
				value: 'C'
			}, {
				fullname: 'Home',
				value: 'H'
			}, {
				fullname: 'Online',
				value: 'O'
			}, {
				fullname: 'Paddington',
				value: 'P'
			}, {
				fullname: 'Mt Gravatt',
				value: 'M'
			}];
			this.studentID = studentID;
			this.states = ['QLD', 'NSW', 'VIC', 'SA', 'WA', 'TAS', 'NT', 'ACT'];
		}
	
		_createClass(_class, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;
	
				this.$http.get('/api/students/' + this.studentID).then(function (res) {
					_this.student = res.data;
	
					console.log(_this.student);
					_this.loaded = true;
				});
			}
		}, {
			key: 'edit',
			value: function edit(callback) {
				var _this2 = this;
	
				var regex = /\d+-[1-9]/;
				if (regex.test(this.student.crmID) && this.student.crmID.split('-')[0].length === 5) {
					this.$http.get('/api/students/crm-id', { params: { id: this.student.crmID } }).then(function (res) {
						if (res.data === "" || res.data._id === _this2.student._id) {
							_this2.$scope.error = null;
							_this2.$http.put('/api/students/' + _this2.student._id, _this2.student).then(function (res) {
								callback();
							});
						} else {
							_this2.$scope.error = "The CRM ID already exists. Try another one";
						}
					});
				} else {
					this.$scope.error = "Wrong format CRM ID";
				}
			}
		}]);
	
		return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 90 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n\t<h4>Edit Student</h4>\n\t<button type=\"button\" tabindex=\"-1\" class=\"close\" aria-label=\"Close\" ng-click=\"$dismiss('close')\"><span aria-hidden=\"true\">&times;</span></button>\n</div>\n<div class=\"p-md\" ng-if=\"vm.loaded\">\n\t<form ng-submit=\"vm.edit($close)\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>First Name</label>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" required ng-model=\"vm.student.nameFirst\" >\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>Last Name</label>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" required ng-model=\"vm.student.nameLast\" >\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>CRM ID</label>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" ng-model=\"vm.student.crmID\" >\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>State</label>\n\t\t\t\t\t<select class=\"form-control\" ng-model=\"vm.student.state\">\n\t\t\t\t\t\t<option ng-repeat=\"state in vm.states\" ng-value=\"state\">{{state}}</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>Tute Location</label>\n\t\t\t\t\t<select class=\"form-control\" ng-model=\"vm.student.tuteLocation\">\n\t\t\t\t\t\t<option ng-repeat=\"location in vm.locations\" ng-value=\"location.value\">{{location.fullname}}</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"alert alert-danger\" ng-show=\"error\" ng-bind=\"error\" style=\"margin-top: 20px\"></div>\n\t\t<hr>\n\t\t<button class=\"btn btn-block btn-lg btn-success\">\n\t\t\t<span>Save Student</span>\n\t\t</button>\n\t</form>\n</div>"

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	CreateStudentFactory.$inject = ['$uibModal'];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _createStudent = __webpack_require__(92);
	
	var _createStudent2 = _interopRequireDefault(_createStudent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CreateStudentFactory($uibModal) {
		'ngInject';
	
		return function (_tutorID) {
			return $uibModal.open({
				template: __webpack_require__(93),
				controller: 'CreateStudentController',
				controllerAs: 'vm',
				resolve: {
					tutorID: function tutorID() {
						return _tutorID;
					}
				}
			}).result;
		};
	}
	
	exports.default = _angular2.default.module('accessApp.CreateStudent', []).controller('CreateStudentController', _createStudent2.default).factory('CreateStudentFactory', CreateStudentFactory).name;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		/*@ngInject*/
		_class.$inject = ['$http', '$scope', 'tutorID'];
		function _class($http, $scope, tutorID) {
			_classCallCheck(this, _class);
	
			this.$http = $http;
			this.$scope = $scope;
			this.loaded = true;
			this.student = {
				nameFirst: '',
				nameLast: '',
				state: '',
				crmID: '',
				tuteLocation: ''
			};
	
			this.preset = false;
			this.presetNew = true;
			this.tutorID = tutorID;
			this.students = [];
			this.locations = [{
				fullname: 'Cannon Hill',
				value: 'C'
			}, {
				fullname: 'Home',
				value: 'H'
			}, {
				fullname: 'Online',
				value: 'O'
			}, {
				fullname: 'Paddington',
				value: 'P'
			}, {
				fullname: 'Mt Gravatt',
				value: 'M'
			}];
			this.states = ['QLD', 'NSW', 'VIC', 'SA', 'WA', 'TAS', 'NT', 'ACT'];
		}
	
		_createClass(_class, [{
			key: '$onInit',
			value: function $onInit() {
				var _this = this;
	
				this.$http.get('/api/students').then(function (res) {
					_this.students = res.data;
					_this.students = _this.students.map(function (student) {
						student.fullName = student.nameFirst + ' ' + student.nameLast;
						return student;
					});
				});
			}
		}, {
			key: 'createPreset',
			value: function createPreset(studentID, callback) {
				var preset = {
					tutorID: this.tutorID,
					studentID: studentID,
					hours: 1,
					rateType: 'B'
				};
	
				this.$http.post('/api/presets', preset).then(function (res) {
					callback(studentID);
				});
			}
		}, {
			key: 'create',
			value: function create(callback) {
				var _this2 = this;
	
				var regex = /\d+-[1-9]/;
				if (regex.test(this.student.crmID) && this.student.crmID.split('-')[0].length === 5) {
					this.$http.get('/api/students/crm-id', { params: { id: this.student.crmID } }).then(function (res) {
						if (res.data === "") {
							_this2.$scope.error = null;
							_this2.$http.post('/api/students', _this2.student).then(function (res) {
								_this2.student = {};
								var studentID = res.data.studentID;
								if (_this2.presetNew) {
									return _this2.createPreset(studentID, callback);
								}
								callback(studentID);
							});
						} else {
							_this2.$scope.error = "The CRM ID already exists. Try another one";
						}
					});
				} else {
					this.$scope.error = "Wrong format CRM ID";
				}
			}
		}, {
			key: 'addExisting',
			value: function addExisting(callback) {
				var studentID = this.selected.studentID;
				if (this.preset) {
					return this.createPreset(studentID, callback);
				}
				callback(studentID);
			}
		}]);
	
		return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 93 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n\t<h4>Create a Student</h4>\n\t<button type=\"button\" tabindex=\"-1\" class=\"close\" aria-label=\"Close\" ng-click=\"$dismiss('close')\"><span aria-hidden=\"true\">&times;</span></button>\n</div>\n<div class=\"p-md\" ng-if=\"vm.loaded\">\n\t<div class=\"row\">\n\t\t<div class=\"col-md-6\">\n\t\t\t<ui-select autofocus ng-model=\"vm.selected\">\n\t\t\t    <ui-select-match>\n\t\t\t        <span>{{vm.selected.nameFirst}} {{vm.selected.nameLast}} - {{vm.selected.crmID || 'No CRM'}}</span>\n\t\t\t    </ui-select-match>\n\t\t\t    <ui-select-choices repeat=\"student in (vm.students | filter: {fullName: $select.search}) | limitTo: ($select.search.length <= 2) ? 0 : undefined track by student._id\">\n\t\t\t        <span>{{student.nameFirst}} {{student.nameLast}} - {{student.crmID || 'No CRM'}}</span>\n\t\t\t    </ui-select-choices>\n\t\t\t</ui-select>\n\t\t</div>\n\t\t<div class=\"col-md-2\">\n\t\t\t<button type=\"button\" class=\"btn btn-block\" ng-class=\"vm.preset ? 'btn-primary' : 'btn-default'\" ng-click=\"vm.preset = !vm.preset\">Make Preset</button>\n\t\t</div>\n\t\t<div class=\"col-md-4\">\n\t\t\t<button type=\"button\" class=\"btn btn-success btn-block\" ng-click=\"vm.addExisting($close)\" ng-disabled=\"!vm.selected\">Add Student</button>\n\t\t</div>\n\t</div>\n\t<hr>\n\t<form ng-submit=\"vm.create($close)\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>First Name</label>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" required ng-model=\"vm.student.nameFirst\" >\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>Last Name</label>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" required ng-model=\"vm.student.nameLast\" >\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>CRM ID</label>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" ng-model=\"vm.student.crmID\" >\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>State</label>\n\t\t\t\t\t<select class=\"form-control\" ng-model=\"vm.student.state\">\n\t\t\t\t\t\t<option ng-repeat=\"state in vm.states\" ng-value=\"state\">{{state}}</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>Tute Location</label>\n\t\t\t\t\t<select class=\"form-control\" ng-model=\"vm.student.tuteLocation\">\n\t\t\t\t\t\t<option ng-repeat=\"location in vm.locations\" ng-value=\"location.value\">{{location.fullname}}</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label style=\"opacity: 0\">hidden</label>\n\t\t\t\t\t<button class=\"btn btn-block\" ng-class=\"vm.presetNew ? 'btn-primary' : 'btn-default'\">Make Preset</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"alert alert-danger\" ng-show=\"error\" ng-bind=\"error\" style=\"margin-top: 20px\"></div>\n\t\t<hr>\n\t\t<button class=\"btn btn-block btn-lg btn-success\">\n\t\t\t<span>Create and Add Student</span>\n\t\t</button>\n\t</form>\n</div>"

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	CreateTutorFactory.$inject = ['$uibModal'];
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _createTutor = __webpack_require__(95);
	
	var _createTutor2 = _interopRequireDefault(_createTutor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function CreateTutorFactory($uibModal) {
		'ngInject';
	
		return function () {
			return $uibModal.open({
				template: __webpack_require__(96),
				controller: 'CreateTutorController',
				controllerAs: 'vm'
			}).result;
		};
	}
	
	exports.default = _angular2.default.module('accessApp.CreateTutor', []).controller('CreateTutorController', _createTutor2.default).factory('CreateTutorFactory', CreateTutorFactory).name;

/***/ }),
/* 95 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
		/*@ngInject*/
		_class.$inject = ['$http'];
		function _class($http) {
			_classCallCheck(this, _class);
	
			this.$http = $http;
			this.loaded = true;
			this.tutor = {
				nameFirst: '',
				nameLast: '',
				state: '',
				crmID: '',
				invoiceCode: '',
				wwcID: '',
				wwcExpires: '',
				wwcState: ''
			};
			this.states = ['QLD', 'NSW', 'VIC', 'SA', 'WA', 'TAS', 'NT', 'ACT'];
		}
	
		_createClass(_class, [{
			key: 'create',
			value: function create(callback) {
				var _this = this;
	
				this.success = null;
				this.$http.post('/api/tutors', this.tutor).then(function (res) {
					_this.tutor = {};
					callback();
				});
			}
		}]);
	
		return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 96 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n\t<h4>Create a Tutor</h4>\n\t<button type=\"button\" tabindex=\"-1\" class=\"close\" aria-label=\"Close\" ng-click=\"$dismiss('close')\"><span aria-hidden=\"true\">&times;</span></button>\n</div>\n<div class=\"p-md\" ng-if=\"vm.loaded\">\n\t<div class=\"alert alert-success\" ng-show=\"vm.success\">\n\t\t<span>Tutor successfully created.</span>\n\t</div>\n\t<form ng-submit=\"vm.create($close)\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>First Name</label>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" required ng-model=\"vm.tutor.nameFirst\" >\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>Last Name</label>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" required ng-model=\"vm.tutor.nameLast\" >\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"row\">\n\t\t\t\t<div class=\"col-md-4\">\n\t\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t\t<label>CRM ID</label>\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" ng-model=\"vm.tutor.crmID\" >\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>State</label>\n\t\t\t\t\t<select class=\"form-control\" ng-model=\"vm.tutor.state\">\n\t\t\t\t\t\t<option ng-repeat=\"state in vm.states\" ng-value=\"state\">{{state}}</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<hr>\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>WWC ID</label>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" ng-model=\"vm.tutor.wwcID\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>WWC Expires</label>\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" ng-model=\"vm.tutor.wwcExpires\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"col-md-4\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<label>WWC State</label>\n\t\t\t\t\t<select class=\"form-control\" ng-model=\"vm.tutor.wwcState\">\n\t\t\t\t\t\t<option ng-repeat=\"state in vm.states\" ng-value=\"state\">{{state}}</option>\n\t\t\t\t\t</select>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<hr>\n\t\t<button class=\"btn btn-block btn-lg btn-success\">\n\t\t\t<span>Create Tutor</span>\n\t\t</button>\n\t</form>\n</div>"

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Factory.$inject = ['$uibModal'];
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _angular = __webpack_require__(1);
	
	var _angular2 = _interopRequireDefault(_angular);
	
	var _controller = __webpack_require__(98);
	
	var _controller2 = _interopRequireDefault(_controller);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Factory($uibModal) {
	    'ngInject';
	
	    return function () {
	        return $uibModal.open({
	            template: __webpack_require__(100),
	            controller: 'DeputyImportController',
	            controllerAs: 'vm'
	        }).result;
	    };
	}
	
	exports.default = _angular2.default.module('accessApp.DeputyImport', []).controller('DeputyImportController', _controller2.default).factory('DeputyImportFactory', Factory).name;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _papaparse = __webpack_require__(99);
	
	var _papaparse2 = _interopRequireDefault(_papaparse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _class = function () {
	    /*@ngInject*/
	    _class.$inject = ['$http'];
	    function _class($http) {
	        var _this = this;
	
	        _classCallCheck(this, _class);
	
	        this.uploadFile = function ($event) {
	            _this.file = $event.target.files[0];
	        };
	
	        this.$http = $http;
	        this.file = null;
	    }
	
	    _createClass(_class, [{
	        key: 'create',
	        value: function create(callback) {
	            var _this2 = this;
	
	            this.success = null;
	            this.$http.post('/api/tutors', this.tutor).then(function (res) {
	                _this2.tutor = {};
	                callback();
	            });
	        }
	    }, {
	        key: 'change',
	        value: function change($close) {
	            _papaparse2.default.parse(this.file, {
	                header: true,
	                dynamicTyping: true,
	                complete: $close
	            });
	        }
	    }]);
	
	    return _class;
	}();
	
	exports.default = _class;

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* @license
	Papa Parse
	v5.0.0
	https://github.com/mholt/PapaParse
	License: MIT
	*/
	!function(e,t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&"undefined"!=typeof exports?module.exports=t():e.Papa=t()}(this,function s(){"use strict";var f="undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==f?f:{};var n=!f.document&&!!f.postMessage,o=n&&/blob:/i.test((f.location||{}).protocol),a={},h=0,k={parse:function(e,t){var r=(t=t||{}).dynamicTyping||!1;q(r)&&(t.dynamicTypingFunction=r,r={});if(t.dynamicTyping=r,t.transform=!!q(t.transform)&&t.transform,t.worker&&k.WORKERS_SUPPORTED){var i=function(){if(!k.WORKERS_SUPPORTED)return!1;var e=(r=f.URL||f.webkitURL||null,i=s.toString(),k.BLOB_URL||(k.BLOB_URL=r.createObjectURL(new Blob(["(",i,")();"],{type:"text/javascript"})))),t=new f.Worker(e);var r,i;return t.onmessage=_,t.id=h++,a[t.id]=t}();return i.userStep=t.step,i.userChunk=t.chunk,i.userComplete=t.complete,i.userError=t.error,t.step=q(t.step),t.chunk=q(t.chunk),t.complete=q(t.complete),t.error=q(t.error),delete t.worker,void i.postMessage({input:e,config:t,workerId:i.id})}var n=null;k.NODE_STREAM_INPUT,"string"==typeof e?n=t.download?new l(t):new p(t):!0===e.readable&&q(e.read)&&q(e.on)?n=new m(t):(f.File&&e instanceof File||e instanceof Object)&&(n=new c(t));return n.stream(e)},unparse:function(e,t){var i=!1,_=!0,g=",",v="\r\n",n='"',s=n+n,r=!1,a=null;!function(){if("object"!=typeof t)return;"string"!=typeof t.delimiter||k.BAD_DELIMITERS.filter(function(e){return-1!==t.delimiter.indexOf(e)}).length||(g=t.delimiter);("boolean"==typeof t.quotes||Array.isArray(t.quotes))&&(i=t.quotes);"boolean"!=typeof t.skipEmptyLines&&"string"!=typeof t.skipEmptyLines||(r=t.skipEmptyLines);"string"==typeof t.newline&&(v=t.newline);"string"==typeof t.quoteChar&&(n=t.quoteChar);"boolean"==typeof t.header&&(_=t.header);if(Array.isArray(t.columns)){if(0===t.columns.length)throw new Error("Option columns is empty");a=t.columns}void 0!==t.escapeChar&&(s=t.escapeChar+n)}();var o=new RegExp(U(n),"g");"string"==typeof e&&(e=JSON.parse(e));if(Array.isArray(e)){if(!e.length||Array.isArray(e[0]))return u(null,e,r);if("object"==typeof e[0])return u(a||h(e[0]),e,r)}else if("object"==typeof e)return"string"==typeof e.data&&(e.data=JSON.parse(e.data)),Array.isArray(e.data)&&(e.fields||(e.fields=e.meta&&e.meta.fields),e.fields||(e.fields=Array.isArray(e.data[0])?e.fields:h(e.data[0])),Array.isArray(e.data[0])||"object"==typeof e.data[0]||(e.data=[e.data])),u(e.fields||[],e.data||[],r);throw new Error("Unable to serialize unrecognized input");function h(e){if("object"!=typeof e)return[];var t=[];for(var r in e)t.push(r);return t}function u(e,t,r){var i="";"string"==typeof e&&(e=JSON.parse(e)),"string"==typeof t&&(t=JSON.parse(t));var n=Array.isArray(e)&&0<e.length,s=!Array.isArray(t[0]);if(n&&_){for(var a=0;a<e.length;a++)0<a&&(i+=g),i+=y(e[a],a);0<t.length&&(i+=v)}for(var o=0;o<t.length;o++){var h=n?e.length:t[o].length,u=!1,f=n?0===Object.keys(t[o]).length:0===t[o].length;if(r&&!n&&(u="greedy"===r?""===t[o].join("").trim():1===t[o].length&&0===t[o][0].length),"greedy"===r&&n){for(var d=[],l=0;l<h;l++){var c=s?e[l]:l;d.push(t[o][c])}u=""===d.join("").trim()}if(!u){for(var p=0;p<h;p++){0<p&&!f&&(i+=g);var m=n&&s?e[p]:p;i+=y(t[o][m],p)}o<t.length-1&&(!r||0<h&&!f)&&(i+=v)}}return i}function y(e,t){if(null==e)return"";if(e.constructor===Date)return JSON.stringify(e).slice(1,25);e=e.toString().replace(o,s);var r="boolean"==typeof i&&i||Array.isArray(i)&&i[t]||function(e,t){for(var r=0;r<t.length;r++)if(-1<e.indexOf(t[r]))return!0;return!1}(e,k.BAD_DELIMITERS)||-1<e.indexOf(g)||" "===e.charAt(0)||" "===e.charAt(e.length-1);return r?n+e+n:e}}};if(k.RECORD_SEP=String.fromCharCode(30),k.UNIT_SEP=String.fromCharCode(31),k.BYTE_ORDER_MARK="\ufeff",k.BAD_DELIMITERS=["\r","\n",'"',k.BYTE_ORDER_MARK],k.WORKERS_SUPPORTED=!n&&!!f.Worker,k.NODE_STREAM_INPUT=1,k.LocalChunkSize=10485760,k.RemoteChunkSize=5242880,k.DefaultDelimiter=",",k.Parser=y,k.ParserHandle=r,k.NetworkStreamer=l,k.FileStreamer=c,k.StringStreamer=p,k.ReadableStreamStreamer=m,f.jQuery){var d=f.jQuery;d.fn.parse=function(o){var r=o.config||{},h=[];return this.each(function(e){if(!("INPUT"===d(this).prop("tagName").toUpperCase()&&"file"===d(this).attr("type").toLowerCase()&&f.FileReader)||!this.files||0===this.files.length)return!0;for(var t=0;t<this.files.length;t++)h.push({file:this.files[t],inputElem:this,instanceConfig:d.extend({},r)})}),e(),this;function e(){if(0!==h.length){var e,t,r,i,n=h[0];if(q(o.before)){var s=o.before(n.file,n.inputElem);if("object"==typeof s){if("abort"===s.action)return e="AbortError",t=n.file,r=n.inputElem,i=s.reason,void(q(o.error)&&o.error({name:e},t,r,i));if("skip"===s.action)return void u();"object"==typeof s.config&&(n.instanceConfig=d.extend(n.instanceConfig,s.config))}else if("skip"===s)return void u()}var a=n.instanceConfig.complete;n.instanceConfig.complete=function(e){q(a)&&a(e,n.file,n.inputElem),u()},k.parse(n.file,n.instanceConfig)}else q(o.complete)&&o.complete()}function u(){h.splice(0,1),e()}}}function u(e){this._handle=null,this._finished=!1,this._completed=!1,this._halted=!1,this._input=null,this._baseIndex=0,this._partialLine="",this._rowCount=0,this._start=0,this._nextChunk=null,this.isFirstChunk=!0,this._completeResults={data:[],errors:[],meta:{}},function(e){var t=b(e);t.chunkSize=parseInt(t.chunkSize),e.step||e.chunk||(t.chunkSize=null);this._handle=new r(t),(this._handle.streamer=this)._config=t}.call(this,e),this.parseChunk=function(e,t){if(this.isFirstChunk&&q(this._config.beforeFirstChunk)){var r=this._config.beforeFirstChunk(e);void 0!==r&&(e=r)}this.isFirstChunk=!1,this._halted=!1;var i=this._partialLine+e;this._partialLine="";var n=this._handle.parse(i,this._baseIndex,!this._finished);if(!this._handle.paused()&&!this._handle.aborted()){var s=n.meta.cursor;this._finished||(this._partialLine=i.substring(s-this._baseIndex),this._baseIndex=s),n&&n.data&&(this._rowCount+=n.data.length);var a=this._finished||this._config.preview&&this._rowCount>=this._config.preview;if(o)f.postMessage({results:n,workerId:k.WORKER_ID,finished:a});else if(q(this._config.chunk)&&!t){if(this._config.chunk(n,this._handle),this._handle.paused()||this._handle.aborted())return void(this._halted=!0);n=void 0,this._completeResults=void 0}return this._config.step||this._config.chunk||(this._completeResults.data=this._completeResults.data.concat(n.data),this._completeResults.errors=this._completeResults.errors.concat(n.errors),this._completeResults.meta=n.meta),this._completed||!a||!q(this._config.complete)||n&&n.meta.aborted||(this._config.complete(this._completeResults,this._input),this._completed=!0),a||n&&n.meta.paused||this._nextChunk(),n}this._halted=!0},this._sendError=function(e){q(this._config.error)?this._config.error(e):o&&this._config.error&&f.postMessage({workerId:k.WORKER_ID,error:e,finished:!1})}}function l(e){var i;(e=e||{}).chunkSize||(e.chunkSize=k.RemoteChunkSize),u.call(this,e),this._nextChunk=n?function(){this._readChunk(),this._chunkLoaded()}:function(){this._readChunk()},this.stream=function(e){this._input=e,this._nextChunk()},this._readChunk=function(){if(this._finished)this._chunkLoaded();else{if(i=new XMLHttpRequest,this._config.withCredentials&&(i.withCredentials=this._config.withCredentials),n||(i.onload=E(this._chunkLoaded,this),i.onerror=E(this._chunkError,this)),i.open("GET",this._input,!n),this._config.downloadRequestHeaders){var e=this._config.downloadRequestHeaders;for(var t in e)i.setRequestHeader(t,e[t])}if(this._config.chunkSize){var r=this._start+this._config.chunkSize-1;i.setRequestHeader("Range","bytes="+this._start+"-"+r)}try{i.send()}catch(e){this._chunkError(e.message)}n&&0===i.status?this._chunkError():this._start+=this._config.chunkSize}},this._chunkLoaded=function(){4===i.readyState&&(i.status<200||400<=i.status?this._chunkError():(this._finished=!this._config.chunkSize||this._start>function(e){var t=e.getResponseHeader("Content-Range");if(null===t)return-1;return parseInt(t.substr(t.lastIndexOf("/")+1))}(i),this.parseChunk(i.responseText)))},this._chunkError=function(e){var t=i.statusText||e;this._sendError(new Error(t))}}function c(e){var i,n;(e=e||{}).chunkSize||(e.chunkSize=k.LocalChunkSize),u.call(this,e);var s="undefined"!=typeof FileReader;this.stream=function(e){this._input=e,n=e.slice||e.webkitSlice||e.mozSlice,s?((i=new FileReader).onload=E(this._chunkLoaded,this),i.onerror=E(this._chunkError,this)):i=new FileReaderSync,this._nextChunk()},this._nextChunk=function(){this._finished||this._config.preview&&!(this._rowCount<this._config.preview)||this._readChunk()},this._readChunk=function(){var e=this._input;if(this._config.chunkSize){var t=Math.min(this._start+this._config.chunkSize,this._input.size);e=n.call(e,this._start,t)}var r=i.readAsText(e,this._config.encoding);s||this._chunkLoaded({target:{result:r}})},this._chunkLoaded=function(e){this._start+=this._config.chunkSize,this._finished=!this._config.chunkSize||this._start>=this._input.size,this.parseChunk(e.target.result)},this._chunkError=function(){this._sendError(i.error)}}function p(e){var r;u.call(this,e=e||{}),this.stream=function(e){return r=e,this._nextChunk()},this._nextChunk=function(){if(!this._finished){var e=this._config.chunkSize,t=e?r.substr(0,e):r;return r=e?r.substr(e):"",this._finished=!r,this.parseChunk(t)}}}function m(e){u.call(this,e=e||{});var t=[],r=!0,i=!1;this.pause=function(){u.prototype.pause.apply(this,arguments),this._input.pause()},this.resume=function(){u.prototype.resume.apply(this,arguments),this._input.resume()},this.stream=function(e){this._input=e,this._input.on("data",this._streamData),this._input.on("end",this._streamEnd),this._input.on("error",this._streamError)},this._checkIsFinished=function(){i&&1===t.length&&(this._finished=!0)},this._nextChunk=function(){this._checkIsFinished(),t.length?this.parseChunk(t.shift()):r=!0},this._streamData=E(function(e){try{t.push("string"==typeof e?e:e.toString(this._config.encoding)),r&&(r=!1,this._checkIsFinished(),this.parseChunk(t.shift()))}catch(e){this._streamError(e)}},this),this._streamError=E(function(e){this._streamCleanUp(),this._sendError(e)},this),this._streamEnd=E(function(){this._streamCleanUp(),i=!0,this._streamData("")},this),this._streamCleanUp=E(function(){this._input.removeListener("data",this._streamData),this._input.removeListener("end",this._streamEnd),this._input.removeListener("error",this._streamError)},this)}function r(_){var a,o,h,i=/^\s*-?(\d*\.?\d+|\d+\.?\d*)(e[-+]?\d+)?\s*$/i,n=/(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))/,t=this,r=0,u=0,f=!1,e=!1,d=[],l={data:[],errors:[],meta:{}};if(q(_.step)){var s=_.step;_.step=function(e){if(l=e,p())c();else{if(c(),0===l.data.length)return;r+=e.data.length,_.preview&&r>_.preview?o.abort():s(l,t)}}}function g(e){return"greedy"===_.skipEmptyLines?""===e.join("").trim():1===e.length&&0===e[0].length}function c(){if(l&&h&&(v("Delimiter","UndetectableDelimiter","Unable to auto-detect delimiting character; defaulted to '"+k.DefaultDelimiter+"'"),h=!1),_.skipEmptyLines)for(var e=0;e<l.data.length;e++)g(l.data[e])&&l.data.splice(e--,1);return p()&&function(){if(!l)return;function e(e){q(_.transformHeader)&&(e=_.transformHeader(e)),d.push(e)}if(Array.isArray(l.data[0])){for(var t=0;p()&&t<l.data.length;t++)l.data[t].forEach(e);l.data.splice(0,1)}else l.data.forEach(e)}(),function(){if(!l||!_.header&&!_.dynamicTyping&&!_.transform)return l;function e(e,t){var r,i=_.header?{}:[];for(r=0;r<e.length;r++){var n=r,s=e[r];_.header&&(n=r>=d.length?"__parsed_extra":d[r]),_.transform&&(s=_.transform(s,n)),s=m(n,s),"__parsed_extra"===n?(i[n]=i[n]||[],i[n].push(s)):i[n]=s}return _.header&&(r>d.length?v("FieldMismatch","TooManyFields","Too many fields: expected "+d.length+" fields but parsed "+r,u+t):r<d.length&&v("FieldMismatch","TooFewFields","Too few fields: expected "+d.length+" fields but parsed "+r,u+t)),i}var t=1;!l.data[0]||Array.isArray(l.data[0])?(l.data=l.data.map(e),t=l.data.length):l.data=e(l.data,0);_.header&&l.meta&&(l.meta.fields=d);return u+=t,l}()}function p(){return _.header&&0===d.length}function m(e,t){return r=e,_.dynamicTypingFunction&&void 0===_.dynamicTyping[r]&&(_.dynamicTyping[r]=_.dynamicTypingFunction(r)),!0===(_.dynamicTyping[r]||_.dynamicTyping)?"true"===t||"TRUE"===t||"false"!==t&&"FALSE"!==t&&(i.test(t)?parseFloat(t):n.test(t)?new Date(t):""===t?null:t):t;var r}function v(e,t,r,i){l.errors.push({type:e,code:t,message:r,row:i})}this.parse=function(e,t,r){var i=_.quoteChar||'"';if(_.newline||(_.newline=function(e,t){e=e.substr(0,1048576);var r=new RegExp(U(t)+"([^]*?)"+U(t),"gm"),i=(e=e.replace(r,"")).split("\r"),n=e.split("\n"),s=1<n.length&&n[0].length<i[0].length;if(1===i.length||s)return"\n";for(var a=0,o=0;o<i.length;o++)"\n"===i[o][0]&&a++;return a>=i.length/2?"\r\n":"\r"}(e,i)),h=!1,_.delimiter)q(_.delimiter)&&(_.delimiter=_.delimiter(e),l.meta.delimiter=_.delimiter);else{var n=function(e,t,r,i,n){var s,a,o;n=n||[",","\t","|",";",k.RECORD_SEP,k.UNIT_SEP];for(var h=0;h<n.length;h++){var u=n[h],f=0,d=0,l=0;o=void 0;for(var c=new y({comments:i,delimiter:u,newline:t,preview:10}).parse(e),p=0;p<c.data.length;p++)if(r&&g(c.data[p]))l++;else{var m=c.data[p].length;d+=m,void 0!==o?1<m&&(f+=Math.abs(m-o),o=m):o=0}0<c.data.length&&(d/=c.data.length-l),(void 0===a||a<f)&&1.99<d&&(a=f,s=u)}return{successful:!!(_.delimiter=s),bestDelimiter:s}}(e,_.newline,_.skipEmptyLines,_.comments,_.delimitersToGuess);n.successful?_.delimiter=n.bestDelimiter:(h=!0,_.delimiter=k.DefaultDelimiter),l.meta.delimiter=_.delimiter}var s=b(_);return _.preview&&_.header&&s.preview++,a=e,o=new y(s),l=o.parse(a,t,r),c(),f?{meta:{paused:!0}}:l||{meta:{paused:!1}}},this.paused=function(){return f},this.pause=function(){f=!0,o.abort(),a=a.substr(o.getCharIndex())},this.resume=function(){t.streamer._halted?(f=!1,t.streamer.parseChunk(a,!0)):setTimeout(this.resume,3)},this.aborted=function(){return e},this.abort=function(){e=!0,o.abort(),l.meta.aborted=!0,q(_.complete)&&_.complete(l),a=""}}function U(e){return e.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")}function y(e){var O,D=(e=e||{}).delimiter,I=e.newline,T=e.comments,A=e.step,L=e.preview,F=e.fastMode,z=O=void 0===e.quoteChar?'"':e.quoteChar;if(void 0!==e.escapeChar&&(z=e.escapeChar),("string"!=typeof D||-1<k.BAD_DELIMITERS.indexOf(D))&&(D=","),T===D)throw new Error("Comment character same as delimiter");!0===T?T="#":("string"!=typeof T||-1<k.BAD_DELIMITERS.indexOf(T))&&(T=!1),"\n"!==I&&"\r"!==I&&"\r\n"!==I&&(I="\n");var M=0,j=!1;this.parse=function(a,r,t){if("string"!=typeof a)throw new Error("Input must be a string");var i=a.length,e=D.length,n=I.length,s=T.length,o=q(A),h=[],u=[],f=[],d=M=0;if(!a)return R();if(F||!1!==F&&-1===a.indexOf(O)){for(var l=a.split(I),c=0;c<l.length;c++){if(f=l[c],M+=f.length,c!==l.length-1)M+=I.length;else if(t)return R();if(!T||f.substr(0,s)!==T){if(o){if(h=[],b(f.split(D)),S(),j)return R()}else b(f.split(D));if(L&&L<=c)return h=h.slice(0,L),R(!0)}}return R()}for(var p=a.indexOf(D,M),m=a.indexOf(I,M),_=new RegExp(U(z)+U(O),"g"),g=a.indexOf(O,M);;)if(a[M]!==O)if(T&&0===f.length&&a.substr(M,s)===T){if(-1===m)return R();M=m+n,m=a.indexOf(I,M),p=a.indexOf(D,M)}else{if(-1!==p&&(p<m||-1===m)){if(-1===g){f.push(a.substring(M,p)),M=p+e,p=a.indexOf(D,M);continue}var v=x(p,g,m);if(v&&v.nextDelim){p=v.nextDelim,g=v.quoteSearch,f.push(a.substring(M,p)),M=p+e,p=a.indexOf(D,M);continue}}if(-1===m)break;if(f.push(a.substring(M,m)),C(m+n),o&&(S(),j))return R();if(L&&h.length>=L)return R(!0)}else for(g=M,M++;;){if(-1===(g=a.indexOf(O,g+1)))return t||u.push({type:"Quotes",code:"MissingQuotes",message:"Quoted field unterminated",row:h.length,index:M}),w();if(g===i-1)return w(a.substring(M,g).replace(_,O));if(O!==z||a[g+1]!==z){if(O===z||0===g||a[g-1]!==z){var y=E(-1===m?p:Math.min(p,m));if(a[g+1+y]===D){f.push(a.substring(M,g).replace(_,O)),a[M=g+1+y+e]!==O&&(g=a.indexOf(O,M)),p=a.indexOf(D,M),m=a.indexOf(I,M);break}var k=E(m);if(a.substr(g+1+k,n)===I){if(f.push(a.substring(M,g).replace(_,O)),C(g+1+k+n),p=a.indexOf(D,M),g=a.indexOf(O,M),o&&(S(),j))return R();if(L&&h.length>=L)return R(!0);break}u.push({type:"Quotes",code:"InvalidQuotes",message:"Trailing quote on quoted field is malformed",row:h.length,index:M}),g++}}else g++}return w();function b(e){h.push(e),d=M}function E(e){var t=0;if(-1!==e){var r=a.substring(g+1,e);r&&""===r.trim()&&(t=r.length)}return t}function w(e){return t||(void 0===e&&(e=a.substr(M)),f.push(e),M=i,b(f),o&&S()),R()}function C(e){M=e,b(f),f=[],m=a.indexOf(I,M)}function R(e,t){return{data:t||!1?h[0]:h,errors:u,meta:{delimiter:D,linebreak:I,aborted:j,truncated:!!e,cursor:d+(r||0)}}}function S(){A(R(void 0,!0)),h=[],u=[]}function x(e,t,r){var i={nextDelim:void 0,quoteSearch:void 0},n=a.indexOf(O,t+1);if(t<e&&e<n&&(n<r||-1===r)){var s=a.indexOf(D,n);if(-1===s)return i;n<s&&(n=a.indexOf(O,n+1)),i=x(s,n,r)}else i={nextDelim:e,quoteSearch:t};return i}},this.abort=function(){j=!0},this.getCharIndex=function(){return M}}function _(e){var t=e.data,r=a[t.workerId],i=!1;if(t.error)r.userError(t.error,t.file);else if(t.results&&t.results.data){var n={abort:function(){i=!0,g(t.workerId,{data:[],errors:[],meta:{aborted:!0}})},pause:v,resume:v};if(q(r.userStep)){for(var s=0;s<t.results.data.length&&(r.userStep({data:t.results.data[s],errors:t.results.errors,meta:t.results.meta},n),!i);s++);delete t.results}else q(r.userChunk)&&(r.userChunk(t.results,n,t.file),delete t.results)}t.finished&&!i&&g(t.workerId,t.results)}function g(e,t){var r=a[e];q(r.userComplete)&&r.userComplete(t),r.terminate(),delete a[e]}function v(){throw new Error("Not implemented.")}function b(e){if("object"!=typeof e||null===e)return e;var t=Array.isArray(e)?[]:{};for(var r in e)t[r]=b(e[r]);return t}function E(e,t){return function(){e.apply(t,arguments)}}function q(e){return"function"==typeof e}return o&&(f.onmessage=function(e){var t=e.data;void 0===k.WORKER_ID&&t&&(k.WORKER_ID=t.workerId);if("string"==typeof t.input)f.postMessage({workerId:k.WORKER_ID,results:k.parse(t.input,t.config),finished:!0});else if(f.File&&t.input instanceof File||t.input instanceof Object){var r=k.parse(t.input,t.config);r&&f.postMessage({workerId:k.WORKER_ID,results:r,finished:!0})}}),(l.prototype=Object.create(u.prototype)).constructor=l,(c.prototype=Object.create(u.prototype)).constructor=c,(p.prototype=Object.create(p.prototype)).constructor=p,(m.prototype=Object.create(u.prototype)).constructor=m,k});

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"modal-header\">\n    <h4>Deputy Import Modal</h4>\n    <button type=\"button\" tabindex=\"-1\" class=\"close\" aria-label=\"Close\" ng-click=\"$dismiss('close')\"><span\n            aria-hidden=\"true\">&times;</span></button>\n</div>\n<div class=\"p-md\">\n    <form ng-submit=\"vm.change($close)\">\n        <input type=\"file\" id=\"csv-file\" name=\"files\" custom-on-change=\"vm.uploadFile\" />\n        <hr>\n        <button class=\"btn btn-block btn-lg btn-success\">\n            <span>Import Timesheets</span>\n        </button>\n    </form>\n</div>"

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(102);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(104)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js!../../node_modules/sass-loader/index.js!./app.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(103)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro:400,600,700);", ""]);
	
	// module
	exports.push([module.id, "/*!\n * Bootstrap v3.3.7 (http://getbootstrap.com)\n * Copyright 2011-2016 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)\n *//*! normalize.css v3.0.3 | MIT License | github.com/necolas/normalize.css */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background-color:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{box-sizing:content-box;height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield;box-sizing:content-box}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}/*! Source: https://github.com/h5bp/html5-boilerplate/blob/master/src/css/main.css */@media print{*,:after,:before{background:transparent!important;color:#000!important;box-shadow:none!important;text-shadow:none!important}a,a:visited{text-decoration:underline}a[href]:after{content:\" (\" attr(href) \")\"}abbr[title]:after{content:\" (\" attr(title) \")\"}a[href^=\"#\"]:after,a[href^=\"javascript:\"]:after{content:\"\"}blockquote,pre{border:1px solid #999;page-break-inside:avoid}thead{display:table-header-group}img,tr{page-break-inside:avoid}img{max-width:100%!important}h2,h3,p{orphans:3;widows:3}h2,h3{page-break-after:avoid}.navbar{display:none}.btn>.caret,.dropup>.btn>.caret{border-top-color:#000!important}.label{border:1px solid #000}.table{border-collapse:collapse!important}.table td,.table th{background-color:#fff!important}.table-bordered td,.table-bordered th{border:1px solid #ddd!important}}@font-face{font-family:Glyphicons Halflings;src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot\");src:url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.eot?#iefix\") format(\"embedded-opentype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff2\") format(\"woff2\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.woff\") format(\"woff\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.ttf\") format(\"truetype\"),url(\"/assets/fonts/bootstrap/glyphicons-halflings-regular.svg#glyphicons_halflingsregular\") format(\"svg\")}.glyphicon{position:relative;top:1px;display:inline-block;font-family:Glyphicons Halflings;font-style:normal;font-weight:400;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.glyphicon-asterisk:before{content:\"*\"}.glyphicon-plus:before{content:\"+\"}.glyphicon-eur:before,.glyphicon-euro:before{content:\"\\20AC\"}.glyphicon-minus:before{content:\"\\2212\"}.glyphicon-cloud:before{content:\"\\2601\"}.glyphicon-envelope:before{content:\"\\2709\"}.glyphicon-pencil:before{content:\"\\270F\"}.glyphicon-glass:before{content:\"\\E001\"}.glyphicon-music:before{content:\"\\E002\"}.glyphicon-search:before{content:\"\\E003\"}.glyphicon-heart:before{content:\"\\E005\"}.glyphicon-star:before{content:\"\\E006\"}.glyphicon-star-empty:before{content:\"\\E007\"}.glyphicon-user:before{content:\"\\E008\"}.glyphicon-film:before{content:\"\\E009\"}.glyphicon-th-large:before{content:\"\\E010\"}.glyphicon-th:before{content:\"\\E011\"}.glyphicon-th-list:before{content:\"\\E012\"}.glyphicon-ok:before{content:\"\\E013\"}.glyphicon-remove:before{content:\"\\E014\"}.glyphicon-zoom-in:before{content:\"\\E015\"}.glyphicon-zoom-out:before{content:\"\\E016\"}.glyphicon-off:before{content:\"\\E017\"}.glyphicon-signal:before{content:\"\\E018\"}.glyphicon-cog:before{content:\"\\E019\"}.glyphicon-trash:before{content:\"\\E020\"}.glyphicon-home:before{content:\"\\E021\"}.glyphicon-file:before{content:\"\\E022\"}.glyphicon-time:before{content:\"\\E023\"}.glyphicon-road:before{content:\"\\E024\"}.glyphicon-download-alt:before{content:\"\\E025\"}.glyphicon-download:before{content:\"\\E026\"}.glyphicon-upload:before{content:\"\\E027\"}.glyphicon-inbox:before{content:\"\\E028\"}.glyphicon-play-circle:before{content:\"\\E029\"}.glyphicon-repeat:before{content:\"\\E030\"}.glyphicon-refresh:before{content:\"\\E031\"}.glyphicon-list-alt:before{content:\"\\E032\"}.glyphicon-lock:before{content:\"\\E033\"}.glyphicon-flag:before{content:\"\\E034\"}.glyphicon-headphones:before{content:\"\\E035\"}.glyphicon-volume-off:before{content:\"\\E036\"}.glyphicon-volume-down:before{content:\"\\E037\"}.glyphicon-volume-up:before{content:\"\\E038\"}.glyphicon-qrcode:before{content:\"\\E039\"}.glyphicon-barcode:before{content:\"\\E040\"}.glyphicon-tag:before{content:\"\\E041\"}.glyphicon-tags:before{content:\"\\E042\"}.glyphicon-book:before{content:\"\\E043\"}.glyphicon-bookmark:before{content:\"\\E044\"}.glyphicon-print:before{content:\"\\E045\"}.glyphicon-camera:before{content:\"\\E046\"}.glyphicon-font:before{content:\"\\E047\"}.glyphicon-bold:before{content:\"\\E048\"}.glyphicon-italic:before{content:\"\\E049\"}.glyphicon-text-height:before{content:\"\\E050\"}.glyphicon-text-width:before{content:\"\\E051\"}.glyphicon-align-left:before{content:\"\\E052\"}.glyphicon-align-center:before{content:\"\\E053\"}.glyphicon-align-right:before{content:\"\\E054\"}.glyphicon-align-justify:before{content:\"\\E055\"}.glyphicon-list:before{content:\"\\E056\"}.glyphicon-indent-left:before{content:\"\\E057\"}.glyphicon-indent-right:before{content:\"\\E058\"}.glyphicon-facetime-video:before{content:\"\\E059\"}.glyphicon-picture:before{content:\"\\E060\"}.glyphicon-map-marker:before{content:\"\\E062\"}.glyphicon-adjust:before{content:\"\\E063\"}.glyphicon-tint:before{content:\"\\E064\"}.glyphicon-edit:before{content:\"\\E065\"}.glyphicon-share:before{content:\"\\E066\"}.glyphicon-check:before{content:\"\\E067\"}.glyphicon-move:before{content:\"\\E068\"}.glyphicon-step-backward:before{content:\"\\E069\"}.glyphicon-fast-backward:before{content:\"\\E070\"}.glyphicon-backward:before{content:\"\\E071\"}.glyphicon-play:before{content:\"\\E072\"}.glyphicon-pause:before{content:\"\\E073\"}.glyphicon-stop:before{content:\"\\E074\"}.glyphicon-forward:before{content:\"\\E075\"}.glyphicon-fast-forward:before{content:\"\\E076\"}.glyphicon-step-forward:before{content:\"\\E077\"}.glyphicon-eject:before{content:\"\\E078\"}.glyphicon-chevron-left:before{content:\"\\E079\"}.glyphicon-chevron-right:before{content:\"\\E080\"}.glyphicon-plus-sign:before{content:\"\\E081\"}.glyphicon-minus-sign:before{content:\"\\E082\"}.glyphicon-remove-sign:before{content:\"\\E083\"}.glyphicon-ok-sign:before{content:\"\\E084\"}.glyphicon-question-sign:before{content:\"\\E085\"}.glyphicon-info-sign:before{content:\"\\E086\"}.glyphicon-screenshot:before{content:\"\\E087\"}.glyphicon-remove-circle:before{content:\"\\E088\"}.glyphicon-ok-circle:before{content:\"\\E089\"}.glyphicon-ban-circle:before{content:\"\\E090\"}.glyphicon-arrow-left:before{content:\"\\E091\"}.glyphicon-arrow-right:before{content:\"\\E092\"}.glyphicon-arrow-up:before{content:\"\\E093\"}.glyphicon-arrow-down:before{content:\"\\E094\"}.glyphicon-share-alt:before{content:\"\\E095\"}.glyphicon-resize-full:before{content:\"\\E096\"}.glyphicon-resize-small:before{content:\"\\E097\"}.glyphicon-exclamation-sign:before{content:\"\\E101\"}.glyphicon-gift:before{content:\"\\E102\"}.glyphicon-leaf:before{content:\"\\E103\"}.glyphicon-fire:before{content:\"\\E104\"}.glyphicon-eye-open:before{content:\"\\E105\"}.glyphicon-eye-close:before{content:\"\\E106\"}.glyphicon-warning-sign:before{content:\"\\E107\"}.glyphicon-plane:before{content:\"\\E108\"}.glyphicon-calendar:before{content:\"\\E109\"}.glyphicon-random:before{content:\"\\E110\"}.glyphicon-comment:before{content:\"\\E111\"}.glyphicon-magnet:before{content:\"\\E112\"}.glyphicon-chevron-up:before{content:\"\\E113\"}.glyphicon-chevron-down:before{content:\"\\E114\"}.glyphicon-retweet:before{content:\"\\E115\"}.glyphicon-shopping-cart:before{content:\"\\E116\"}.glyphicon-folder-close:before{content:\"\\E117\"}.glyphicon-folder-open:before{content:\"\\E118\"}.glyphicon-resize-vertical:before{content:\"\\E119\"}.glyphicon-resize-horizontal:before{content:\"\\E120\"}.glyphicon-hdd:before{content:\"\\E121\"}.glyphicon-bullhorn:before{content:\"\\E122\"}.glyphicon-bell:before{content:\"\\E123\"}.glyphicon-certificate:before{content:\"\\E124\"}.glyphicon-thumbs-up:before{content:\"\\E125\"}.glyphicon-thumbs-down:before{content:\"\\E126\"}.glyphicon-hand-right:before{content:\"\\E127\"}.glyphicon-hand-left:before{content:\"\\E128\"}.glyphicon-hand-up:before{content:\"\\E129\"}.glyphicon-hand-down:before{content:\"\\E130\"}.glyphicon-circle-arrow-right:before{content:\"\\E131\"}.glyphicon-circle-arrow-left:before{content:\"\\E132\"}.glyphicon-circle-arrow-up:before{content:\"\\E133\"}.glyphicon-circle-arrow-down:before{content:\"\\E134\"}.glyphicon-globe:before{content:\"\\E135\"}.glyphicon-wrench:before{content:\"\\E136\"}.glyphicon-tasks:before{content:\"\\E137\"}.glyphicon-filter:before{content:\"\\E138\"}.glyphicon-briefcase:before{content:\"\\E139\"}.glyphicon-fullscreen:before{content:\"\\E140\"}.glyphicon-dashboard:before{content:\"\\E141\"}.glyphicon-paperclip:before{content:\"\\E142\"}.glyphicon-heart-empty:before{content:\"\\E143\"}.glyphicon-link:before{content:\"\\E144\"}.glyphicon-phone:before{content:\"\\E145\"}.glyphicon-pushpin:before{content:\"\\E146\"}.glyphicon-usd:before{content:\"\\E148\"}.glyphicon-gbp:before{content:\"\\E149\"}.glyphicon-sort:before{content:\"\\E150\"}.glyphicon-sort-by-alphabet:before{content:\"\\E151\"}.glyphicon-sort-by-alphabet-alt:before{content:\"\\E152\"}.glyphicon-sort-by-order:before{content:\"\\E153\"}.glyphicon-sort-by-order-alt:before{content:\"\\E154\"}.glyphicon-sort-by-attributes:before{content:\"\\E155\"}.glyphicon-sort-by-attributes-alt:before{content:\"\\E156\"}.glyphicon-unchecked:before{content:\"\\E157\"}.glyphicon-expand:before{content:\"\\E158\"}.glyphicon-collapse-down:before{content:\"\\E159\"}.glyphicon-collapse-up:before{content:\"\\E160\"}.glyphicon-log-in:before{content:\"\\E161\"}.glyphicon-flash:before{content:\"\\E162\"}.glyphicon-log-out:before{content:\"\\E163\"}.glyphicon-new-window:before{content:\"\\E164\"}.glyphicon-record:before{content:\"\\E165\"}.glyphicon-save:before{content:\"\\E166\"}.glyphicon-open:before{content:\"\\E167\"}.glyphicon-saved:before{content:\"\\E168\"}.glyphicon-import:before{content:\"\\E169\"}.glyphicon-export:before{content:\"\\E170\"}.glyphicon-send:before{content:\"\\E171\"}.glyphicon-floppy-disk:before{content:\"\\E172\"}.glyphicon-floppy-saved:before{content:\"\\E173\"}.glyphicon-floppy-remove:before{content:\"\\E174\"}.glyphicon-floppy-save:before{content:\"\\E175\"}.glyphicon-floppy-open:before{content:\"\\E176\"}.glyphicon-credit-card:before{content:\"\\E177\"}.glyphicon-transfer:before{content:\"\\E178\"}.glyphicon-cutlery:before{content:\"\\E179\"}.glyphicon-header:before{content:\"\\E180\"}.glyphicon-compressed:before{content:\"\\E181\"}.glyphicon-earphone:before{content:\"\\E182\"}.glyphicon-phone-alt:before{content:\"\\E183\"}.glyphicon-tower:before{content:\"\\E184\"}.glyphicon-stats:before{content:\"\\E185\"}.glyphicon-sd-video:before{content:\"\\E186\"}.glyphicon-hd-video:before{content:\"\\E187\"}.glyphicon-subtitles:before{content:\"\\E188\"}.glyphicon-sound-stereo:before{content:\"\\E189\"}.glyphicon-sound-dolby:before{content:\"\\E190\"}.glyphicon-sound-5-1:before{content:\"\\E191\"}.glyphicon-sound-6-1:before{content:\"\\E192\"}.glyphicon-sound-7-1:before{content:\"\\E193\"}.glyphicon-copyright-mark:before{content:\"\\E194\"}.glyphicon-registration-mark:before{content:\"\\E195\"}.glyphicon-cloud-download:before{content:\"\\E197\"}.glyphicon-cloud-upload:before{content:\"\\E198\"}.glyphicon-tree-conifer:before{content:\"\\E199\"}.glyphicon-tree-deciduous:before{content:\"\\E200\"}.glyphicon-cd:before{content:\"\\E201\"}.glyphicon-save-file:before{content:\"\\E202\"}.glyphicon-open-file:before{content:\"\\E203\"}.glyphicon-level-up:before{content:\"\\E204\"}.glyphicon-copy:before{content:\"\\E205\"}.glyphicon-paste:before{content:\"\\E206\"}.glyphicon-alert:before{content:\"\\E209\"}.glyphicon-equalizer:before{content:\"\\E210\"}.glyphicon-king:before{content:\"\\E211\"}.glyphicon-queen:before{content:\"\\E212\"}.glyphicon-pawn:before{content:\"\\E213\"}.glyphicon-bishop:before{content:\"\\E214\"}.glyphicon-knight:before{content:\"\\E215\"}.glyphicon-baby-formula:before{content:\"\\E216\"}.glyphicon-tent:before{content:\"\\26FA\"}.glyphicon-blackboard:before{content:\"\\E218\"}.glyphicon-bed:before{content:\"\\E219\"}.glyphicon-apple:before{content:\"\\F8FF\"}.glyphicon-erase:before{content:\"\\E221\"}.glyphicon-hourglass:before{content:\"\\231B\"}.glyphicon-lamp:before{content:\"\\E223\"}.glyphicon-duplicate:before{content:\"\\E224\"}.glyphicon-piggy-bank:before{content:\"\\E225\"}.glyphicon-scissors:before{content:\"\\E226\"}.glyphicon-bitcoin:before,.glyphicon-btc:before,.glyphicon-xbt:before{content:\"\\E227\"}.glyphicon-jpy:before,.glyphicon-yen:before{content:\"\\A5\"}.glyphicon-rub:before,.glyphicon-ruble:before{content:\"\\20BD\"}.glyphicon-scale:before{content:\"\\E230\"}.glyphicon-ice-lolly:before{content:\"\\E231\"}.glyphicon-ice-lolly-tasted:before{content:\"\\E232\"}.glyphicon-education:before{content:\"\\E233\"}.glyphicon-option-horizontal:before{content:\"\\E234\"}.glyphicon-option-vertical:before{content:\"\\E235\"}.glyphicon-menu-hamburger:before{content:\"\\E236\"}.glyphicon-modal-window:before{content:\"\\E237\"}.glyphicon-oil:before{content:\"\\E238\"}.glyphicon-grain:before{content:\"\\E239\"}.glyphicon-sunglasses:before{content:\"\\E240\"}.glyphicon-text-size:before{content:\"\\E241\"}.glyphicon-text-color:before{content:\"\\E242\"}.glyphicon-text-background:before{content:\"\\E243\"}.glyphicon-object-align-top:before{content:\"\\E244\"}.glyphicon-object-align-bottom:before{content:\"\\E245\"}.glyphicon-object-align-horizontal:before{content:\"\\E246\"}.glyphicon-object-align-left:before{content:\"\\E247\"}.glyphicon-object-align-vertical:before{content:\"\\E248\"}.glyphicon-object-align-right:before{content:\"\\E249\"}.glyphicon-triangle-right:before{content:\"\\E250\"}.glyphicon-triangle-left:before{content:\"\\E251\"}.glyphicon-triangle-bottom:before{content:\"\\E252\"}.glyphicon-triangle-top:before{content:\"\\E253\"}.glyphicon-console:before{content:\"\\E254\"}.glyphicon-superscript:before{content:\"\\E255\"}.glyphicon-subscript:before{content:\"\\E256\"}.glyphicon-menu-left:before{content:\"\\E257\"}.glyphicon-menu-right:before{content:\"\\E258\"}.glyphicon-menu-down:before{content:\"\\E259\"}.glyphicon-menu-up:before{content:\"\\E260\"}*,:after,:before{box-sizing:border-box}html{font-size:10px;-webkit-tap-highlight-color:transparent}body{font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-size:14px;line-height:1.428571429;color:#333;background-color:#fff}button,input,select,textarea{font-family:inherit;font-size:inherit;line-height:inherit}a{color:#337ab7;text-decoration:none}a:focus,a:hover{color:#23527c;text-decoration:underline}a:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}figure{margin:0}img{vertical-align:middle}.img-responsive{display:block;max-width:100%;height:auto}.img-rounded{border-radius:6px}.img-thumbnail{padding:4px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:all .2s ease-in-out;display:inline-block;max-width:100%;height:auto}.img-circle{border-radius:50%}hr{margin-top:20px;margin-bottom:20px;border:0;border-top:1px solid #eee}[role=button]{cursor:pointer}.h1,.h2,.h3,.h4,.h5,.h6,h1,h2,h3,h4,h5,h6{font-family:inherit;font-weight:500;line-height:1.1;color:inherit}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-weight:400;line-height:1;color:#777}.h1,.h2,.h3,h1,h2,h3{margin-top:20px;margin-bottom:10px}.h1 .small,.h1 small,.h2 .small,.h2 small,.h3 .small,.h3 small,h1 .small,h1 small,h2 .small,h2 small,h3 .small,h3 small{font-size:65%}.h4,.h5,.h6,h4,h5,h6{margin-top:10px;margin-bottom:10px}.h4 .small,.h4 small,.h5 .small,.h5 small,.h6 .small,.h6 small,h4 .small,h4 small,h5 .small,h5 small,h6 .small,h6 small{font-size:75%}.h1,h1{font-size:36px}.h2,h2{font-size:30px}.h3,h3{font-size:24px}.h4,h4{font-size:18px}.h5,h5{font-size:14px}.h6,h6{font-size:12px}p{margin:0 0 10px}.lead{margin-bottom:20px;font-size:16px;font-weight:300;line-height:1.4}@media (min-width:768px){.lead{font-size:21px}}.small,small{font-size:85%}.mark,mark{background-color:#fcf8e3;padding:.2em}.text-left{text-align:left}.text-right{text-align:right}.text-center{text-align:center}.text-justify{text-align:justify}.text-nowrap{white-space:nowrap}.text-lowercase{text-transform:lowercase}.initialism,.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.text-muted{color:#777}.text-primary{color:#337ab7}a.text-primary:focus,a.text-primary:hover{color:#286090}.text-success{color:#3c763d}a.text-success:focus,a.text-success:hover{color:#2b542c}.text-info{color:#31708f}a.text-info:focus,a.text-info:hover{color:#245269}.text-warning{color:#8a6d3b}a.text-warning:focus,a.text-warning:hover{color:#66512c}.text-danger{color:#a94442}a.text-danger:focus,a.text-danger:hover{color:#843534}.bg-primary{color:#fff;background-color:#337ab7}a.bg-primary:focus,a.bg-primary:hover{background-color:#286090}.bg-success{background-color:#dff0d8}a.bg-success:focus,a.bg-success:hover{background-color:#c1e2b3}.bg-info{background-color:#d9edf7}a.bg-info:focus,a.bg-info:hover{background-color:#afd9ee}.bg-warning{background-color:#fcf8e3}a.bg-warning:focus,a.bg-warning:hover{background-color:#f7ecb5}.bg-danger{background-color:#f2dede}a.bg-danger:focus,a.bg-danger:hover{background-color:#e4b9b9}.page-header{padding-bottom:9px;margin:40px 0 20px;border-bottom:1px solid #eee}ol,ul{margin-top:0;margin-bottom:10px}ol ol,ol ul,ul ol,ul ul{margin-bottom:0}.list-inline,.list-unstyled{padding-left:0;list-style:none}.list-inline{margin-left:-5px}.list-inline>li{display:inline-block;padding-left:5px;padding-right:5px}dl{margin-top:0;margin-bottom:20px}dd,dt{line-height:1.428571429}dt{font-weight:700}dd{margin-left:0}.dl-horizontal dd:after,.dl-horizontal dd:before{content:\" \";display:table}.dl-horizontal dd:after{clear:both}@media (min-width:768px){.dl-horizontal dt{float:left;width:160px;clear:left;text-align:right;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.dl-horizontal dd{margin-left:180px}}abbr[data-original-title],abbr[title]{cursor:help;border-bottom:1px dotted #777}.initialism{font-size:90%}blockquote{padding:10px 20px;margin:0 0 20px;font-size:17.5px;border-left:5px solid #eee}blockquote ol:last-child,blockquote p:last-child,blockquote ul:last-child{margin-bottom:0}blockquote .small,blockquote footer,blockquote small{display:block;font-size:80%;line-height:1.428571429;color:#777}blockquote .small:before,blockquote footer:before,blockquote small:before{content:\"\\2014   \\A0\"}.blockquote-reverse,blockquote.pull-right{padding-right:15px;padding-left:0;border-right:5px solid #eee;border-left:0;text-align:right}.blockquote-reverse .small:before,.blockquote-reverse footer:before,.blockquote-reverse small:before,blockquote.pull-right .small:before,blockquote.pull-right footer:before,blockquote.pull-right small:before{content:\"\"}.blockquote-reverse .small:after,.blockquote-reverse footer:after,.blockquote-reverse small:after,blockquote.pull-right .small:after,blockquote.pull-right footer:after,blockquote.pull-right small:after{content:\"\\A0   \\2014\"}address{margin-bottom:20px;font-style:normal;line-height:1.428571429}code,kbd,pre,samp{font-family:Menlo,Monaco,Consolas,Courier New,monospace}code{color:#c7254e;background-color:#f9f2f4;border-radius:4px}code,kbd{padding:2px 4px;font-size:90%}kbd{color:#fff;background-color:#333;border-radius:3px;box-shadow:inset 0 -1px 0 rgba(0,0,0,.25)}kbd kbd{padding:0;font-size:100%;font-weight:700;box-shadow:none}pre{display:block;padding:9.5px;margin:0 0 10px;font-size:13px;line-height:1.428571429;word-break:break-all;word-wrap:break-word;color:#333;background-color:#f5f5f5;border:1px solid #ccc;border-radius:4px}pre code{padding:0;font-size:inherit;color:inherit;white-space:pre-wrap;background-color:transparent;border-radius:0}.pre-scrollable{max-height:340px;overflow-y:scroll}.container{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container:after,.container:before{content:\" \";display:table}.container:after{clear:both}@media (min-width:768px){.container{width:750px}}@media (min-width:992px){.container{width:970px}}@media (min-width:1200px){.container{width:1170px}}.container-fluid{margin-right:auto;margin-left:auto;padding-left:15px;padding-right:15px}.container-fluid:after,.container-fluid:before{content:\" \";display:table}.container-fluid:after{clear:both}.row{margin-left:-15px;margin-right:-15px}.row:after,.row:before{content:\" \";display:table}.row:after{clear:both}.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12,.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12,.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12,.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{position:relative;min-height:1px;padding-left:15px;padding-right:15px}.col-xs-1,.col-xs-2,.col-xs-3,.col-xs-4,.col-xs-5,.col-xs-6,.col-xs-7,.col-xs-8,.col-xs-9,.col-xs-10,.col-xs-11,.col-xs-12{float:left}.col-xs-1{width:8.3333333333%}.col-xs-2{width:16.6666666667%}.col-xs-3{width:25%}.col-xs-4{width:33.3333333333%}.col-xs-5{width:41.6666666667%}.col-xs-6{width:50%}.col-xs-7{width:58.3333333333%}.col-xs-8{width:66.6666666667%}.col-xs-9{width:75%}.col-xs-10{width:83.3333333333%}.col-xs-11{width:91.6666666667%}.col-xs-12{width:100%}.col-xs-pull-0{right:auto}.col-xs-pull-1{right:8.3333333333%}.col-xs-pull-2{right:16.6666666667%}.col-xs-pull-3{right:25%}.col-xs-pull-4{right:33.3333333333%}.col-xs-pull-5{right:41.6666666667%}.col-xs-pull-6{right:50%}.col-xs-pull-7{right:58.3333333333%}.col-xs-pull-8{right:66.6666666667%}.col-xs-pull-9{right:75%}.col-xs-pull-10{right:83.3333333333%}.col-xs-pull-11{right:91.6666666667%}.col-xs-pull-12{right:100%}.col-xs-push-0{left:auto}.col-xs-push-1{left:8.3333333333%}.col-xs-push-2{left:16.6666666667%}.col-xs-push-3{left:25%}.col-xs-push-4{left:33.3333333333%}.col-xs-push-5{left:41.6666666667%}.col-xs-push-6{left:50%}.col-xs-push-7{left:58.3333333333%}.col-xs-push-8{left:66.6666666667%}.col-xs-push-9{left:75%}.col-xs-push-10{left:83.3333333333%}.col-xs-push-11{left:91.6666666667%}.col-xs-push-12{left:100%}.col-xs-offset-0{margin-left:0}.col-xs-offset-1{margin-left:8.3333333333%}.col-xs-offset-2{margin-left:16.6666666667%}.col-xs-offset-3{margin-left:25%}.col-xs-offset-4{margin-left:33.3333333333%}.col-xs-offset-5{margin-left:41.6666666667%}.col-xs-offset-6{margin-left:50%}.col-xs-offset-7{margin-left:58.3333333333%}.col-xs-offset-8{margin-left:66.6666666667%}.col-xs-offset-9{margin-left:75%}.col-xs-offset-10{margin-left:83.3333333333%}.col-xs-offset-11{margin-left:91.6666666667%}.col-xs-offset-12{margin-left:100%}@media (min-width:768px){.col-sm-1,.col-sm-2,.col-sm-3,.col-sm-4,.col-sm-5,.col-sm-6,.col-sm-7,.col-sm-8,.col-sm-9,.col-sm-10,.col-sm-11,.col-sm-12{float:left}.col-sm-1{width:8.3333333333%}.col-sm-2{width:16.6666666667%}.col-sm-3{width:25%}.col-sm-4{width:33.3333333333%}.col-sm-5{width:41.6666666667%}.col-sm-6{width:50%}.col-sm-7{width:58.3333333333%}.col-sm-8{width:66.6666666667%}.col-sm-9{width:75%}.col-sm-10{width:83.3333333333%}.col-sm-11{width:91.6666666667%}.col-sm-12{width:100%}.col-sm-pull-0{right:auto}.col-sm-pull-1{right:8.3333333333%}.col-sm-pull-2{right:16.6666666667%}.col-sm-pull-3{right:25%}.col-sm-pull-4{right:33.3333333333%}.col-sm-pull-5{right:41.6666666667%}.col-sm-pull-6{right:50%}.col-sm-pull-7{right:58.3333333333%}.col-sm-pull-8{right:66.6666666667%}.col-sm-pull-9{right:75%}.col-sm-pull-10{right:83.3333333333%}.col-sm-pull-11{right:91.6666666667%}.col-sm-pull-12{right:100%}.col-sm-push-0{left:auto}.col-sm-push-1{left:8.3333333333%}.col-sm-push-2{left:16.6666666667%}.col-sm-push-3{left:25%}.col-sm-push-4{left:33.3333333333%}.col-sm-push-5{left:41.6666666667%}.col-sm-push-6{left:50%}.col-sm-push-7{left:58.3333333333%}.col-sm-push-8{left:66.6666666667%}.col-sm-push-9{left:75%}.col-sm-push-10{left:83.3333333333%}.col-sm-push-11{left:91.6666666667%}.col-sm-push-12{left:100%}.col-sm-offset-0{margin-left:0}.col-sm-offset-1{margin-left:8.3333333333%}.col-sm-offset-2{margin-left:16.6666666667%}.col-sm-offset-3{margin-left:25%}.col-sm-offset-4{margin-left:33.3333333333%}.col-sm-offset-5{margin-left:41.6666666667%}.col-sm-offset-6{margin-left:50%}.col-sm-offset-7{margin-left:58.3333333333%}.col-sm-offset-8{margin-left:66.6666666667%}.col-sm-offset-9{margin-left:75%}.col-sm-offset-10{margin-left:83.3333333333%}.col-sm-offset-11{margin-left:91.6666666667%}.col-sm-offset-12{margin-left:100%}}@media (min-width:992px){.col-md-1,.col-md-2,.col-md-3,.col-md-4,.col-md-5,.col-md-6,.col-md-7,.col-md-8,.col-md-9,.col-md-10,.col-md-11,.col-md-12{float:left}.col-md-1{width:8.3333333333%}.col-md-2{width:16.6666666667%}.col-md-3{width:25%}.col-md-4{width:33.3333333333%}.col-md-5{width:41.6666666667%}.col-md-6{width:50%}.col-md-7{width:58.3333333333%}.col-md-8{width:66.6666666667%}.col-md-9{width:75%}.col-md-10{width:83.3333333333%}.col-md-11{width:91.6666666667%}.col-md-12{width:100%}.col-md-pull-0{right:auto}.col-md-pull-1{right:8.3333333333%}.col-md-pull-2{right:16.6666666667%}.col-md-pull-3{right:25%}.col-md-pull-4{right:33.3333333333%}.col-md-pull-5{right:41.6666666667%}.col-md-pull-6{right:50%}.col-md-pull-7{right:58.3333333333%}.col-md-pull-8{right:66.6666666667%}.col-md-pull-9{right:75%}.col-md-pull-10{right:83.3333333333%}.col-md-pull-11{right:91.6666666667%}.col-md-pull-12{right:100%}.col-md-push-0{left:auto}.col-md-push-1{left:8.3333333333%}.col-md-push-2{left:16.6666666667%}.col-md-push-3{left:25%}.col-md-push-4{left:33.3333333333%}.col-md-push-5{left:41.6666666667%}.col-md-push-6{left:50%}.col-md-push-7{left:58.3333333333%}.col-md-push-8{left:66.6666666667%}.col-md-push-9{left:75%}.col-md-push-10{left:83.3333333333%}.col-md-push-11{left:91.6666666667%}.col-md-push-12{left:100%}.col-md-offset-0{margin-left:0}.col-md-offset-1{margin-left:8.3333333333%}.col-md-offset-2{margin-left:16.6666666667%}.col-md-offset-3{margin-left:25%}.col-md-offset-4{margin-left:33.3333333333%}.col-md-offset-5{margin-left:41.6666666667%}.col-md-offset-6{margin-left:50%}.col-md-offset-7{margin-left:58.3333333333%}.col-md-offset-8{margin-left:66.6666666667%}.col-md-offset-9{margin-left:75%}.col-md-offset-10{margin-left:83.3333333333%}.col-md-offset-11{margin-left:91.6666666667%}.col-md-offset-12{margin-left:100%}}@media (min-width:1200px){.col-lg-1,.col-lg-2,.col-lg-3,.col-lg-4,.col-lg-5,.col-lg-6,.col-lg-7,.col-lg-8,.col-lg-9,.col-lg-10,.col-lg-11,.col-lg-12{float:left}.col-lg-1{width:8.3333333333%}.col-lg-2{width:16.6666666667%}.col-lg-3{width:25%}.col-lg-4{width:33.3333333333%}.col-lg-5{width:41.6666666667%}.col-lg-6{width:50%}.col-lg-7{width:58.3333333333%}.col-lg-8{width:66.6666666667%}.col-lg-9{width:75%}.col-lg-10{width:83.3333333333%}.col-lg-11{width:91.6666666667%}.col-lg-12{width:100%}.col-lg-pull-0{right:auto}.col-lg-pull-1{right:8.3333333333%}.col-lg-pull-2{right:16.6666666667%}.col-lg-pull-3{right:25%}.col-lg-pull-4{right:33.3333333333%}.col-lg-pull-5{right:41.6666666667%}.col-lg-pull-6{right:50%}.col-lg-pull-7{right:58.3333333333%}.col-lg-pull-8{right:66.6666666667%}.col-lg-pull-9{right:75%}.col-lg-pull-10{right:83.3333333333%}.col-lg-pull-11{right:91.6666666667%}.col-lg-pull-12{right:100%}.col-lg-push-0{left:auto}.col-lg-push-1{left:8.3333333333%}.col-lg-push-2{left:16.6666666667%}.col-lg-push-3{left:25%}.col-lg-push-4{left:33.3333333333%}.col-lg-push-5{left:41.6666666667%}.col-lg-push-6{left:50%}.col-lg-push-7{left:58.3333333333%}.col-lg-push-8{left:66.6666666667%}.col-lg-push-9{left:75%}.col-lg-push-10{left:83.3333333333%}.col-lg-push-11{left:91.6666666667%}.col-lg-push-12{left:100%}.col-lg-offset-0{margin-left:0}.col-lg-offset-1{margin-left:8.3333333333%}.col-lg-offset-2{margin-left:16.6666666667%}.col-lg-offset-3{margin-left:25%}.col-lg-offset-4{margin-left:33.3333333333%}.col-lg-offset-5{margin-left:41.6666666667%}.col-lg-offset-6{margin-left:50%}.col-lg-offset-7{margin-left:58.3333333333%}.col-lg-offset-8{margin-left:66.6666666667%}.col-lg-offset-9{margin-left:75%}.col-lg-offset-10{margin-left:83.3333333333%}.col-lg-offset-11{margin-left:91.6666666667%}.col-lg-offset-12{margin-left:100%}}table{background-color:transparent}caption{padding-top:8px;padding-bottom:8px;color:#777}caption,th{text-align:left}.table{width:100%;max-width:100%;margin-bottom:20px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:8px;line-height:1.428571429;vertical-align:top;border-top:1px solid #ddd}.table>thead>tr>th{vertical-align:bottom;border-bottom:2px solid #ddd}.table>caption+thead>tr:first-child>td,.table>caption+thead>tr:first-child>th,.table>colgroup+thead>tr:first-child>td,.table>colgroup+thead>tr:first-child>th,.table>thead:first-child>tr:first-child>td,.table>thead:first-child>tr:first-child>th{border-top:0}.table>tbody+tbody{border-top:2px solid #ddd}.table .table{background-color:#fff}.table-condensed>tbody>tr>td,.table-condensed>tbody>tr>th,.table-condensed>tfoot>tr>td,.table-condensed>tfoot>tr>th,.table-condensed>thead>tr>td,.table-condensed>thead>tr>th{padding:5px}.table-bordered,.table-bordered>tbody>tr>td,.table-bordered>tbody>tr>th,.table-bordered>tfoot>tr>td,.table-bordered>tfoot>tr>th,.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border:1px solid #ddd}.table-bordered>thead>tr>td,.table-bordered>thead>tr>th{border-bottom-width:2px}.table-striped>tbody>tr:nth-of-type(odd){background-color:#f9f9f9}.table-hover>tbody>tr:hover{background-color:#f5f5f5}table col[class*=col-]{position:static;float:none;display:table-column}table td[class*=col-],table th[class*=col-]{position:static;float:none;display:table-cell}.table>tbody>tr.active>td,.table>tbody>tr.active>th,.table>tbody>tr>td.active,.table>tbody>tr>th.active,.table>tfoot>tr.active>td,.table>tfoot>tr.active>th,.table>tfoot>tr>td.active,.table>tfoot>tr>th.active,.table>thead>tr.active>td,.table>thead>tr.active>th,.table>thead>tr>td.active,.table>thead>tr>th.active{background-color:#f5f5f5}.table-hover>tbody>tr.active:hover>td,.table-hover>tbody>tr.active:hover>th,.table-hover>tbody>tr:hover>.active,.table-hover>tbody>tr>td.active:hover,.table-hover>tbody>tr>th.active:hover{background-color:#e8e8e8}.table>tbody>tr.success>td,.table>tbody>tr.success>th,.table>tbody>tr>td.success,.table>tbody>tr>th.success,.table>tfoot>tr.success>td,.table>tfoot>tr.success>th,.table>tfoot>tr>td.success,.table>tfoot>tr>th.success,.table>thead>tr.success>td,.table>thead>tr.success>th,.table>thead>tr>td.success,.table>thead>tr>th.success{background-color:#dff0d8}.table-hover>tbody>tr.success:hover>td,.table-hover>tbody>tr.success:hover>th,.table-hover>tbody>tr:hover>.success,.table-hover>tbody>tr>td.success:hover,.table-hover>tbody>tr>th.success:hover{background-color:#d0e9c6}.table>tbody>tr.info>td,.table>tbody>tr.info>th,.table>tbody>tr>td.info,.table>tbody>tr>th.info,.table>tfoot>tr.info>td,.table>tfoot>tr.info>th,.table>tfoot>tr>td.info,.table>tfoot>tr>th.info,.table>thead>tr.info>td,.table>thead>tr.info>th,.table>thead>tr>td.info,.table>thead>tr>th.info{background-color:#d9edf7}.table-hover>tbody>tr.info:hover>td,.table-hover>tbody>tr.info:hover>th,.table-hover>tbody>tr:hover>.info,.table-hover>tbody>tr>td.info:hover,.table-hover>tbody>tr>th.info:hover{background-color:#c4e3f3}.table>tbody>tr.warning>td,.table>tbody>tr.warning>th,.table>tbody>tr>td.warning,.table>tbody>tr>th.warning,.table>tfoot>tr.warning>td,.table>tfoot>tr.warning>th,.table>tfoot>tr>td.warning,.table>tfoot>tr>th.warning,.table>thead>tr.warning>td,.table>thead>tr.warning>th,.table>thead>tr>td.warning,.table>thead>tr>th.warning{background-color:#fcf8e3}.table-hover>tbody>tr.warning:hover>td,.table-hover>tbody>tr.warning:hover>th,.table-hover>tbody>tr:hover>.warning,.table-hover>tbody>tr>td.warning:hover,.table-hover>tbody>tr>th.warning:hover{background-color:#faf2cc}.table>tbody>tr.danger>td,.table>tbody>tr.danger>th,.table>tbody>tr>td.danger,.table>tbody>tr>th.danger,.table>tfoot>tr.danger>td,.table>tfoot>tr.danger>th,.table>tfoot>tr>td.danger,.table>tfoot>tr>th.danger,.table>thead>tr.danger>td,.table>thead>tr.danger>th,.table>thead>tr>td.danger,.table>thead>tr>th.danger{background-color:#f2dede}.table-hover>tbody>tr.danger:hover>td,.table-hover>tbody>tr.danger:hover>th,.table-hover>tbody>tr:hover>.danger,.table-hover>tbody>tr>td.danger:hover,.table-hover>tbody>tr>th.danger:hover{background-color:#ebcccc}.table-responsive{overflow-x:auto;min-height:.01%}@media screen and (max-width:767px){.table-responsive{width:100%;margin-bottom:15px;overflow-y:hidden;-ms-overflow-style:-ms-autohiding-scrollbar;border:1px solid #ddd}.table-responsive>.table{margin-bottom:0}.table-responsive>.table>tbody>tr>td,.table-responsive>.table>tbody>tr>th,.table-responsive>.table>tfoot>tr>td,.table-responsive>.table>tfoot>tr>th,.table-responsive>.table>thead>tr>td,.table-responsive>.table>thead>tr>th{white-space:nowrap}.table-responsive>.table-bordered{border:0}.table-responsive>.table-bordered>tbody>tr>td:first-child,.table-responsive>.table-bordered>tbody>tr>th:first-child,.table-responsive>.table-bordered>tfoot>tr>td:first-child,.table-responsive>.table-bordered>tfoot>tr>th:first-child,.table-responsive>.table-bordered>thead>tr>td:first-child,.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.table-responsive>.table-bordered>tbody>tr>td:last-child,.table-responsive>.table-bordered>tbody>tr>th:last-child,.table-responsive>.table-bordered>tfoot>tr>td:last-child,.table-responsive>.table-bordered>tfoot>tr>th:last-child,.table-responsive>.table-bordered>thead>tr>td:last-child,.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.table-responsive>.table-bordered>tbody>tr:last-child>td,.table-responsive>.table-bordered>tbody>tr:last-child>th,.table-responsive>.table-bordered>tfoot>tr:last-child>td,.table-responsive>.table-bordered>tfoot>tr:last-child>th{border-bottom:0}}fieldset{margin:0;min-width:0}fieldset,legend{padding:0;border:0}legend{display:block;width:100%;margin-bottom:20px;font-size:21px;line-height:inherit;color:#333;border-bottom:1px solid #e5e5e5}label{display:inline-block;max-width:100%;margin-bottom:5px;font-weight:700}input[type=search]{box-sizing:border-box}input[type=checkbox],input[type=radio]{margin:4px 0 0;margin-top:1px\\9;line-height:normal}input[type=file]{display:block}input[type=range]{display:block;width:100%}select[multiple],select[size]{height:auto}input[type=checkbox]:focus,input[type=file]:focus,input[type=radio]:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}output{padding-top:7px}.form-control,output{display:block;font-size:14px;line-height:1.428571429;color:#555}.form-control{width:100%;height:34px;padding:6px 12px;background-color:#fff;background-image:none;border:1px solid #ccc;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out}.form-control:focus{border-color:#66afe9;outline:0;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.form-control::-moz-placeholder{color:#999;opacity:1}.form-control:-ms-input-placeholder{color:#999}.form-control::-webkit-input-placeholder{color:#999}.form-control::-ms-expand{border:0;background-color:transparent}.form-control[disabled],.form-control[readonly],fieldset[disabled] .form-control{background-color:#eee;opacity:1}.form-control[disabled],fieldset[disabled] .form-control{cursor:not-allowed}textarea.form-control{height:auto}input[type=search]{-webkit-appearance:none}@media screen and (-webkit-min-device-pixel-ratio:0){input[type=date].form-control,input[type=datetime-local].form-control,input[type=month].form-control,input[type=time].form-control{line-height:34px}.input-group-sm>.input-group-btn>input[type=date].btn,.input-group-sm>.input-group-btn>input[type=datetime-local].btn,.input-group-sm>.input-group-btn>input[type=month].btn,.input-group-sm>.input-group-btn>input[type=time].btn,.input-group-sm>input[type=date].form-control,.input-group-sm>input[type=date].input-group-addon,.input-group-sm>input[type=datetime-local].form-control,.input-group-sm>input[type=datetime-local].input-group-addon,.input-group-sm>input[type=month].form-control,.input-group-sm>input[type=month].input-group-addon,.input-group-sm>input[type=time].form-control,.input-group-sm>input[type=time].input-group-addon,.input-group-sm input[type=date],.input-group-sm input[type=datetime-local],.input-group-sm input[type=month],.input-group-sm input[type=time],input[type=date].input-sm,input[type=datetime-local].input-sm,input[type=month].input-sm,input[type=time].input-sm{line-height:30px}.input-group-lg>.input-group-btn>input[type=date].btn,.input-group-lg>.input-group-btn>input[type=datetime-local].btn,.input-group-lg>.input-group-btn>input[type=month].btn,.input-group-lg>.input-group-btn>input[type=time].btn,.input-group-lg>input[type=date].form-control,.input-group-lg>input[type=date].input-group-addon,.input-group-lg>input[type=datetime-local].form-control,.input-group-lg>input[type=datetime-local].input-group-addon,.input-group-lg>input[type=month].form-control,.input-group-lg>input[type=month].input-group-addon,.input-group-lg>input[type=time].form-control,.input-group-lg>input[type=time].input-group-addon,.input-group-lg input[type=date],.input-group-lg input[type=datetime-local],.input-group-lg input[type=month],.input-group-lg input[type=time],input[type=date].input-lg,input[type=datetime-local].input-lg,input[type=month].input-lg,input[type=time].input-lg{line-height:46px}}.form-group{margin-bottom:15px}.checkbox,.radio{position:relative;display:block;margin-top:10px;margin-bottom:10px}.checkbox label,.radio label{min-height:20px;padding-left:20px;margin-bottom:0;font-weight:400;cursor:pointer}.checkbox-inline input[type=checkbox],.checkbox input[type=checkbox],.radio-inline input[type=radio],.radio input[type=radio]{position:absolute;margin-left:-20px;margin-top:4px\\9}.checkbox+.checkbox,.radio+.radio{margin-top:-5px}.checkbox-inline,.radio-inline{position:relative;display:inline-block;padding-left:20px;margin-bottom:0;vertical-align:middle;font-weight:400;cursor:pointer}.checkbox-inline+.checkbox-inline,.radio-inline+.radio-inline{margin-top:0;margin-left:10px}.checkbox-inline.disabled,.checkbox.disabled label,.radio-inline.disabled,.radio.disabled label,fieldset[disabled] .checkbox-inline,fieldset[disabled] .checkbox label,fieldset[disabled] .radio-inline,fieldset[disabled] .radio label,fieldset[disabled] input[type=checkbox],fieldset[disabled] input[type=radio],input[type=checkbox].disabled,input[type=checkbox][disabled],input[type=radio].disabled,input[type=radio][disabled]{cursor:not-allowed}.form-control-static{padding-top:7px;padding-bottom:7px;margin-bottom:0;min-height:34px}.form-control-static.input-lg,.form-control-static.input-sm,.input-group-lg>.form-control-static.form-control,.input-group-lg>.form-control-static.input-group-addon,.input-group-lg>.input-group-btn>.form-control-static.btn,.input-group-sm>.form-control-static.form-control,.input-group-sm>.form-control-static.input-group-addon,.input-group-sm>.input-group-btn>.form-control-static.btn{padding-left:0;padding-right:0}.input-group-sm>.form-control,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.btn,.input-sm{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.input-group-sm>.input-group-btn>select.btn,.input-group-sm>select.form-control,.input-group-sm>select.input-group-addon,select.input-sm{height:30px;line-height:30px}.input-group-sm>.input-group-btn>select[multiple].btn,.input-group-sm>.input-group-btn>textarea.btn,.input-group-sm>select[multiple].form-control,.input-group-sm>select[multiple].input-group-addon,.input-group-sm>textarea.form-control,.input-group-sm>textarea.input-group-addon,select[multiple].input-sm,textarea.input-sm{height:auto}.form-group-sm .form-control{height:30px;padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.form-group-sm select.form-control{height:30px;line-height:30px}.form-group-sm select[multiple].form-control,.form-group-sm textarea.form-control{height:auto}.form-group-sm .form-control-static{height:30px;min-height:32px;padding:6px 10px;font-size:12px;line-height:1.5}.input-group-lg>.form-control,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.btn,.input-lg{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.input-group-lg>.input-group-btn>select.btn,.input-group-lg>select.form-control,.input-group-lg>select.input-group-addon,select.input-lg{height:46px;line-height:46px}.input-group-lg>.input-group-btn>select[multiple].btn,.input-group-lg>.input-group-btn>textarea.btn,.input-group-lg>select[multiple].form-control,.input-group-lg>select[multiple].input-group-addon,.input-group-lg>textarea.form-control,.input-group-lg>textarea.input-group-addon,select[multiple].input-lg,textarea.input-lg{height:auto}.form-group-lg .form-control{height:46px;padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.form-group-lg select.form-control{height:46px;line-height:46px}.form-group-lg select[multiple].form-control,.form-group-lg textarea.form-control{height:auto}.form-group-lg .form-control-static{height:46px;min-height:38px;padding:11px 16px;font-size:18px;line-height:1.3333333}.has-feedback{position:relative}.has-feedback .form-control{padding-right:42.5px}.form-control-feedback{position:absolute;top:0;right:0;z-index:2;display:block;width:34px;height:34px;line-height:34px;text-align:center;pointer-events:none}.form-group-lg .form-control+.form-control-feedback,.input-group-lg+.form-control-feedback,.input-group-lg>.form-control+.form-control-feedback,.input-group-lg>.input-group-addon+.form-control-feedback,.input-group-lg>.input-group-btn>.btn+.form-control-feedback,.input-lg+.form-control-feedback{width:46px;height:46px;line-height:46px}.form-group-sm .form-control+.form-control-feedback,.input-group-sm+.form-control-feedback,.input-group-sm>.form-control+.form-control-feedback,.input-group-sm>.input-group-addon+.form-control-feedback,.input-group-sm>.input-group-btn>.btn+.form-control-feedback,.input-sm+.form-control-feedback{width:30px;height:30px;line-height:30px}.has-success .checkbox,.has-success .checkbox-inline,.has-success.checkbox-inline label,.has-success.checkbox label,.has-success .control-label,.has-success .help-block,.has-success .radio,.has-success .radio-inline,.has-success.radio-inline label,.has-success.radio label{color:#3c763d}.has-success .form-control{border-color:#3c763d;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-success .form-control:focus{border-color:#2b542c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #67b168}.has-success .input-group-addon{color:#3c763d;border-color:#3c763d;background-color:#dff0d8}.has-success .form-control-feedback{color:#3c763d}.has-warning .checkbox,.has-warning .checkbox-inline,.has-warning.checkbox-inline label,.has-warning.checkbox label,.has-warning .control-label,.has-warning .help-block,.has-warning .radio,.has-warning .radio-inline,.has-warning.radio-inline label,.has-warning.radio label{color:#8a6d3b}.has-warning .form-control{border-color:#8a6d3b;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-warning .form-control:focus{border-color:#66512c;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #c0a16b}.has-warning .input-group-addon{color:#8a6d3b;border-color:#8a6d3b;background-color:#fcf8e3}.has-warning .form-control-feedback{color:#8a6d3b}.has-error .checkbox,.has-error .checkbox-inline,.has-error.checkbox-inline label,.has-error.checkbox label,.has-error .control-label,.has-error .help-block,.has-error .radio,.has-error .radio-inline,.has-error.radio-inline label,.has-error.radio label{color:#a94442}.has-error .form-control{border-color:#a94442;box-shadow:inset 0 1px 1px rgba(0,0,0,.075)}.has-error .form-control:focus{border-color:#843534;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 6px #ce8483}.has-error .input-group-addon{color:#a94442;border-color:#a94442;background-color:#f2dede}.has-error .form-control-feedback{color:#a94442}.has-feedback label~.form-control-feedback{top:25px}.has-feedback label.sr-only~.form-control-feedback{top:0}.help-block{display:block;margin-top:5px;margin-bottom:10px;color:#737373}@media (min-width:768px){.form-inline .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.form-inline .form-control{display:inline-block;width:auto;vertical-align:middle}.form-inline .form-control-static{display:inline-block}.form-inline .input-group{display:inline-table;vertical-align:middle}.form-inline .input-group .form-control,.form-inline .input-group .input-group-addon,.form-inline .input-group .input-group-btn{width:auto}.form-inline .input-group>.form-control{width:100%}.form-inline .control-label{margin-bottom:0;vertical-align:middle}.form-inline .checkbox,.form-inline .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.form-inline .checkbox label,.form-inline .radio label{padding-left:0}.form-inline .checkbox input[type=checkbox],.form-inline .radio input[type=radio]{position:relative;margin-left:0}.form-inline .has-feedback .form-control-feedback{top:0}}.form-horizontal .checkbox,.form-horizontal .checkbox-inline,.form-horizontal .radio,.form-horizontal .radio-inline{margin-top:0;margin-bottom:0;padding-top:7px}.form-horizontal .checkbox,.form-horizontal .radio{min-height:27px}.form-horizontal .form-group{margin-left:-15px;margin-right:-15px}.form-horizontal .form-group:after,.form-horizontal .form-group:before{content:\" \";display:table}.form-horizontal .form-group:after{clear:both}@media (min-width:768px){.form-horizontal .control-label{text-align:right;margin-bottom:0;padding-top:7px}}.form-horizontal .has-feedback .form-control-feedback{right:15px}@media (min-width:768px){.form-horizontal .form-group-lg .control-label{padding-top:11px;font-size:18px}}@media (min-width:768px){.form-horizontal .form-group-sm .control-label{padding-top:6px;font-size:12px}}.btn{display:inline-block;margin-bottom:0;font-weight:400;text-align:center;vertical-align:middle;touch-action:manipulation;cursor:pointer;background-image:none;border:1px solid transparent;white-space:nowrap;padding:6px 12px;font-size:14px;line-height:1.428571429;border-radius:4px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.btn.active.focus,.btn.active:focus,.btn.focus,.btn:active.focus,.btn:active:focus,.btn:focus{outline:5px auto -webkit-focus-ring-color;outline-offset:-2px}.btn.focus,.btn:focus,.btn:hover{color:#333;text-decoration:none}.btn.active,.btn:active{outline:0;background-image:none;box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn.disabled,.btn[disabled],fieldset[disabled] .btn{cursor:not-allowed;opacity:.65;filter:alpha(opacity=65);box-shadow:none}a.btn.disabled,fieldset[disabled] a.btn{pointer-events:none}.btn-default{color:#333;background-color:#fff;border-color:#ccc}.btn-default.focus,.btn-default:focus{color:#333;background-color:#e6e6e6;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.btn-default:hover,.open>.btn-default.dropdown-toggle{color:#333;background-color:#e6e6e6;border-color:#adadad}.btn-default.active.focus,.btn-default.active:focus,.btn-default.active:hover,.btn-default:active.focus,.btn-default:active:focus,.btn-default:active:hover,.open>.btn-default.dropdown-toggle.focus,.open>.btn-default.dropdown-toggle:focus,.open>.btn-default.dropdown-toggle:hover{color:#333;background-color:#d4d4d4;border-color:#8c8c8c}.btn-default.active,.btn-default:active,.open>.btn-default.dropdown-toggle{background-image:none}.btn-default.disabled.focus,.btn-default.disabled:focus,.btn-default.disabled:hover,.btn-default[disabled].focus,.btn-default[disabled]:focus,.btn-default[disabled]:hover,fieldset[disabled] .btn-default.focus,fieldset[disabled] .btn-default:focus,fieldset[disabled] .btn-default:hover{background-color:#fff;border-color:#ccc}.btn-default .badge{color:#fff;background-color:#333}.btn-primary{color:#fff;background-color:#337ab7;border-color:#2e6da4}.btn-primary.focus,.btn-primary:focus{color:#fff;background-color:#286090;border-color:#122b40}.btn-primary.active,.btn-primary:active,.btn-primary:hover,.open>.btn-primary.dropdown-toggle{color:#fff;background-color:#286090;border-color:#204d74}.btn-primary.active.focus,.btn-primary.active:focus,.btn-primary.active:hover,.btn-primary:active.focus,.btn-primary:active:focus,.btn-primary:active:hover,.open>.btn-primary.dropdown-toggle.focus,.open>.btn-primary.dropdown-toggle:focus,.open>.btn-primary.dropdown-toggle:hover{color:#fff;background-color:#204d74;border-color:#122b40}.btn-primary.active,.btn-primary:active,.open>.btn-primary.dropdown-toggle{background-image:none}.btn-primary.disabled.focus,.btn-primary.disabled:focus,.btn-primary.disabled:hover,.btn-primary[disabled].focus,.btn-primary[disabled]:focus,.btn-primary[disabled]:hover,fieldset[disabled] .btn-primary.focus,fieldset[disabled] .btn-primary:focus,fieldset[disabled] .btn-primary:hover{background-color:#337ab7;border-color:#2e6da4}.btn-primary .badge{color:#337ab7;background-color:#fff}.btn-success{color:#fff;background-color:#5cb85c;border-color:#4cae4c}.btn-success.focus,.btn-success:focus{color:#fff;background-color:#449d44;border-color:#255625}.btn-success.active,.btn-success:active,.btn-success:hover,.open>.btn-success.dropdown-toggle{color:#fff;background-color:#449d44;border-color:#398439}.btn-success.active.focus,.btn-success.active:focus,.btn-success.active:hover,.btn-success:active.focus,.btn-success:active:focus,.btn-success:active:hover,.open>.btn-success.dropdown-toggle.focus,.open>.btn-success.dropdown-toggle:focus,.open>.btn-success.dropdown-toggle:hover{color:#fff;background-color:#398439;border-color:#255625}.btn-success.active,.btn-success:active,.open>.btn-success.dropdown-toggle{background-image:none}.btn-success.disabled.focus,.btn-success.disabled:focus,.btn-success.disabled:hover,.btn-success[disabled].focus,.btn-success[disabled]:focus,.btn-success[disabled]:hover,fieldset[disabled] .btn-success.focus,fieldset[disabled] .btn-success:focus,fieldset[disabled] .btn-success:hover{background-color:#5cb85c;border-color:#4cae4c}.btn-success .badge{color:#5cb85c;background-color:#fff}.btn-info{color:#fff;background-color:#5bc0de;border-color:#46b8da}.btn-info.focus,.btn-info:focus{color:#fff;background-color:#31b0d5;border-color:#1b6d85}.btn-info.active,.btn-info:active,.btn-info:hover,.open>.btn-info.dropdown-toggle{color:#fff;background-color:#31b0d5;border-color:#269abc}.btn-info.active.focus,.btn-info.active:focus,.btn-info.active:hover,.btn-info:active.focus,.btn-info:active:focus,.btn-info:active:hover,.open>.btn-info.dropdown-toggle.focus,.open>.btn-info.dropdown-toggle:focus,.open>.btn-info.dropdown-toggle:hover{color:#fff;background-color:#269abc;border-color:#1b6d85}.btn-info.active,.btn-info:active,.open>.btn-info.dropdown-toggle{background-image:none}.btn-info.disabled.focus,.btn-info.disabled:focus,.btn-info.disabled:hover,.btn-info[disabled].focus,.btn-info[disabled]:focus,.btn-info[disabled]:hover,fieldset[disabled] .btn-info.focus,fieldset[disabled] .btn-info:focus,fieldset[disabled] .btn-info:hover{background-color:#5bc0de;border-color:#46b8da}.btn-info .badge{color:#5bc0de;background-color:#fff}.btn-warning{color:#fff;background-color:#f0ad4e;border-color:#eea236}.btn-warning.focus,.btn-warning:focus{color:#fff;background-color:#ec971f;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.btn-warning:hover,.open>.btn-warning.dropdown-toggle{color:#fff;background-color:#ec971f;border-color:#d58512}.btn-warning.active.focus,.btn-warning.active:focus,.btn-warning.active:hover,.btn-warning:active.focus,.btn-warning:active:focus,.btn-warning:active:hover,.open>.btn-warning.dropdown-toggle.focus,.open>.btn-warning.dropdown-toggle:focus,.open>.btn-warning.dropdown-toggle:hover{color:#fff;background-color:#d58512;border-color:#985f0d}.btn-warning.active,.btn-warning:active,.open>.btn-warning.dropdown-toggle{background-image:none}.btn-warning.disabled.focus,.btn-warning.disabled:focus,.btn-warning.disabled:hover,.btn-warning[disabled].focus,.btn-warning[disabled]:focus,.btn-warning[disabled]:hover,fieldset[disabled] .btn-warning.focus,fieldset[disabled] .btn-warning:focus,fieldset[disabled] .btn-warning:hover{background-color:#f0ad4e;border-color:#eea236}.btn-warning .badge{color:#f0ad4e;background-color:#fff}.btn-danger{color:#fff;background-color:#d9534f;border-color:#d43f3a}.btn-danger.focus,.btn-danger:focus{color:#fff;background-color:#c9302c;border-color:#761c19}.btn-danger.active,.btn-danger:active,.btn-danger:hover,.open>.btn-danger.dropdown-toggle{color:#fff;background-color:#c9302c;border-color:#ac2925}.btn-danger.active.focus,.btn-danger.active:focus,.btn-danger.active:hover,.btn-danger:active.focus,.btn-danger:active:focus,.btn-danger:active:hover,.open>.btn-danger.dropdown-toggle.focus,.open>.btn-danger.dropdown-toggle:focus,.open>.btn-danger.dropdown-toggle:hover{color:#fff;background-color:#ac2925;border-color:#761c19}.btn-danger.active,.btn-danger:active,.open>.btn-danger.dropdown-toggle{background-image:none}.btn-danger.disabled.focus,.btn-danger.disabled:focus,.btn-danger.disabled:hover,.btn-danger[disabled].focus,.btn-danger[disabled]:focus,.btn-danger[disabled]:hover,fieldset[disabled] .btn-danger.focus,fieldset[disabled] .btn-danger:focus,fieldset[disabled] .btn-danger:hover{background-color:#d9534f;border-color:#d43f3a}.btn-danger .badge{color:#d9534f;background-color:#fff}.btn-link{color:#337ab7;font-weight:400;border-radius:0}.btn-link,.btn-link.active,.btn-link:active,.btn-link[disabled],fieldset[disabled] .btn-link{background-color:transparent;box-shadow:none}.btn-link,.btn-link:active,.btn-link:focus,.btn-link:hover{border-color:transparent}.btn-link:focus,.btn-link:hover{color:#23527c;text-decoration:underline;background-color:transparent}.btn-link[disabled]:focus,.btn-link[disabled]:hover,fieldset[disabled] .btn-link:focus,fieldset[disabled] .btn-link:hover{color:#777;text-decoration:none}.btn-group-lg>.btn,.btn-lg{padding:10px 16px;font-size:18px;line-height:1.3333333;border-radius:6px}.btn-group-sm>.btn,.btn-sm{padding:5px 10px;font-size:12px;line-height:1.5;border-radius:3px}.btn-group-xs>.btn,.btn-xs{padding:1px 5px;font-size:12px;line-height:1.5;border-radius:3px}.btn-block{display:block;width:100%}.btn-block+.btn-block{margin-top:5px}input[type=button].btn-block,input[type=reset].btn-block,input[type=submit].btn-block{width:100%}.fade{opacity:0;transition:opacity .15s linear}.fade.in{opacity:1}.collapse{display:none}.collapse.in{display:block}tr.collapse.in{display:table-row}tbody.collapse.in{display:table-row-group}.collapsing{position:relative;height:0;overflow:hidden;transition-property:height,visibility;transition-duration:.35s;transition-timing-function:ease}.caret{display:inline-block;width:0;height:0;margin-left:2px;vertical-align:middle;border-top:4px dashed;border-top:4px solid\\9;border-right:4px solid transparent;border-left:4px solid transparent}.dropdown,.dropup{position:relative}.dropdown-toggle:focus{outline:0}.dropdown-menu{position:absolute;top:100%;left:0;z-index:1000;display:none;float:left;min-width:160px;padding:5px 0;margin:2px 0 0;list-style:none;font-size:14px;text-align:left;background-color:#fff;border:1px solid #ccc;border:1px solid rgba(0,0,0,.15);border-radius:4px;box-shadow:0 6px 12px rgba(0,0,0,.175);background-clip:padding-box}.dropdown-menu.pull-right{right:0;left:auto}.dropdown-menu .divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.dropdown-menu>li>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.428571429;color:#333;white-space:nowrap}.dropdown-menu>li>a:focus,.dropdown-menu>li>a:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.dropdown-menu>.active>a,.dropdown-menu>.active>a:focus,.dropdown-menu>.active>a:hover{color:#fff;text-decoration:none;outline:0;background-color:#337ab7}.dropdown-menu>.disabled>a,.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{color:#777}.dropdown-menu>.disabled>a:focus,.dropdown-menu>.disabled>a:hover{text-decoration:none;background-color:transparent;background-image:none;filter:progid:DXImageTransform.Microsoft.gradient(enabled = false);cursor:not-allowed}.open>.dropdown-menu{display:block}.open>a{outline:0}.dropdown-menu-right{left:auto;right:0}.dropdown-menu-left{left:0;right:auto}.dropdown-header{display:block;padding:3px 20px;font-size:12px;line-height:1.428571429;color:#777;white-space:nowrap}.dropdown-backdrop{position:fixed;left:0;right:0;bottom:0;top:0;z-index:990}.pull-right>.dropdown-menu{right:0;left:auto}.dropup .caret,.navbar-fixed-bottom .dropdown .caret{border-top:0;border-bottom:4px dashed;border-bottom:4px solid\\9;content:\"\"}.dropup .dropdown-menu,.navbar-fixed-bottom .dropdown .dropdown-menu{top:auto;bottom:100%;margin-bottom:2px}@media (min-width:768px){.navbar-right .dropdown-menu{right:0;left:auto}.navbar-right .dropdown-menu-left{left:0;right:auto}}.btn-group,.btn-group-vertical{position:relative;display:inline-block;vertical-align:middle}.btn-group-vertical>.btn,.btn-group>.btn{position:relative;float:left}.btn-group-vertical>.btn.active,.btn-group-vertical>.btn:active,.btn-group-vertical>.btn:focus,.btn-group-vertical>.btn:hover,.btn-group>.btn.active,.btn-group>.btn:active,.btn-group>.btn:focus,.btn-group>.btn:hover{z-index:2}.btn-group .btn+.btn,.btn-group .btn+.btn-group,.btn-group .btn-group+.btn,.btn-group .btn-group+.btn-group{margin-left:-1px}.btn-toolbar{margin-left:-5px}.btn-toolbar:after,.btn-toolbar:before{content:\" \";display:table}.btn-toolbar:after{clear:both}.btn-toolbar .btn,.btn-toolbar .btn-group,.btn-toolbar .input-group{float:left}.btn-toolbar>.btn,.btn-toolbar>.btn-group,.btn-toolbar>.input-group{margin-left:5px}.btn-group>.btn:not(:first-child):not(:last-child):not(.dropdown-toggle){border-radius:0}.btn-group>.btn:first-child{margin-left:0}.btn-group>.btn:first-child:not(:last-child):not(.dropdown-toggle){border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn:last-child:not(:first-child),.btn-group>.dropdown-toggle:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0}.btn-group>.btn-group{float:left}.btn-group>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-top-right-radius:0}.btn-group>.btn-group:last-child:not(:first-child)>.btn:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.btn-group .dropdown-toggle:active,.btn-group.open .dropdown-toggle{outline:0}.btn-group>.btn+.dropdown-toggle{padding-left:8px;padding-right:8px}.btn-group-lg.btn-group>.btn+.dropdown-toggle,.btn-group>.btn-lg+.dropdown-toggle{padding-left:12px;padding-right:12px}.btn-group.open .dropdown-toggle{box-shadow:inset 0 3px 5px rgba(0,0,0,.125)}.btn-group.open .dropdown-toggle.btn-link{box-shadow:none}.btn .caret{margin-left:0}.btn-group-lg>.btn .caret,.btn-lg .caret{border-width:5px 5px 0;border-bottom-width:0}.dropup .btn-group-lg>.btn .caret,.dropup .btn-lg .caret{border-width:0 5px 5px}.btn-group-vertical>.btn,.btn-group-vertical>.btn-group,.btn-group-vertical>.btn-group>.btn{display:block;float:none;width:100%;max-width:100%}.btn-group-vertical>.btn-group:after,.btn-group-vertical>.btn-group:before{content:\" \";display:table}.btn-group-vertical>.btn-group:after{clear:both}.btn-group-vertical>.btn-group>.btn{float:none}.btn-group-vertical>.btn+.btn,.btn-group-vertical>.btn+.btn-group,.btn-group-vertical>.btn-group+.btn,.btn-group-vertical>.btn-group+.btn-group{margin-top:-1px;margin-left:0}.btn-group-vertical>.btn:not(:first-child):not(:last-child){border-radius:0}.btn-group-vertical>.btn:first-child:not(:last-child){border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn:last-child:not(:first-child){border-top-right-radius:0;border-top-left-radius:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}.btn-group-vertical>.btn-group:not(:first-child):not(:last-child)>.btn{border-radius:0}.btn-group-vertical>.btn-group:first-child:not(:last-child)>.btn:last-child,.btn-group-vertical>.btn-group:first-child:not(:last-child)>.dropdown-toggle{border-bottom-right-radius:0;border-bottom-left-radius:0}.btn-group-vertical>.btn-group:last-child:not(:first-child)>.btn:first-child{border-top-right-radius:0;border-top-left-radius:0}.btn-group-justified{display:table;width:100%;table-layout:fixed;border-collapse:separate}.btn-group-justified>.btn,.btn-group-justified>.btn-group{float:none;display:table-cell;width:1%}.btn-group-justified>.btn-group .btn{width:100%}.btn-group-justified>.btn-group .dropdown-menu{left:auto}[data-toggle=buttons]>.btn-group>.btn input[type=checkbox],[data-toggle=buttons]>.btn-group>.btn input[type=radio],[data-toggle=buttons]>.btn input[type=checkbox],[data-toggle=buttons]>.btn input[type=radio]{position:absolute;clip:rect(0,0,0,0);pointer-events:none}.input-group{position:relative;display:table;border-collapse:separate}.input-group[class*=col-]{float:none;padding-left:0;padding-right:0}.input-group .form-control{position:relative;z-index:2;float:left;width:100%;margin-bottom:0}.input-group .form-control:focus{z-index:3}.input-group-addon,.input-group-btn,.input-group .form-control{display:table-cell}.input-group-addon:not(:first-child):not(:last-child),.input-group-btn:not(:first-child):not(:last-child),.input-group .form-control:not(:first-child):not(:last-child){border-radius:0}.input-group-addon,.input-group-btn{width:1%;white-space:nowrap;vertical-align:middle}.input-group-addon{padding:6px 12px;font-size:14px;font-weight:400;line-height:1;color:#555;text-align:center;background-color:#eee;border:1px solid #ccc;border-radius:4px}.input-group-addon.input-sm,.input-group-sm>.input-group-addon,.input-group-sm>.input-group-btn>.input-group-addon.btn{padding:5px 10px;font-size:12px;border-radius:3px}.input-group-addon.input-lg,.input-group-lg>.input-group-addon,.input-group-lg>.input-group-btn>.input-group-addon.btn{padding:10px 16px;font-size:18px;border-radius:6px}.input-group-addon input[type=checkbox],.input-group-addon input[type=radio]{margin-top:0}.input-group-addon:first-child,.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group>.btn,.input-group-btn:first-child>.dropdown-toggle,.input-group-btn:last-child>.btn-group:not(:last-child)>.btn,.input-group-btn:last-child>.btn:not(:last-child):not(.dropdown-toggle),.input-group .form-control:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.input-group-addon:first-child{border-right:0}.input-group-addon:last-child,.input-group-btn:first-child>.btn-group:not(:first-child)>.btn,.input-group-btn:first-child>.btn:not(:first-child),.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group>.btn,.input-group-btn:last-child>.dropdown-toggle,.input-group .form-control:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.input-group-addon:last-child{border-left:0}.input-group-btn{font-size:0;white-space:nowrap}.input-group-btn,.input-group-btn>.btn{position:relative}.input-group-btn>.btn+.btn{margin-left:-1px}.input-group-btn>.btn:active,.input-group-btn>.btn:focus,.input-group-btn>.btn:hover{z-index:2}.input-group-btn:first-child>.btn,.input-group-btn:first-child>.btn-group{margin-right:-1px}.input-group-btn:last-child>.btn,.input-group-btn:last-child>.btn-group{z-index:2;margin-left:-1px}.nav{margin-bottom:0;padding-left:0;list-style:none}.nav:after,.nav:before{content:\" \";display:table}.nav:after{clear:both}.nav>li,.nav>li>a{position:relative;display:block}.nav>li>a{padding:10px 15px}.nav>li>a:focus,.nav>li>a:hover{text-decoration:none;background-color:#eee}.nav>li.disabled>a{color:#777}.nav>li.disabled>a:focus,.nav>li.disabled>a:hover{color:#777;text-decoration:none;background-color:transparent;cursor:not-allowed}.nav .open>a,.nav .open>a:focus,.nav .open>a:hover{background-color:#eee;border-color:#337ab7}.nav .nav-divider{height:1px;margin:9px 0;overflow:hidden;background-color:#e5e5e5}.nav>li>a>img{max-width:none}.nav-tabs{border-bottom:1px solid #ddd}.nav-tabs>li{float:left;margin-bottom:-1px}.nav-tabs>li>a{margin-right:2px;line-height:1.428571429;border:1px solid transparent;border-radius:4px 4px 0 0}.nav-tabs>li>a:hover{border-color:#eee #eee #ddd}.nav-tabs>li.active>a,.nav-tabs>li.active>a:focus,.nav-tabs>li.active>a:hover{color:#555;background-color:#fff;border:1px solid #ddd;border-bottom-color:transparent;cursor:default}.nav-pills>li{float:left}.nav-pills>li>a{border-radius:4px}.nav-pills>li+li{margin-left:2px}.nav-pills>li.active>a,.nav-pills>li.active>a:focus,.nav-pills>li.active>a:hover{color:#fff;background-color:#337ab7}.nav-stacked>li{float:none}.nav-stacked>li+li{margin-top:2px;margin-left:0}.nav-justified,.nav-tabs.nav-justified{width:100%}.nav-justified>li,.nav-tabs.nav-justified>li{float:none}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{text-align:center;margin-bottom:5px}.nav-justified>.dropdown .dropdown-menu{top:auto;left:auto}@media (min-width:768px){.nav-justified>li,.nav-tabs.nav-justified>li{display:table-cell;width:1%}.nav-justified>li>a,.nav-tabs.nav-justified>li>a{margin-bottom:0}}.nav-tabs-justified,.nav-tabs.nav-justified{border-bottom:0}.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{margin-right:0;border-radius:4px}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border:1px solid #ddd}@media (min-width:768px){.nav-tabs-justified>li>a,.nav-tabs.nav-justified>li>a{border-bottom:1px solid #ddd;border-radius:4px 4px 0 0}.nav-tabs-justified>.active>a,.nav-tabs-justified>.active>a:focus,.nav-tabs-justified>.active>a:hover,.nav-tabs.nav-justified>.active>a,.nav-tabs.nav-justified>.active>a:focus,.nav-tabs.nav-justified>.active>a:hover{border-bottom-color:#fff}}.tab-content>.tab-pane{display:none}.tab-content>.active{display:block}.nav-tabs .dropdown-menu{margin-top:-1px;border-top-right-radius:0;border-top-left-radius:0}.navbar{position:relative;min-height:50px;margin-bottom:20px;border:1px solid transparent}.navbar:after,.navbar:before{content:\" \";display:table}.navbar:after{clear:both}@media (min-width:768px){.navbar{border-radius:4px}}.navbar-header:after,.navbar-header:before{content:\" \";display:table}.navbar-header:after{clear:both}@media (min-width:768px){.navbar-header{float:left}}.navbar-collapse{overflow-x:visible;padding-right:15px;padding-left:15px;border-top:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1);-webkit-overflow-scrolling:touch}.navbar-collapse:after,.navbar-collapse:before{content:\" \";display:table}.navbar-collapse:after{clear:both}.navbar-collapse.in{overflow-y:auto}@media (min-width:768px){.navbar-collapse{width:auto;border-top:0;box-shadow:none}.navbar-collapse.collapse{display:block!important;height:auto!important;padding-bottom:0;overflow:visible!important}.navbar-collapse.in{overflow-y:visible}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse,.navbar-static-top .navbar-collapse{padding-left:0;padding-right:0}}.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:340px}@media (max-device-width:480px) and (orientation:landscape){.navbar-fixed-bottom .navbar-collapse,.navbar-fixed-top .navbar-collapse{max-height:200px}}.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:-15px;margin-left:-15px}@media (min-width:768px){.container-fluid>.navbar-collapse,.container-fluid>.navbar-header,.container>.navbar-collapse,.container>.navbar-header{margin-right:0;margin-left:0}}.navbar-static-top{z-index:1000;border-width:0 0 1px}@media (min-width:768px){.navbar-static-top{border-radius:0}}.navbar-fixed-bottom,.navbar-fixed-top{position:fixed;right:0;left:0;z-index:1030}@media (min-width:768px){.navbar-fixed-bottom,.navbar-fixed-top{border-radius:0}}.navbar-fixed-top{top:0;border-width:0 0 1px}.navbar-fixed-bottom{bottom:0;margin-bottom:0;border-width:1px 0 0}.navbar-brand{float:left;padding:15px;font-size:18px;line-height:20px;height:50px}.navbar-brand:focus,.navbar-brand:hover{text-decoration:none}.navbar-brand>img{display:block}@media (min-width:768px){.navbar>.container-fluid .navbar-brand,.navbar>.container .navbar-brand{margin-left:-15px}}.navbar-toggle{position:relative;float:right;margin-right:15px;padding:9px 10px;margin-top:8px;margin-bottom:8px;background-color:transparent;background-image:none;border:1px solid transparent;border-radius:4px}.navbar-toggle:focus{outline:0}.navbar-toggle .icon-bar{display:block;width:22px;height:2px;border-radius:1px}.navbar-toggle .icon-bar+.icon-bar{margin-top:4px}@media (min-width:768px){.navbar-toggle{display:none}}.navbar-nav{margin:7.5px -15px}.navbar-nav>li>a{padding-top:10px;padding-bottom:10px;line-height:20px}@media (max-width:767px){.navbar-nav .open .dropdown-menu{position:static;float:none;width:auto;margin-top:0;background-color:transparent;border:0;box-shadow:none}.navbar-nav .open .dropdown-menu .dropdown-header,.navbar-nav .open .dropdown-menu>li>a{padding:5px 15px 5px 25px}.navbar-nav .open .dropdown-menu>li>a{line-height:20px}.navbar-nav .open .dropdown-menu>li>a:focus,.navbar-nav .open .dropdown-menu>li>a:hover{background-image:none}}@media (min-width:768px){.navbar-nav{float:left;margin:0}.navbar-nav>li{float:left}.navbar-nav>li>a{padding-top:15px;padding-bottom:15px}}.navbar-form{margin:8px -15px;padding:10px 15px;border-top:1px solid transparent;border-bottom:1px solid transparent;box-shadow:inset 0 1px 0 hsla(0,0%,100%,.1),0 1px 0 hsla(0,0%,100%,.1)}@media (min-width:768px){.navbar-form .form-group{display:inline-block;margin-bottom:0;vertical-align:middle}.navbar-form .form-control{display:inline-block;width:auto;vertical-align:middle}.navbar-form .form-control-static{display:inline-block}.navbar-form .input-group{display:inline-table;vertical-align:middle}.navbar-form .input-group .form-control,.navbar-form .input-group .input-group-addon,.navbar-form .input-group .input-group-btn{width:auto}.navbar-form .input-group>.form-control{width:100%}.navbar-form .control-label{margin-bottom:0;vertical-align:middle}.navbar-form .checkbox,.navbar-form .radio{display:inline-block;margin-top:0;margin-bottom:0;vertical-align:middle}.navbar-form .checkbox label,.navbar-form .radio label{padding-left:0}.navbar-form .checkbox input[type=checkbox],.navbar-form .radio input[type=radio]{position:relative;margin-left:0}.navbar-form .has-feedback .form-control-feedback{top:0}}@media (max-width:767px){.navbar-form .form-group{margin-bottom:5px}.navbar-form .form-group:last-child{margin-bottom:0}}@media (min-width:768px){.navbar-form{width:auto;border:0;margin-left:0;margin-right:0;padding-top:0;padding-bottom:0;box-shadow:none}}.navbar-nav>li>.dropdown-menu{margin-top:0;border-top-right-radius:0;border-top-left-radius:0}.navbar-fixed-bottom .navbar-nav>li>.dropdown-menu{margin-bottom:0;border-top-right-radius:4px;border-top-left-radius:4px;border-bottom-right-radius:0;border-bottom-left-radius:0}.navbar-btn{margin-top:8px;margin-bottom:8px}.btn-group-sm>.navbar-btn.btn,.navbar-btn.btn-sm{margin-top:10px;margin-bottom:10px}.btn-group-xs>.navbar-btn.btn,.navbar-btn.btn-xs{margin-top:14px;margin-bottom:14px}.navbar-text{margin-top:15px;margin-bottom:15px}@media (min-width:768px){.navbar-text{float:left;margin-left:15px;margin-right:15px}}@media (min-width:768px){.navbar-left{float:left!important}.navbar-right{float:right!important;margin-right:-15px}.navbar-right~.navbar-right{margin-right:0}}.navbar-default{background-color:#f8f8f8;border-color:#e7e7e7}.navbar-default .navbar-brand{color:#777}.navbar-default .navbar-brand:focus,.navbar-default .navbar-brand:hover{color:#5e5e5e;background-color:transparent}.navbar-default .navbar-nav>li>a,.navbar-default .navbar-text{color:#777}.navbar-default .navbar-nav>li>a:focus,.navbar-default .navbar-nav>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav>.active>a,.navbar-default .navbar-nav>.active>a:focus,.navbar-default .navbar-nav>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav>.disabled>a,.navbar-default .navbar-nav>.disabled>a:focus,.navbar-default .navbar-nav>.disabled>a:hover{color:#ccc;background-color:transparent}.navbar-default .navbar-toggle{border-color:#ddd}.navbar-default .navbar-toggle:focus,.navbar-default .navbar-toggle:hover{background-color:#ddd}.navbar-default .navbar-toggle .icon-bar{background-color:#888}.navbar-default .navbar-collapse,.navbar-default .navbar-form{border-color:#e7e7e7}.navbar-default .navbar-nav>.open>a,.navbar-default .navbar-nav>.open>a:focus,.navbar-default .navbar-nav>.open>a:hover{background-color:#e7e7e7;color:#555}@media (max-width:767px){.navbar-default .navbar-nav .open .dropdown-menu>li>a{color:#777}.navbar-default .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>li>a:hover{color:#333;background-color:transparent}.navbar-default .navbar-nav .open .dropdown-menu>.active>a,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.active>a:hover{color:#555;background-color:#e7e7e7}.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-default .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#ccc;background-color:transparent}}.navbar-default .navbar-link{color:#777}.navbar-default .navbar-link:hover{color:#333}.navbar-default .btn-link{color:#777}.navbar-default .btn-link:focus,.navbar-default .btn-link:hover{color:#333}.navbar-default .btn-link[disabled]:focus,.navbar-default .btn-link[disabled]:hover,fieldset[disabled] .navbar-default .btn-link:focus,fieldset[disabled] .navbar-default .btn-link:hover{color:#ccc}.navbar-inverse{background-color:#222;border-color:#090909}.navbar-inverse .navbar-brand{color:#9d9d9d}.navbar-inverse .navbar-brand:focus,.navbar-inverse .navbar-brand:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>li>a,.navbar-inverse .navbar-text{color:#9d9d9d}.navbar-inverse .navbar-nav>li>a:focus,.navbar-inverse .navbar-nav>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav>.active>a,.navbar-inverse .navbar-nav>.active>a:focus,.navbar-inverse .navbar-nav>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav>.disabled>a,.navbar-inverse .navbar-nav>.disabled>a:focus,.navbar-inverse .navbar-nav>.disabled>a:hover{color:#444;background-color:transparent}.navbar-inverse .navbar-toggle{border-color:#333}.navbar-inverse .navbar-toggle:focus,.navbar-inverse .navbar-toggle:hover{background-color:#333}.navbar-inverse .navbar-toggle .icon-bar{background-color:#fff}.navbar-inverse .navbar-collapse,.navbar-inverse .navbar-form{border-color:#101010}.navbar-inverse .navbar-nav>.open>a,.navbar-inverse .navbar-nav>.open>a:focus,.navbar-inverse .navbar-nav>.open>a:hover{background-color:#090909;color:#fff}@media (max-width:767px){.navbar-inverse .navbar-nav .open .dropdown-menu>.dropdown-header{border-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu .divider{background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a{color:#9d9d9d}.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>li>a:hover{color:#fff;background-color:transparent}.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.active>a:hover{color:#fff;background-color:#090909}.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:focus,.navbar-inverse .navbar-nav .open .dropdown-menu>.disabled>a:hover{color:#444;background-color:transparent}}.navbar-inverse .navbar-link{color:#9d9d9d}.navbar-inverse .navbar-link:hover{color:#fff}.navbar-inverse .btn-link{color:#9d9d9d}.navbar-inverse .btn-link:focus,.navbar-inverse .btn-link:hover{color:#fff}.navbar-inverse .btn-link[disabled]:focus,.navbar-inverse .btn-link[disabled]:hover,fieldset[disabled] .navbar-inverse .btn-link:focus,fieldset[disabled] .navbar-inverse .btn-link:hover{color:#444}.breadcrumb{padding:8px 15px;margin-bottom:20px;list-style:none;background-color:#f5f5f5;border-radius:4px}.breadcrumb>li{display:inline-block}.breadcrumb>li+li:before{content:\"/\\A0\";padding:0 5px;color:#ccc}.breadcrumb>.active{color:#777}.pagination{display:inline-block;padding-left:0;margin:20px 0;border-radius:4px}.pagination>li{display:inline}.pagination>li>a,.pagination>li>span{position:relative;float:left;padding:6px 12px;line-height:1.428571429;text-decoration:none;color:#337ab7;background-color:#fff;border:1px solid #ddd;margin-left:-1px}.pagination>li:first-child>a,.pagination>li:first-child>span{margin-left:0;border-bottom-left-radius:4px;border-top-left-radius:4px}.pagination>li:last-child>a,.pagination>li:last-child>span{border-bottom-right-radius:4px;border-top-right-radius:4px}.pagination>li>a:focus,.pagination>li>a:hover,.pagination>li>span:focus,.pagination>li>span:hover{z-index:2;color:#23527c;background-color:#eee;border-color:#ddd}.pagination>.active>a,.pagination>.active>a:focus,.pagination>.active>a:hover,.pagination>.active>span,.pagination>.active>span:focus,.pagination>.active>span:hover{z-index:3;color:#fff;background-color:#337ab7;border-color:#337ab7;cursor:default}.pagination>.disabled>a,.pagination>.disabled>a:focus,.pagination>.disabled>a:hover,.pagination>.disabled>span,.pagination>.disabled>span:focus,.pagination>.disabled>span:hover{color:#777;background-color:#fff;border-color:#ddd;cursor:not-allowed}.pagination-lg>li>a,.pagination-lg>li>span{padding:10px 16px;font-size:18px;line-height:1.3333333}.pagination-lg>li:first-child>a,.pagination-lg>li:first-child>span{border-bottom-left-radius:6px;border-top-left-radius:6px}.pagination-lg>li:last-child>a,.pagination-lg>li:last-child>span{border-bottom-right-radius:6px;border-top-right-radius:6px}.pagination-sm>li>a,.pagination-sm>li>span{padding:5px 10px;font-size:12px;line-height:1.5}.pagination-sm>li:first-child>a,.pagination-sm>li:first-child>span{border-bottom-left-radius:3px;border-top-left-radius:3px}.pagination-sm>li:last-child>a,.pagination-sm>li:last-child>span{border-bottom-right-radius:3px;border-top-right-radius:3px}.pager{padding-left:0;margin:20px 0;list-style:none;text-align:center}.pager:after,.pager:before{content:\" \";display:table}.pager:after{clear:both}.pager li{display:inline}.pager li>a,.pager li>span{display:inline-block;padding:5px 14px;background-color:#fff;border:1px solid #ddd;border-radius:15px}.pager li>a:focus,.pager li>a:hover{text-decoration:none;background-color:#eee}.pager .next>a,.pager .next>span{float:right}.pager .previous>a,.pager .previous>span{float:left}.pager .disabled>a,.pager .disabled>a:focus,.pager .disabled>a:hover,.pager .disabled>span{color:#777;background-color:#fff;cursor:not-allowed}.label{display:inline;padding:.2em .6em .3em;font-size:75%;font-weight:700;line-height:1;color:#fff;text-align:center;white-space:nowrap;vertical-align:baseline;border-radius:.25em}.label:empty{display:none}.btn .label{position:relative;top:-1px}a.label:focus,a.label:hover{color:#fff;text-decoration:none;cursor:pointer}.label-default{background-color:#777}.label-default[href]:focus,.label-default[href]:hover{background-color:#5e5e5e}.label-primary{background-color:#337ab7}.label-primary[href]:focus,.label-primary[href]:hover{background-color:#286090}.label-success{background-color:#5cb85c}.label-success[href]:focus,.label-success[href]:hover{background-color:#449d44}.label-info{background-color:#5bc0de}.label-info[href]:focus,.label-info[href]:hover{background-color:#31b0d5}.label-warning{background-color:#f0ad4e}.label-warning[href]:focus,.label-warning[href]:hover{background-color:#ec971f}.label-danger{background-color:#d9534f}.label-danger[href]:focus,.label-danger[href]:hover{background-color:#c9302c}.badge{display:inline-block;min-width:10px;padding:3px 7px;font-size:12px;font-weight:700;color:#fff;line-height:1;vertical-align:middle;white-space:nowrap;text-align:center;background-color:#777;border-radius:10px}.badge:empty{display:none}.btn .badge{position:relative;top:-1px}.btn-group-xs>.btn .badge,.btn-xs .badge{top:0;padding:1px 5px}.list-group-item.active>.badge,.nav-pills>.active>a>.badge{color:#337ab7;background-color:#fff}.list-group-item>.badge{float:right}.list-group-item>.badge+.badge{margin-right:5px}.nav-pills>li>a>.badge{margin-left:3px}a.badge:focus,a.badge:hover{color:#fff;text-decoration:none;cursor:pointer}.jumbotron{padding-top:30px;padding-bottom:30px;margin-bottom:30px;background-color:#eee}.jumbotron,.jumbotron .h1,.jumbotron h1{color:inherit}.jumbotron p{margin-bottom:15px;font-size:21px;font-weight:200}.jumbotron>hr{border-top-color:#d5d5d5}.container-fluid .jumbotron,.container .jumbotron{border-radius:6px;padding-left:15px;padding-right:15px}.jumbotron .container{max-width:100%}@media screen and (min-width:768px){.jumbotron{padding-top:48px;padding-bottom:48px}.container-fluid .jumbotron,.container .jumbotron{padding-left:60px;padding-right:60px}.jumbotron .h1,.jumbotron h1{font-size:63px}}.thumbnail{display:block;padding:4px;margin-bottom:20px;line-height:1.428571429;background-color:#fff;border:1px solid #ddd;border-radius:4px;transition:border .2s ease-in-out}.thumbnail>img,.thumbnail a>img{display:block;max-width:100%;height:auto;margin-left:auto;margin-right:auto}.thumbnail .caption{padding:9px;color:#333}a.thumbnail.active,a.thumbnail:focus,a.thumbnail:hover{border-color:#337ab7}.alert{padding:15px;margin-bottom:20px;border:1px solid transparent;border-radius:4px}.alert h4{margin-top:0;color:inherit}.alert .alert-link{font-weight:700}.alert>p,.alert>ul{margin-bottom:0}.alert>p+p{margin-top:5px}.alert-dismissable,.alert-dismissible{padding-right:35px}.alert-dismissable .close,.alert-dismissible .close{position:relative;top:-2px;right:-21px;color:inherit}.alert-success{background-color:#dff0d8;border-color:#d6e9c6;color:#3c763d}.alert-success hr{border-top-color:#c9e2b3}.alert-success .alert-link{color:#2b542c}.alert-info{background-color:#d9edf7;border-color:#bce8f1;color:#31708f}.alert-info hr{border-top-color:#a6e1ec}.alert-info .alert-link{color:#245269}.alert-warning{background-color:#fcf8e3;border-color:#faebcc;color:#8a6d3b}.alert-warning hr{border-top-color:#f7e1b5}.alert-warning .alert-link{color:#66512c}.alert-danger{background-color:#f2dede;border-color:#ebccd1;color:#a94442}.alert-danger hr{border-top-color:#e4b9c0}.alert-danger .alert-link{color:#843534}@keyframes progress-bar-stripes{0%{background-position:40px 0}to{background-position:0 0}}.progress{overflow:hidden;height:20px;margin-bottom:20px;background-color:#f5f5f5;border-radius:4px;box-shadow:inset 0 1px 2px rgba(0,0,0,.1)}.progress-bar{float:left;width:0;height:100%;font-size:12px;line-height:20px;color:#fff;text-align:center;background-color:#337ab7;box-shadow:inset 0 -1px 0 rgba(0,0,0,.15);transition:width .6s ease}.progress-bar-striped,.progress-striped .progress-bar{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent);background-size:40px 40px}.progress-bar.active,.progress.active .progress-bar{animation:progress-bar-stripes 2s linear infinite}.progress-bar-success{background-color:#5cb85c}.progress-striped .progress-bar-success{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-info{background-color:#5bc0de}.progress-striped .progress-bar-info{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-warning{background-color:#f0ad4e}.progress-striped .progress-bar-warning{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.progress-bar-danger{background-color:#d9534f}.progress-striped .progress-bar-danger{background-image:linear-gradient(45deg,hsla(0,0%,100%,.15) 25%,transparent 0,transparent 50%,hsla(0,0%,100%,.15) 0,hsla(0,0%,100%,.15) 75%,transparent 0,transparent)}.media{margin-top:15px}.media:first-child{margin-top:0}.media,.media-body{zoom:1;overflow:hidden}.media-body{width:10000px}.media-object{display:block}.media-object.img-thumbnail{max-width:none}.media-right,.media>.pull-right{padding-left:10px}.media-left,.media>.pull-left{padding-right:10px}.media-body,.media-left,.media-right{display:table-cell;vertical-align:top}.media-middle{vertical-align:middle}.media-bottom{vertical-align:bottom}.media-heading{margin-top:0;margin-bottom:5px}.media-list{padding-left:0;list-style:none}.list-group{margin-bottom:20px;padding-left:0}.list-group-item{position:relative;display:block;padding:10px 15px;margin-bottom:-1px;background-color:#fff;border:1px solid #ddd}.list-group-item:first-child{border-top-right-radius:4px;border-top-left-radius:4px}.list-group-item:last-child{margin-bottom:0;border-bottom-right-radius:4px;border-bottom-left-radius:4px}a.list-group-item,button.list-group-item{color:#555}a.list-group-item .list-group-item-heading,button.list-group-item .list-group-item-heading{color:#333}a.list-group-item:focus,a.list-group-item:hover,button.list-group-item:focus,button.list-group-item:hover{text-decoration:none;color:#555;background-color:#f5f5f5}button.list-group-item{width:100%;text-align:left}.list-group-item.disabled,.list-group-item.disabled:focus,.list-group-item.disabled:hover{background-color:#eee;color:#777;cursor:not-allowed}.list-group-item.disabled .list-group-item-heading,.list-group-item.disabled:focus .list-group-item-heading,.list-group-item.disabled:hover .list-group-item-heading{color:inherit}.list-group-item.disabled .list-group-item-text,.list-group-item.disabled:focus .list-group-item-text,.list-group-item.disabled:hover .list-group-item-text{color:#777}.list-group-item.active,.list-group-item.active:focus,.list-group-item.active:hover{z-index:2;color:#fff;background-color:#337ab7;border-color:#337ab7}.list-group-item.active .list-group-item-heading,.list-group-item.active .list-group-item-heading>.small,.list-group-item.active .list-group-item-heading>small,.list-group-item.active:focus .list-group-item-heading,.list-group-item.active:focus .list-group-item-heading>.small,.list-group-item.active:focus .list-group-item-heading>small,.list-group-item.active:hover .list-group-item-heading,.list-group-item.active:hover .list-group-item-heading>.small,.list-group-item.active:hover .list-group-item-heading>small{color:inherit}.list-group-item.active .list-group-item-text,.list-group-item.active:focus .list-group-item-text,.list-group-item.active:hover .list-group-item-text{color:#c7ddef}.list-group-item-success{color:#3c763d;background-color:#dff0d8}a.list-group-item-success,button.list-group-item-success{color:#3c763d}a.list-group-item-success .list-group-item-heading,button.list-group-item-success .list-group-item-heading{color:inherit}a.list-group-item-success:focus,a.list-group-item-success:hover,button.list-group-item-success:focus,button.list-group-item-success:hover{color:#3c763d;background-color:#d0e9c6}a.list-group-item-success.active,a.list-group-item-success.active:focus,a.list-group-item-success.active:hover,button.list-group-item-success.active,button.list-group-item-success.active:focus,button.list-group-item-success.active:hover{color:#fff;background-color:#3c763d;border-color:#3c763d}.list-group-item-info{color:#31708f;background-color:#d9edf7}a.list-group-item-info,button.list-group-item-info{color:#31708f}a.list-group-item-info .list-group-item-heading,button.list-group-item-info .list-group-item-heading{color:inherit}a.list-group-item-info:focus,a.list-group-item-info:hover,button.list-group-item-info:focus,button.list-group-item-info:hover{color:#31708f;background-color:#c4e3f3}a.list-group-item-info.active,a.list-group-item-info.active:focus,a.list-group-item-info.active:hover,button.list-group-item-info.active,button.list-group-item-info.active:focus,button.list-group-item-info.active:hover{color:#fff;background-color:#31708f;border-color:#31708f}.list-group-item-warning{color:#8a6d3b;background-color:#fcf8e3}a.list-group-item-warning,button.list-group-item-warning{color:#8a6d3b}a.list-group-item-warning .list-group-item-heading,button.list-group-item-warning .list-group-item-heading{color:inherit}a.list-group-item-warning:focus,a.list-group-item-warning:hover,button.list-group-item-warning:focus,button.list-group-item-warning:hover{color:#8a6d3b;background-color:#faf2cc}a.list-group-item-warning.active,a.list-group-item-warning.active:focus,a.list-group-item-warning.active:hover,button.list-group-item-warning.active,button.list-group-item-warning.active:focus,button.list-group-item-warning.active:hover{color:#fff;background-color:#8a6d3b;border-color:#8a6d3b}.list-group-item-danger{color:#a94442;background-color:#f2dede}a.list-group-item-danger,button.list-group-item-danger{color:#a94442}a.list-group-item-danger .list-group-item-heading,button.list-group-item-danger .list-group-item-heading{color:inherit}a.list-group-item-danger:focus,a.list-group-item-danger:hover,button.list-group-item-danger:focus,button.list-group-item-danger:hover{color:#a94442;background-color:#ebcccc}a.list-group-item-danger.active,a.list-group-item-danger.active:focus,a.list-group-item-danger.active:hover,button.list-group-item-danger.active,button.list-group-item-danger.active:focus,button.list-group-item-danger.active:hover{color:#fff;background-color:#a94442;border-color:#a94442}.list-group-item-heading{margin-top:0;margin-bottom:5px}.list-group-item-text{margin-bottom:0;line-height:1.3}.panel{margin-bottom:20px;background-color:#fff;border:1px solid transparent;border-radius:4px;box-shadow:0 1px 1px rgba(0,0,0,.05)}.panel-body{padding:15px}.panel-body:after,.panel-body:before{content:\" \";display:table}.panel-body:after{clear:both}.panel-heading{padding:10px 15px;border-bottom:1px solid transparent;border-top-right-radius:3px;border-top-left-radius:3px}.panel-heading>.dropdown .dropdown-toggle,.panel-title{color:inherit}.panel-title{margin-top:0;margin-bottom:0;font-size:16px}.panel-title>.small,.panel-title>.small>a,.panel-title>a,.panel-title>small,.panel-title>small>a{color:inherit}.panel-footer{padding:10px 15px;background-color:#f5f5f5;border-top:1px solid #ddd;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.list-group,.panel>.panel-collapse>.list-group{margin-bottom:0}.panel>.list-group .list-group-item,.panel>.panel-collapse>.list-group .list-group-item{border-width:1px 0;border-radius:0}.panel>.list-group:first-child .list-group-item:first-child,.panel>.panel-collapse>.list-group:first-child .list-group-item:first-child{border-top:0;border-top-right-radius:3px;border-top-left-radius:3px}.panel>.list-group:last-child .list-group-item:last-child,.panel>.panel-collapse>.list-group:last-child .list-group-item:last-child{border-bottom:0;border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.panel-heading+.panel-collapse>.list-group .list-group-item:first-child{border-top-right-radius:0;border-top-left-radius:0}.list-group+.panel-footer,.panel-heading+.list-group .list-group-item:first-child{border-top-width:0}.panel>.panel-collapse>.table,.panel>.table,.panel>.table-responsive>.table{margin-bottom:0}.panel>.panel-collapse>.table caption,.panel>.table-responsive>.table caption,.panel>.table caption{padding-left:15px;padding-right:15px}.panel>.table-responsive:first-child>.table:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child,.panel>.table:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child,.panel>.table:first-child>thead:first-child>tr:first-child{border-top-right-radius:3px;border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:first-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:first-child,.panel>.table:first-child>thead:first-child>tr:first-child td:first-child,.panel>.table:first-child>thead:first-child>tr:first-child th:first-child{border-top-left-radius:3px}.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table-responsive:first-child>.table:first-child>thead:first-child>tr:first-child th:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child td:last-child,.panel>.table:first-child>tbody:first-child>tr:first-child th:last-child,.panel>.table:first-child>thead:first-child>tr:first-child td:last-child,.panel>.table:first-child>thead:first-child>tr:first-child th:last-child{border-top-right-radius:3px}.panel>.table-responsive:last-child>.table:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child,.panel>.table:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child{border-bottom-right-radius:3px;border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:first-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:first-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:first-child{border-bottom-left-radius:3px}.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table-responsive:last-child>.table:last-child>tfoot:last-child>tr:last-child th:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child td:last-child,.panel>.table:last-child>tbody:last-child>tr:last-child th:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child td:last-child,.panel>.table:last-child>tfoot:last-child>tr:last-child th:last-child{border-bottom-right-radius:3px}.panel>.panel-body+.table,.panel>.panel-body+.table-responsive,.panel>.table+.panel-body,.panel>.table-responsive+.panel-body{border-top:1px solid #ddd}.panel>.table>tbody:first-child>tr:first-child td,.panel>.table>tbody:first-child>tr:first-child th{border-top:0}.panel>.table-bordered,.panel>.table-responsive>.table-bordered{border:0}.panel>.table-bordered>tbody>tr>td:first-child,.panel>.table-bordered>tbody>tr>th:first-child,.panel>.table-bordered>tfoot>tr>td:first-child,.panel>.table-bordered>tfoot>tr>th:first-child,.panel>.table-bordered>thead>tr>td:first-child,.panel>.table-bordered>thead>tr>th:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:first-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:first-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:first-child,.panel>.table-responsive>.table-bordered>thead>tr>td:first-child,.panel>.table-responsive>.table-bordered>thead>tr>th:first-child{border-left:0}.panel>.table-bordered>tbody>tr>td:last-child,.panel>.table-bordered>tbody>tr>th:last-child,.panel>.table-bordered>tfoot>tr>td:last-child,.panel>.table-bordered>tfoot>tr>th:last-child,.panel>.table-bordered>thead>tr>td:last-child,.panel>.table-bordered>thead>tr>th:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>td:last-child,.panel>.table-responsive>.table-bordered>tbody>tr>th:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>td:last-child,.panel>.table-responsive>.table-bordered>tfoot>tr>th:last-child,.panel>.table-responsive>.table-bordered>thead>tr>td:last-child,.panel>.table-responsive>.table-bordered>thead>tr>th:last-child{border-right:0}.panel>.table-bordered>tbody>tr:first-child>td,.panel>.table-bordered>tbody>tr:first-child>th,.panel>.table-bordered>tbody>tr:last-child>td,.panel>.table-bordered>tbody>tr:last-child>th,.panel>.table-bordered>tfoot>tr:last-child>td,.panel>.table-bordered>tfoot>tr:last-child>th,.panel>.table-bordered>thead>tr:first-child>td,.panel>.table-bordered>thead>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:first-child>th,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>td,.panel>.table-responsive>.table-bordered>tbody>tr:last-child>th,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>td,.panel>.table-responsive>.table-bordered>tfoot>tr:last-child>th,.panel>.table-responsive>.table-bordered>thead>tr:first-child>td,.panel>.table-responsive>.table-bordered>thead>tr:first-child>th{border-bottom:0}.panel>.table-responsive{border:0;margin-bottom:0}.panel-group{margin-bottom:20px}.panel-group .panel{margin-bottom:0;border-radius:4px}.panel-group .panel+.panel{margin-top:5px}.panel-group .panel-heading{border-bottom:0}.panel-group .panel-heading+.panel-collapse>.list-group,.panel-group .panel-heading+.panel-collapse>.panel-body{border-top:1px solid #ddd}.panel-group .panel-footer{border-top:0}.panel-group .panel-footer+.panel-collapse .panel-body{border-bottom:1px solid #ddd}.panel-default{border-color:#ddd}.panel-default>.panel-heading{color:#333;background-color:#f5f5f5;border-color:#ddd}.panel-default>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ddd}.panel-default>.panel-heading .badge{color:#f5f5f5;background-color:#333}.panel-default>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ddd}.panel-primary{border-color:#337ab7}.panel-primary>.panel-heading{color:#fff;background-color:#337ab7;border-color:#337ab7}.panel-primary>.panel-heading+.panel-collapse>.panel-body{border-top-color:#337ab7}.panel-primary>.panel-heading .badge{color:#337ab7;background-color:#fff}.panel-primary>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#337ab7}.panel-success{border-color:#d6e9c6}.panel-success>.panel-heading{color:#3c763d;background-color:#dff0d8;border-color:#d6e9c6}.panel-success>.panel-heading+.panel-collapse>.panel-body{border-top-color:#d6e9c6}.panel-success>.panel-heading .badge{color:#dff0d8;background-color:#3c763d}.panel-success>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#d6e9c6}.panel-info{border-color:#bce8f1}.panel-info>.panel-heading{color:#31708f;background-color:#d9edf7;border-color:#bce8f1}.panel-info>.panel-heading+.panel-collapse>.panel-body{border-top-color:#bce8f1}.panel-info>.panel-heading .badge{color:#d9edf7;background-color:#31708f}.panel-info>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#bce8f1}.panel-warning{border-color:#faebcc}.panel-warning>.panel-heading{color:#8a6d3b;background-color:#fcf8e3;border-color:#faebcc}.panel-warning>.panel-heading+.panel-collapse>.panel-body{border-top-color:#faebcc}.panel-warning>.panel-heading .badge{color:#fcf8e3;background-color:#8a6d3b}.panel-warning>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#faebcc}.panel-danger{border-color:#ebccd1}.panel-danger>.panel-heading{color:#a94442;background-color:#f2dede;border-color:#ebccd1}.panel-danger>.panel-heading+.panel-collapse>.panel-body{border-top-color:#ebccd1}.panel-danger>.panel-heading .badge{color:#f2dede;background-color:#a94442}.panel-danger>.panel-footer+.panel-collapse>.panel-body{border-bottom-color:#ebccd1}.embed-responsive{position:relative;display:block;height:0;padding:0;overflow:hidden}.embed-responsive .embed-responsive-item,.embed-responsive embed,.embed-responsive iframe,.embed-responsive object,.embed-responsive video{position:absolute;top:0;left:0;bottom:0;height:100%;width:100%;border:0}.embed-responsive-16by9{padding-bottom:56.25%}.embed-responsive-4by3{padding-bottom:75%}.well{min-height:20px;padding:19px;margin-bottom:20px;background-color:#f5f5f5;border:1px solid #e3e3e3;border-radius:4px;box-shadow:inset 0 1px 1px rgba(0,0,0,.05)}.well blockquote{border-color:#ddd;border-color:rgba(0,0,0,.15)}.well-lg{padding:24px;border-radius:6px}.well-sm{padding:9px;border-radius:3px}.close{float:right;font-size:21px;font-weight:700;line-height:1;color:#000;text-shadow:0 1px 0 #fff;opacity:.2;filter:alpha(opacity=20)}.close:focus,.close:hover{color:#000;text-decoration:none;cursor:pointer;opacity:.5;filter:alpha(opacity=50)}button.close{padding:0;cursor:pointer;background:transparent;border:0;-webkit-appearance:none}.modal,.modal-open{overflow:hidden}.modal{display:none;position:fixed;top:0;right:0;bottom:0;left:0;z-index:1050;-webkit-overflow-scrolling:touch;outline:0}.modal.fade .modal-dialog{transform:translateY(-25%);transition:transform .3s ease-out}.modal.in .modal-dialog{transform:translate(0)}.modal-open .modal{overflow-x:hidden;overflow-y:auto}.modal-dialog{position:relative;width:auto;margin:10px}.modal-content{position:relative;background-color:#fff;border:1px solid #999;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 3px 9px rgba(0,0,0,.5);background-clip:padding-box;outline:0}.modal-backdrop{position:fixed;top:0;right:0;bottom:0;left:0;z-index:1040;background-color:#000}.modal-backdrop.fade{opacity:0;filter:alpha(opacity=0)}.modal-backdrop.in{opacity:.5;filter:alpha(opacity=50)}.modal-header{padding:15px;border-bottom:1px solid #e5e5e5}.modal-header:after,.modal-header:before{content:\" \";display:table}.modal-header:after{clear:both}.modal-header .close{margin-top:-2px}.modal-title{margin:0;line-height:1.428571429}.modal-body{position:relative;padding:15px}.modal-footer{padding:15px;text-align:right;border-top:1px solid #e5e5e5}.modal-footer:after,.modal-footer:before{content:\" \";display:table}.modal-footer:after{clear:both}.modal-footer .btn+.btn{margin-left:5px;margin-bottom:0}.modal-footer .btn-group .btn+.btn{margin-left:-1px}.modal-footer .btn-block+.btn-block{margin-left:0}.modal-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}@media (min-width:768px){.modal-dialog{width:600px;margin:30px auto}.modal-content{box-shadow:0 5px 15px rgba(0,0,0,.5)}.modal-sm{width:300px}}@media (min-width:992px){.modal-lg{width:900px}}.tooltip{position:absolute;z-index:1070;display:block;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.428571429;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:12px;opacity:0;filter:alpha(opacity=0)}.tooltip.in{opacity:.9;filter:alpha(opacity=90)}.tooltip.top{margin-top:-3px;padding:5px 0}.tooltip.right{margin-left:3px;padding:0 5px}.tooltip.bottom{margin-top:3px;padding:5px 0}.tooltip.left{margin-left:-3px;padding:0 5px}.tooltip-inner{max-width:200px;padding:3px 8px;color:#fff;text-align:center;background-color:#000;border-radius:4px}.tooltip-arrow{position:absolute;width:0;height:0;border-color:transparent;border-style:solid}.tooltip.top .tooltip-arrow{bottom:0;left:50%;margin-left:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-left .tooltip-arrow{right:5px}.tooltip.top-left .tooltip-arrow,.tooltip.top-right .tooltip-arrow{bottom:0;margin-bottom:-5px;border-width:5px 5px 0;border-top-color:#000}.tooltip.top-right .tooltip-arrow{left:5px}.tooltip.right .tooltip-arrow{top:50%;left:0;margin-top:-5px;border-width:5px 5px 5px 0;border-right-color:#000}.tooltip.left .tooltip-arrow{top:50%;right:0;margin-top:-5px;border-width:5px 0 5px 5px;border-left-color:#000}.tooltip.bottom .tooltip-arrow{top:0;left:50%;margin-left:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-left .tooltip-arrow{top:0;right:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.tooltip.bottom-right .tooltip-arrow{top:0;left:5px;margin-top:-5px;border-width:0 5px 5px;border-bottom-color:#000}.popover{position:absolute;top:0;left:0;z-index:1060;display:none;max-width:276px;padding:1px;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;font-style:normal;font-weight:400;letter-spacing:normal;line-break:auto;line-height:1.428571429;text-align:left;text-align:start;text-decoration:none;text-shadow:none;text-transform:none;white-space:normal;word-break:normal;word-spacing:normal;word-wrap:normal;font-size:14px;background-color:#fff;background-clip:padding-box;border:1px solid #ccc;border:1px solid rgba(0,0,0,.2);border-radius:6px;box-shadow:0 5px 10px rgba(0,0,0,.2)}.popover.top{margin-top:-10px}.popover.right{margin-left:10px}.popover.bottom{margin-top:10px}.popover.left{margin-left:-10px}.popover-title{margin:0;padding:8px 14px;font-size:14px;background-color:#f7f7f7;border-bottom:1px solid #ebebeb;border-radius:5px 5px 0 0}.popover-content{padding:9px 14px}.popover>.arrow,.popover>.arrow:after{position:absolute;display:block;width:0;height:0;border-color:transparent;border-style:solid}.popover>.arrow{border-width:11px}.popover>.arrow:after{border-width:10px;content:\"\"}.popover.top>.arrow{left:50%;margin-left:-11px;border-bottom-width:0;border-top-color:#999;border-top-color:rgba(0,0,0,.25);bottom:-11px}.popover.top>.arrow:after{content:\" \";bottom:1px;margin-left:-10px;border-bottom-width:0;border-top-color:#fff}.popover.right>.arrow{top:50%;left:-11px;margin-top:-11px;border-left-width:0;border-right-color:#999;border-right-color:rgba(0,0,0,.25)}.popover.right>.arrow:after{content:\" \";left:1px;bottom:-10px;border-left-width:0;border-right-color:#fff}.popover.bottom>.arrow{left:50%;margin-left:-11px;border-top-width:0;border-bottom-color:#999;border-bottom-color:rgba(0,0,0,.25);top:-11px}.popover.bottom>.arrow:after{content:\" \";top:1px;margin-left:-10px;border-top-width:0;border-bottom-color:#fff}.popover.left>.arrow{top:50%;right:-11px;margin-top:-11px;border-right-width:0;border-left-color:#999;border-left-color:rgba(0,0,0,.25)}.popover.left>.arrow:after{content:\" \";right:1px;border-right-width:0;border-left-color:#fff;bottom:-10px}.carousel,.carousel-inner{position:relative}.carousel-inner{overflow:hidden;width:100%}.carousel-inner>.item{display:none;position:relative;transition:left .6s ease-in-out}.carousel-inner>.item>a>img,.carousel-inner>.item>img{display:block;max-width:100%;height:auto;line-height:1}@media (-webkit-transform-3d),(transform-3d){.carousel-inner>.item{transition:transform .6s ease-in-out;-webkit-backface-visibility:hidden;backface-visibility:hidden;perspective:1000px}.carousel-inner>.item.active.right,.carousel-inner>.item.next{transform:translate3d(100%,0,0);left:0}.carousel-inner>.item.active.left,.carousel-inner>.item.prev{transform:translate3d(-100%,0,0);left:0}.carousel-inner>.item.active,.carousel-inner>.item.next.left,.carousel-inner>.item.prev.right{transform:translateZ(0);left:0}}.carousel-inner>.active,.carousel-inner>.next,.carousel-inner>.prev{display:block}.carousel-inner>.active{left:0}.carousel-inner>.next,.carousel-inner>.prev{position:absolute;top:0;width:100%}.carousel-inner>.next{left:100%}.carousel-inner>.prev{left:-100%}.carousel-inner>.next.left,.carousel-inner>.prev.right{left:0}.carousel-inner>.active.left{left:-100%}.carousel-inner>.active.right{left:100%}.carousel-control{position:absolute;top:0;left:0;bottom:0;width:15%;opacity:.5;filter:alpha(opacity=50);font-size:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6);background-color:transparent}.carousel-control.left{background-image:linear-gradient(90deg,rgba(0,0,0,.5) 0,rgba(0,0,0,.0001));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#80000000\",endColorstr=\"#00000000\",GradientType=1)}.carousel-control.right{left:auto;right:0;background-image:linear-gradient(90deg,rgba(0,0,0,.0001) 0,rgba(0,0,0,.5));background-repeat:repeat-x;filter:progid:DXImageTransform.Microsoft.gradient(startColorstr=\"#00000000\",endColorstr=\"#80000000\",GradientType=1)}.carousel-control:focus,.carousel-control:hover{outline:0;color:#fff;text-decoration:none;opacity:.9;filter:alpha(opacity=90)}.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{position:absolute;top:50%;margin-top:-10px;z-index:5;display:inline-block}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{left:50%;margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{right:50%;margin-right:-10px}.carousel-control .icon-next,.carousel-control .icon-prev{width:20px;height:20px;line-height:1;font-family:serif}.carousel-control .icon-prev:before{content:\"\\2039\"}.carousel-control .icon-next:before{content:\"\\203A\"}.carousel-indicators{position:absolute;bottom:10px;left:50%;z-index:15;width:60%;margin-left:-30%;padding-left:0;list-style:none;text-align:center}.carousel-indicators li{display:inline-block;width:10px;height:10px;margin:1px;text-indent:-999px;border:1px solid #fff;border-radius:10px;cursor:pointer;background-color:#000\\9;background-color:transparent}.carousel-indicators .active{margin:0;width:12px;height:12px;background-color:#fff}.carousel-caption{position:absolute;left:15%;right:15%;bottom:20px;z-index:10;padding-top:20px;padding-bottom:20px;color:#fff;text-align:center;text-shadow:0 1px 2px rgba(0,0,0,.6)}.carousel-caption .btn{text-shadow:none}@media screen and (min-width:768px){.carousel-control .glyphicon-chevron-left,.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next,.carousel-control .icon-prev{width:30px;height:30px;margin-top:-10px;font-size:30px}.carousel-control .glyphicon-chevron-left,.carousel-control .icon-prev{margin-left:-10px}.carousel-control .glyphicon-chevron-right,.carousel-control .icon-next{margin-right:-10px}.carousel-caption{left:20%;right:20%;padding-bottom:30px}.carousel-indicators{bottom:20px}}.clearfix:after,.clearfix:before{content:\" \";display:table}.clearfix:after{clear:both}.center-block{display:block;margin-left:auto;margin-right:auto}.pull-right{float:right!important}.pull-left{float:left!important}.hide{display:none!important}.show{display:block!important}.invisible{visibility:hidden}.text-hide{font:0/0 a;color:transparent;text-shadow:none;background-color:transparent;border:0}.hidden{display:none!important}.affix{position:fixed}@-ms-viewport{width:device-width}.visible-lg,.visible-lg-block,.visible-lg-inline,.visible-lg-inline-block,.visible-md,.visible-md-block,.visible-md-inline,.visible-md-inline-block,.visible-sm,.visible-sm-block,.visible-sm-inline,.visible-sm-inline-block,.visible-xs,.visible-xs-block,.visible-xs-inline,.visible-xs-inline-block{display:none!important}@media (max-width:767px){.visible-xs{display:block!important}table.visible-xs{display:table!important}tr.visible-xs{display:table-row!important}td.visible-xs,th.visible-xs{display:table-cell!important}}@media (max-width:767px){.visible-xs-block{display:block!important}}@media (max-width:767px){.visible-xs-inline{display:inline!important}}@media (max-width:767px){.visible-xs-inline-block{display:inline-block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm{display:block!important}table.visible-sm{display:table!important}tr.visible-sm{display:table-row!important}td.visible-sm,th.visible-sm{display:table-cell!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-block{display:block!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline{display:inline!important}}@media (min-width:768px) and (max-width:991px){.visible-sm-inline-block{display:inline-block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md{display:block!important}table.visible-md{display:table!important}tr.visible-md{display:table-row!important}td.visible-md,th.visible-md{display:table-cell!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-block{display:block!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline{display:inline!important}}@media (min-width:992px) and (max-width:1199px){.visible-md-inline-block{display:inline-block!important}}@media (min-width:1200px){.visible-lg{display:block!important}table.visible-lg{display:table!important}tr.visible-lg{display:table-row!important}td.visible-lg,th.visible-lg{display:table-cell!important}}@media (min-width:1200px){.visible-lg-block{display:block!important}}@media (min-width:1200px){.visible-lg-inline{display:inline!important}}@media (min-width:1200px){.visible-lg-inline-block{display:inline-block!important}}@media (max-width:767px){.hidden-xs{display:none!important}}@media (min-width:768px) and (max-width:991px){.hidden-sm{display:none!important}}@media (min-width:992px) and (max-width:1199px){.hidden-md{display:none!important}}@media (min-width:1200px){.hidden-lg{display:none!important}}.visible-print{display:none!important}@media print{.visible-print{display:block!important}table.visible-print{display:table!important}tr.visible-print{display:table-row!important}td.visible-print,th.visible-print{display:table-cell!important}}.visible-print-block{display:none!important}@media print{.visible-print-block{display:block!important}}.visible-print-inline{display:none!important}@media print{.visible-print-inline{display:inline!important}}.visible-print-inline-block{display:none!important}@media print{.visible-print-inline-block{display:inline-block!important}}@media print{.hidden-print{display:none!important}}/*!\n *  Font Awesome 4.7.0 by @davegandy - http://fontawesome.io - @fontawesome\n *  License - http://fontawesome.io/license (Font: SIL OFL 1.1, CSS: MIT License)\n */@font-face{font-family:FontAwesome;src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?v=4.7.0\");src:url(\"/assets/fonts/font-awesome//fontawesome-webfont.eot?#iefix&v=4.7.0\") format(\"embedded-opentype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff2?v=4.7.0\") format(\"woff2\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.woff?v=4.7.0\") format(\"woff\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.ttf?v=4.7.0\") format(\"truetype\"),url(\"/assets/fonts/font-awesome//fontawesome-webfont.svg?v=4.7.0#fontawesomeregular\") format(\"svg\");font-weight:400;font-style:normal}.fa{display:inline-block;font:normal normal normal 14px/1 FontAwesome;font-size:inherit;text-rendering:auto;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.fa-lg{font-size:1.3333333333em;line-height:.75em;vertical-align:-15%}.fa-2x{font-size:2em}.fa-3x{font-size:3em}.fa-4x{font-size:4em}.fa-5x{font-size:5em}.fa-fw{width:1.2857142857em;text-align:center}.fa-ul{padding-left:0;margin-left:2.1428571429em;list-style-type:none}.fa-ul>li{position:relative}.fa-li{position:absolute;left:-2.1428571429em;width:2.1428571429em;top:.1428571429em;text-align:center}.fa-li.fa-lg{left:-1.8571428571em}.fa-border{padding:.2em .25em .15em;border:.08em solid #eee;border-radius:.1em}.fa-pull-left{float:left}.fa-pull-right{float:right}.fa.fa-pull-left{margin-right:.3em}.fa.fa-pull-right{margin-left:.3em}.pull-right{float:right}.pull-left{float:left}.fa.pull-left{margin-right:.3em}.fa.pull-right{margin-left:.3em}.fa-spin{animation:fa-spin 2s infinite linear}.fa-pulse{animation:fa-spin 1s infinite steps(8)}@keyframes fa-spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.fa-rotate-90{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";transform:rotate(90deg)}.fa-rotate-180{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";transform:rotate(180deg)}.fa-rotate-270{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";transform:rotate(270deg)}.fa-flip-horizontal{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";transform:scaleX(-1)}.fa-flip-vertical{-ms-filter:\"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";transform:scaleY(-1)}:root .fa-flip-horizontal,:root .fa-flip-vertical,:root .fa-rotate-90,:root .fa-rotate-180,:root .fa-rotate-270{filter:none}.fa-stack{position:relative;display:inline-block;width:2em;height:2em;line-height:2em;vertical-align:middle}.fa-stack-1x,.fa-stack-2x{position:absolute;left:0;width:100%;text-align:center}.fa-stack-1x{line-height:inherit}.fa-stack-2x{font-size:2em}.fa-inverse{color:#fff}.fa-glass:before{content:\"\\F000\"}.fa-music:before{content:\"\\F001\"}.fa-search:before{content:\"\\F002\"}.fa-envelope-o:before{content:\"\\F003\"}.fa-heart:before{content:\"\\F004\"}.fa-star:before{content:\"\\F005\"}.fa-star-o:before{content:\"\\F006\"}.fa-user:before{content:\"\\F007\"}.fa-film:before{content:\"\\F008\"}.fa-th-large:before{content:\"\\F009\"}.fa-th:before{content:\"\\F00A\"}.fa-th-list:before{content:\"\\F00B\"}.fa-check:before{content:\"\\F00C\"}.fa-close:before,.fa-remove:before,.fa-times:before{content:\"\\F00D\"}.fa-search-plus:before{content:\"\\F00E\"}.fa-search-minus:before{content:\"\\F010\"}.fa-power-off:before{content:\"\\F011\"}.fa-signal:before{content:\"\\F012\"}.fa-cog:before,.fa-gear:before{content:\"\\F013\"}.fa-trash-o:before{content:\"\\F014\"}.fa-home:before{content:\"\\F015\"}.fa-file-o:before{content:\"\\F016\"}.fa-clock-o:before{content:\"\\F017\"}.fa-road:before{content:\"\\F018\"}.fa-download:before{content:\"\\F019\"}.fa-arrow-circle-o-down:before{content:\"\\F01A\"}.fa-arrow-circle-o-up:before{content:\"\\F01B\"}.fa-inbox:before{content:\"\\F01C\"}.fa-play-circle-o:before{content:\"\\F01D\"}.fa-repeat:before,.fa-rotate-right:before{content:\"\\F01E\"}.fa-refresh:before{content:\"\\F021\"}.fa-list-alt:before{content:\"\\F022\"}.fa-lock:before{content:\"\\F023\"}.fa-flag:before{content:\"\\F024\"}.fa-headphones:before{content:\"\\F025\"}.fa-volume-off:before{content:\"\\F026\"}.fa-volume-down:before{content:\"\\F027\"}.fa-volume-up:before{content:\"\\F028\"}.fa-qrcode:before{content:\"\\F029\"}.fa-barcode:before{content:\"\\F02A\"}.fa-tag:before{content:\"\\F02B\"}.fa-tags:before{content:\"\\F02C\"}.fa-book:before{content:\"\\F02D\"}.fa-bookmark:before{content:\"\\F02E\"}.fa-print:before{content:\"\\F02F\"}.fa-camera:before{content:\"\\F030\"}.fa-font:before{content:\"\\F031\"}.fa-bold:before{content:\"\\F032\"}.fa-italic:before{content:\"\\F033\"}.fa-text-height:before{content:\"\\F034\"}.fa-text-width:before{content:\"\\F035\"}.fa-align-left:before{content:\"\\F036\"}.fa-align-center:before{content:\"\\F037\"}.fa-align-right:before{content:\"\\F038\"}.fa-align-justify:before{content:\"\\F039\"}.fa-list:before{content:\"\\F03A\"}.fa-dedent:before,.fa-outdent:before{content:\"\\F03B\"}.fa-indent:before{content:\"\\F03C\"}.fa-video-camera:before{content:\"\\F03D\"}.fa-image:before,.fa-photo:before,.fa-picture-o:before{content:\"\\F03E\"}.fa-pencil:before{content:\"\\F040\"}.fa-map-marker:before{content:\"\\F041\"}.fa-adjust:before{content:\"\\F042\"}.fa-tint:before{content:\"\\F043\"}.fa-edit:before,.fa-pencil-square-o:before{content:\"\\F044\"}.fa-share-square-o:before{content:\"\\F045\"}.fa-check-square-o:before{content:\"\\F046\"}.fa-arrows:before{content:\"\\F047\"}.fa-step-backward:before{content:\"\\F048\"}.fa-fast-backward:before{content:\"\\F049\"}.fa-backward:before{content:\"\\F04A\"}.fa-play:before{content:\"\\F04B\"}.fa-pause:before{content:\"\\F04C\"}.fa-stop:before{content:\"\\F04D\"}.fa-forward:before{content:\"\\F04E\"}.fa-fast-forward:before{content:\"\\F050\"}.fa-step-forward:before{content:\"\\F051\"}.fa-eject:before{content:\"\\F052\"}.fa-chevron-left:before{content:\"\\F053\"}.fa-chevron-right:before{content:\"\\F054\"}.fa-plus-circle:before{content:\"\\F055\"}.fa-minus-circle:before{content:\"\\F056\"}.fa-times-circle:before{content:\"\\F057\"}.fa-check-circle:before{content:\"\\F058\"}.fa-question-circle:before{content:\"\\F059\"}.fa-info-circle:before{content:\"\\F05A\"}.fa-crosshairs:before{content:\"\\F05B\"}.fa-times-circle-o:before{content:\"\\F05C\"}.fa-check-circle-o:before{content:\"\\F05D\"}.fa-ban:before{content:\"\\F05E\"}.fa-arrow-left:before{content:\"\\F060\"}.fa-arrow-right:before{content:\"\\F061\"}.fa-arrow-up:before{content:\"\\F062\"}.fa-arrow-down:before{content:\"\\F063\"}.fa-mail-forward:before,.fa-share:before{content:\"\\F064\"}.fa-expand:before{content:\"\\F065\"}.fa-compress:before{content:\"\\F066\"}.fa-plus:before{content:\"\\F067\"}.fa-minus:before{content:\"\\F068\"}.fa-asterisk:before{content:\"\\F069\"}.fa-exclamation-circle:before{content:\"\\F06A\"}.fa-gift:before{content:\"\\F06B\"}.fa-leaf:before{content:\"\\F06C\"}.fa-fire:before{content:\"\\F06D\"}.fa-eye:before{content:\"\\F06E\"}.fa-eye-slash:before{content:\"\\F070\"}.fa-exclamation-triangle:before,.fa-warning:before{content:\"\\F071\"}.fa-plane:before{content:\"\\F072\"}.fa-calendar:before{content:\"\\F073\"}.fa-random:before{content:\"\\F074\"}.fa-comment:before{content:\"\\F075\"}.fa-magnet:before{content:\"\\F076\"}.fa-chevron-up:before{content:\"\\F077\"}.fa-chevron-down:before{content:\"\\F078\"}.fa-retweet:before{content:\"\\F079\"}.fa-shopping-cart:before{content:\"\\F07A\"}.fa-folder:before{content:\"\\F07B\"}.fa-folder-open:before{content:\"\\F07C\"}.fa-arrows-v:before{content:\"\\F07D\"}.fa-arrows-h:before{content:\"\\F07E\"}.fa-bar-chart-o:before,.fa-bar-chart:before{content:\"\\F080\"}.fa-twitter-square:before{content:\"\\F081\"}.fa-facebook-square:before{content:\"\\F082\"}.fa-camera-retro:before{content:\"\\F083\"}.fa-key:before{content:\"\\F084\"}.fa-cogs:before,.fa-gears:before{content:\"\\F085\"}.fa-comments:before{content:\"\\F086\"}.fa-thumbs-o-up:before{content:\"\\F087\"}.fa-thumbs-o-down:before{content:\"\\F088\"}.fa-star-half:before{content:\"\\F089\"}.fa-heart-o:before{content:\"\\F08A\"}.fa-sign-out:before{content:\"\\F08B\"}.fa-linkedin-square:before{content:\"\\F08C\"}.fa-thumb-tack:before{content:\"\\F08D\"}.fa-external-link:before{content:\"\\F08E\"}.fa-sign-in:before{content:\"\\F090\"}.fa-trophy:before{content:\"\\F091\"}.fa-github-square:before{content:\"\\F092\"}.fa-upload:before{content:\"\\F093\"}.fa-lemon-o:before{content:\"\\F094\"}.fa-phone:before{content:\"\\F095\"}.fa-square-o:before{content:\"\\F096\"}.fa-bookmark-o:before{content:\"\\F097\"}.fa-phone-square:before{content:\"\\F098\"}.fa-twitter:before{content:\"\\F099\"}.fa-facebook-f:before,.fa-facebook:before{content:\"\\F09A\"}.fa-github:before{content:\"\\F09B\"}.fa-unlock:before{content:\"\\F09C\"}.fa-credit-card:before{content:\"\\F09D\"}.fa-feed:before,.fa-rss:before{content:\"\\F09E\"}.fa-hdd-o:before{content:\"\\F0A0\"}.fa-bullhorn:before{content:\"\\F0A1\"}.fa-bell:before{content:\"\\F0F3\"}.fa-certificate:before{content:\"\\F0A3\"}.fa-hand-o-right:before{content:\"\\F0A4\"}.fa-hand-o-left:before{content:\"\\F0A5\"}.fa-hand-o-up:before{content:\"\\F0A6\"}.fa-hand-o-down:before{content:\"\\F0A7\"}.fa-arrow-circle-left:before{content:\"\\F0A8\"}.fa-arrow-circle-right:before{content:\"\\F0A9\"}.fa-arrow-circle-up:before{content:\"\\F0AA\"}.fa-arrow-circle-down:before{content:\"\\F0AB\"}.fa-globe:before{content:\"\\F0AC\"}.fa-wrench:before{content:\"\\F0AD\"}.fa-tasks:before{content:\"\\F0AE\"}.fa-filter:before{content:\"\\F0B0\"}.fa-briefcase:before{content:\"\\F0B1\"}.fa-arrows-alt:before{content:\"\\F0B2\"}.fa-group:before,.fa-users:before{content:\"\\F0C0\"}.fa-chain:before,.fa-link:before{content:\"\\F0C1\"}.fa-cloud:before{content:\"\\F0C2\"}.fa-flask:before{content:\"\\F0C3\"}.fa-cut:before,.fa-scissors:before{content:\"\\F0C4\"}.fa-copy:before,.fa-files-o:before{content:\"\\F0C5\"}.fa-paperclip:before{content:\"\\F0C6\"}.fa-floppy-o:before,.fa-save:before{content:\"\\F0C7\"}.fa-square:before{content:\"\\F0C8\"}.fa-bars:before,.fa-navicon:before,.fa-reorder:before{content:\"\\F0C9\"}.fa-list-ul:before{content:\"\\F0CA\"}.fa-list-ol:before{content:\"\\F0CB\"}.fa-strikethrough:before{content:\"\\F0CC\"}.fa-underline:before{content:\"\\F0CD\"}.fa-table:before{content:\"\\F0CE\"}.fa-magic:before{content:\"\\F0D0\"}.fa-truck:before{content:\"\\F0D1\"}.fa-pinterest:before{content:\"\\F0D2\"}.fa-pinterest-square:before{content:\"\\F0D3\"}.fa-google-plus-square:before{content:\"\\F0D4\"}.fa-google-plus:before{content:\"\\F0D5\"}.fa-money:before{content:\"\\F0D6\"}.fa-caret-down:before{content:\"\\F0D7\"}.fa-caret-up:before{content:\"\\F0D8\"}.fa-caret-left:before{content:\"\\F0D9\"}.fa-caret-right:before{content:\"\\F0DA\"}.fa-columns:before{content:\"\\F0DB\"}.fa-sort:before,.fa-unsorted:before{content:\"\\F0DC\"}.fa-sort-desc:before,.fa-sort-down:before{content:\"\\F0DD\"}.fa-sort-asc:before,.fa-sort-up:before{content:\"\\F0DE\"}.fa-envelope:before{content:\"\\F0E0\"}.fa-linkedin:before{content:\"\\F0E1\"}.fa-rotate-left:before,.fa-undo:before{content:\"\\F0E2\"}.fa-gavel:before,.fa-legal:before{content:\"\\F0E3\"}.fa-dashboard:before,.fa-tachometer:before{content:\"\\F0E4\"}.fa-comment-o:before{content:\"\\F0E5\"}.fa-comments-o:before{content:\"\\F0E6\"}.fa-bolt:before,.fa-flash:before{content:\"\\F0E7\"}.fa-sitemap:before{content:\"\\F0E8\"}.fa-umbrella:before{content:\"\\F0E9\"}.fa-clipboard:before,.fa-paste:before{content:\"\\F0EA\"}.fa-lightbulb-o:before{content:\"\\F0EB\"}.fa-exchange:before{content:\"\\F0EC\"}.fa-cloud-download:before{content:\"\\F0ED\"}.fa-cloud-upload:before{content:\"\\F0EE\"}.fa-user-md:before{content:\"\\F0F0\"}.fa-stethoscope:before{content:\"\\F0F1\"}.fa-suitcase:before{content:\"\\F0F2\"}.fa-bell-o:before{content:\"\\F0A2\"}.fa-coffee:before{content:\"\\F0F4\"}.fa-cutlery:before{content:\"\\F0F5\"}.fa-file-text-o:before{content:\"\\F0F6\"}.fa-building-o:before{content:\"\\F0F7\"}.fa-hospital-o:before{content:\"\\F0F8\"}.fa-ambulance:before{content:\"\\F0F9\"}.fa-medkit:before{content:\"\\F0FA\"}.fa-fighter-jet:before{content:\"\\F0FB\"}.fa-beer:before{content:\"\\F0FC\"}.fa-h-square:before{content:\"\\F0FD\"}.fa-plus-square:before{content:\"\\F0FE\"}.fa-angle-double-left:before{content:\"\\F100\"}.fa-angle-double-right:before{content:\"\\F101\"}.fa-angle-double-up:before{content:\"\\F102\"}.fa-angle-double-down:before{content:\"\\F103\"}.fa-angle-left:before{content:\"\\F104\"}.fa-angle-right:before{content:\"\\F105\"}.fa-angle-up:before{content:\"\\F106\"}.fa-angle-down:before{content:\"\\F107\"}.fa-desktop:before{content:\"\\F108\"}.fa-laptop:before{content:\"\\F109\"}.fa-tablet:before{content:\"\\F10A\"}.fa-mobile-phone:before,.fa-mobile:before{content:\"\\F10B\"}.fa-circle-o:before{content:\"\\F10C\"}.fa-quote-left:before{content:\"\\F10D\"}.fa-quote-right:before{content:\"\\F10E\"}.fa-spinner:before{content:\"\\F110\"}.fa-circle:before{content:\"\\F111\"}.fa-mail-reply:before,.fa-reply:before{content:\"\\F112\"}.fa-github-alt:before{content:\"\\F113\"}.fa-folder-o:before{content:\"\\F114\"}.fa-folder-open-o:before{content:\"\\F115\"}.fa-smile-o:before{content:\"\\F118\"}.fa-frown-o:before{content:\"\\F119\"}.fa-meh-o:before{content:\"\\F11A\"}.fa-gamepad:before{content:\"\\F11B\"}.fa-keyboard-o:before{content:\"\\F11C\"}.fa-flag-o:before{content:\"\\F11D\"}.fa-flag-checkered:before{content:\"\\F11E\"}.fa-terminal:before{content:\"\\F120\"}.fa-code:before{content:\"\\F121\"}.fa-mail-reply-all:before,.fa-reply-all:before{content:\"\\F122\"}.fa-star-half-empty:before,.fa-star-half-full:before,.fa-star-half-o:before{content:\"\\F123\"}.fa-location-arrow:before{content:\"\\F124\"}.fa-crop:before{content:\"\\F125\"}.fa-code-fork:before{content:\"\\F126\"}.fa-chain-broken:before,.fa-unlink:before{content:\"\\F127\"}.fa-question:before{content:\"\\F128\"}.fa-info:before{content:\"\\F129\"}.fa-exclamation:before{content:\"\\F12A\"}.fa-superscript:before{content:\"\\F12B\"}.fa-subscript:before{content:\"\\F12C\"}.fa-eraser:before{content:\"\\F12D\"}.fa-puzzle-piece:before{content:\"\\F12E\"}.fa-microphone:before{content:\"\\F130\"}.fa-microphone-slash:before{content:\"\\F131\"}.fa-shield:before{content:\"\\F132\"}.fa-calendar-o:before{content:\"\\F133\"}.fa-fire-extinguisher:before{content:\"\\F134\"}.fa-rocket:before{content:\"\\F135\"}.fa-maxcdn:before{content:\"\\F136\"}.fa-chevron-circle-left:before{content:\"\\F137\"}.fa-chevron-circle-right:before{content:\"\\F138\"}.fa-chevron-circle-up:before{content:\"\\F139\"}.fa-chevron-circle-down:before{content:\"\\F13A\"}.fa-html5:before{content:\"\\F13B\"}.fa-css3:before{content:\"\\F13C\"}.fa-anchor:before{content:\"\\F13D\"}.fa-unlock-alt:before{content:\"\\F13E\"}.fa-bullseye:before{content:\"\\F140\"}.fa-ellipsis-h:before{content:\"\\F141\"}.fa-ellipsis-v:before{content:\"\\F142\"}.fa-rss-square:before{content:\"\\F143\"}.fa-play-circle:before{content:\"\\F144\"}.fa-ticket:before{content:\"\\F145\"}.fa-minus-square:before{content:\"\\F146\"}.fa-minus-square-o:before{content:\"\\F147\"}.fa-level-up:before{content:\"\\F148\"}.fa-level-down:before{content:\"\\F149\"}.fa-check-square:before{content:\"\\F14A\"}.fa-pencil-square:before{content:\"\\F14B\"}.fa-external-link-square:before{content:\"\\F14C\"}.fa-share-square:before{content:\"\\F14D\"}.fa-compass:before{content:\"\\F14E\"}.fa-caret-square-o-down:before,.fa-toggle-down:before{content:\"\\F150\"}.fa-caret-square-o-up:before,.fa-toggle-up:before{content:\"\\F151\"}.fa-caret-square-o-right:before,.fa-toggle-right:before{content:\"\\F152\"}.fa-eur:before,.fa-euro:before{content:\"\\F153\"}.fa-gbp:before{content:\"\\F154\"}.fa-dollar:before,.fa-usd:before{content:\"\\F155\"}.fa-inr:before,.fa-rupee:before{content:\"\\F156\"}.fa-cny:before,.fa-jpy:before,.fa-rmb:before,.fa-yen:before{content:\"\\F157\"}.fa-rouble:before,.fa-rub:before,.fa-ruble:before{content:\"\\F158\"}.fa-krw:before,.fa-won:before{content:\"\\F159\"}.fa-bitcoin:before,.fa-btc:before{content:\"\\F15A\"}.fa-file:before{content:\"\\F15B\"}.fa-file-text:before{content:\"\\F15C\"}.fa-sort-alpha-asc:before{content:\"\\F15D\"}.fa-sort-alpha-desc:before{content:\"\\F15E\"}.fa-sort-amount-asc:before{content:\"\\F160\"}.fa-sort-amount-desc:before{content:\"\\F161\"}.fa-sort-numeric-asc:before{content:\"\\F162\"}.fa-sort-numeric-desc:before{content:\"\\F163\"}.fa-thumbs-up:before{content:\"\\F164\"}.fa-thumbs-down:before{content:\"\\F165\"}.fa-youtube-square:before{content:\"\\F166\"}.fa-youtube:before{content:\"\\F167\"}.fa-xing:before{content:\"\\F168\"}.fa-xing-square:before{content:\"\\F169\"}.fa-youtube-play:before{content:\"\\F16A\"}.fa-dropbox:before{content:\"\\F16B\"}.fa-stack-overflow:before{content:\"\\F16C\"}.fa-instagram:before{content:\"\\F16D\"}.fa-flickr:before{content:\"\\F16E\"}.fa-adn:before{content:\"\\F170\"}.fa-bitbucket:before{content:\"\\F171\"}.fa-bitbucket-square:before{content:\"\\F172\"}.fa-tumblr:before{content:\"\\F173\"}.fa-tumblr-square:before{content:\"\\F174\"}.fa-long-arrow-down:before{content:\"\\F175\"}.fa-long-arrow-up:before{content:\"\\F176\"}.fa-long-arrow-left:before{content:\"\\F177\"}.fa-long-arrow-right:before{content:\"\\F178\"}.fa-apple:before{content:\"\\F179\"}.fa-windows:before{content:\"\\F17A\"}.fa-android:before{content:\"\\F17B\"}.fa-linux:before{content:\"\\F17C\"}.fa-dribbble:before{content:\"\\F17D\"}.fa-skype:before{content:\"\\F17E\"}.fa-foursquare:before{content:\"\\F180\"}.fa-trello:before{content:\"\\F181\"}.fa-female:before{content:\"\\F182\"}.fa-male:before{content:\"\\F183\"}.fa-gittip:before,.fa-gratipay:before{content:\"\\F184\"}.fa-sun-o:before{content:\"\\F185\"}.fa-moon-o:before{content:\"\\F186\"}.fa-archive:before{content:\"\\F187\"}.fa-bug:before{content:\"\\F188\"}.fa-vk:before{content:\"\\F189\"}.fa-weibo:before{content:\"\\F18A\"}.fa-renren:before{content:\"\\F18B\"}.fa-pagelines:before{content:\"\\F18C\"}.fa-stack-exchange:before{content:\"\\F18D\"}.fa-arrow-circle-o-right:before{content:\"\\F18E\"}.fa-arrow-circle-o-left:before{content:\"\\F190\"}.fa-caret-square-o-left:before,.fa-toggle-left:before{content:\"\\F191\"}.fa-dot-circle-o:before{content:\"\\F192\"}.fa-wheelchair:before{content:\"\\F193\"}.fa-vimeo-square:before{content:\"\\F194\"}.fa-try:before,.fa-turkish-lira:before{content:\"\\F195\"}.fa-plus-square-o:before{content:\"\\F196\"}.fa-space-shuttle:before{content:\"\\F197\"}.fa-slack:before{content:\"\\F198\"}.fa-envelope-square:before{content:\"\\F199\"}.fa-wordpress:before{content:\"\\F19A\"}.fa-openid:before{content:\"\\F19B\"}.fa-bank:before,.fa-institution:before,.fa-university:before{content:\"\\F19C\"}.fa-graduation-cap:before,.fa-mortar-board:before{content:\"\\F19D\"}.fa-yahoo:before{content:\"\\F19E\"}.fa-google:before{content:\"\\F1A0\"}.fa-reddit:before{content:\"\\F1A1\"}.fa-reddit-square:before{content:\"\\F1A2\"}.fa-stumbleupon-circle:before{content:\"\\F1A3\"}.fa-stumbleupon:before{content:\"\\F1A4\"}.fa-delicious:before{content:\"\\F1A5\"}.fa-digg:before{content:\"\\F1A6\"}.fa-pied-piper-pp:before{content:\"\\F1A7\"}.fa-pied-piper-alt:before{content:\"\\F1A8\"}.fa-drupal:before{content:\"\\F1A9\"}.fa-joomla:before{content:\"\\F1AA\"}.fa-language:before{content:\"\\F1AB\"}.fa-fax:before{content:\"\\F1AC\"}.fa-building:before{content:\"\\F1AD\"}.fa-child:before{content:\"\\F1AE\"}.fa-paw:before{content:\"\\F1B0\"}.fa-spoon:before{content:\"\\F1B1\"}.fa-cube:before{content:\"\\F1B2\"}.fa-cubes:before{content:\"\\F1B3\"}.fa-behance:before{content:\"\\F1B4\"}.fa-behance-square:before{content:\"\\F1B5\"}.fa-steam:before{content:\"\\F1B6\"}.fa-steam-square:before{content:\"\\F1B7\"}.fa-recycle:before{content:\"\\F1B8\"}.fa-automobile:before,.fa-car:before{content:\"\\F1B9\"}.fa-cab:before,.fa-taxi:before{content:\"\\F1BA\"}.fa-tree:before{content:\"\\F1BB\"}.fa-spotify:before{content:\"\\F1BC\"}.fa-deviantart:before{content:\"\\F1BD\"}.fa-soundcloud:before{content:\"\\F1BE\"}.fa-database:before{content:\"\\F1C0\"}.fa-file-pdf-o:before{content:\"\\F1C1\"}.fa-file-word-o:before{content:\"\\F1C2\"}.fa-file-excel-o:before{content:\"\\F1C3\"}.fa-file-powerpoint-o:before{content:\"\\F1C4\"}.fa-file-image-o:before,.fa-file-photo-o:before,.fa-file-picture-o:before{content:\"\\F1C5\"}.fa-file-archive-o:before,.fa-file-zip-o:before{content:\"\\F1C6\"}.fa-file-audio-o:before,.fa-file-sound-o:before{content:\"\\F1C7\"}.fa-file-movie-o:before,.fa-file-video-o:before{content:\"\\F1C8\"}.fa-file-code-o:before{content:\"\\F1C9\"}.fa-vine:before{content:\"\\F1CA\"}.fa-codepen:before{content:\"\\F1CB\"}.fa-jsfiddle:before{content:\"\\F1CC\"}.fa-life-bouy:before,.fa-life-buoy:before,.fa-life-ring:before,.fa-life-saver:before,.fa-support:before{content:\"\\F1CD\"}.fa-circle-o-notch:before{content:\"\\F1CE\"}.fa-ra:before,.fa-rebel:before,.fa-resistance:before{content:\"\\F1D0\"}.fa-empire:before,.fa-ge:before{content:\"\\F1D1\"}.fa-git-square:before{content:\"\\F1D2\"}.fa-git:before{content:\"\\F1D3\"}.fa-hacker-news:before,.fa-y-combinator-square:before,.fa-yc-square:before{content:\"\\F1D4\"}.fa-tencent-weibo:before{content:\"\\F1D5\"}.fa-qq:before{content:\"\\F1D6\"}.fa-wechat:before,.fa-weixin:before{content:\"\\F1D7\"}.fa-paper-plane:before,.fa-send:before{content:\"\\F1D8\"}.fa-paper-plane-o:before,.fa-send-o:before{content:\"\\F1D9\"}.fa-history:before{content:\"\\F1DA\"}.fa-circle-thin:before{content:\"\\F1DB\"}.fa-header:before{content:\"\\F1DC\"}.fa-paragraph:before{content:\"\\F1DD\"}.fa-sliders:before{content:\"\\F1DE\"}.fa-share-alt:before{content:\"\\F1E0\"}.fa-share-alt-square:before{content:\"\\F1E1\"}.fa-bomb:before{content:\"\\F1E2\"}.fa-futbol-o:before,.fa-soccer-ball-o:before{content:\"\\F1E3\"}.fa-tty:before{content:\"\\F1E4\"}.fa-binoculars:before{content:\"\\F1E5\"}.fa-plug:before{content:\"\\F1E6\"}.fa-slideshare:before{content:\"\\F1E7\"}.fa-twitch:before{content:\"\\F1E8\"}.fa-yelp:before{content:\"\\F1E9\"}.fa-newspaper-o:before{content:\"\\F1EA\"}.fa-wifi:before{content:\"\\F1EB\"}.fa-calculator:before{content:\"\\F1EC\"}.fa-paypal:before{content:\"\\F1ED\"}.fa-google-wallet:before{content:\"\\F1EE\"}.fa-cc-visa:before{content:\"\\F1F0\"}.fa-cc-mastercard:before{content:\"\\F1F1\"}.fa-cc-discover:before{content:\"\\F1F2\"}.fa-cc-amex:before{content:\"\\F1F3\"}.fa-cc-paypal:before{content:\"\\F1F4\"}.fa-cc-stripe:before{content:\"\\F1F5\"}.fa-bell-slash:before{content:\"\\F1F6\"}.fa-bell-slash-o:before{content:\"\\F1F7\"}.fa-trash:before{content:\"\\F1F8\"}.fa-copyright:before{content:\"\\F1F9\"}.fa-at:before{content:\"\\F1FA\"}.fa-eyedropper:before{content:\"\\F1FB\"}.fa-paint-brush:before{content:\"\\F1FC\"}.fa-birthday-cake:before{content:\"\\F1FD\"}.fa-area-chart:before{content:\"\\F1FE\"}.fa-pie-chart:before{content:\"\\F200\"}.fa-line-chart:before{content:\"\\F201\"}.fa-lastfm:before{content:\"\\F202\"}.fa-lastfm-square:before{content:\"\\F203\"}.fa-toggle-off:before{content:\"\\F204\"}.fa-toggle-on:before{content:\"\\F205\"}.fa-bicycle:before{content:\"\\F206\"}.fa-bus:before{content:\"\\F207\"}.fa-ioxhost:before{content:\"\\F208\"}.fa-angellist:before{content:\"\\F209\"}.fa-cc:before{content:\"\\F20A\"}.fa-ils:before,.fa-shekel:before,.fa-sheqel:before{content:\"\\F20B\"}.fa-meanpath:before{content:\"\\F20C\"}.fa-buysellads:before{content:\"\\F20D\"}.fa-connectdevelop:before{content:\"\\F20E\"}.fa-dashcube:before{content:\"\\F210\"}.fa-forumbee:before{content:\"\\F211\"}.fa-leanpub:before{content:\"\\F212\"}.fa-sellsy:before{content:\"\\F213\"}.fa-shirtsinbulk:before{content:\"\\F214\"}.fa-simplybuilt:before{content:\"\\F215\"}.fa-skyatlas:before{content:\"\\F216\"}.fa-cart-plus:before{content:\"\\F217\"}.fa-cart-arrow-down:before{content:\"\\F218\"}.fa-diamond:before{content:\"\\F219\"}.fa-ship:before{content:\"\\F21A\"}.fa-user-secret:before{content:\"\\F21B\"}.fa-motorcycle:before{content:\"\\F21C\"}.fa-street-view:before{content:\"\\F21D\"}.fa-heartbeat:before{content:\"\\F21E\"}.fa-venus:before{content:\"\\F221\"}.fa-mars:before{content:\"\\F222\"}.fa-mercury:before{content:\"\\F223\"}.fa-intersex:before,.fa-transgender:before{content:\"\\F224\"}.fa-transgender-alt:before{content:\"\\F225\"}.fa-venus-double:before{content:\"\\F226\"}.fa-mars-double:before{content:\"\\F227\"}.fa-venus-mars:before{content:\"\\F228\"}.fa-mars-stroke:before{content:\"\\F229\"}.fa-mars-stroke-v:before{content:\"\\F22A\"}.fa-mars-stroke-h:before{content:\"\\F22B\"}.fa-neuter:before{content:\"\\F22C\"}.fa-genderless:before{content:\"\\F22D\"}.fa-facebook-official:before{content:\"\\F230\"}.fa-pinterest-p:before{content:\"\\F231\"}.fa-whatsapp:before{content:\"\\F232\"}.fa-server:before{content:\"\\F233\"}.fa-user-plus:before{content:\"\\F234\"}.fa-user-times:before{content:\"\\F235\"}.fa-bed:before,.fa-hotel:before{content:\"\\F236\"}.fa-viacoin:before{content:\"\\F237\"}.fa-train:before{content:\"\\F238\"}.fa-subway:before{content:\"\\F239\"}.fa-medium:before{content:\"\\F23A\"}.fa-y-combinator:before,.fa-yc:before{content:\"\\F23B\"}.fa-optin-monster:before{content:\"\\F23C\"}.fa-opencart:before{content:\"\\F23D\"}.fa-expeditedssl:before{content:\"\\F23E\"}.fa-battery-4:before,.fa-battery-full:before,.fa-battery:before{content:\"\\F240\"}.fa-battery-3:before,.fa-battery-three-quarters:before{content:\"\\F241\"}.fa-battery-2:before,.fa-battery-half:before{content:\"\\F242\"}.fa-battery-1:before,.fa-battery-quarter:before{content:\"\\F243\"}.fa-battery-0:before,.fa-battery-empty:before{content:\"\\F244\"}.fa-mouse-pointer:before{content:\"\\F245\"}.fa-i-cursor:before{content:\"\\F246\"}.fa-object-group:before{content:\"\\F247\"}.fa-object-ungroup:before{content:\"\\F248\"}.fa-sticky-note:before{content:\"\\F249\"}.fa-sticky-note-o:before{content:\"\\F24A\"}.fa-cc-jcb:before{content:\"\\F24B\"}.fa-cc-diners-club:before{content:\"\\F24C\"}.fa-clone:before{content:\"\\F24D\"}.fa-balance-scale:before{content:\"\\F24E\"}.fa-hourglass-o:before{content:\"\\F250\"}.fa-hourglass-1:before,.fa-hourglass-start:before{content:\"\\F251\"}.fa-hourglass-2:before,.fa-hourglass-half:before{content:\"\\F252\"}.fa-hourglass-3:before,.fa-hourglass-end:before{content:\"\\F253\"}.fa-hourglass:before{content:\"\\F254\"}.fa-hand-grab-o:before,.fa-hand-rock-o:before{content:\"\\F255\"}.fa-hand-paper-o:before,.fa-hand-stop-o:before{content:\"\\F256\"}.fa-hand-scissors-o:before{content:\"\\F257\"}.fa-hand-lizard-o:before{content:\"\\F258\"}.fa-hand-spock-o:before{content:\"\\F259\"}.fa-hand-pointer-o:before{content:\"\\F25A\"}.fa-hand-peace-o:before{content:\"\\F25B\"}.fa-trademark:before{content:\"\\F25C\"}.fa-registered:before{content:\"\\F25D\"}.fa-creative-commons:before{content:\"\\F25E\"}.fa-gg:before{content:\"\\F260\"}.fa-gg-circle:before{content:\"\\F261\"}.fa-tripadvisor:before{content:\"\\F262\"}.fa-odnoklassniki:before{content:\"\\F263\"}.fa-odnoklassniki-square:before{content:\"\\F264\"}.fa-get-pocket:before{content:\"\\F265\"}.fa-wikipedia-w:before{content:\"\\F266\"}.fa-safari:before{content:\"\\F267\"}.fa-chrome:before{content:\"\\F268\"}.fa-firefox:before{content:\"\\F269\"}.fa-opera:before{content:\"\\F26A\"}.fa-internet-explorer:before{content:\"\\F26B\"}.fa-television:before,.fa-tv:before{content:\"\\F26C\"}.fa-contao:before{content:\"\\F26D\"}.fa-500px:before{content:\"\\F26E\"}.fa-amazon:before{content:\"\\F270\"}.fa-calendar-plus-o:before{content:\"\\F271\"}.fa-calendar-minus-o:before{content:\"\\F272\"}.fa-calendar-times-o:before{content:\"\\F273\"}.fa-calendar-check-o:before{content:\"\\F274\"}.fa-industry:before{content:\"\\F275\"}.fa-map-pin:before{content:\"\\F276\"}.fa-map-signs:before{content:\"\\F277\"}.fa-map-o:before{content:\"\\F278\"}.fa-map:before{content:\"\\F279\"}.fa-commenting:before{content:\"\\F27A\"}.fa-commenting-o:before{content:\"\\F27B\"}.fa-houzz:before{content:\"\\F27C\"}.fa-vimeo:before{content:\"\\F27D\"}.fa-black-tie:before{content:\"\\F27E\"}.fa-fonticons:before{content:\"\\F280\"}.fa-reddit-alien:before{content:\"\\F281\"}.fa-edge:before{content:\"\\F282\"}.fa-credit-card-alt:before{content:\"\\F283\"}.fa-codiepie:before{content:\"\\F284\"}.fa-modx:before{content:\"\\F285\"}.fa-fort-awesome:before{content:\"\\F286\"}.fa-usb:before{content:\"\\F287\"}.fa-product-hunt:before{content:\"\\F288\"}.fa-mixcloud:before{content:\"\\F289\"}.fa-scribd:before{content:\"\\F28A\"}.fa-pause-circle:before{content:\"\\F28B\"}.fa-pause-circle-o:before{content:\"\\F28C\"}.fa-stop-circle:before{content:\"\\F28D\"}.fa-stop-circle-o:before{content:\"\\F28E\"}.fa-shopping-bag:before{content:\"\\F290\"}.fa-shopping-basket:before{content:\"\\F291\"}.fa-hashtag:before{content:\"\\F292\"}.fa-bluetooth:before{content:\"\\F293\"}.fa-bluetooth-b:before{content:\"\\F294\"}.fa-percent:before{content:\"\\F295\"}.fa-gitlab:before{content:\"\\F296\"}.fa-wpbeginner:before{content:\"\\F297\"}.fa-wpforms:before{content:\"\\F298\"}.fa-envira:before{content:\"\\F299\"}.fa-universal-access:before{content:\"\\F29A\"}.fa-wheelchair-alt:before{content:\"\\F29B\"}.fa-question-circle-o:before{content:\"\\F29C\"}.fa-blind:before{content:\"\\F29D\"}.fa-audio-description:before{content:\"\\F29E\"}.fa-volume-control-phone:before{content:\"\\F2A0\"}.fa-braille:before{content:\"\\F2A1\"}.fa-assistive-listening-systems:before{content:\"\\F2A2\"}.fa-american-sign-language-interpreting:before,.fa-asl-interpreting:before{content:\"\\F2A3\"}.fa-deaf:before,.fa-deafness:before,.fa-hard-of-hearing:before{content:\"\\F2A4\"}.fa-glide:before{content:\"\\F2A5\"}.fa-glide-g:before{content:\"\\F2A6\"}.fa-sign-language:before,.fa-signing:before{content:\"\\F2A7\"}.fa-low-vision:before{content:\"\\F2A8\"}.fa-viadeo:before{content:\"\\F2A9\"}.fa-viadeo-square:before{content:\"\\F2AA\"}.fa-snapchat:before{content:\"\\F2AB\"}.fa-snapchat-ghost:before{content:\"\\F2AC\"}.fa-snapchat-square:before{content:\"\\F2AD\"}.fa-pied-piper:before{content:\"\\F2AE\"}.fa-first-order:before{content:\"\\F2B0\"}.fa-yoast:before{content:\"\\F2B1\"}.fa-themeisle:before{content:\"\\F2B2\"}.fa-google-plus-circle:before,.fa-google-plus-official:before{content:\"\\F2B3\"}.fa-fa:before,.fa-font-awesome:before{content:\"\\F2B4\"}.fa-handshake-o:before{content:\"\\F2B5\"}.fa-envelope-open:before{content:\"\\F2B6\"}.fa-envelope-open-o:before{content:\"\\F2B7\"}.fa-linode:before{content:\"\\F2B8\"}.fa-address-book:before{content:\"\\F2B9\"}.fa-address-book-o:before{content:\"\\F2BA\"}.fa-address-card:before,.fa-vcard:before{content:\"\\F2BB\"}.fa-address-card-o:before,.fa-vcard-o:before{content:\"\\F2BC\"}.fa-user-circle:before{content:\"\\F2BD\"}.fa-user-circle-o:before{content:\"\\F2BE\"}.fa-user-o:before{content:\"\\F2C0\"}.fa-id-badge:before{content:\"\\F2C1\"}.fa-drivers-license:before,.fa-id-card:before{content:\"\\F2C2\"}.fa-drivers-license-o:before,.fa-id-card-o:before{content:\"\\F2C3\"}.fa-quora:before{content:\"\\F2C4\"}.fa-free-code-camp:before{content:\"\\F2C5\"}.fa-telegram:before{content:\"\\F2C6\"}.fa-thermometer-4:before,.fa-thermometer-full:before,.fa-thermometer:before{content:\"\\F2C7\"}.fa-thermometer-3:before,.fa-thermometer-three-quarters:before{content:\"\\F2C8\"}.fa-thermometer-2:before,.fa-thermometer-half:before{content:\"\\F2C9\"}.fa-thermometer-1:before,.fa-thermometer-quarter:before{content:\"\\F2CA\"}.fa-thermometer-0:before,.fa-thermometer-empty:before{content:\"\\F2CB\"}.fa-shower:before{content:\"\\F2CC\"}.fa-bath:before,.fa-bathtub:before,.fa-s15:before{content:\"\\F2CD\"}.fa-podcast:before{content:\"\\F2CE\"}.fa-window-maximize:before{content:\"\\F2D0\"}.fa-window-minimize:before{content:\"\\F2D1\"}.fa-window-restore:before{content:\"\\F2D2\"}.fa-times-rectangle:before,.fa-window-close:before{content:\"\\F2D3\"}.fa-times-rectangle-o:before,.fa-window-close-o:before{content:\"\\F2D4\"}.fa-bandcamp:before{content:\"\\F2D5\"}.fa-grav:before{content:\"\\F2D6\"}.fa-etsy:before{content:\"\\F2D7\"}.fa-imdb:before{content:\"\\F2D8\"}.fa-ravelry:before{content:\"\\F2D9\"}.fa-eercast:before{content:\"\\F2DA\"}.fa-microchip:before{content:\"\\F2DB\"}.fa-snowflake-o:before{content:\"\\F2DC\"}.fa-superpowers:before{content:\"\\F2DD\"}.fa-wpexplorer:before{content:\"\\F2DE\"}.fa-meetup:before{content:\"\\F2E0\"}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);border:0}.sr-only-focusable:active,.sr-only-focusable:focus{position:static;width:auto;height:auto;margin:0;overflow:visible;clip:auto}body{font-family:Source Sans Pro,Helvetica,Arial,\"sans-serif\";text-rendering:optimizeLegibility!important;-webkit-font-smoothing:antialiased!important;-moz-osx-font-smoothing:grayscale!important}.ui-select-choices-row.active{background-color:#efefef}div .table-striped>tbody>tr:nth-of-type(odd){background-color:#eaeaea}navbar .navbar-default{background:#3d484e}navbar .navbar-default *{color:#fff!important}body .navbar-default .navbar-nav>.active>a{background-color:transparent!important;box-shadow:inset 0 -4px 0 0 #fff;cursor:default}.is-odd{background-color:#f9f9f9}.spinner{width:70px;height:70px;border:5px solid rgba(0,0,0,.2);border-left-color:rgba(0,0,0,.4);border-radius:50%;animation:rotate .5s linear infinite}@keyframes rotate{to{transform:rotate(1turn)}}body .navbar-default .navbar-nav>.active>a:hover{opacity:1!important}.btn,.modal-header h4{font-weight:600}.browserupgrade{margin:.2em 0;background:#ccc;color:#000;padding:.2em 0}.modal-header{position:relative}.modal-header .close{float:none;position:absolute;right:20px;font-size:30px;top:20px;padding-left:5px;padding-right:5px}.ui-select-choices-row{border-radius:3px;padding:4px 5px;margin-left:-5px;margin-right:-5px}@media (min-width:1000px){.modal-dialog{width:900px}}.ui-select-bootstrap>.ui-select-choices{padding-left:10px;padding-right:10px}.only-sundays .uib-weeks td{display:none}.only-sundays .uib-weeks td:first-child{display:block;height:30px}.only-sundays .uib-weeks td:first-child button{position:absolute;left:0}.only-sundays .uib-button-bar,.only-sundays .uib-daypicker thead tr:nth-child(2){display:none}.only-sundays .uib-daypicker button.uib-title{min-width:180px}.trash{color:#d15b47}.user-list li{display:flex;border:none;border-bottom:1px solid #d3d3d3;margin-bottom:0}.user-list li:last-child{border-bottom:none}.user-list li .user-info{flex-grow:1}.user-list li .trash{display:flex;align-items:center;text-decoration:none}.flex{display:-ms-flexbox;display:flex}.flex .flex-grow{-ms-flex-positive:1;flex-grow:1}.flex.flex-wrap{-ms-flex-wrap:wrap;flex-wrap:wrap}.flex.h-center{-ms-flex-pack:center;justify-content:center}.flex.h-right{-ms-flex-pack:end;justify-content:flex-end}.flex.v-center{-ms-flex-align:center;align-items:center}.flex.v-bottom{-ms-flex-align:end;align-items:flex-end}.flex.h-separate{-ms-flex-pack:justify;justify-content:space-between}.flex.child-stretch>*{-ms-flex-positive:1;flex-grow:1;-ms-flex-preferred-size:0;flex-basis:0}.flex.child-stretch .no-stretch{-ms-flex-positive:0;flex-grow:0}.flex.v-flex{-ms-flex-direction:column;flex-direction:column}.row-bleed{margin-left:-10px;margin-right:-10px}.o70{opacity:.7}.o0{opacity:0}.w600{font-weight:600}.w700{font-weight:700}.width60{width:60%}.fs16{font-size:16px}.fs14{font-size:14px}.fs12{font-size:12px}.no-click{pointer-events:none;cursor:default}.big-shadow{box-shadow:0 20px 66px 0 rgba(34,48,73,.2)}.small-shadow{box-shadow:0 0 10px 0 rgba(34,48,73,.2)}.smaller-shadow{box-shadow:0 0 5px 0 rgba(34,48,73,.2)}.m-r-xs{margin-right:6px}.m-r-sm{margin-right:12px}.m-r-md{margin-right:18px}.m-r-lg{margin-right:24px}.m-r-xl{margin-right:30px}.m-l-xs{margin-left:6px}.m-l-sm{margin-left:12px}.m-l-md{margin-left:18px}.m-l-lg{margin-left:24px}.m-l-xl{margin-left:30px}.m-t-xs{margin-top:6px}.m-t-sm{margin-top:12px}.m-t-md{margin-top:18px}.m-t-lg{margin-top:24px}.m-t-xl{margin-top:30px}.m-b-xs{margin-bottom:6px}.m-b-sm{margin-bottom:12px}.m-b-md{margin-bottom:18px}.m-b-lg{margin-bottom:24px}.m-b-xl{margin-bottom:30px}.p-xs{padding:6px}.p-sm{padding:12px}.p-md{padding:18px}.p-lg{padding:24px}.p-xl{padding:30px}.b-r{border-radius:4px}.abs-cover{position:absolute;top:0;left:0;right:0;bottom:0}.fill-bg{background-size:cover;background-position:50%}.bg-white{background-color:#fff}.border-grey{border:1px solid #ccc}.thing-form{margin:20px 0}#banner{border-bottom:none;margin-top:-20px}#banner h1{font-size:60px;line-height:1;letter-spacing:-1px}.hero-unit{position:relative;padding:30px 15px;color:#f5f5f5;text-align:center;text-shadow:0 1px 0 rgba(0,0,0,.1);background:#4393b9}.navbar-text{margin-left:15px}/*!\n * ui-select\n * http://github.com/angular-ui/ui-select\n * Version: 0.11.2 - 2015-03-17T04:08:46.478Z\n * License: MIT\n */.ui-select-highlight{font-weight:700}.ui-select-offscreen{clip:rect(0 0 0 0)!important;width:1px!important;height:1px!important;border:0!important;margin:0!important;padding:0!important;overflow:hidden!important;position:absolute!important;outline:0!important;left:0!important;top:0!important}.ng-dirty.ng-invalid>a.select2-choice{border-color:#d44950}.select2-result-single{padding-left:0}.select2-locked>.select2-search-choice-close,.select-locked>.ui-select-match-close{display:none}body>.select2-container.open{z-index:9999}.selectize-input.selectize-focus{border-color:#007fbb!important}.selectize-control>.selectize-dropdown,.selectize-control>.selectize-input>input{width:100%}.ng-dirty.ng-invalid>div.selectize-input{border-color:#d44950}.btn-default-focus{color:#333;background-color:#ebebeb;border-color:#adadad;text-decoration:none;outline:5px auto -webkit-focus-ring-color;outline-offset:-2px;box-shadow:inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)}.ui-select-bootstrap .ui-select-toggle{position:relative}.ui-select-bootstrap .ui-select-toggle>.caret{position:absolute;height:10px;top:50%;right:10px;margin-top:-2px}.input-group>.ui-select-bootstrap.dropdown{position:static}.input-group>.ui-select-bootstrap>input.ui-select-search.form-control{border-radius:4px;border-top-right-radius:0;border-bottom-right-radius:0}.ui-select-bootstrap>.ui-select-match>.btn{text-align:left!important}.ui-select-bootstrap>.ui-select-match>.caret{position:absolute;top:45%;right:15px}.ui-select-bootstrap>.ui-select-choices{width:100%;height:auto;max-height:200px;overflow-x:hidden;margin-top:-1px}body>.ui-select-bootstrap.open{z-index:1000}.ui-select-multiple.ui-select-bootstrap{height:auto;padding:3px 3px 0}.ui-select-multiple.ui-select-bootstrap input.ui-select-search{background-color:transparent!important;border:none;outline:none;height:1.666666em;margin-bottom:3px}.ui-select-multiple.ui-select-bootstrap .ui-select-match .close{font-size:1.6em;line-height:.75}.ui-select-multiple.ui-select-bootstrap .ui-select-match-item{outline:0;margin:0 3px 3px 0}.ui-select-multiple .ui-select-match-item{position:relative}.ui-select-multiple .ui-select-match-item.dropping-before:before{content:\"\";position:absolute;top:0;right:100%;height:100%;margin-right:2px;border-left:1px solid #428bca}.ui-select-multiple .ui-select-match-item.dropping-after:after{content:\"\";position:absolute;top:0;left:100%;height:100%;margin-left:2px;border-right:1px solid #428bca}.ui-select-bootstrap .ui-select-choices-row>a{display:block;padding:3px 20px;clear:both;font-weight:400;line-height:1.42857143;color:#333;white-space:nowrap}.ui-select-bootstrap .ui-select-choices-row>a:focus,.ui-select-bootstrap .ui-select-choices-row>a:hover{text-decoration:none;color:#262626;background-color:#f5f5f5}.ui-select-bootstrap .ui-select-choices-row.active>a{color:#fff;text-decoration:none;outline:0;background-color:#428bca}.ui-select-bootstrap .ui-select-choices-row.active.disabled>a,.ui-select-bootstrap .ui-select-choices-row.disabled>a{color:#777;cursor:not-allowed;background-color:#fff}.ui-select-match.ng-hide-add,.ui-select-search.ng-hide-add{display:none!important}.ui-select-bootstrap.ng-dirty.ng-invalid>button.btn.ui-select-match{border-color:#d44950}.modal-danger .modal-header,.modal-info .modal-header,.modal-primary .modal-header,.modal-success .modal-header,.modal-warning .modal-header{color:#fff;border-radius:5px 5px 0 0}.modal-primary .modal-header{background:#337ab7}.modal-info .modal-header{background:#5bc0de}.modal-success .modal-header{background:#5cb85c}.modal-warning .modal-header{background:#f0ad4e}.modal-danger .modal-header{background:#d9534f}", ""]);
	
	// exports


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ })
]);


// WEBPACK FOOTER //
// app.200701e622f73fc542c7.js